const en: Record<string, string> = {
    // Common
    back: "Back",
    home: "Home",
    admin: "Admin",
    login: "Login",
    logout: "Logout",
    submit: "Submit",
    yes: "Yes",
    no: "No",
    close: "Close",
    reset: "Reset",
    search: "Search",
    loading: "Loading...",
    submitting: "Submitting...",
    searching: "Searching...",
    save: "Save",
    saving: "Saving...",
    refresh: "Refresh",
    confirm: "Confirm",
    cancel: "Cancel",
    error: "Error",
    success: "Success",
    info: "Info",
    export: "Export",

    // Home
    hello_user: "Hello {name}!",
    goods_in: "Goods In",

    // Wipe module
    wipe: "Wipe",
    wipe_settings: "Wipe",
    wipe_settings_hint: "Every item is routed to a pallet by its net value. Data-bearing devices are always relabelled: at or above the data-wipe threshold they are wiped, relabelled and placed in the pink pallet; above the dispose threshold they are relabelled and placed in the pink pallet; at or below the dispose threshold they are relabelled and placed in the yellow pallet. Items marked as not data-bearing get no label and go in the pink pallet, or the yellow pallet when at or below the dispose threshold.",
    wipe_scan_prompt: "Scan Item",
    wipe_scan_lpn_prompt: "Scan LPN",
    wipe_individual_items: "Individual items",
    wipe_individual_items_hint: "Individual items: scan one LPN at a time. Units of a box-listed box are matched to their product through the LPN weekly manifest. Every found LPN gets a new SKU, data-bearing or not, so every row reaches the Jobalots export. Box codes are refused; an unmatched LPN goes to the Unmanifested pallet.",
    wipe_individual_not_lpn: "Individual items mode: scan an LPN.",
    wipe_mode_on: "ON",
    wipe_mode_off: "OFF",
    wipe_not_found: "Item not found",
    wipe_scan_lpns_prompt: "This box holds {count} data-bearing units and will be sold individually as PINKS. Scan the first LPN.",
    wipe_scan_lpns_cover: "Box damaged or LPNs missing? Cover instead ({count} labels)",
    wipe_scan_lpns_not_lpn: "Scan an LPN from this box.",
    wipe_unmanifested_title: "LPN not on any manifest",
    wipe_unmanifested_prompt: "{lpn} is not on any manifest. Print a cover label and place the unit on the Unmanifested pallet?",
    wipe_unmanifested_confirm: "Print cover label",
    wipe_outcome_cover_unmanifested: "Unmanifested",
    wipe_rates_button: "Exchange rates",
    wipe_rates_title: "Exchange rates (HMRC monthly)",
    wipe_rates_hint: "Used to convert EU-stock prices to GBP when a Wipe label becomes a product. Rates are fetched from HMRC automatically each month; type a value and save to override a month.",
    wipe_rates_refresh: "Fetch this month from HMRC",
    wipe_rates_refreshed: "Rates updated from HMRC",
    wipe_rates_refresh_failed: "Could not fetch rates from HMRC",
    wipe_rates_saved: "Rate saved",
    wipe_rates_invalid: "Enter a positive rate (currency units per £1)",
    wipe_rates_empty: "No rates stored yet. Fetch this month from HMRC.",
    wipe_rates_col_month: "Month",
    wipe_rates_col_currency: "Currency",
    wipe_rates_col_rate: "Units per £1",
    wipe_rates_col_source: "Source",
    wipe_rates_source_override: "Override",
    wipe_quantity: "Quantity",
    wipe_data_sensitive_q: "Is this a data-bearing device?",
    wipe_data_sensitive_yes: "Yes — data device",
    wipe_data_sensitive_no: "No — not a data device",
    wipe_yes: "Yes",
    wipe_no: "No",
    wipe_ai_suggests: "AI suggests",
    wipe_human_suggests: "Humans suggest",
    wipe_instructions_title: "Data wipe steps",
    wipe_outcome_auto_list: "Pink",
    wipe_outcome_auto_dispose: "Yellow",
    wipe_outcome_data_wipe_relabel: "Wipe Relabel Pink",
    wipe_outcome_relabel: "Relabel Pink",
    wipe_outcome_relabel_dispose: "Relabel Yellow",
    wipe_outcome_cover_relabel: "Cover Labels",
    wipe_outcome_box_blue: "Blue",
    wipe_outcome_box_pink: "Pink",
    wipe_outcome_reprint: "Reprint",
    wipe_print_all: "Print all {count} units",
    wipe_cover_title: "Data-bearing box",
    wipe_cover_prompt: "This box holds {count} data-bearing units and will be sold as a BLUE. All LPNs need to be covered with new barcodes.",
    wipe_cover_confirm: "Print {count} labels",
    wipe_cover_cancel: "Cancel",
    wipe_record: "Confirm",
    wipe_recorded: "Recorded",
    wipe_labels: "labels",
    wipe_items: "items",
    wipe_undo: "Undo",
    wipe_go_back: "Go back",
    wipe_undone: "Undone",
    wipe_next_item: "Next item",
    wipe_today: "Today",
    wipe_per_hour: "Per hour",
    wipe_target: "Target",
    wipe_print_failed: "Print failed",
    wipe_done_dispose: "Dispose this item",
    wipe_threshold_label: "Data-wipe threshold (£ net)",
    wipe_threshold_hint: "Data-bearing items worth this much or more (net) are data-wiped, relabelled, and sold on Jobalots.",
    wipe_dispose_threshold_label: "Dispose threshold (£ net)",
    wipe_dispose_threshold_hint: "Items worth this much or less (net) go in the yellow pallet — data-bearing ones are relabelled first; anything dearer goes in the pink pallet.",
    wipe_box_threshold_label: "Box threshold (£ avg net)",
    wipe_box_threshold_hint: "A scanned box of mixed products is judged by its average item value. With no data-bearing items it goes whole to a pallet: above this goes in the pink pallet, otherwise the blue pallet. With a data-bearing item, if every unit is listed by its own LPN and the average is above this, the worker scans each LPN and labels the units individually, and every unit goes in the pink pallet whatever its own value; otherwise the units are covered with new barcodes and the box goes whole to the blue pallet.",
    wipe_label_width_label: "Label width (mm)",
    wipe_label_height_label: "Label height (mm)",
    wipe_label_orientation_label: "Label orientation",
    wipe_label_orientation_hint: "How the relabel label is rotated when printed. Change this if labels come out sideways or upside-down.",
    wipe_orientation_normal: "Normal",
    wipe_orientation_cw: "90° clockwise",
    wipe_orientation_ccw: "90° anti-clockwise",
    wipe_orientation_flip: "180° (upside-down)",
    wipe_auto_process_no_label: "Hands-free auto-process",
    wipe_auto_process_no_hint: "When on, items the portal has seen before are processed with no taps: non-data items are listed on Jobalots (no label), and data devices that only need relabelling have their label printed automatically — both then return to the scan screen. The first time a product is scanned it always stops on the Yes/No screen with the AI's answer pre-selected, so you can correct it before anything prints; your confirm is what later scans run on. Data devices that need wiping still stop so you can wipe them and confirm. If the AI gets it wrong, press \"Go back\" on the confirmation to re-open the item.",

    scan_sheet: "Scan Sheet",
    book_in: "Book In",

    // Relabel — Goods In scan-and-print module + warehouse admin page.
    // (`relabel` module title already defined below.)
    relabel_scan_original: "Scan Barcode",
    relabel_remaining: "{count} new barcode(s) left for this item",
    relabel_all_used: "All new barcodes for this item have been used",
    relabel_not_found: "No relabel entry for that barcode",
    relabel_dispense_failed: "Couldn't get a new barcode — try again",
    relabel_settings: "Relabel",
    relabel_settings_hint: "PO / original-barcode / new-barcode pairings for the Goods In Relabel station. Scanning an original barcode prints the next available new barcode and marks it used. Each new barcode can only be used once; the same original barcode may have many new barcodes, dispensed in upload order.",
    warehouse_tile_relabel_desc: "Relabel pairings — upload and track",
    relabel_status_available: "Available",
    relabel_status_used: "Used",
    relabel_toggle_hint: "Click to toggle available / used",
    relabel_download_template: "Download Template",
    relabel_download_current: "Download Current",
    relabel_upload_xlsx: "Upload XLSX",
    relabel_upload_parse_error: "Couldn't read that file — is it a valid .xlsx?",
    relabel_upload_empty: "That file has no data rows",
    relabel_upload_bad_header: "File must have Original Barcode and New Barcode columns",
    relabel_bulk_summary: "Added {added}, updated {updated}",
    relabel_filter_search_hint: "Search PO, original or new barcode (press Enter)",
    relabel_col_id: "ID",
    relabel_col_po: "PO",
    relabel_col_original: "Original Barcode",
    relabel_col_new: "New Barcode",
    relabel_col_status: "Status",
    relabel_no_rows: "No relabel entries at the selected filters.",
    wipe_admin_hint: "Processed items from the Wipe / data-wipe station. Each row is one recorded unit — the new relabel barcode, what was scanned, the resolved product, the routing outcome and its recovery value.",
    warehouse_tile_wipe_desc: "Processed wipe items and recovery values",
    // ── Warehouse > Points ──────────────────────────────────────────────
    points_settings_title: "Points",
    warehouse_tile_points_desc: "Time targets and trophy leaderboard",
    points_flow_large: "Large",
    points_tab_targets: "Targets",
    points_tab_leaderboard: "Leaderboard",
    points_targets_hint: "A target is what a point is worth: beat it on one unit of work and the operator banks the seconds they saved. Leave a target blank and that flow does not score at all.",
    points_target_put_away_hint: "One item put into a location, or one tote fully put away — whichever mode the warehouse runs.",
    points_target_picking_hint: "One line picked: from an accepted item scan to the next. Single is stored as the 'light' pick type.",
    points_target_dispatch_hint: "One order packed and closed at the bench, timed against the target for the pick type it came from.",
    points_target_wipe_hint: "One item scanned, graded and recorded.",
    points_celebrations: "Celebrations",
    points_celebration_sound: "Milestone sound",
    points_celebration_sound_hint: "A chime from 1,000 points and a fanfare from 5,000 up — about one day in ten. Turn it off for a floor where the noise would not land well; the visuals stay either way.",
    targets_moved_to_points: "Time targets now live in",
    points_range: "Period",
    points_range_today: "Today",
    points_range_yesterday: "Yesterday",
    points_range_this_week: "This week",
    points_range_last_week: "Last week",
    points_range_this_month: "This month",
    points_range_last_month: "Last month",
    points_range_this_year: "This year",
    points_range_all: "All time",
    points_range_custom: "Custom range",
    points_col_rank: "Rank",
    points_col_name: "Name",
    points_col_time_saved: "Time saved",
    points_col_days: "Days",
    points_col_best_day: "Best day",
    points_no_scores: "Nobody scored in this period",
    points_unstamped_hidden: "{count} operator-days in this range have no site recorded, so they are not shown here. Switch to All warehouses to include them.",
    points_leaderboard_lag: "Scores are sent in batches, so the last minute may be missing",
    wipe_filter_search_hint: "Search new/old SKU, pkg id, ASIN, title or warehouse (press Enter)",
    wipe_clear_filters: "Clear filters",
    wipe_export_table: "Table",
    wipe_ppd_export: "PPD",
    wipe_jobalots_export: "Jobalots",
    wipe_filter_all_warehouses: "All warehouses",
    wipe_filter_all_outcomes: "All outcomes",
    wipe_outcome_box_prefixed: "Box {label}",
    wipe_filter_from: "From",
    wipe_filter_to: "To",
    wipe_col_id: "ID",
    wipe_col_date: "Date",
    wipe_col_warehouse: "Warehouse",
    wipe_col_new_sku: "New SKU",
    wipe_col_old_sku: "Old SKU",
    wipe_col_jli_pkg_id: "jli_pkg_id",
    wipe_col_asin: "Asin",
    wipe_col_title: "Title",
    wipe_col_data_sensitive: "Data Sensitive",
    wipe_col_outcome: "Outcome",
    wipe_col_unit_cost: "Unit Cost",
    wipe_col_weight: "Weight (g)",
    wipe_no_rows: "No wipe products at the selected filters.",
    wipe_col_jobalots: "Jobalots",
    wipe_jobalots_listed: "Listed",
    wipe_jobalots_not_listed: "Not listed",
    wipe_jobalots_not_checked: "Not checked",
    wipe_jobalots_checked_at: "Last stock push {date}",
    wipe_filter_all_listing: "Listed or not",
    wipe_filter_listed: "Listed on Jobalots",
    wipe_filter_not_listed: "Not listed on Jobalots",
    wipe_jobalots_queue: "Queue Jobalots export",
    wipe_jobalots_queued: "Export queued — it will appear under Reports › Queued exports when ready.",
    wipe_jobalots_queue_failed: "Could not queue the export — try again",
    wipe_jobalots_sync: "Sync Jobalots",
    wipe_jobalots_sync_hint: "Re-send stock for every SKU in view marked Not listed on Jobalots. Jobalots' replies update the Jobalots column over the next few minutes.",
    wipe_jobalots_sync_started: "Checking {count} SKUs with Jobalots — the Jobalots column updates as it replies. Refresh in a few minutes.",
    wipe_jobalots_sync_none: "No SKU in view is marked Not listed on Jobalots.",
    wipe_jobalots_sync_failed: "Could not start the Jobalots sync — try again",
    zone_storage: "Sorting",
    conveyor: "Conveyor",

    // Login
    portal_login: "Portal Login",
    logging_in: "Logging In...",
    password: "Password",
    select_colour: "Select",
    colour_blue: "Blue",
    colour_black: "Black",
    colour_green: "Green",
    colour_grey: "Grey",
    colour_pink: "Pink",
    colour_purple: "Purple",
    colour_red: "Red",
    colour_yellow: "Yellow",
    colour_dsd: "Data Devices",
    colour_white: "White",
    version_text: "v0.22.2",

    // Scan Sheet
    scan_here: "Scan here...",
    scan: "Scan",
    server_error: "Server error — try again",
    label_size_forbidden: "You can't change the saved label size — ask an Admin, or print at the current size",
    not_in_manifest: "Item Not in Manifest",
    bulk_upload_too_large: "Upload batch is too large for the server (5MB limit). Some rows may carry unusually long values (descriptions, notes). Try shrinking those fields, or contact admin to raise the limit. Any earlier batches in this upload have already been saved.",
    ppd_sync_failed: "PPd sync failed — scan tote again to retry",
    unsellable_location_title: "Unsellable location",
    unsellable_location_body: "Stock placed here won't be picked for orders. Continue anyway?",
    unsellable_location_confirm: "Place anyway",
    put_away_confirm_title: "Put away all items?",
    put_away_confirm_hint: "Scan {location} again or tap Confirm to move all {units} items there",
    put_away_confirm_rescan_mismatch: "Scan the same location again to confirm, or cancel",
    put_away_confirm_button: "Confirm put away",
    put_away_item_already_done: "Item already put away from this tote",
    label_size_aria: "Cycle label size",
    label_size_button: "Label: {size}",
    nothing_scanned: "Nothing scanned",
    oversize: "Oversize",
    scan_location_to_begin: "Scan location",
    scan_location_sub: "Area · Parcels · Pallets",
    unknown_location_barcode: "Unknown location barcode",
    location_check_failed: "Couldn't verify location — try again",
    last_scanned: "Last: {value}",
    blue: "Blue",
    green_hot: "Green Hot",
    green_cold: "Green Cold",
    green: "Green",
    pink: "Pink",
    orange: "Orange",
    grey: "Grey",
    red: "Red",
    yellow: "Yellow",
    relabel: "Relabel",
    banned: "Banned",
    special: "Special",
    storage_device: "Storage Device",
    pricing_dispute: "Pricing Dispute",

    // Book In
    book_in_category_title: "Select Colour",
    book_in_category_sub: "Choose a category to begin",
    colour_orange: "Orange",
    category_misc: "Misc",
    category_supplier: "Supplier",
    category_supplier_action: "Choose Supplier",
    category_label: "Category: {category}",
    change_category: "Change",
    tote_colour_mismatch: "Tote booked in as {colour} — scan another tote",
    scan_tote: "Scan Tote",
    invalid_tote: "Not a valid tote",
    tote_status_open: "Tote in use",
    tote_status_closed: "Tote closed",
    tote_status_stored: "Tote in storage",
    tote_status_available: "Tote is empty",
    tote_not_awaiting_put_away: "Tote holds picked stock — nothing to put away",
    close_tote: "Close Tote",
    scan_to_close: "Scan to close",
    scan_tote_sub: "Scan a tote to begin",
    scan_item_sub: "Scan tote again to close",
    remove_item_sub: "Tap trash icon to exit",
    resume_tote_hint: "Resume {tote} ({count}) — scan to open",
    complete: "Complete",
    complete_and_putaway: "Complete & Putaway",
    items_count: "{count} items",
    tote_label: "Tote: {tote}",
    close_tote_confirm: "Scan tote again or press Complete to book in all items.",
    remove_item: "Remove Item",
    item_not_in_tote: "Item not in tote",
    enter_remove_mode: "Enter remove mode",
    exit_remove_mode: "Exit remove mode",
    tote_empty_cant_close: "Scan items before closing the tote",
    abandon_tote_title: "Close Empty Tote?",
    abandon_tote_body: "No items have been scanned into this tote. Closing it now will return the tote to available so it can be re-used.",
    abandon_tote_yes: "Yes, abandon",
    already_in_tote: "Already in tote",
    already_in_stock: "SKU already in stock at {location} ({qty} units), please give this product to a leader",
    already_in_stock_multi: "SKU already in stock at {location} ({qty} units) and {more} more locations, please give this product to a leader",
    tote_in_use_by: "Tote in use by {name}",
    tote_resumed: "Resumed tote started by {name}",
    reopen_tote_title: "Reopen Tote",
    reopen_tote_intro: "This tote was already booked in. Continue from current contents or empty it and start over?",
    reopen_tote_intro_named: "Already booked in by {name}. Continue from current contents or empty it and start over?",
    reopen_continue: "Continue",
    reopen_empty: "Empty",
    reopen_empty_confirm_title: "Empty Tote?",
    reopen_empty_confirm_body: "All items currently in this tote will be removed and you'll be starting fresh. This can't be undone.",
    reopen_empty_confirm_yes: "Yes, empty it",
    join_tote_title: "Join Tote?",
    join_tote_intro: "Another operator already has this tote open. Join and add to its current contents?",
    join_tote_intro_named: "{name} already has this tote open. Join and add to its current contents?",
    join_tote_join: "Join",
    must_close_tote_first: "Close tote {tote} before opening a new one",
    tote_closed_externally: "Tote {tote} was closed by another operator",
    no_open_manifest: "No manifest for this SKU at this warehouse — add one before booking in",
    manifest_short: "Manifest short for: {skus}",
    items_missing_sku: "Couldn't identify these items: {barcodes}. Check they're set up in products / manifests.",
    book_in_tote_not_in_progress: "Tote {tote} has no book-in open — nothing was booked in. Scan the tote again to start one.",
    // Book In — supplier / PO flow
    book_in_select_supplier_title: "Select Supplier",
    book_in_select_supplier_sub: "Suppliers with open POs",
    book_in_select_po_title: "Select PO",
    book_in_select_po_sub: "Open POs for {supplier}",
    book_in_no_suppliers: "No suppliers with open POs. Switch suppliers on under Admin → Warehouse → Suppliers.",
    book_in_no_pos: "No open POs for this supplier",
    book_in_po_meta: "{done} / {total} lines · {received} / {expected} units",
    book_in_supplier_meta: "{pos} open POs · {lines} open lines",
    book_in_back: "Back",
    po_chip: "{supplier} · {po}",
    tote_po_mismatch: "Tote booked in against {po} — scan another tote",
    tote_po_mismatch_none: "Tote booked in without a PO — scan another tote",
    item_not_on_po_title: "Not on this PO",
    item_not_on_po_body: "{sku} is not on PO {po}. Add it to the PO?",
    item_not_on_po_add: "Add to PO",
    item_po_progress: "PO {received} / {expected}",

    // Pallet Receiving
    pallet_receiving: "Inbound",
    pallet_receiving_short: "Inbound",
    how_many_labels: "How many labels?",
    printing_label_n_of_m: "Printing {n} of {m}",
    print_partial_failed: "{failed} of {total} labels failed to print",
    scan_pallet: "Scan pallet",
    scan_loading_bay: "Scan location",
    pallet_loading_bay_only: "Scan a lane or storage location, not the scan sheet",
    pallet_already_placed: "Pallet already placed",
    pallet_unknown: "Unknown pallet",
    pallet_wrong_warehouse: "Pallet from another warehouse",
    void_label_mode: "Void label",
    scan_label_to_void: "Scan to void",
    pallet_voided: "Label voided",
    cannot_void_placed: "Already placed — can't void",
    pallets_pending_count: "{count} to place",
    pallets_today_count: "Today: {count}",
    pallets_all_placed: "All pallets placed",
    receive_more: "Receive more",
    scan_to_place: "Scan to place",
    printed_n_labels: "Printed {count} labels",
    inbound_stock_type_prompt: "What type of stock?",
    inbound_stock_type_required: "Choose a stock type first",
    inbound_stock_type_unknown: "Stock type no longer exists — reload the page",
    inbound_print_prompt: "Print {count} labels",
    inbound_supplier: "Supplier",
    inbound_supplier_required: "Choose a supplier first",

    // Goods In > Inbound settings (stock types printed on inbound labels)
    inbound_settings: "Inbound settings",
    inbound_stock_types: "Stock types",
    inbound_stock_types_hint: "The types the operator picks from when printing inbound labels, e.g. Envelopes, Parcels, Pallets. The code becomes the barcode prefix (ENV-NP-20260915-001) and the name is printed on the label. With no types set up there is no prompt and labels use the P prefix.",
    inbound_stock_types_none: "No types — labels print with the P prefix and no prompt",
    inbound_stock_type_name: "Name",
    inbound_stock_type_name_placeholder: "e.g. Envelopes",
    inbound_stock_type_code: "Code",
    inbound_stock_type_code_placeholder: "e.g. ENV",
    inbound_stock_type_add: "Add type",
    inbound_stock_type_remove: "Remove {name}",
    inbound_stock_type_code_invalid: "Code must be 1–4 letters or digits",
    inbound_stock_type_duplicate: "That name or code is already used",
    inbound_pallet_age_thresholds: "Age warnings",
    inbound_pallet_age_thresholds_hint: "On the Inbound dashboard a placed pallet turns amber after the first number of days and red after the second. Blank switches the warning off.",
    inbound_pallet_age_warn_days: "Amber after",
    inbound_pallet_age_alert_days: "Red after",

    // Stock check — inbound pallets parked at the location
    stock_check_location_rescan: "That's the location you're checking — scan an item",
    stock_check_pallet: "Inbound pallet",
    stock_check_pallet_was_missing: "was missing",
    stock_check_pallet_rehomed: "{pallet} moved here from {from}",
    stock_check_pallet_not_placed: "{pallet} hasn't been placed yet — nothing to check",
    stock_check_pallet_processed: "{pallet} has already gone to the scan sheet",
    stock_check_pallets_flagged_missing: "{count} pallet(s) flagged missing",
    stock_check_pallets_unseen_body: "{count} inbound pallet(s) recorded here were not scanned. They will be flagged missing, not written off.",

    // Stock check — pallet crates stored inside the location (2026-10-26)
    stock_check_crate: "Crate",
    stock_check_crate_units: "{count} units",
    stock_check_crate_in: "in {location}",
    stock_check_crate_rehomed: "Crate {crate} moved here from {from}",
    stock_check_crate_wrong_warehouse: "Crate {crate} belongs to another warehouse",
    stock_check_crate_other: "That's crate {crate} — finish this crate first",
    stock_check_crate_blocked: "Crate {crate} can't be moved here right now",
    stock_check_not_a_crate: "That tote has no stock stored in it",
    stock_check_crates_flagged_missing: "{count} crate(s) flagged missing",
    stock_check_crates_unseen_body: "{count} crate(s) recorded here were not scanned. They will be flagged missing, not written off.",

    // Admin > Warehouse > Inbound (pallet dashboard)
    inbound_admin_title: "Inbound",
    inbound_admin_hint: "Every inbound pallet label: where it is, how long it has waited, and who last scanned it. Pallets are not stock — they only appear here, on Move, and in stock checks of the location they are parked in.",
    warehouse_tile_inbound_desc: "Pallets printed, parked, missing, delivered",
    inbound_admin_status_pending: "Printed",
    inbound_admin_status_placed: "Placed",
    inbound_admin_status_missing: "Missing",
    inbound_admin_status_processed: "Processed",
    inbound_admin_status_voided: "Voided",
    inbound_admin_tile_pending: "Labels to place",
    inbound_admin_tile_in_lanes: "In loading bays",
    inbound_admin_tile_in_storage: "In storage",
    inbound_admin_tile_missing: "Missing",
    inbound_admin_tile_processed_today: "To scan sheet today",
    inbound_admin_tile_oldest: "Oldest waiting",
    inbound_admin_col_pallet: "Pallet",
    inbound_admin_col_type: "Type",
    inbound_admin_col_supplier: "Supplier",
    inbound_admin_col_status: "Status",
    inbound_admin_col_location: "Location",
    inbound_admin_col_printed: "Printed",
    inbound_admin_col_age: "Age",
    inbound_admin_col_at_location: "At location",
    inbound_admin_col_last_seen: "Last seen",
    inbound_admin_col_by: "By",
    inbound_admin_group_by_location: "Group by location",
    inbound_admin_export: "Export CSV",
    inbound_admin_search_hint: "Search pallet ID, location or supplier",
    inbound_admin_none: "No pallets match",
    inbound_admin_no_location: "No location",
    inbound_admin_pallets_here: "{count} pallets",
    inbound_admin_history_title: "Pallet history",
    inbound_admin_event_printed: "Label printed",
    inbound_admin_event_placed: "Placed at {location}",
    inbound_admin_event_moved: "Moved {from} → {to}",
    inbound_admin_event_missing: "Flagged missing at {location}",
    inbound_admin_event_processed: "Delivered to scan sheet",
    inbound_admin_event_voided: "Label voided",
    inbound_admin_source_place: "Inbound",
    inbound_admin_source_move: "Move",
    inbound_admin_source_stock_check: "Stock check",
    inbound_admin_source_admin: "Admin",
    inbound_admin_action_reprint: "Reprint label",
    inbound_admin_action_void: "Void label",
    inbound_admin_action_found: "Mark found at…",
    inbound_admin_action_force_process: "Mark processed",
    inbound_admin_found_prompt: "Scan or type the location barcode where {pallet} was found",
    inbound_admin_found_done: "{pallet} is now at {location}",
    inbound_admin_force_process_confirm: "Mark {pallet} as processed? It will leave the Move queue.",
    inbound_admin_void_confirm: "Void label {pallet}? Only printed, unplaced labels can be voided.",
    inbound_admin_reprinted: "Label reprinted",
    inbound_admin_age_days: "{days}d",
    inbound_admin_age_hours: "{hours}h",

    // Move (inbound pallet → scansheet handoff)
    move: "Move",
    move_go_to_lane: "Go to Lane",
    move_pallets_in_bay: "{count} pallets in this lane",
    move_choose_another_bay: "Choose another bay",
    move_scan_pallet: "Scan pallet",
    move_scan_scansheet: "Scan destination",
    move_inbound_processing_only: "That location can't hold a pallet",
    move_stored_at: "Moved to {location} — still to do",
    move_pallet_was_missing: "This pallet was flagged missing — delivering it clears that",
    move_all_caught_up: "All caught up",
    move_pallets_to_move: "{count} to move",
    move_no_inbound_location: "No scansheet location set — print one in Goods In settings",
    pallet_already_processed: "Pallet already processed",
    pallet_not_placed: "Pallet not in a loading bay",

    locations_col_type: "Type",

    // Developer / Demo
    developer_settings: "Developer",
    demo_mode: "Demo Mode",
    demo_mode_hint: "Show demo barcode buttons on scan pages (Book In, Inbound, Move, Put Away, Dispatch). Stored per device.",
    demo_mode_super_admin_only: "SuperAdmin Only",
    demo_mode_super_admin_only_hint: "When on, only SuperAdmin users see demo barcodes. When off, both Admins and SuperAdmins see them. Basic users never see demo barcodes. Stored per device.",
    label_batch_position: "{n} / {total} in batch",
    label_today_position: "#{n} today",
    decrease: "Decrease",
    increase: "Increase",

    // Admin Settings
    settings: "Settings",
    warehouses_settings: "Warehouses",
    warehouses_settings_hint: "Add or review the warehouses configured in this Portal. Each warehouse is grouped by country (used by the Inventory page's UK / EU pills). Hide a dormant site to take it out of every picker, filter and report without touching its data; delete only removes a warehouse nothing references.",
    country_col: "Country",
    warehouse_add: "Add Warehouse",
    warehouse_name_placeholder: "e.g. Manchester",
    country_placeholder: "e.g. UK",
    warehouse_added: "Warehouse {name} added",
    warehouse_already_exists: "A warehouse with that name already exists",
    warehouse_edit: "Edit Warehouse",
    warehouse_updated: "Warehouse {name} updated",
    warehouse_rename_warning_title: "Renaming this warehouse",
    warehouse_rename_warning_body: "The warehouse name is the canonical ID referenced by every users, totes, book-in, scan-log, and inventory row. Renaming cascades the change across every table and collection — but if any reference is missed (e.g. a future table not yet wired up), it'll silently keep pointing at the old name. Only rename when you're sure.",
    warehouse_rename_confirm_label: "Type {name} to confirm",
    warehouse_rename_confirm_mismatch: "Confirmation text doesn't match the current warehouse name",
    warehouse_renamed: "Renamed {from} → {to}",
    warehouse_renamed_partial: "Renamed to {name}, but these collections need a manual fix: {failures}",
    warehouse_hide: "Hide warehouse",
    warehouse_show: "Show warehouse",
    warehouse_hide_hint: "Hide — removes it from every warehouse picker, filter and report. Data is kept.",
    warehouse_show_hint: "Show — put it back in the warehouse pickers, filters and reports.",
    warehouse_hidden_pill: "Hidden",
    warehouse_hidden: "{name} hidden — it no longer appears in pickers, filters or reports",
    warehouse_shown: "{name} is visible again",
    warehouse_delete: "Delete Warehouse",
    warehouse_delete_checking: "Checking what uses this warehouse…",
    warehouse_delete_unused: "Nothing references {name}. Deleting removes it from the warehouse list.",
    warehouse_delete_in_use: "{name} can't be deleted — it's still referenced by:",
    warehouse_delete_in_use_hint: "Clear or move this data first, then try again. Deleting a warehouse never deletes its data.",
    warehouse_delete_unchecked: "Couldn't check: {sources}. Try again once these are reachable.",
    warehouse_delete_confirm_label: "Type {name} to confirm deletion",
    warehouse_delete_history_note: "Historical scan, sort and conveyor logs mentioning this warehouse are kept and don't block deletion.",
    warehouse_deleted: "Warehouse {name} deleted",
    warehouse_delete_failed: "Failed to delete warehouse",
    rows_count: "{count} rows",
    rows_count_capped: "{count}+ rows",
    goods_in_settings: "Goods In",
    scan_sheet_settings: "Scan Sheet",
    sorting_settings: "Sorting",
    sorter_1_settings: "Sorter 1",
    sorter_2_settings: "Sorter 2",
    default_timer_target: "Default Time Target",
    default_timer_target_hint: "Default progress-bar target in milliseconds. Leave blank to use the app default. Lower values = tighter gamification.",
    location_timer_targets: "Location Time Targets",
    location_timer_targets_hint: "Sets the progress-bar target (in milliseconds) per location prefix (first 6 characters of the scanned barcode). Leave blank to use the app default.",
    sorting_shared_lighting: "Lighting (all sorters)",
    sorting_lighting_hint: "Moving-head light configuration shared by Sorter 1, Sorter 2 and Pick & Sort. Colours and agents are global; brightness and auto-off are per warehouse.",
    sorter_bays_grid: "Bays & light grid",
    sorter_bay_no_label: "Sorter 2 bay number",
    sorter_no_locations: "No existing locations found for this bay. Check the bay number matches the location codes (e.g. 01 in NPS201A1).",
    home_modules_settings: "App Modules",
    home_modules_settings_hint: "Per warehouse, choose which App modules — and their sub-pages — are visible to each user role. Expand a parent row to configure its children.",
    module_col: "Module",
    role_super_admin: "SuperAdmin",
    // Position compatibility layer (9 positions replacing the 3 legacy
    // ranks) — labels for the position select / list / filter UI.
    position_admin: "Admin",
    position_manager: "Manager",
    position_supervisor: "Supervisor",
    position_team_leader: "Team Leader",
    position_assistant_team_leader: "Assistant Team Leader",
    position_site_assistant: "Site Assistant",
    position_operative: "Operative",
    position_marketing: "Marketing",
    position_customer_service: "Customer Service",
    legacy_value: "legacy",
    // Access Control editor (Settings > Access Control) — position/user
    // permission matrix, replacing App Modules as the source of truth
    // once a warehouse's mode is "active".
    access_control_settings_note: "Looking for the new position/user permission matrix?",
    access_control_settings_link: "Open Access Control",
    access_control_settings_title: "Access Control",
    ac_title: "Access Control",
    ac_tables_missing: "Access control tables are not set up yet (migration 193 has not run). Saving is disabled until this is fixed.",
    ac_preview_only_banner: "Preview only — App Modules is still in charge. Changes here take effect once access control is switched on.",
    ac_revision_conflict: "Someone else saved changes while you were editing. Reload the latest rules and try again.",
    ac_reload_and_retry: "Reload and retry",
    ac_view_matrix: "Matrix",
    ac_view_users: "Users",
    ac_view_preview: "Preview as…",
    ac_view_changelog: "Change log",
    ac_view_parity: "Parity",
    ac_view_snapshots: "Snapshots",
    ac_pending_changes: "{count} unsaved change(s)",
    ac_no_pending_changes: "No unsaved changes",
    ac_gated_by_area: "Inactive: the {area} area is set to none for this position, so this cell has no effect until the area is granted.",
    ac_saved_revision: "Saved — rules are now at revision {revision}",
    ac_discard: "Discard",
    ac_defaults_tab: "Defaults",
    ac_filter_placeholder: "Filter by label or key...",
    ac_key_col: "Permission",
    ac_menu_tag: "Menu",
    ac_floor_note: "Enforced floor: {floor}",
    ac_admin_locked: "Admin always has full access — this cannot be changed here.",
    ac_inherited_from_default: "Inherited from the Defaults tab",
    ac_inherited_from_code_default: "Inherited from the built-in default",
    ac_inherited_from_position: "Inherited from the position",
    ac_user_override_beats_position: "A user override beats the position rule",
    ac_group_goods_in: "Goods In",
    ac_group_conveyor: "Conveyor",
    ac_group_handheld: "Handheld",
    ac_group_dispatch: "Dispatch",
    ac_group_admin_overview: "Admin Overview",
    ac_group_admin_warehouse: "Admin Warehouse",
    ac_group_admin_catalogue: "Admin Catalogue",
    ac_group_admin_people: "Admin People",
    ac_group_admin_settings: "Admin Settings",
    ac_group_company: "Company-wide",
    users_action_not_granted: "You don't have permission for this action. Ask an Admin to grant it in Access Control.",
    ac_view_fixed: "Fixed rules",
    ac_fixed_intro: "These rules hold whatever the matrix says. A matrix cell cannot grant past them.",
    ac_fixed_floors_title: "Actions limited to a position",
    ac_fixed_floors_hint: "Checked before the matrix. Below the listed position the answer is always no; at or above it, the matrix row must still grant the permission.",
    ac_fixed_guards_title: "Account and system rules",
    ac_fixed_col_action: "Action",
    ac_fixed_col_who: "Who",
    ac_fixed_col_row: "Matrix row",
    ac_fixed_col_why: "Why it is fixed",
    ac_fixed_admin_only: "Admin only",
    ac_fixed_manager_admin: "Manager and Admin",
    ac_fixed_none: "No fixed rules reported by the server.",
    ac_floor_access_control: "Change access rules, take or restore a snapshot",
    ac_floor_warehouses: "Create, rename, hide or delete a warehouse",
    ac_floor_maintenance: "Maintenance actions (clear put-away queue, reset totes, seed picking demo)",
    ac_floor_remove_batch_data: "Remove batch data",
    ac_floor_network_access: "View or edit the IP allow-list, login activity and blocked attempts",
    ac_floor_saved_logins: "Let devices save Portal login details (Settings › Login screen)",
    ac_floor_why_saved_logins: "On shared devices a saved login signs the next person in as someone else; switching it on affects every device at every site.",
    ac_floor_integrations_config: "Configure sales channels (create, edit, secrets, webhooks, catalogue sync, test calls, vendors)",
    ac_floor_carriers_config: "Configure carrier accounts and services, mint a webhook secret",
    ac_floor_legacy_maintenance: "Legacy maintenance routes (scan-item deletes, oranges, pallet items, LaaS test imports)",
    ac_floor_layout_delete: "Delete the warehouse layout",
    ac_floor_channel_rules: "Channel cut-offs and dashboard metrics (Settings › Dispatch)",
    ac_floor_integrations_live: "Live integration traffic (Amazon poll, push all stock, test shipment)",
    ac_floor_lockout_unlock: "Unlock a locked colour (after repeated wrong PINs)",
    ac_floor_carrier_environment: "Switch a carrier between training and live",
    ac_floor_carrier_claims: "Send carrier claims now",
    ac_floor_carrier_test_booking: "Run a carrier test booking (DPD / Cargus)",
    ac_floor_why_access_control: "Whoever could change the rules could grant themselves anything.",
    ac_floor_why_warehouses: "Changes the structure every rule hangs on.",
    ac_floor_why_maintenance: "Destructive and hard to undo.",
    ac_floor_why_remove_batch_data: "Destructive and hard to undo.",
    ac_floor_why_layout_delete: "Destructive and hard to undo.",
    ac_floor_why_integrations_live: "Talks to partners with real stock and money.",
    ac_floor_why_lockout_unlock: "Security action.",
    ac_floor_why_carrier_environment: "Live mode books real waybills.",
    ac_floor_why_carrier_claims: "Sends real claims to the carrier.",
    ac_floor_why_carrier_test_booking: "Calls the carrier with real credentials (a dry run, but still outbound).",
    ac_guard_admin_always: "Admin always has every permission in every warehouse and cannot be restricted.",
    ac_guard_downstream: "Permissions run downstream: an Admin manages every account below Admin, a Manager every account below Manager, and nobody edits, suspends, deactivates or resets the password of a peer. Only an Admin creates an Admin.",
    ac_guard_own_details: "Your own name, email, username and warehouse are yours to change; nobody else edits an Admin's.",
    ac_guard_own_position: "Nobody changes their own position.",
    ac_guard_self_actions: "Nobody deactivates, suspends or forces a password change on their own account.",
    ac_guard_concurrent_sessions: "Only an Admin can allow an account to be signed in on several devices at once.",
    ac_guard_location_barcode: "Only an Admin can change a location's barcode.",
    ac_guard_legacy_levels: "In legacy and shadow mode every route also keeps its old rank level (basic, admin, superAdmin). In active mode the matrix decides.",
    ac_no_access: "You don't have access to Access Control. Ask an Admin to grant it in the matrix.",
    ac_users_search_placeholder: "Search by name, warehouse or UID...",
    ac_users_none_found: "No users found",
    ac_users_select_hint: "Select a user to see and edit their overrides.",
    ac_users_unknown_position: "This user's position could not be determined.",
    ac_users_override_hint: "Overrides for this user only — these beat the {position} position rule.",
    ac_preview_position: "Position",
    ac_preview_uid: "User ID (optional)",
    ac_preview_uid_placeholder: "e.g. 42",
    ac_preview_resolved: "Resolved",
    ac_preview_source: "Source",
    ac_preview_legacy: "Legacy",
    ac_audit_when: "When",
    ac_audit_who: "Who",
    ac_audit_subject: "Subject",
    ac_audit_change: "Change",
    ac_audit_empty: "No changes recorded yet.",
    ac_audit_load_older: "Load older",
    ac_parity_warehouses: "Warehouses",
    ac_parity_cells: "Cells compared",
    ac_parity_differences: "Differences",
    ac_parity_reductions: "Reductions",
    ac_parity_widenings: "Widenings",
    ac_parity_migrated_ok: "Migrated positions: every difference decided (cutover check passes)",
    ac_parity_migrated_undecided: "Migrated positions: undecided differences",
    ac_parity_new_positions: "New positions (no legacy equivalent, informational)",
    ac_parity_kind: "Kind",
    ac_parity_rules_col: "Access Control",
    ac_parity_none: "No differences found.",
    ac_snapshot_reason_placeholder: "Reason for this snapshot (optional)",
    ac_snapshot_take: "Take snapshot",
    ac_snapshot_when: "Taken",
    ac_snapshot_reason: "Reason",
    ac_snapshot_revision: "Revision",
    ac_snapshot_rule_count: "Rules",
    ac_snapshot_restore: "Restore",
    ac_snapshot_empty: "No snapshots yet.",
    ac_snapshot_restore_title: "Restore this snapshot?",
    ac_snapshot_restore_body: "This replaces the current rules with the ones stored in this snapshot. This cannot be undone from here — take a fresh snapshot first if you want to keep the current state.",
    warehouse_menu_title: "Warehouse",
    search_admin_placeholder: "Search admin pages...",
    search_no_results: "No results",
    search_min_chars: "Type at least {n} characters",
    search_view_all_in: "View all in {section} →",
    search_in_placeholder: "Search {section}...",
    admin_search_section_pages: "Pages",
    book_in_settings: "Book In",
    warehouse_col: "Warehouse",
    allow_duplicate_barcodes: "Allow duplicates",
    allow_duplicate_barcodes_hint: "Own tote only. When off, the same barcode cannot be scanned twice into the tote the operator has open. It does not look at stock already on the shelves — that is 'Check for duplicates'. Turn on for warehouses where stock is booked in by bulk weight rather than by individual unit.",
    send_to_ppd: "Send to PPd",
    send_to_ppd_hint: "When on, completed totes are posted to the PPd goods-in API (same channel the conveyor uses for completed chutes).",
    zone_dispatch_via_portal: "Sorter 2 → Portal dispatch",
    zone_dispatch_via_portal_hint: "When on, closing a tag on the Sorter 2 Unloader binds the tote to the Portal order, allocates its stock and sends the order to Portal's dispatch queue instead of PPd. The opening tag scan then checks the tote is free and the order is ready.",
    zone_singles_dispatch_via_portal: "Singles lane → Portal dispatch",
    zone_singles_dispatch_via_portal_hint: "When on, the Sorter 1 singles lane scan binds every one-unit order on the tag to the tote, allocates their stock and sends them to Portal's dispatch queue instead of PPd. The tag is refused whole if any item fails, and the opening tag scan checks the tote is free.",
    zone_reauction_via_portal: "Unsold Reauction → Portal stock move",
    zone_reauction_via_portal_hint: "When on, Sorter 1 loaders move Unsold Reauction items out of their Portal stock location into a reauction tote mapped to the bay (scan the tote to open it; scan it again on SCAN ITEM to close it into the Put Away queue), and a conveyor reauction pallet's items go onto the pallet tote in Portal (sorter chute: moved from stock; goods-in BLUE: booked in as new stock). The conveyor Add Pallet scan is then checked against Portal totes. PPd is no longer called for reauction pallets while this is on.",
    zone_grey_write_off_via_portal: "Unsold Grey → Portal write-off",
    zone_grey_write_off_via_portal_hint: "When on, confirming a Sorter 1 slot for an Unsold Grey item writes one unit of that SKU off Portal stock, and the conveyor's items message for an Unsold Grey chute writes one unit per distinct SKU on the pallet off (the oldest unallocated unit at a storage location; reason Unsold grey in Stock Control › Write Off › History). No stock found = nothing written off; the loader is warned and the conveyor logs it.",
    allocate_on_ingest: "Allocate stock on arrival",
    allocate_on_ingest_hint: "When on, every order that lands at this warehouse claims its stock straight away (oldest stock first) and is hidden from the pick queues — it reaches dispatch through the Sorter 2 / singles close. If stock is short the order waits On Hold and is released when stock arrives. When off, stock is allocated at wave build or at the Sorter close as before.",
    zone_portal_dispatch_settings: "Portal dispatch",
    zone_portal_dispatch_hint: "Per-warehouse cut-over from PPd to Portal dispatch. Off keeps today's behaviour: the closing scan only records the tag and the PPd poller picks it up.",
    allow_multi_user_book_in: "Multi-User Book In",
    allow_multi_user_book_in_hint: "When on, an in-progress tote opened by one operator can be picked up and added to by ANY operator. When off (default) only the original operator can resume; others see a 'tote in use' message.",
    allow_tote_reopen: "Allow Re-open",
    allow_tote_reopen_hint: "When on, a closed tote can be re-opened from book-in to add more items. When off (default for PPd warehouses) the close is final — operators must scan the next available tote.",
    bulk_qty_book_in: "Bulk Qty",
    bulk_qty_book_in_hint: "When on, after each item scan a small popup asks the operator how many of that SKU went into the tote. Lets a single scan stand in for many units instead of forcing one scan per item.",
    manifest_required_book_in: "Manifest Required",
    manifest_required_book_in_hint: "When on (default), an item can only be booked in if its SKU is on a manifest, and tote close fails if manifest quantity can't cover the receipt. When off, any product in the Portal catalogue can be booked in — quantity not covered by a manifest is received at zero cost.",
    book_in_duplicate_stock_check: "Check for duplicates",
    book_in_duplicate_stock_check_hint: "Whole warehouse. When on, a scan is rejected if its SKU already has stock at an in-transit or sellable location anywhere in this warehouse, and the operator is told to give the product to a leader. Only products whose supplier has 'Allow duplicates' switched off are checked (Warehouse › Suppliers). Red and yellow totes are never checked. Unlike 'Allow duplicate barcodes', which only looks at the operator's own tote.",
    bulk_qty_title: "Set quantity",
    bulk_qty_open: "Edit quantity",
    bulk_qty_qty_label: "Qty",
    toggle_blocked_by_ppd: "Send to PPd is on — re-open and multi-user must stay off",
    cannot_reopen: "Tote was closed by {name} — re-opening isn't allowed at this warehouse",
    tote_holds_picked_stock: "Tote holds picked stock from Drop or Picking — put it away there, not here",
    warehouse_toggles: "Warehouse Toggles",
    warehouse_toggles_hint: "Per-warehouse feature flags that apply to Book In.",
    no_warehouses: "No warehouses configured",
    po_timer_targets: "Time Targets",
    po_timer_targets_hint: "Sets the progress-bar target (in milliseconds) per PO. Leave blank for the default 4000ms. Lower values = tighter gamification.",
    custom_short: "custom",

    // Totes admin
    totes_settings: "Totes",
    totes_settings_hint: "Manage the list of tote IDs by uploading an XLSX spreadsheet. Each row has an action (add, update, remove), a tote_id, and a type (box or pallet).",
    totes_download_template: "Download template",
    totes_download_current: "Download current",
    totes_print_labels_n: "Print labels ({count})",
    totes_print_label: "Print label",
    totes_print_labels_title: "Print tote labels",
    totes_print_labels_hint: "{count} tote(s) from the current filters. Untick any you don't need. The label size is remembered on this device.",
    totes_print_label_hint: "Tote {tote}. The label size is remembered on this device.",
    totes_upload_csv: "Upload CSV",
    orders_bulk_actions: "Bulk actions",
    totes_upload_xlsx: "Upload XLSX",
    totes_upload_empty: "Spreadsheet is empty",
    totes_upload_bad_header: "Spreadsheet must have action and tote_id columns",
    totes_upload_parse_error: "Could not read spreadsheet — make sure it's a valid .xlsx file",
    totes_bulk_summary: "Added {added}, updated {updated}, removed {removed}",
    totes_row_label: "Row {row}",
    totes_count: "{count} totes",
    totes_col_tote_id: "Tote ID",
    totes_col_type: "Type",
    totes_col_status: "Status",
    totes_col_warehouse: "Warehouse",
    totes_col_last_user: "Last User",
    totes_col_updated_at: "Updated At",
    totes_col_totes: "Totes",
    totes_total_label: "Total totes",
    totes_upload_progress: "Processing {done} of {total} rows",

    // Put-away queue admin
    putaway_queue_title: "Putaway Queue",
    putaway_queue_hint: "Every tote currently awaiting put-away across all warehouses you can see. Use the warehouse pills to narrow to one site. The queue refreshes automatically while this page is visible.",
    putaway_queue_tile_desc: "Totes waiting to be put away",
    putaway_queue_download_current: "Download current",
    putaway_queue_search_hint: "Search tote ID",
    putaway_queue_filter_source: "Source",
    putaway_queue_filter_category: "Category",
    putaway_queue_filter_type: "Type",
    putaway_queue_total_totes: "Total totes",
    putaway_queue_units_remaining: "Units remaining",
    putaway_queue_oldest_waiting: "Oldest waiting",
    putaway_queue_col_tote: "Tote",
    putaway_queue_col_warehouse: "Warehouse",
    putaway_queue_col_type: "Type",
    putaway_queue_col_closed: "Closed",
    putaway_queue_col_closed_by: "Closed by",
    putaway_queue_col_age: "Age",
    putaway_queue_col_units: "Units",
    putaway_queue_col_category: "Category",
    putaway_queue_col_source: "Source",
    putaway_queue_units_of: "{remaining} of {total}",
    putaway_queue_category_none: "None",
    putaway_queue_source_drop: "Drop",
    putaway_queue_type_box: "Box",
    putaway_queue_type_pallet: "Pallet",
    putaway_queue_no_rows: "No totes match the current filters.",
    putaway_queue_age_minutes: "{minutes}m",
    putaway_queue_age_hours: "{hours}h",
    putaway_queue_age_hours_minutes: "{hours}h {minutes}m",
    putaway_queue_age_days: "{days}d",
    putaway_queue_age_days_hours: "{days}d {hours}h",

    // Put Away
    put_away: "Put Away",
    invalid_location: "Not a valid location",
    not_a_tote: "Not a valid tote",
    put_away_awaiting_location: "Awaiting location",
    put_away_tote_closed: "Tote closed",
    // Pallet crates: the crate barcode is also its storage location.
    put_away_crate_sub: "Crate — scan it again to put everything away into {tote}",
    put_away_crate_close: "Close crate {tote}",
    put_away_sub_tote: "Closed totes only",
    put_away_category_mode: "Tote Category",
    put_away_mode_toggle: "Put Away / Tote Category / Empty High Locations",
    put_away_category_sub: "Scan a tote to see its category",
    put_away_category_none: "No category",
    put_away_category_never_booked_in: "Tote has never been booked in",
    put_away_high_mode: "Empty High Locations",
    put_away_high_sub_anchor: "Scan the high location you're at",
    put_away_high_go_to: "Go to",
    put_away_high_sub_arrive: "Scan it when you arrive",
    put_away_high_sub_none: "Scan another high location",
    put_away_high_none: "No empty high locations",
    put_away_high_from: "From {location}",
    put_away_high_change: "Change location",
    put_away_high_missing: "Location doesn't exist",
    put_away_high_missing_title: "Location doesn't exist?",
    put_away_high_missing_body: "This location will be marked unsellable and won't be suggested again. Confirm it isn't physically there.",
    put_away_high_missing_confirm: "Doesn't exist",
    put_away_high_missing_done: "{location} marked unsellable",
    put_away_high_not_high: "Not a high location",
    put_away_high_wrong_location: "Scan the suggested location: {location}",
    put_away_high_zones_title: "Empty high locations",
    put_away_high_zones_hint: "Empty locations per zone, in walk order.",
    // Consolidate — the Empty High Locations pill's second view (Pembroke only)
    put_away_high_view_toggle: "Empties / Consolidate",
    put_away_high_view_empty: "Empties",
    put_away_high_view_consolidate: "Consolidate",
    put_away_consolidate_sub_tote: "Scan an empty tote to consolidate into",
    put_away_consolidate_sub_anchor: "Scan the high location you're at",
    put_away_consolidate_sub_arrive: "Scan it when you arrive — or tap the pin to go somewhere else",
    put_away_consolidate_sub_items: "Scan each item onto your tote",
    put_away_consolidate_units: "{count} to move",
    put_away_consolidate_on_tote: "{count} on tote",
    put_away_consolidate_none: "Nothing left to consolidate",
    put_away_consolidate_location_empty: "Nothing left here — moving on",
    put_away_consolidate_change_body: "Scan the location you're moving to. This one stays on the list.",
    put_away_consolidate_skipped: "{location} skipped",
    put_away_consolidate_tote_full: "Tote full",
    put_away_consolidate_tote_full_title: "Tote full — leave this location?",
    put_away_consolidate_tote_full_body: "{location} won't be suggested again until something is picked from it.",
    put_away_consolidate_tote_full_confirm: "Confirm - Tote Full",
    put_away_consolidate_reopen_title: "Reopen tote?",
    put_away_consolidate_reopen_body: "Tote {tote} was closed with {units} units on it. Reopen it to carry on filling it?",
    put_away_consolidate_reopen_confirm: "Reopen",
    put_away_consolidate_close_title: "Close Tote",
    put_away_consolidate_close_body: "Close it and send it to put-away, or close it and put it away now. Scanning the tote again closes it to put-away. This ends your walk.",
    put_away_consolidate_close_confirm: "Close",
    put_away_consolidate_close_put_away: "Close & Put Away",
    put_away_consolidate_next_location: "Next location",
    put_away_consolidate_not_here_btn: "Not here",
    put_away_consolidate_not_here_btn_aria: "Not here: {title}",
    put_away_consolidate_write_off_title: "Write off stock?",
    put_away_consolidate_write_off_body: "{qty} × {title} is recorded at {location} but isn't there. It will be written off.",
    put_away_consolidate_write_off_confirm: "Write off",
    put_away_consolidate_written_off: "{title} written off",
    put_away_consolidate_write_off_allocated: "Reserved for an order — it can't be written off here",
    put_away_consolidate_swap_title: "Change Tote?",
    put_away_consolidate_swap_body: "Scan tote {tote} again or tap Confirm to carry on into it. Anything already moved stays in tote {current} and goes to put-away.",
    put_away_consolidate_swap_confirm: "Confirm",
    put_away_consolidate_closed_toast: "Tote {tote} was sent to put-away.",
    put_away_consolidate_closed_empty_toast: "Tote {tote} was empty — released.",
    put_away_consolidate_take_tote: "Take the empty tote: {totes}",
    put_away_consolidate_not_here: "That item isn't recorded at this location",
    put_away_consolidate_on_wave: "Leave it — a picker is on the way for this",
    put_away_consolidate_reserved: "Leave it — an order needs this and there's none elsewhere",
    put_away_consolidate_book_in_title: "Not recorded here",
    put_away_consolidate_book_in_body: "{title} isn't recorded at {location}. Book one in here and move it onto your tote?",
    put_away_consolidate_book_in_confirm: "Book it in and move",
    put_away_consolidate_booked_in: "{title} booked in and moved",
    put_away_consolidate_none_left: "None of that left here",
    put_away_consolidate_tote_in_move_stock: "Tote {tote} is open in Move Stock — finish it there",
    put_away_consolidate_resumed: "Back on tote {tote}",
    put_away_consolidate_resume_title: "Unfinished consolidation",
    put_away_consolidate_resume_body: "Tote {tote} has {units} items on it. Resume, or close the tote and send it to put-away.",
    put_away_consolidate_resume_confirm: "Resume",
    put_away_consolidate_resume_close: "Close tote",
    put_away_consolidate_zones_title: "Locations to consolidate",
    put_away_consolidate_zones_hint: "Locations with 1–2 units per zone, in walk order.",
    put_away_consolidate_not_available: "Consolidate isn't available at this warehouse",
    move_stock_tote_in_consolidate: "Tote {tote} is open in Put Away → Consolidate — finish it there",
    put_away_temp_cold: "Cold putaway",
    put_away_cold_sub_anchor: "Scan where you are",
    put_away_cold_sub_tote: "Scan the tote — closed Cold totes only",
    put_away_cold_sub_location: "Scan the location to confirm",
    put_away_cold_wrong_category: "This tote isn't marked Cold",
    put_away_cold_now_occupied: "Someone beat you to it — here's the next one",
    put_away_cold_occupied_btn: "Stock already here",
    put_away_cold_cancel: "Cancel",
    put_away_found_sub_location: "Scan this location to confirm you're there",
    put_away_found_sub_tote: "Scan the tote that's already here",
    put_away_found_release_cmd: "Tote found",
    put_away_found_sub_release: "This tote is still awaiting putaway",
    put_away_found_release: "Release into this location",
    put_away_found_count_cmd: "Scan items",
    put_away_found_sub_count: "Scan every item here, then Finish",
    put_away_found_count_empty: "Nothing is recorded here yet — each item you scan can be booked in",
    put_away_found_finish: "Finish",
    put_away_found_finish_title: "Finish counting?",
    put_away_found_finish_body: "Anything you haven't scanned won't be recorded here.",
    put_away_found_add_yes: "Book it in",
    put_away_found_released: "{tote} released into {location}",
    put_away_found_finished: "{count} booked into {location}",
    put_away_found_sub_dest: "Scan the location to put these {count} away into",
    put_away_found_moved: "{count} moved to {location}",
    put_away_found_dest_on_wave: "Stock here is on a picking wave — it has to stay",
    put_away_sub_loc: "Any location barcode",
    put_away_sub_item_or_loc: "Item or location",
    put_away_sub_item_location: "Location for {item}",
    put_away_item_location_title: "Location for",
    scan_item_or_location: "Scan Item/Loc",
    scan_not_recognised: "Not a known item or location",

    // Put Away admin settings
    put_away_settings: "Put Away",
    put_away_warehouse_toggles: "Warehouse Toggles",
    put_away_warehouse_toggles_hint: "Per-warehouse feature flags that apply to Put Away.",
    allow_item_level_put_away: "Item-Level",
    allow_item_level_put_away_hint: "When on, operators can put away one item at a time (scan tote → item → location). When the last in-tote item is moved, the tote returns to the available pool. Tote-level put-away still works either way.",
    allow_out_of_tote_put_away: "Off-Tote Items",
    allow_out_of_tote_put_away_hint: "When on, scanning an item that isn't in the tote but IS a known scansheet item still lets the operator put it away. Otherwise off-tote items show an error. Requires Item-Level.",

    // Picking admin settings
    picking_settings: "Picking",
    picking_settings_hint: "How waves are shaped, how stock is allocated, and which orders qualify as Large.",
    picking_alloc_method: "Stock Allocation",
    picking_alloc_method_hint: "How inventory is reserved when waves are generated. FIFO walks the oldest receipts first; Fastest scores each candidate location by proximity and temperature (see weights below).",
    picking_alloc_fifo: "FIFO (oldest first)",
    picking_alloc_fastest: "Fastest pick",
    picking_wave_shaping: "Wave Shape",
    picking_wave_shaping_hint: "How many orders end up in each wave, and how many highest-priority orders anchor a Pick & Sort wave. Priority: due to ship today before not yet due, then the earlier order date, then express before standard on the same day, then oldest first.",
    picking_pick_type_settings: "Pick Type Settings",
    picking_pick_type_settings_hint: "Settings that only apply to one pick type. Expand a type to view its wave-shaping rules and thresholds.",
    picking_pick_and_sort_settings: "Pick & Sort",
    picking_light_settings: "Single",
    picking_max_wave_orders: "Pick & Sort wave size",
    picking_pas_large_wave_enabled: "Large Pick & Sort waves (two bays)",
    picking_pas_large_wave_enabled_hint: "Pick up to twice as many orders in one walk and sort them across both Pick & Sort bays at once. When on, the wave size is chosen automatically: a queue holding a full Small wave's worth picks Large; a smaller tail picks Small.",
    picking_pas_large_wave_orders: "Large wave size",
    picking_pas_large_wave_orders_hint: "Ceiling for a Large wave. The actual size is capped by the two bays' enabled slots (e.g. 24 + 24 = 48).",
    picking_pas_large_max_items: "Large wave: max items per order",
    picking_pas_large_max_items_hint: "Orders with more items than this stay Pick & Sort but build into Small waves instead. 0 = no limit.",
    picking_pas_large_max_order_kg: "Large wave: max order weight",
    picking_pas_large_max_order_kg_hint: "Orders heavier than this stay Pick & Sort but build into Small waves instead. 0 = no limit.",

    // Putwall (Pembroke) — Settings > Picking > Putwall
    picking_put_wall: "Putwall",
    picking_put_wall_hint: "A Pick & Sort wave variant sorted on the Putwall (72 slots) instead of a bay. Only orders that fit whole into one tote go to the Putwall; the normal Pick & Sort queue leaves them out unless the picker ticks \"Include Putwall orders\". The wall itself is added as a bay under Sorting > Pick & Sort with the \"Putwall\" toggle.",
    picking_put_wall_enabled: "Putwall waves",
    picking_put_wall_enabled_hint: "Offer Putwall as a choice when a picker taps Pick & Sort. Also needs a Putwall bay under Sorting > Pick & Sort (Add Bay with the \"Putwall\" toggle).",
    picking_put_wall_wave_orders: "Putwall wave size",
    picking_put_wall_wave_orders_hint: "Ceiling for a Putwall wave. The actual size is capped by the Putwall's enabled slots (e.g. 72).",
    picking_put_wall_tote: "Tote",
    picking_put_wall_tote_hint: "Inside dimensions of the tote a Putwall order must fit into whole. Together with the fill % below this decides which orders are eligible.",
    picking_put_wall_tote_l_cm: "Tote length (cm)",
    picking_put_wall_tote_w_cm: "Tote width (cm)",
    picking_put_wall_tote_h_cm: "Tote depth (cm)",
    picking_put_wall_fill_pct: "Tote fill",
    picking_put_wall_fill_pct_hint: "How much of the tote's volume an order may use and still count as fitting. Nothing packs to 100% — 75% leaves room for awkward shapes.",
    picking_put_wall_min_orders: "Minimum Putwall orders",
    picking_put_wall_min_orders_hint: "When fewer eligible Putwall orders than this are waiting, the \"Include Putwall orders\" box on the Pick & Sort chooser starts ticked, so a thin Putwall pool is swept up by the normal Pick & Sort wave instead of sitting until it grows. 0 = never tick it automatically.",
    picking_put_wall_max_totes: "Totes per order",
    picking_put_wall_max_totes_hint: "How many totes an order may need and still go to the Putwall. The racking is one tote deep, so an order needing two totes gets two cubbies side by side and counts as two of the wall's slots; the sorter swaps to the second cubby when the first is full, and each cubby goes out in its own tote. 1 = only orders that fit one tote.",
    picking_unit_totes: "totes",
    // Paired Pick & Sort waves (migration 223).
    picking_pairing_settings: "Paired waves",
    picking_pairing_hint: "Two pickers on one Sorting or Putwall wave, each on their own aisles, so the wave reaches the bay roughly twice as fast. The wave is built exactly as today and cut once at an aisle boundary; the second half waits on the Pick Face as a Join card. If nobody joins, the first picker simply carries on into it with the same york. Large (two-bay) waves are never paired.",
    picking_ps_pairing_enabled: "Allow paired waves",
    picking_ps_pairing_enabled_hint: "Shows the \"Pick as a pair\" toggle on the Pick Queue and lets the Pick Advisor suggest pairs from the order cut-off (and earlier when a solo wave would miss the ship cut-off).",
    picking_ps_segment_split_pct: "First picker's share",
    picking_ps_segment_split_pct_hint: "Share of the wave's stops the first picker takes, 20-80%. The cut snaps to the nearest aisle change so the two never share an aisle.",
    picking_ps_pair_min_units: "Minimum wave size for a pair",
    picking_ps_pair_min_units_hint: "A wave is only split when it has MORE than this many units; smaller waves start as a normal wave even when a pair was asked for, and the Pick Advisor only suggests a pair above it. 0 = no minimum.",
    picking_ps_sort_on_first_segment: "Sort from the first half",
    picking_ps_sort_on_first_segment_hint: "On: the bay may enter a paired wave as soon as one half is picked; the other half's units are counted and topped up when it lands. Off: the bay waits for both halves.",

    // Putwall — the "Which wave?" page (/picking/choose) behind the
    // Pick Queue's Pick & Sort card
    picking_wave_chooser_title: "Which wave?",
    picking_wave_chooser_sorting: "Sorting",
    picking_wave_chooser_put_wall: "Putwall",
    picking_include_put_wall: "Include Putwall orders",
    picking_put_wall_empty: "No orders fit the Putwall right now",
    picking_put_wall_unavailable: "Putwall waves need the feature enabled and a configured Putwall bay",
    picking_put_wall_too_few: "No orders waiting for the Putwall",
    picking_wave_size: "Wave size",
    picking_wave_size_small: "Small",
    picking_wave_size_large: "Large",
    picking_large_wave_unavailable: "Large waves need the feature enabled and two configured Pick & Sort bays",
    picking_small_blocked: "The queue holds a full wave — a Large wave will be picked",
    picking_large_too_few: "Not enough orders for a Large wave — a Small wave will be picked",
    picking_light_max_wave_orders: "Single wave size",
    picking_anchor_count: "Anchor count",
    picking_anchor_count_hint: "How many highest-priority unfulfilled orders seed each Pick & Sort wave (due today first, then the earlier order date, then express before standard on the same day, then oldest first). The rest of the wave is filled with orders sharing SKUs with these anchors.",
    picking_auto_pause: "Auto-Pause",
    picking_auto_pause_hint: "Idle minutes before an active wave is automatically paused so another picker can claim it.",
    picking_lookahead: "Pre-load Locations",
    picking_lookahead_hint: "How many upcoming locations are pre-loaded on screen for Shelf Drop and Forecast Drop, so the picker sees the next target instantly with no round-trip wait. Picking (Single, Pick & Sort, Large) no longer uses this: the whole wave is loaded once at wave start and the device shows the next pick locally — Large still queues its next order only when the current one is fully picked. Recommended 2-3.",
    picking_large_settings: "Large",
    picking_large_settings_hint: "The single-order pick type: one order per wave, one tote at a time. What lands an order here, and what the picker is told when it does.",
    picking_large_thresholds: "Thresholds",
    picking_large_thresholds_hint: "An order is treated as Large (single-order wave, one tote at a time) if any threshold is exceeded. The three dimension limits are orientation-independent: an item's sides are sorted longest to shortest and compared against the three limits sorted the same way, so it doesn't matter which of the product's length/width/height fields holds the long side. Leave a field blank to skip that check — but note that blanking only one or two of the three dimension limits makes the item's longest side unlimited, and the remaining limits apply to its smaller sides; blank all three to skip the dimension check entirely.",
    picking_large_max_items: "Max items per order",
    picking_large_max_order_kg: "Max order weight (kg)",
    picking_large_max_order_cbm: "Max order volume (CBM)",
    picking_large_max_order_cbm_hint: "Total volume of the whole order in cubic metres — every line's length × width × height × quantity, added up (1 CBM = 1,000,000 cm³, so a 40 × 30 × 25 cm box is 0.03 CBM). Items with no recorded dimensions count as zero, so an order can still trip this limit on the lines that do have sizes. Use it to catch orders that are bulky without being heavy or containing any single oversized item. Unlike the other Large thresholds this one defaults to 0.15 CBM rather than blank — clear it to disable the check for a warehouse.",
    picking_large_max_item_grams: "Max item weight (g)",
    picking_large_max_item_l_cm: "Max item longest side (cm)",
    picking_large_max_item_w_cm: "Max item 2nd-longest side (cm)",
    picking_large_max_item_h_cm: "Max item shortest side (cm)",
    picking_large_roll_cages: "Roll cages",
    picking_large_roll_cages_hint: "These two do not classify anything — they size the roll-cage count shown to the picker when a Large order opens. They multiply: capacity × utilisation is what one cage is planned to hold.",
    picking_roll_cage_cbm: "Roll cage capacity (CBM)",
    picking_roll_cage_cbm_hint: "Internal volume of one roll cage at this warehouse, in cubic metres. Sites buy different cages, so measure yours rather than assuming — a standard UK cage is about 0.72 CBM (roughly 120 × 80 × 75 cm of usable space). This is the raw capacity; what the picker is actually planned against is this figure multiplied by the utilisation below. Leave it blank to fall back to the standard 0.72 CBM cage — blanking it does NOT turn the estimate off, blanking the utilisation does.",
    picking_roll_cage_utilisation_pct: "Roll cage utilisation",
    picking_roll_cage_utilisation_pct_hint: "Not a threshold — this is how the picker is told how many roll cages to fetch when they open a Large order. Nothing packs to 100%: boxes don't tessellate, awkward shapes waste the corners, and nobody stacks to the bar. This percentage of the capacity above is what a cage is planned to hold — at 70% of a 0.72 CBM cage that is 0.504 CBM, so an order summing to 0.6 CBM reads 1.2 roll cages. The figure is shown to the nearest tenth of a cage rather than rounded up to a whole one: most Large orders are a fraction of a cage, and “0.3” and “1.2” are different instructions where “1 cage” and “1 cage” are not. Items with no recorded dimensions add no volume, so the picking screen also names how many of them there are — the count is a floor, not a promise. Lower this if pickers keep coming back for another cage; raise it if they keep dragging an empty one. Clear the field to hide the estimate for a warehouse.",
    picking_require_location_scan: "Require Location Scan",
    picking_require_location_scan_hint: "Applies to Single, Pick & Sort, Large, Shelf Drop and Forecast Drop. When off, pickers walk by walk_order without confirming each per-line location with a scan. The starting-location scan that anchors the picker's position is always required on Large, Shelf Drop and Forecast Drop regardless of this setting (Single is allocated upfront and needs no starting-location scan). Scanning is the safer default.",
    auto_release_short: "Auto Release Short",
    auto_release_short_hint: "When on, an order that has been stock blocked for 30 minutes is released short automatically if at least one line can be picked: the missing units are marked on the order, it waves with what exists, and dispatch shows the marked units as missing for the refund. Orders with nothing pickable are always left for a manual decision. When off, blocked orders wait under Stock blocked until someone presses Release short.",
    picking_local_first_enabled: "Local-First Picking (Beta)",
    picking_local_first_enabled_hint: "When on, the entire wave + tote registry + barcode map ship to the picker's device on wave start. Scans validate locally for instant feedback and persist to the BE in the background. Off by default — enable per warehouse once verified.",
    picking_location_grouping_enabled: "Location-Commonality Grouping",
    picking_location_grouping_enabled_hint: "When on, a Pick & Sort wave is filled with the orders that add the fewest new storage locations to the wave — grouping orders that share the same boxes so the picker visits fewer locations and walks less. Orders with no shared box or SKU are added by closest walk-order. On by default; turn off to fall back to shared-SKU-only grouping.",
    picking_unit_minutes: "min",
    picking_unit_orders: "orders",
    picking_unit_items: "items",
    picking_unit_days: "days",

    // Picking settings — reorganised sub-section headings
    picking_queues_section: "Pick Queues",
    picking_wave_building_section: "Wave Building",
    picking_wave_building_toggles: "Location grouping & local first",
    picking_wave_building_section_hint: "How a wave is assembled: which stock is allocated, which orders are grouped together, and when an idle wave is handed back.",
    picking_picker_screen_section: "Picker Screen",
    picking_picker_screen_toggles: "Location scan & product image",
    picking_picker_screen_section_hint: "What the picker sees on the handheld, and how long the location-change prompts stay up.",
    picking_experiments_section: "Experiments",
    picking_experiments_section_hint: "A/B tests that run on live waves. Each splits waves evenly between the current behaviour and a proposed one, measures both, and lets you adopt the winner for everyone.",

    // Walk-pattern A/B experiment
    walk_pattern_standard: "Alternating (current)",
    walk_pattern_corridor: "Corridor 1 bay",
    walk_pattern_dynamic: "Dynamic (per-wave route)",
    walk_pattern_aligned: "Aligned (merge sides by position)",
    walk_experiment_title: "Walk Order Experiments",
    walk_experiment_intro: "Test walk orders against each other on the floor. Download the current one, re-number it however you like, upload it back as A, B, C… and run any two or more side by side. Waves rotate evenly through the arms, per picker and per pick type, so the comparison is like for like and picker skill cancels out.",
    walk_experiment_running: "Running",
    walk_experiment_running_until: "Running until {date}",
    walk_experiment_finished: "Finished",
    walk_experiment_off: "Off · {pattern}",
    walk_experiment_pick_types: "Pick types",
    walk_experiment_need_one_pick_type: "At least one pick type must stay enrolled.",
    walk_experiment_ends_at: "End date",
    walk_experiment_ends_at_hint: "Leave blank to run until you stop it.",
    walk_experiment_no_data: "No completed waves yet",
    walk_experiment_delta_caption: "{pattern} is faster per move",
    walk_experiment_confidence_insufficient: "Not enough waves yet",
    walk_experiment_confidence_indicative: "Indicative only",
    walk_experiment_confidence_clear: "Clear result",
    walk_experiment_need_moves: "needs {n}+ moves per arm",
    walk_experiment_ci: "95% range {low}% to {high}%",
    walk_experiment_col_arm: "Arm",
    walk_experiment_col_wave: "Wave",
    walk_experiment_col_waves: "Waves",
    walk_experiment_col_units: "Units",
    walk_experiment_col_move: "s / move",
    walk_experiment_col_move_hint: "Median seconds between two picks at DIFFERENT locations. This is the primary metric — it isolates travel, which is the only thing the walk order changes.",
    walk_experiment_col_same: "s / same spot",
    walk_experiment_col_same_hint: "Median seconds between two picks at the SAME location. A control: it should read the same on both arms. If it doesn't, the arms differ in something other than the route and the headline can't be trusted yet.",
    walk_experiment_col_uph: "Units/hr",
    walk_experiment_recent_waves: "Recent waves",
    walk_experiment_preview: "Preview the route",
    walk_experiment_preview_hint: "Which two bays face each other isn't recorded anywhere — it's inferred from bays whose walk orders interleave. Check these pairs look right before switching the experiment on.",
    walk_experiment_preview_none: "No facing pairs found at this warehouse — the corridor pattern would change nothing here.",
    walk_experiment_coverage: "{pct}% of low locations would be reordered ({reordered} of {total}).",
    walk_experiment_coverage_ambiguous: "{n} were left alone because more than two bays overlap there — check those walk orders.",
    walk_experiment_large_hint: "Large waves are picked one order at a time, so the walk order only changes the sequence within a single order. Expect a much weaker signal here than Pick & Sort.",
    walk_experiment_adopt_no_data: "No comparison data yet — switching now would not be based on evidence.",
    walk_experiment_adopt_confirm: "Every new wave will use {pattern}. Waves already in progress keep the pattern they started with. This ends the experiment.",
    walk_experiment_adopt_confirm_measured: "Measured so far: {winner} is {pct}% faster per move ({confidence}).",
    walk_experiment_adopt_confirm_nodata: "No comparison data has been collected yet.",
    walk_experiment_arms_running: "{n} arms",
    walk_experiment_vs_baseline: "vs {arm}",
    walk_experiment_baseline: "baseline",
    walk_experiment_multiple_note: "More than two arms are running, so these ranges are not corrected for multiple comparisons — with four arms there are four chances to read a \"clear\" result out of noise. Treat a single surprising winner as a reason to keep running, not to adopt.",
    walk_experiment_adopt_label: "Use for every wave",
    walk_variant_section: "Walk orders",
    walk_variant_hint: "Download the current walk order, re-number it in the spreadsheet, and upload it back as A, B, C… Tick any two or more to run them against each other. A variant never overwrites the live walk order — deleting it puts everything back.",
    walk_variant_col_arm: "Walk order",
    walk_variant_col_coverage: "Covers",
    walk_variant_col_in_test: "In test",
    walk_variant_col_actions: "Actions",
    walk_variant_builtin_standard: "The live walk order for this warehouse",
    walk_variant_builtin_corridor: "Derived — finishes one bay before crossing the corridor",
    walk_variant_builtin_dynamic: "Computed per wave — shortest route over the drawn warehouse layout; falls back to Alternating if the layout is missing",
    walk_variant_builtin_aligned: "Derived from the drawn layout — the same serpentine, but facing sides merge by physical position instead of bay number; updates itself when the plan changes",
    walk_exp_sec_arms: "Arms & uploads",
    walk_exp_sec_arms_meta: "{n} enrolled",
    walk_exp_sec_controls: "Pick types & schedule",
    walk_exp_sec_analysis: "Which walk order is faster",
    walk_exp_sec_detail: "Per-arm detail & control metric",
    walk_exp_col_estimated: "Estimated Δ",
    walk_exp_col_measured: "Measured Δ",
    walk_exp_col_confidence: "Confidence",
    walk_exp_fastest: "Fastest",
    walk_exp_estimates_stale: "The warehouse plan has changed since the estimated deltas were measured — the arms, map and distances follow the new plan automatically, but these estimates are a snapshot and should be re-measured.",
    walk_exp_estimates_only_hint: "Estimates come from replaying real waves through each order over the drawn layout. Measured numbers appear here as experiment waves complete.",
    walk_exp_map_title: "Route map",
    walk_exp_map_meta: "The walk drawn over the layout plan",
    walk_exp_map_arm: "Walk order",
    walk_exp_map_sample: "P&S wave #{id} under this order · {m} m between picks — same wave for every arm, so routes compare directly",
    walk_exp_map_arrows: "Direction",
    walk_exp_tiers: "Tiers",
    walk_exp_tiers_hint: "Which wave tiers enrol. Results report Low and High separately — different racking, different work.",
    walk_experiment_need_one_tier: "At least one tier must stay enrolled",
    walk_exp_map_view_wave: "Sample P&S wave",
    walk_exp_map_view_full: "Full warehouse",
    walk_exp_map_full: "Full walk of every bay: {m} m",
    walk_exp_map_full_hint: "This draws a walk that visits every bay, so it exaggerates differences a real, sparser wave never pays. The estimated and measured deltas above are the numbers to compare.",
    walk_exp_map_no_layout: "No warehouse layout is drawn for this site yet — draw it in Experiments › Warehouse layout to see the route.",
    walk_exp_map_start: "Start",
    walk_exp_map_end: "End",
    walk_exp_map_point_distance: "{m} m from {bay}",
    walk_variant_coverage: "{n} of {total} locations ({pct}%)",
    walk_variant_adopted: "live",
    walk_variant_in_test: "In test",
    walk_variant_download: "Download this walk order",
    walk_variant_download_current: "Download current walk order",
    walk_variant_delete: "Delete this variant",
    walk_variant_delete_confirm: "Delete walk order {code}? Waves that already ran on it keep their results.",
    walk_variant_delete_enrolled: "{code} is currently in the test. Deleting it removes it from the running experiment; waves that already ran on it keep their results. Delete it?",
    walk_variant_upload: "Upload variant",
    walk_variant_uploading: "Uploading {done} / {total}…",
    walk_variant_upload_hint: "The uploaded sheet needs a location column and a walk_order column; everything else is ignored. Uploading an existing code replaces it. Locations you leave out keep their live walk order.",

    // ── Settings › Picking › Experiments › Warehouse layout ──────────────
    wlayout_title: "Warehouse layout",
    wlayout_intro: "The racking in metres, so a pick route can be costed before it is run. Seeded from the locations table — aisles, bays, corridor pairing and travel direction all come from data you already keep — then corrected here for the things it cannot know: bay widths, uprights, offsets, tunnels and where a route starts and ends.",
    wlayout_none: "No layout yet for this warehouse. Seed one from the locations table to begin.",
    wlayout_seed: "Seed from locations",
    wlayout_saved: "Layout saved — {n} bays placed.",
    wlayout_unsaved: "Unsaved changes",
    wlayout_calibrate: "Check against measured times",
    wlayout_fit: "Fit to view",
    wlayout_scale: "{n} m across",
    wlayout_drag_corridor: "drag to move this corridor",
    wlayout_drag_column: "drag along the aisle to set where this column starts",
    wlayout_drag_tunnel: "drag to move this tunnel to another shelf",
    wlayout_stat_corridors: "{n} corridors",
    wlayout_stat_aisles: "{n} aisles",
    wlayout_stat_bays: "{n} bays placed",
    wlayout_select_hint: "Select an aisle or a bay on the plan to edit it.",
    wlayout_movement: "Movement",
    wlayout_walk_speed: "Walking speed (m/s)",
    wlayout_cage_mode: "Roll cage",
    wlayout_cage_with_picker: "Comes down the corridor",
    wlayout_cage_staged_at_end: "Left at the end of the corridor",
    wlayout_cage_none: "No cage",
    wlayout_cage_hint: "In a 1.1 m corridor this decides whether the picker can work one side and return down the other at all — it changes which walk orders are physically possible, not just their cost.",
    wlayout_aisle: "Aisle {a}",
    wlayout_racking: "Racking",
    wlayout_shelving: "Shelving",
    wlayout_pallet: "Pallet",
    wlayout_rack_depth: "Rack depth (m)",
    wlayout_offset: "Start offset (m)",
    wlayout_offset_hint: "Where this aisle's first bay begins relative to the corridor entrance. Two sides that start at different points never line up bay for bay, which is exactly why G and H do not.",
    wlayout_bay_one: "Bay 1 is at",
    wlayout_bay_one_origin: "The corridor entrance",
    wlayout_bay_one_far: "The far end",
    wlayout_runs: "Shelving runs",
    wlayout_runs_hint: "A run is a continuous stretch of racking with one bay width. Split a run wherever the spacing changes — a run of 4, 6 or 7 bays is what makes the two sides of a corridor disagree.",
    wlayout_undo: "Back",
    wlayout_undo_hint: "Step back one change. Nothing is written until you save.",
    wlayout_routes: "Tunnels",
    wlayout_routes_hint: "Show or hide the tunnels and end cross-aisles.",
    wlayout_walk: "Walk order",
    wlayout_walk_hint: "Show the route a picker is sent in. The 3D view also shows the level.",
    wlayout_nothing_selected: "nothing selected",
    wlayout_show_people: "People on the floor",
    wlayout_people_count: "{n} scanned in the last 90s",
    wlayout_bulk_all_shelves: "All {n} shelves",
    wlayout_bulk_hint: "Changes here apply to every shelf in the aisle. Blank means the shelves differ.",
    wlayout_mixed: "mixed",
    wlayout_shelf_n: "Shelf {n}",
    wlayout_run_summary: "{w} m, {n} per shelf",
    wlayout_run_tunnel: "Tunnel — no locations",
    wlayout_point_x: "X, metres",
    wlayout_point_y: "Y, metres",
    wlayout_refresh: "Refresh from locations",
    wlayout_refresh_hint: "Takes fresh aisles, bays and levels from the locations table and keeps your drawing.",
    wlayout_rebuild: "Rebuild from scratch",
    wlayout_rebuild_hint: "Derives the whole model again. Discards the drawing.",
    wlayout_rebuild_confirm: "Rebuild the layout from locations? Every measurement you have drawn will be replaced. Nothing is saved until you press Save.",
    wlayout_tier_both: "Both",
    wlayout_tier_low: "Low",
    wlayout_tier_high: "High",
    wlayout_shelf_count: "Shelves in this aisle",
    wlayout_bays_per_shelf: "Bays per shelf (from locations)",
    wlayout_shelf_width: "Shelf width (m)",
    wlayout_locations_per_shelf: "Locations per shelf (bays)",
    wlayout_upright: "Upright (m)",
    wlayout_shelves_derived: "Shelves (from locations)",
    wlayout_shelves_split: "{low} low · {high} high",
    wlayout_shelf_height: "Shelf height (m)",
    wlayout_shelf_gap: "Shelf gap (m)",
    wlayout_split_run: "Split",
    wlayout_run_total: "Runs cover {covered} of {total} bays · {len} m of racking",
    wlayout_crossings: "Crossings",
    wlayout_crossings_hint: "Where the picker can move between corridors — the end cross-aisles and any tunnel. Tunnels already exist in the location data as bay 'TUN' but have never been modelled, so until now every cost model priced a move through one as a long walk.",
    wlayout_tunnel: "Tunnel",
    wlayout_end_crossaisle: "End cross-aisle",
    wlayout_add_tunnel: "Add tunnel",
    wlayout_points: "Route start and end",
    wlayout_points_hint: "Where a wave begins and ends. Today the start is a single scanned location and the end is not recorded at all, so any distance saved is only measured across the middle of the job.",
    wlayout_point_distance: "{m} m from {bay}",
    wlayout_point_cage_pickup: "Cage pickup",
    wlayout_point_pack_desk: "Pack desk",
    wlayout_point_conveyor: "Conveyor",
    wlayout_point_drop_zone: "Drop zone",
    wlayout_problems: "{n} things to check",
    wlayout_problems_more: "…and {n} more.",
    wlayout_calibration: "Measured against real picks",
    wlayout_calibration_hint: "Move times from live picking events, bucketed by how far the layout says the picker walked. If the drawing is right the times rise with distance; if a band is badly out, the geometry in that band is wrong.",
    wlayout_fit_summary: "Fitted: {speed} m/s walking, {step} s to start moving at all, {handling} s handling per pick (R² {r2}, {n} moves).",
    wlayout_no_fit: "Not enough spread in the data to fit a speed.",
    wlayout_coverage: "{pct}% of moves could be placed on the layout — {unmapped} could not.",
    wlayout_band: "Distance",
    wlayout_moves: "Moves",
    wlayout_median_m: "Median m",
    wlayout_median_s: "Median s",
    wlayout_residual: "Residual s",
    wlayout_band_same_spot: "Same spot",
    wlayout_band_under_2m: "Under 2 m",
    wlayout_band_2_to_5m: "2–5 m",
    wlayout_band_5_to_10m: "5–10 m",
    wlayout_band_10_to_20m: "10–20 m",
    wlayout_band_20_to_40m: "20–40 m",
    wlayout_band_over_40m: "Over 40 m",
    wlayout_view_2d: "Plan",
    wlayout_view_3d: "3D",
    wlayout_3d_loading: "Loading the 3D view…",
    wlayout_3d_failed: "The 3D view could not be loaded.",
    wlayout_3d_hint: "Drag to orbit, scroll to zoom. Read-only — routing uses the plan geometry, and heights only affect how long a pick takes, not how far the picker walks. This view is for spotting a rack that is the wrong shape.",
    walk_variant_code_placeholder: "Code (A)",
    walk_variant_name_placeholder: "Name (e.g. Fast movers first)",
    walk_variant_need_code: "Give the variant a code first — A, B, C…",
    walk_variant_need_two_arms: "An experiment needs at least two walk orders to compare.",
    walk_variant_bad_header: "That sheet has no location and walk_order columns. Download the current walk order and edit that.",
    walk_variant_empty: "That sheet has no rows.",
    walk_variant_uploaded: "Walk order {code} saved — {n} locations ({pct}% of the warehouse).",
    walk_variant_rejects: "{unknown} rows matched no location here and {invalid} had no usable walk order. Those locations keep their live walk order.",
    walk_variant_download_failed: "Could not download the walk order.",

    // Shelf Drop & Forecast Drop settings
    picking_shelf_drop_settings: "Shelf Drop",
    picking_shelf_drop_settings_hint: "Replenishment from high shelf_drop locations down to low pick faces, driven by unfulfilled orders.",
    picking_forecast_drop_settings: "Forecast Drop",
    picking_forecast_drop_settings_hint: "Replenishment driven by the BargainFox HOT target — top up any low location to the same figure the goods-in scan sheet books HOT stock against. Units in the HOT put-away queue count as already down; units sold but not yet picked do not. Shelf Drop brings down what open orders need — Forecast only tops up on top of that and never takes the units they are waiting for.",
    drop_claim_ttl_minutes: "Claim TTL",
    drop_claim_ttl_minutes_hint: "How long a picker's reservation stays held before it auto-expires and the units become available to others.",
    forecast_drop_target_source_hint: "Target per SKU = BF products 30-day sales ÷ 30 × BF hot cover days (see the BargainFox scan sheet settings), refreshed every morning at 05:30. No separate Forecast Drop setting.",
    require_location_scan_shelf_drop: "Require Location Scan (Shelf Drop)",
    require_location_scan_shelf_drop_hint: "When on, the picker must scan their current location before Shelf Drop starts ranking the nearest target.",
    require_location_scan_forecast_drop: "Require Location Scan (Forecast Drop)",
    require_location_scan_forecast_drop_hint: "When on, the picker must scan their current location before Forecast Drop starts ranking the nearest target.",

    // Shelf/Forecast Drop — picker UI
    drop_scan_current_location: "SCAN LOCATION",
    drop_scan_empty_tote: "SCAN TOTE",
    drop_scan_target_location: "SCAN LOCATION",
    drop_scan_items: "SCAN ITEM",
    drop_scan_items_one: "SCAN ITEM",
    drop_all_caught_up: "All caught up",
    drop_finding_next_location: "Finding next location...",
    drop_put_away_toggle: "Put Away",
    drop_view_toggle: "View",
    drop_view_pick: "Pick",
    drop_view_put_away: "Put Away",
    drop_put_away_view_title: "Put Away",
    drop_put_away_queue_empty: "All caught up",
    drop_back_to_picking: "Back to picking",
    drop_aisles_title: "Units by aisle",
    drop_aisles_hint: "Where the outstanding units will be picked from.",
    drop_aisles_empty: "Nothing to drop right now.",
    drop_aisles_aisle: "Aisle {aisle}",
    drop_aisles_other: "No aisle",
    drop_aisles_total: "Total",
    drop_invalid_starting_location: "Location not found.",
    scan_wrong_warehouse: "That location is in the {warehouse} warehouse. Change your warehouse to use it.",
    drop_move_location_title: "Move to a new location",
    drop_move_location_hint: "Scan the location you are moving to. Items you haven't picked here stay in the drop queue.",
    drop_move_invalid_location: "That's not a valid storage location.",
    picking_location_tap_label: "Change location",
    picking_skip_title: "Skip location",
    picking_skip_body: "Scan the location you are moving to. Locations you skip will come back at the end of your walk.",
    picking_skip_unknown_location: "Location not recognised — scan a location barcode.",
    drop_not_a_tote: "Not a tote.",
    drop_tote_in_use_elsewhere: "Tote is in use elsewhere.",
    drop_tote_unavailable: "Tote unavailable.",
    drop_reopen_tote_title: "Reopen Tote",
    drop_reopen_tote_intro: "This tote is closed and waiting to be put away. Reopen it to keep adding to it — its current contents are kept.",
    drop_reopen_confirm: "Reopen",
    drop_swap_tote_title: "Change Tote?",
    drop_swap_tote_intro: "Scan tote {tote} again or tap Confirm to carry on picking into it. Anything already scanned stays in tote {current} and goes to put-away.",
    drop_swap_confirm: "Confirm",
    drop_close_tote_title: "Close Tote",
    drop_close_tote_intro: "Scan the tote again or confirm to close it and send it to put-away. This ends your drop session.",
    drop_close_confirm: "Close Tote",
    drop_close_last_location: "Last item picked from {location}",
    drop_tote_closed_toast: "Tote {tote} was sent to put-away.",
    drop_tote_closed_empty_toast: "Tote {tote} was empty — released.",
    drop_close_failed: "Couldn't close the tote ({reason}) — try again.",
    drop_resume_title: "Unfinished drop",
    drop_resume_intro: "Tote {tote} has {items} items. Your current location is {location}. Resume, or close the tote and send it to put-away.",
    drop_resume_intro_no_location: "Tote {tote} has {items} items. Resume to find the next location, or close the tote and send it to put-away.",
    drop_resume_intro_no_tote: "This unfinished drop has {items} items recorded. Resume and scan a tote to continue.",
    drop_resume_no_tote: "No tote",
    drop_resume_confirm: "Resume",
    drop_resume_close_tote: "Close tote",
    drop_resume_discard: "Discard",
    drop_resumed_toast: "Resumed drop with tote {tote}.",
    drop_resuming: "Resuming drop…",
    drop_start_blocked_by_tote: "Tote {tote} is still open on your drop — resume it or close it first.",
    drop_resumed_no_tote_toast: "Drop resumed — scan a tote to continue.",
    drop_session_lost: "This drop session has ended elsewhere — start again.",
    drop_takeover_title: "Tote in unfinished drop",
    drop_takeover_intro: "Tote {tote} belongs to {picker}'s unfinished drop. Confirming sends its stock to Put Away.",
    drop_takeover_confirm: "Send to Put Away",
    drop_takeover_done: "Tote {tote} was sent to Put Away.",
    drop_takeover_unknown_picker: "another picker",
    drop_wrong_location: "Wrong location — go to the highlighted one.",
    drop_wrong_item: "That item isn't on this drop.",
    drop_already_picked_qty: "Quantity already met for this SKU.",
    drop_partial_claim_race: "Another picker claimed some units — bring down what's in your tote.",
    drop_pick_complete_failed: "Could not finalise pick.",
    drop_pa_scan_tote: "SCAN A TOTE",
    drop_pa_scan_target_location: "SCAN LOCATION",
    drop_pa_scan_item_or_location: "SCAN ITEM OR LOCATION",
    drop_pa_item_gone: "That item is no longer in this tote.",
    drop_pa_picked_by: "Picked by {name}",
    drop_pa_tote_item_count: "{n} items",
    drop_pa_tote_not_in_queue: "That tote isn't awaiting put-away here.",
    // Wrong-queue prompt (shared by Put Away / Shelf Drop / Forecast Drop put-away)
    wrong_queue_title: "Wrong queue",
    wrong_queue_drop: "Tote {tote} is awaiting put-away in {queue} — {units} units picked by {name}.",
    wrong_queue_put_away: "Tote {tote} is a goods-in tote — it belongs in Put Away.",
    wrong_queue_picking: "Tote {tote} is on a picking wave — it goes to sorting and dispatch, not put-away.",
    wrong_queue_go: "Take me to {queue}",
    wrong_queue_stay: "Stay here",
    drop_pa_unknown_location: "Location not found.",
    drop_pa_not_low: "Target must be a low location.",
    drop_pa_target_is_source: "Target can't be a shelf-drop source.",
    drop_pa_not_storage: "Target must be a storage location.",
    drop_pa_failed: "Put-away failed.",
    drop_filter_channel: "Channel",
    drop_filter_express: "Express",
    drop_filter_standard: "Standard",
    drop_filter_age: "Order age",
    drop_filter_age_2plus: "2+ days",
    drop_filter_age_1to2: "1–2 days",
    drop_filter_age_lt1: "< 1 day",
    drop_filter_older_than: "Older than",

    // Picking admin (top-level page)
    dashboard_admin_title: "Dashboard",
    dashboard_admin_hint: "Live progress of warehouse tasks — who's working on what, how far through they are, and when they should finish.",
    tile_dashboard_desc: "Live task progress and completion estimates",
    dashboard_col_user: "User",
    dashboard_col_bay: "Bay",
    dashboard_col_wave_order: "Wave / Order",
    dashboard_wave_order_more: "+{n} more",
    dashboard_col_progress: "Progress",
    dashboard_col_speed: "Speed",
    dashboard_col_eta: "Est. completion",
    dashboard_speed_iph: "{n} items/hr",
    dashboard_eta_in: "~{mins} min ({time})",
    dashboard_idle: "Idle",
    dashboard_paused: "Paused",
    dashboard_no_picks: "No live picks right now.",
    dashboard_no_sorts: "No live sorts right now.",
    dashboard_col_start: "Start",
    dashboard_col_end: "End",
    dashboard_completed_today: "Completed today",
    dashboard_passed_on: "Passed on",
    dashboard_taken_over: "Taken over",
    dashboard_no_completed: "Nothing completed yet today.",
    dashboard_col_source: "Source",
    dashboard_col_ref: "Tote / Session",
    dashboard_col_units: "Units",
    dashboard_col_last_activity: "Last activity",
    dashboard_col_orders: "Orders",
    dashboard_col_parcels: "Parcels",
    dashboard_col_orders_ph: "Orders/hr",
    dashboard_col_units_ph: "Units/hr",
    dashboard_col_parcels_ph: "Parcels/hr",
    dashboard_rate_ph: "{n}/hr",
    dashboard_source_book_in: "Book In",
    dashboard_source_bf_scan: "BF Scan",
    dashboard_source_bf_scan_big: "BF Scan BIG",
    dashboard_no_goods_in: "No live goods-in sessions right now.",
    dashboard_no_dispatch: "No live dispatch sessions right now.",
    dashboard_no_putaway: "No live put-away sessions right now.",
    dashboard_col_type: "Type",
    dashboard_col_totes_short: "Totes",
    dashboard_col_misslotted: "Mis-slotted",
    dashboard_rate_totes_ph: "{n} totes/hr",
    dashboard_putaway_type_hot: "Hot",
    dashboard_putaway_type_cold: "Cold",
    dashboard_putaway_type_other: "Other",
    dashboard_no_shelf_drops: "Nobody is on Shelf Drop right now.",
    dashboard_no_forecast_drops: "Nobody is on Forecast Drop right now.",
    dashboard_phase_putaway: "Putting away",
    dashboard_scope_toggle: "Dashboard view",
    dashboard_scope_individual: "Summary",
    dashboard_pick_type_other: "Other",
    dashboard_sort_hint: "Sort by this column",
    dashboard_scope_waves: "Waves",
    dashboard_scope_team: "Team",
    dashboard_scope_planner: "Planner",
    dashboard_planner_hint: "People needed on each job, from now, to hit the dispatch target.",
    dashboard_planner_footer: "Live at {time} · {scope} · Rates: {days}-day average ({from} – {to}) · Flagged / on hold left out: {n}",
    dashboard_planner_scope_label: "Orders to plan",
    dashboard_planner_scope_due: "Due today",
    dashboard_planner_scope_all: "All open orders",
    dashboard_planner_refresh: "Refresh figures",
    dashboard_planner_reset: "Reset",
    dashboard_planner_reset_hint: "Clear edited figures and put the target back to the default.",
    dashboard_planner_error: "Could not load today's figures — enter them by hand or refresh.",
    dashboard_planner_target: "Dispatch target",
    dashboard_planner_target_sub: "Cut-off {cutoff} less {buffer} min",
    dashboard_planner_time_left: "Time left",
    dashboard_planner_past_target: "Past target",
    dashboard_planner_now: "Now {time}",
    dashboard_planner_people: "People",
    dashboard_planner_people_summary: "{needed} needed · {active} on it",
    dashboard_planner_projected: "Projected dispatch finish",
    dashboard_planner_projected_none: "Nothing to plan",
    dashboard_planner_projected_unknown: "Needs a rate on every job",
    dashboard_planner_projected_blocked: "Nobody on a job with work",
    dashboard_planner_projected_on_track: "{time} — on track",
    dashboard_planner_projected_late: "{time} — late by {late}",
    dashboard_planner_col_job: "Job",
    dashboard_planner_col_work: "Work to do",
    dashboard_planner_col_rate: "Rate per person / hr",
    dashboard_planner_col_needed: "People needed",
    dashboard_planner_col_active: "On it now",
    dashboard_planner_active_hint: "People Portal can see on this job right now, from live sessions",
    dashboard_planner_col_finish: "Projected finish",
    dashboard_planner_dept_by: "Finish by {time}",
    dashboard_planner_row_by: "by {time}",
    dashboard_planner_dept_hours: "{time} left",
    dashboard_planner_dept_passed: "Finish-by time has passed",
    dashboard_planner_unit_items: "items",
    dashboard_planner_unit_orders: "orders",
    dashboard_planner_revert: "Live figure: {n}",
    dashboard_planner_revert_none: "Live figure: none",
    dashboard_planner_revert_hint: "Go back to the live figure",
    dashboard_planner_no_history: "No recent history — enter a rate",
    dashboard_planner_short: "{n} more needed",
    dashboard_planner_status_nothing: "Nothing to do",
    dashboard_planner_status_no_rate: "Enter a rate",
    dashboard_planner_status_no_time: "Finish-by passed",
    dashboard_planner_status_nobody: "Nobody on it",
    dashboard_planner_status_on_track: "On track",
    dashboard_planner_status_late: "Late by {time}",
    dashboard_planner_tomorrow: "Tomorrow",
    dashboard_advisor_pembroke_only: "The Pick Advisor runs at Pembroke Dock only.",
    dashboard_planner_views: "Planner view",
    dashboard_planner_view_staffing: "Staffing",
    dashboard_planner_view_advisor: "Pick Advisor",
    dashboard_advisor_hint: "What the Pick Queue is suggesting a free picker right now, why, and what it decided from. Pickers never see the reason.",
    dashboard_advisor_load_error: "Could not load the Pick Advisor — refresh.",
    dashboard_advisor_off_banner: "The Pick Advisor is switched off on the server (PICK_ADVISOR_ENABLED) — every handheld shows the full queue.",
    dashboard_advisor_off: "Advisor off",
    dashboard_advisor_off_hint: "No recommendation is being shown to pickers.",
    dashboard_advisor_error: "Could not read the queue's recommendation",
    dashboard_advisor_none: "No recommendation",
    dashboard_advisor_no_warehouses: "No warehouse in scope.",
    dashboard_advisor_state_at: "Live at {time}",
    dashboard_advisor_recommending: "Suggesting now",
    dashboard_advisor_pick_none: "Nothing — ask a leader",
    dashboard_advisor_pick_with_orders: "{pick} · {n} orders",
    dashboard_advisor_sort_load: "Sort load",
    dashboard_advisor_sort_load_sub: "minutes of sorting per sorter already waiting, in progress or landing",
    dashboard_advisor_pack_runway: "Pack runway",
    dashboard_advisor_pack_runway_sub: "until the packers run out of ready work",
    dashboard_advisor_no_packers: "no packers",
    dashboard_advisor_sorters: "Sorters",
    dashboard_advisor_now_expected: "{now} now · {expected} expected",
    dashboard_advisor_sorters_sub: "usually {n} mid-morning",
    dashboard_advisor_packers: "Packers",
    dashboard_advisor_packers_sub: "packed something in the last 15 min",
    dashboard_advisor_lands_at: "Lands at sort",
    dashboard_advisor_lands_at_sub: "if the suggested wave starts now",
    dashboard_advisor_packed_by: "Packed by",
    dashboard_advisor_packed_by_sub: "cut-off {cutoff}",
    dashboard_advisor_pools: "Pools: Pick & Sort {ps} · Putwall {wall} · Large {large} · Single {light} orders",
    dashboard_advisor_wall_off: "off",
    dashboard_advisor_after_cutoff: "After the cut-off — picking for tomorrow",
    dashboard_advisor_tile_sort: "At the sort stage",
    dashboard_advisor_tile_sort_value: "{waiting} waiting · {busy} sorting",
    dashboard_advisor_tile_sort_sub: "{items} items to sort · {slots} wall slots free",
    dashboard_advisor_tile_inflight: "Waves in flight",
    dashboard_advisor_tile_pack: "Ready to pack",
    dashboard_advisor_tile_people: "Active now",
    dashboard_advisor_tile_people_value: "{pickers} · {sorters} · {packers}",
    dashboard_advisor_tile_people_sub: "pickers · sorters · packers, last 15 min",
    dashboard_advisor_tile_none: "none",
    dashboard_advisor_waiting_title: "Sort queue",
    dashboard_advisor_waiting_none: "Nothing picked is waiting to be sorted.",
    dashboard_advisor_inflight_title: "Waves in flight",
    dashboard_advisor_inflight_none: "No wave is being picked.",
    dashboard_advisor_col_wave: "Wave",
    dashboard_advisor_col_station: "Station",
    dashboard_advisor_col_orders: "Orders",
    dashboard_advisor_col_items: "Items",
    dashboard_advisor_col_status: "Status",
    dashboard_advisor_col_type: "Type",
    dashboard_advisor_col_picked: "Picked",
    dashboard_advisor_col_lands: "Lands at",
    dashboard_advisor_status_sorting: "Sorting",
    dashboard_advisor_status_waiting: "Waiting",
    dashboard_advisor_status_waiting_for: "Waiting {time}",
    dashboard_advisor_status_paused: "Paused",
    dashboard_advisor_today_title: "Today's starts vs the advice",
    dashboard_advisor_today_summary: "{starts} waves started · {advised} with a suggestion · {followed} followed ({pct}) · {suggested} started from the Suggested view",
    dashboard_advisor_today_none: "No wave started yet today.",
    dashboard_advisor_rule_followed: "{followed} of {advised} followed",
    dashboard_advisor_col_time: "Time",
    dashboard_advisor_col_picker: "Picker",
    dashboard_advisor_col_picked_wave: "Picked",
    dashboard_advisor_col_suggested: "Suggested",
    dashboard_advisor_col_followed: "Followed",
    dashboard_advisor_followed_yes: "Followed",
    dashboard_advisor_followed_no: "Not followed",
    dashboard_advisor_followed_na: "No advice",
    dashboard_advisor_toggle_off: "Suggested view off",
    dashboard_advisor_high_tier: "High tier",
    dashboard_advisor_reason_orders: "orders in the wave",
    dashboard_advisor_reason_lands_at: "lands at sort",
    dashboard_advisor_reason_packed_by: "packed by",
    dashboard_advisor_reason_latest_start: "latest start",
    dashboard_advisor_reason_last_start: "last possible start",
    dashboard_advisor_reason_sort_load: "sort load",
    dashboard_advisor_reason_pack_runway: "pack runway",
    dashboard_advisor_reason_large_due: "Large due",
    dashboard_advisor_reason_due: "due orders left",
    dashboard_advisor_reason_include: "wall orders folded in",
    dashboard_advisor_reason_ps: "Pick & Sort pool",
    dashboard_advisor_reason_put_wall: "Putwall pool",
    dashboard_advisor_reason_large: "Large pool",
    dashboard_advisor_reason_light: "Single pool",
    dashboard_advisor_rule_high_tier: "High tier — never advised",
    dashboard_advisor_rule_morning_wall: "Morning — full Putwall wave",
    dashboard_advisor_rule_morning_wall_why: "Before sorting starts and the Pick & Sort-only pool is under the minimum, so the wall leads.",
    dashboard_advisor_rule_morning_ps: "Morning — Pick & Sort first",
    dashboard_advisor_rule_morning_ps_why: "Before sorting starts: a full Sorting wave of the bigger orders fills the packing queue; the wall comes second.",
    dashboard_advisor_rule_single_full: "Single pool has reached 40",
    dashboard_advisor_rule_single_full_why: "A Single wave is suggested whenever 40 Single orders are waiting, at any time of day.",
    dashboard_advisor_rule_single_sweep: "Single sweep at the order cut-off",
    dashboard_advisor_rule_single_sweep_why: "From 13:00 every Single still waiting is collected straight away.",
    dashboard_advisor_rule_pack_dry_large: "Packing about to run dry — Large",
    dashboard_advisor_rule_pack_dry_large_why: "Little ready work at the pack desk and nothing Large in flight; Large feeds packing directly.",
    dashboard_advisor_rule_pack_dry_single: "Packing about to run dry — Singles",
    dashboard_advisor_rule_pack_dry_single_why: "No Large left to pick; a Single wave feeds packing directly.",
    dashboard_advisor_rule_cutoff_large: "Cut-off — Large",
    dashboard_advisor_rule_cutoff_large_why: "A Sorting wave started now could not be packed by the cut-off, and due Large orders are waiting.",
    dashboard_advisor_rule_sort_spare_wall: "Sorters have spare capacity — Putwall",
    dashboard_advisor_rule_sort_spare_wall_why: "The wall pool is big enough and would be packed before the cut-off.",
    dashboard_advisor_rule_sort_spare_ps: "Sorters have spare capacity — Pick & Sort",
    dashboard_advisor_rule_sort_spare_ps_why: "Sort load is under the horizon, so more Pick & Sort keeps the sorters fed.",
    dashboard_advisor_rule_sort_loaded_large: "Sorters loaded — Large",
    dashboard_advisor_rule_sort_loaded_large_why: "More Pick & Sort would only queue at the bays; Large feeds packing directly.",
    dashboard_advisor_rule_ps_queue: "Pick & Sort for the queue",
    dashboard_advisor_rule_ps_queue_why: "Nothing Large is left; keeps a wave ready for the sorters.",
    dashboard_advisor_rule_drop_done_wall: "Afternoon drop done — last Put Wall",
    dashboard_advisor_rule_drop_done_wall_why: "The second shelf drop has finished, so no more stock is coming down and the due pool is final: the wall orders still due go now as a wall.",
    dashboard_advisor_rule_drop_done_ps: "Afternoon drop done — last Sorting",
    dashboard_advisor_rule_drop_done_ps_why: "The second shelf drop has finished, so no more stock is coming down and the due pool is final: every due Sorting order still waiting goes now, below the minimum if that is all that is left.",
    dashboard_advisor_rule_override_1530: "Cut-off override",
    dashboard_advisor_rule_override_1530_why: "Due orders under the minimum wave size, started from their last possible start so they still go out today.",
    dashboard_advisor_rule_ask_leader: "Nothing qualifies — ask a leader",
    dashboard_advisor_rule_ask_leader_why: "No pick meets the rules right now; the picker is told to ask a team leader.",
    dashboard_advisor_rule_ps_join_urgent: "Join the open half — needs two pickers",
    dashboard_advisor_rule_ps_join_urgent_why: "Half of a paired wave is waiting for a picker and its orders only make 15:30 with two people on it.",
    dashboard_advisor_rule_ps_join_fallback: "Join the open half",
    dashboard_advisor_rule_ps_join_fallback_why: "Nothing else qualifies and half of a paired wave is waiting for a picker.",
    dashboard_updated_secs: "Updated {n}s ago",
    dashboard_updated_mins: "Updated {n}m ago",
    dashboard_col_sessions: "Sessions",
    dashboard_col_waves: "Waves",
    dashboard_col_time_spent: "Time",
    dashboard_col_totes: "Totes completed",
    dashboard_no_individual: "Nothing recorded for this department yet today.",
    dashboard_team_race_title: "Race to the cut-off",
    dashboard_team_race_orders_count: "{done} / {due} orders",
    dashboard_team_race_items_count: "{done} / {due} items",
    dashboard_team_race_projected: "Projected finish",
    dashboard_team_race_finish_time: "Finish time",
    dashboard_team_race_not_today: "Not today",
    dashboard_team_race_rate: "Current pace {n} items/hr",
    dashboard_team_race_clock: "Time of day (06:00 → cut-off)",
    dashboard_team_race_finished: "Finished!",
    dashboard_team_race_no_estimate: "No estimate yet",
    dashboard_team_race_frozen: "Cut-off passed",
    dashboard_team_race_status_flying: "Flying",
    dashboard_team_race_status_on_track: "On track",
    dashboard_team_race_status_behind: "Behind",
    dashboard_team_race_status_danger: "Danger zone",
    dashboard_team_orders_out_today: "Orders out today",
    dashboard_team_dispatch_cutoff: "Dispatch cut-off {time}",
    dashboard_team_of_due: "of {n} due",
    dashboard_team_progress_count: "{done} / {due}",
    dashboard_team_kpis: "Warehouse KPIs",
    dashboard_team_daily_kpis: "Daily KPIs",
    dashboard_team_weekly_kpis: "Weekly KPIs",
    dashboard_team_week_range: "{from} – {to}",
    dashboard_team_orders_out_week: "Orders out this week",
    dashboard_team_on_time_pct: "{pct}% on time",
    dashboard_team_on_time_short: "{on_time} / {total} on time",
    dashboard_team_on_time_word: "on time",
    dashboard_team_late_word: "late",
    dashboard_team_vs_last_week: "{pct} vs last week",
    dashboard_team_week_dept_help: "Rates are the average across the week so far. Comparison is the same point last week.",

    dashboard_team_range_label: "Date range",
    dashboard_team_range_from: "From",
    dashboard_team_range_to: "To",
    dashboard_team_range_this_week: "This week",
    dashboard_team_target: "Target {pct}%",
    dashboard_team_tip_on_time: "{shipped} / {due} shipped on time · {pct}%",
    dashboard_team_tip_early: "{early} shipped early",
    dashboard_team_range_wtd: "Week to date",
    dashboard_team_range_last_week: "Last week",
    dashboard_team_range_mtd: "Month to date",
    dashboard_team_range_custom: "Custom",
    dashboard_team_range_today: "Today",
    dashboard_team_range_yesterday: "Yesterday",
    dashboard_completed_range: "Completed {range}",
    dashboard_no_completed_range: "Nothing completed in this period.",
    // Leaders Bonus (Alex, 2026-09-28) — settings + dashboard view
    dashboard_scope_leaders_bonus: "Leaders Bonus",
    leaders_bonus_settings: "Leaders Bonus",
    leaders_bonus_settings_hint: "Pay periods and KPI targets for the team leaders' bonus. Daily targets are multiplied by the period's working days (Mon–Fri, minus UK bank holidays) to give the period target shown on the Leaders Bonus dashboard.",
    leaders_bonus_add_period: "Add pay period",
    leaders_bonus_no_periods: "No pay periods yet.",
    leaders_bonus_col_period: "Pay period",
    leaders_bonus_col_working_days: "Working days",
    leaders_bonus_col_on_time: "On time target",
    leaders_bonus_col_booked_in: "Booked in / day",
    leaders_bonus_col_put_away: "Put away / day",
    leaders_bonus_col_period_targets: "Period targets",
    leaders_bonus_period_targets: "{booked} booked in · {put_away} put away",
    leaders_bonus_starts_on: "Starts",
    leaders_bonus_ends_on: "Ends",
    leaders_bonus_on_time_target: "On time shipment rate target",
    leaders_bonus_booked_in_target: "Items booked in per working day",
    leaders_bonus_put_away_target: "Items put away per working day",
    leaders_bonus_form_hint: "Working days and period targets are worked out when you save.",
    leaders_bonus_overlap: "This period overlaps another one for this warehouse ({from} – {to}).",
    leaders_bonus_saved: "Pay period saved",
    leaders_bonus_deleted: "Pay period deleted",
    leaders_bonus_current: "Current",
    leaders_bonus_upcoming: "Upcoming",
    leaders_bonus_ended: "Ended",
    dashboard_lb_select_warehouse: "No pay periods set up yet. Add one under Settings › Leaders Bonus.",
    dashboard_lb_no_periods: "No pay periods set for {warehouse}. Add one under Settings › Leaders Bonus.",
    dashboard_lb_period_label: "Pay period",
    dashboard_lb_period_meta: "{from} – {to} · {days} working days · {elapsed} elapsed",
    dashboard_lb_fail_days: "Days below target",
    dashboard_lb_fail_days_unit: "days",
    dashboard_lb_fail_days_of: "of {n} scored days · target {pct}%",
    dashboard_lb_fail_day_line: "{late} late of {due} due",
    dashboard_lb_no_fail_days: "Every scored day hit the target",
    dashboard_lb_no_scored_days: "No due days scored yet",
    dashboard_lb_booked_in: "Items booked in",
    dashboard_lb_put_away: "Items put away",
    dashboard_lb_of_target: "of {target}",
    dashboard_lb_progress_pct: "{pct}% of target",
    dashboard_lb_daily_target: "Target {n}/day",
    dashboard_lb_tip_units: "{n} units",
    dashboard_lb_non_working: "Non-working day · counts, not targeted",
    dashboard_lb_points: "Projected Bonus Points",
    dashboard_lb_daily_avg: "Daily target {n}",
    dashboard_lb_need_per_day: "Need {n}/day to hit 100%",
    dashboard_lb_target_reached: "100% reached",
    dashboard_lb_no_days_left: "No working days left",
    dashboard_lb_points_of: "of {max} points",
    dashboard_lb_pts: "{n} pts",
    dashboard_lb_next_step: "Next: {from} for {points} pts",
    dashboard_lb_max_reached: "Top step reached",
    dashboard_lb_no_value: "Nothing to score yet",
    dashboard_lb_pct_of_target_value: "{pct}% of target",
    dashboard_lb_pace_value: "Tracking {pct}% of target",
    leaders_bonus_points_title: "Bonus points",
    leaders_bonus_points_hint: "What each KPI earns this period. Below the first step scores 0; otherwise the highest step reached. On time steps are the rate itself; item steps are % of the period target.",
    leaders_bonus_ladder_from: "From",
    leaders_bonus_ladder_points: "Points",
    leaders_bonus_ladder_add_step: "Add step",
    leaders_bonus_ladder_reset: "Reset to default",
    leaders_bonus_ladder_remove_step: "Remove step",
    leaders_bonus_ladder_unit_rate: "% on time",
    leaders_bonus_ladder_unit_target: "% of target",
    dashboard_lb_booked_in_hint: "BF + Big scan sheets · Hot, Cold, Measure, Red",
    dashboard_lb_put_away_hint: "Hot and Cold book-in totes only",
    dashboard_team_on_time_rate: "On Time Shipment Rate",
    dashboard_team_on_time_count: "{on_time} / {total} orders shipped on time",
    dashboard_team_time_to_ship: "Time to Ship",
    dashboard_team_hours_unit: "hrs",
    dashboard_team_orders_shipped_count: "{n} orders shipped",
    dashboard_team_no_orders_in_range: "No orders in range",
    dashboard_team_shipped_by_date: "Orders Shipped by date",
    dashboard_team_shipped_by_date_help: "{channel} orders placed on each date, and how many of them have shipped",
    dashboard_team_shipped_of_total: "of {total}",
    dashboard_team_shipped_by_date_total: "Range total",
    dashboard_team_range_last_days: "Last {n} days",
    dashboard_col_shipped: "Shipped",
    dashboard_team_same_time_yesterday: "Same time yesterday",
    dashboard_team_by_department: "By department",
    dashboard_team_dept_help: "Rates are the average across the day so far. Comparison is the same point yesterday.",
    dashboard_team_units_hr: "units/hr",
    dashboard_team_totes: "totes",
    dashboard_team_units_count: "{n} units",
    dashboard_team_vs_yesterday: "{pct} vs yesterday",
    dashboard_team_no_activity: "No activity logged yet",
    dashboard_team_booked_in: "Booked in",
    dashboard_team_units_picked: "Units picked",
    dashboard_team_awaiting_putaway: "Awaiting put-away",
    dashboard_team_shelf_queue_title: "Shelf Drop queue",
    dashboard_team_forecast_queue_title: "Forecast Drop queue",
    dashboard_team_units_to_drop_due_today: "units to drop · due today",
    dashboard_team_units_to_drop: "units to drop",
    dashboard_team_totes_to_put_away: "Totes to put away",
    dashboard_team_picking_due_today: "Picking due today",
    dashboard_team_of_items: "of {n} items",
    dashboard_team_ready_to_pick: "Ready to pick",
    dashboard_team_ready_word: "ready",
    dashboard_team_not_ready_word: "not ready",
    dashboard_team_low_waiting_word: "down low",
    dashboard_team_high_word: "up high",
    dashboard_team_ready_caption: "{pct}% of units · {ready} of {total} orders",
    dashboard_team_ready_help: "Units on waiting orders due today (overdue orders are not counted). Green = units on orders that can be picked in full down low right now. Amber = units already down low whose order is still waiting on other lines. Red = units that still need a shelf drop or are short of stock. The order count is orders that can be picked in full down low.",
    dashboard_team_items_picked: "Items picked",
    dashboard_team_items_sorted: "Items sorted",
    dashboard_team_orders_sorted: "Orders sorted",
    pallets_created: "Pallets created",
    dashboard_team_sorter_batch: "{date} · Batch {n}",
    dashboard_team_sorter_no_batch: "No batch scanned yet today",
    dashboard_team_sorter_items_count: "{done} / {total} items",
    dashboard_team_sorter_people: "{n} people",
    dashboard_team_sorter_people_now: "{n} scanning now",
    dashboard_team_sorter_other_batches: "Also on the station",
    dashboard_team_sorter_target: "Target finish {time}",
    dashboard_team_sorter_no_target: "No target yet (needs 30 days of history)",
    dashboard_team_sorter_average: "{days}-day average {n} items/hr",
    dashboard_team_sorter_average_person: "{days}-day average {n} items/hr per person × {bays} bays",
    dashboard_team_sorter_help: "Target finish = today's first scan on the batch + the items left at that point, at the 30-day average rate per person times the station's sorting bays — what a full team should manage for the whole sort. Flying / On track / Behind / Danger zone are the projected finish against that target, 30 minutes either side. Newport Sorter 1 is the conveyor, so it uses the station's own 30-day rate.",
    dashboard_team_people_on_station: "Scanning now",
    dashboard_team_batches_finished: "Batches finished",
    dashboard_team_pallets: "pallets",
    dashboard_team_orders_shipped_word: "orders shipped",
    dashboard_team_orders_shipped_week: "orders shipped this week",
    dashboard_col_date: "Date",
    dashboard_col_batch: "Batch",
    dashboard_col_people: "People",
    dashboard_col_pallet: "Pallet",
    dashboard_col_colour: "Colour",
    dashboard_col_status: "Status",
    dashboard_col_created: "Created",
    dashboard_col_pallets: "Pallets",
    dashboard_no_sorter_batches: "No batch on the station right now.",
    dashboard_no_pallets: "No pallets created.",
    dashboard_team_units_dispatched: "Units dispatched",
    dashboard_team_orders_dispatched: "Orders dispatched",
    dashboard_team_hot: "Hot",
    dashboard_team_cold: "Cold",
    dashboard_team_skus: "SKUs",
    dashboard_team_new_skus: "New",
    picking_admin_title: "Picking",
    picking_admin_hint: "Active and historical picking waves across all warehouses. Click a row for details.",
    picking_admin_active: "Active",
    picking_admin_paused: "Paused",
    picking_admin_history: "History",
    picking_admin_no_active: "No active waves",
    picking_admin_no_paused: "No paused waves",
    picking_admin_no_history: "No completed waves yet",
    picking_admin_all_warehouses: "All warehouses",
    picking_admin_pick_type_col: "Type",
    picking_admin_status_col: "Status",
    picking_admin_orders_col: "Orders",
    picking_admin_lines_col: "Lines",
    picking_admin_events_col: "Events",
    picking_admin_location_col: "Location",
    picking_admin_walk_order_col: "Walk #",
    picking_admin_qty_col: "Qty",
    picking_admin_distribution_col: "Distribution",
    picking_admin_when_col: "When",
    picking_admin_action_col: "Action",
    picking_admin_anchor: "Anchor",
    picking_admin_status_building: "Building",
    picking_admin_status_active: "Active",
    picking_admin_status_paused: "Paused",
    picking_admin_status_completed: "Completed",
    picking_admin_status_released: "Released",
    picking_admin_generate: "Generate test wave:",
    picking_admin_generate_btn: "Generate",
    picking_admin_generate_ok: "Wave #{waveId} generated · {orders} orders · {lines} lines",
    picking_admin_generate_failed: "Generate failed: {reason}",
    picking_admin_pick_warehouse: "Pick a warehouse first",
    picking_admin_force_release_btn: "Force release",
    picking_admin_force_release_confirm: "Release wave #{waveId}? Allocations will return to inventory and the orders go back to unfulfilled.",
    picking_admin_force_release_ok: "Wave #{waveId} released · {n} allocations returned",
    picking_admin_force_release_failed: "Release failed: {reason}",
    picking_admin_filter_all_types: "All types",
    picking_admin_filter_all_tiers: "All tiers",
    picking_pick_type_light: "Single",
    picking_pick_type_pick_and_sort: "Pick & Sort",
    picking_pick_type_put_wall: "Putwall",
    picking_pick_type_large: "Large",
    // Two-bay Pick & Sort wave — the strip names the size so the picker
    // and the sorters both know the totes span both bays.
    picking_pick_type_pick_and_sort_large: "Pick & Sort · Large wave",
    // Accessible name of the pick-type strip on the picker's top bar.
    picking_pick_type_strip_label: "Pick type: {type}",
    picking_tier: "Tier",
    picking_tier_high: "High",
    picking_tier_low: "Low",
    picking_wave_id_col: "Wave",
    picking_wave_picker_col: "Picker",
    picking_wave_remaining_col: "Picked",
    picking_wave_started_col: "Started",
    coming_soon: "coming soon",

    // Stock Control — warehouse stock maintenance hub
    stock_control: "Stock Control",
    stock_check: "Stock Check",
    move_stock: "Move Stock",
    sku_check: "SKU Check",
    stock_check_scan_prompt: "Scan location to count",
    move_stock_scan_prompt: "Scan SKU to move",
    sku_check_scan_prompt: "Scan SKU or barcode",
    stock_control_coming_soon: "Coming soon",
    // Stock Check workflow
    stock_check_scan_location: "Scan location",
    stock_check_scan_products: "Scan products to check",
    stock_check_empty_location: "No stock expected here — scan to add",
    stock_check_unknown_location: "Location not recognised",
    stock_check_wrong_warehouse: "Location is in another warehouse",
    stock_check_being_checked: "Being checked by {name}",
    stock_check_locked_title: "Location in use",
    stock_check_take_over: "Take over",
    stock_check_resumed: "Resumed your check",
    stock_check_session_ended: "This check has ended",
    stock_check_barcode_not_recognised: "Barcode not recognised",
    stock_check_added: "added",
    stock_check_allocated: "allocated",
    stock_check_complete: "Stock Check Complete",
    stock_check_complete_confirm: "All items counted. Finish this stock check?",
    stock_check_complete_summary: "Done — {matched} matched, {surplus} added, {writtenOff} written off",
    stock_check_add_title: "Add to location?",
    stock_check_add_body: "Book this product into {location}?",
    stock_check_writeoff_title: "Stock not found",
    stock_check_writeoff_body: "These expected items weren't scanned. Write off the missing stock?",
    stock_check_writeoff_confirm: "Write-off & complete",
    stock_check_complete_no_writeoff: "Complete without write-off",
    stock_check_keep_scanning: "Return to stock check",
    stock_check_resume_title: "Resume stock check?",
    stock_check_resume_body: "You have a check in progress at {location} — {counted}/{total} counted. Continue where you left off, or start over?",
    stock_check_continue: "Continue",
    stock_check_start_over: "Start over",
    stock_check_recheck_title: "Already checked today",
    stock_check_recheck_last: "Last check",
    stock_check_recheck_by: "By",
    stock_check_recheck_again: "Check again",
    stock_check_recheck_new: "Scan new location",
    // Move Stock workflow
    move_stock_scan_tote: "Scan tote",
    move_stock_scan_location: "Scan location",
    move_stock_scan_products: "Scan products to move",
    move_stock_moved: "moved",
    move_stock_left: "left",
    move_stock_at_location: "here",
    move_stock_switch_location: "Switch location",
    move_stock_complete: "Complete Tote",
    move_stock_complete_title: "Complete tote?",
    move_stock_complete_confirm: "Send this tote to Put Away with {count} units?",
    move_stock_complete_empty_confirm: "Nothing has been moved. Release this tote?",
    move_stock_sent_title: "Tote sent to Put Away",
    move_stock_sent_body: "{count} units are on their way to Put Away. Open a new tote or leave?",
    move_stock_released_title: "Tote released",
    move_stock_released_body: "Nothing was moved — the tote is free to reuse.",
    move_stock_open_new: "Open new tote",
    move_stock_leave: "Leave",
    move_stock_auto_sent: "Tote {tote} closed — {count} units sent to Put Away",
    move_stock_auto_released: "Tote {tote} released — nothing was moved",
    move_stock_reopen_title: "Re-open tote?",
    move_stock_reopen_body: "Tote {tote} is closed with {count} units on it. Re-open it to add more stock?",
    move_stock_manual_title: "Move quantity",
    move_stock_manual_max: "Up to {max} available",
    move_stock_manual_confirm: "Move",
    move_stock_move_all: "Move all",
    move_stock_move_all_title: "Move all items?",
    move_stock_move_all_confirm: "You are attempting to move all items from this location into your tote, do you want to proceed?",
    move_stock_all_short: "ALL",
    move_stock_empty_location: "No stock at this location",
    move_stock_location_empty_hint: "Location empty — scan another location or complete the tote",
    move_stock_not_a_tote: "Barcode is not a tote",
    move_stock_tote_open: "Tote is in use",
    move_stock_tote_closed: "Tote is already awaiting put-away",
    move_stock_closed_goods_in: "Closed by Goods In — re-open it in Book In",
    move_stock_tote_stored: "Tote is already stored",
    // Move Stock — move a whole pallet crate (2026-10-26)
    move_stock_crate_title: "Move crate",
    move_stock_crate_scan_location: "Scan new location",
    move_stock_crate_units: "{count} units",
    move_stock_crate_at: "Now in {location}",
    move_stock_crate_confirm_title: "Move crate?",
    move_stock_crate_confirm_body: "Move crate {crate} with {count} units from {from} to {to}?",
    move_stock_crate_moved: "Crate {crate} moved to {to} — {count} units",
    move_stock_crate_same_location: "The crate is already in that location",
    move_stock_crate_not_a_destination: "Can't move the crate there",
    move_stock_crate_on_wave: "A picker is on the way for {title} — move the crate after the wave",
    move_stock_crate_gone: "That crate is no longer stored with stock",
    move_stock_crate_cancel: "Cancel",
    move_stock_tote_locked: "Tote in use by {name}",
    move_stock_user_has_open_tote: "Finish your open tote {tote} first",
    move_stock_unknown_location: "Location not recognised",
    move_stock_wrong_warehouse: "Location is in another warehouse",
    move_stock_not_a_source: "Can't move stock out of this location",
    move_stock_not_here: "That product isn't at this location",
    move_stock_none_left: "No more of that product here",
    move_stock_book_in_title: "Not recorded here",
    move_stock_book_in_body: "This product isn't recorded at {location}. Book one in here and move it onto your tote?",
    move_stock_book_in_confirm: "Book it in and move",
    move_stock_booked_in: "booked in",
    move_stock_barcode_not_recognised: "Barcode not recognised",
    move_stock_session_ended: "This move session has ended",
    // Move Stock — Move / Consolidate pills
    move_stock_mode_toggle: "Move Stock mode",
    move_stock_mode_move: "Move",
    move_stock_mode_consolidate: "Consolidate",
    move_stock_cons_scan_location: "Scan location to empty",
    move_stock_cons_moving: "Moving",
    move_stock_cons_units: "units",
    move_stock_cons_emptied: "Emptied",
    move_stock_cons_blocked_title: "Leave this location",
    move_stock_cons_blocked_on_wave: "A picker is on the way to {location} for {title}. Nothing has been moved — come back once it's picked.",
    move_stock_cons_blocked_reserved: "An order needs {title} and there is none anywhere else on the shelf. Nothing has been moved from {location}.",
    move_stock_cons_blocked_held: "{title} at {location} is on hold and can't be moved. Nothing has been moved.",
    move_stock_cons_blocked_empty: "No stock is recorded at {location}. Nothing to move.",
    move_stock_cons_blocked_ok: "OK",
    move_stock_cons_released_totes: "Empty tote {totes} freed — take it with you",
    move_stock_complete_only: "Complete",
    move_stock_complete_put_away: "Complete & Put Away",
    // Move Stock — Tote to tote pill (2026-10-26)
    move_stock_mode_transfer: "Tote to tote",
    move_stock_xfer_scan_source: "Scan tote to move from",
    move_stock_xfer_scan_items: "Scan items",
    move_stock_xfer_then_tote: "then scan the tote to move to",
    move_stock_xfer_in_hand: "in hand",
    move_stock_xfer_on_tote: "on tote",
    move_stock_xfer_all_in_hand: "Everything is in hand — scan the tote to move to",
    move_stock_xfer_nothing_in_hand: "Scan the items to move first",
    move_stock_xfer_moved_toast: "{count} units moved from {from} to {to}",
    move_stock_xfer_emptied_toast: "{from} is empty and freed — take it with you",
    move_stock_xfer_cancel_title: "Cancel transfer?",
    move_stock_xfer_cancel_body: "Nothing has been moved. Put the {count} items back on {from}?",
    move_stock_xfer_move_all_confirm: "Pick up everything left on {from}?",
    move_stock_xfer_not_here: "That product isn't on this tote",
    move_stock_xfer_same_tote: "That is the same tote",
    move_stock_xfer_not_awaiting: "Tote is not awaiting put-away",
    move_stock_xfer_picked: "Tote holds picked order stock — it can't be split",
    move_stock_xfer_empty: "No stock is recorded on this tote",
    move_stock_xfer_wrong_warehouse: "Tote belongs to another warehouse",
    move_stock_xfer_category: "Tote is booked in as {category} — colours can't be mixed",
    move_stock_xfer_no_category: "no colour",
    move_stock_xfer_crate: "That crate is stored with stock — use Move to relocate it",
    move_stock_xfer_not_destination: "That tote can't receive stock",
    // SKU Check workflow
    sku_check_not_found: "Barcode not recognised",
    sku_check_sku: "SKU",
    sku_check_barcode: "Barcode",
    sku_check_supplier: "Supplier",
    sku_check_weight: "Weight",
    sku_check_sellable: "Sellable",
    sku_check_unsellable: "Unsellable",
    sku_check_totals: "Sellable {sellable} · Unsellable {unsellable}",
    sku_check_no_stock: "No stock in this warehouse",
    sku_check_no_image: "No image",
    sku_check_scan_another: "Scan another barcode",

    // Goods In › SKU Finder — find a JliPkgID for one product at one quantity
    sku_finder: "SKU Finder",
    sku_finder_code_label: "EAN / ASIN / FNSKU",
    sku_finder_code_placeholder: "Scan or type the code",
    sku_finder_qty_label: "Quantity you have",
    sku_finder_search: "Search",
    sku_finder_searching: "Searching…",
    sku_finder_result_title: "Matching package",
    sku_finder_units: "{count} unit(s) — nothing else in this package",
    sku_finder_print: "Print barcode",
    sku_finder_search_again: "New search",
    sku_finder_not_found: "That code isn't in the manifests",
    sku_finder_no_package: "No package holds exactly {qty} of this product and nothing else",
    sku_finder_failed: "Search failed — try again",
    sku_finder_printer: "Printer",
    sku_finder_printer_online: "Printer connected — tap to change",
    sku_finder_printer_offline: "No printer connected — tap to choose",
    sku_finder_printed: "Label sent to printer",
    sku_finder_choose_printer: "Choose a printer first",
    sku_finder_asin: "ASIN",
    sku_finder_fnsku: "FNSKU",
    sku_finder_ean: "EAN",
    sku_finder_region: "Region",
    sku_finder_mode_package: "Package",
    sku_finder_mode_manual: "Manual Products",
    // ---- SKU Finder › Manual Products (products without barcodes) ----
    manual_products: "Manual Products",
    manual_products_list_label: "List",
    manual_products_select_list: "Choose a list",
    manual_products_no_lists: "No lists yet — an admin creates them under Admin › Warehouse › Manual Products",
    manual_products_search_label: "Identifier, barcode or title",
    manual_products_search_placeholder: "Start typing…",
    manual_products_min_chars: "Type at least 2 characters",
    manual_products_no_matches: "Nothing in this list matches",
    manual_products_more_results: "Showing the first {count} matches — keep typing to narrow down",
    manual_products_supplier: "Supplier",
    manual_products_identifier: "Product identifier",
    manual_products_barcode: "Barcode",
    manual_products_title: "Title",
    manual_products_cost: "Cost",
    manual_products_rrp: "RRP",
    manual_products_weight: "Weight (g)",
    manual_products_confirm_title: "Is this the product?",
    manual_products_confirm: "Confirm & print",
    manual_products_creating: "Creating…",
    manual_products_back: "Back to results",
    manual_products_enlarge_image: "Enlarge image",
    manual_products_created_title: "New SKU created",
    manual_products_print_again: "Print again",
    manual_products_next: "Next product",
    manual_products_create_failed: "Could not create the SKU — try again",
    manual_products_load_failed: "Could not load — try again",
    manual_products_print_failed: "Label did not print — use Print again",
    // ---- Admin › Warehouse › Bundles (plan feat-bundles.md) ----
    bundles_settings: "Bundles",
    warehouse_tile_bundles_desc: "One channel SKU that expands into component SKUs on orders",
    bundles_admin_hint: "A bundle is one channel SKU (for example a Jobalots listing) that stands for a set number of units of one or more portal SKUs. Bundles are definitions only — a bundle SKU is never a product and never holds stock. When a bundle SKU arrives on an order, the order gets the component SKUs instead, with the bundle shown as the original SKU on each line. Complete bundles is how many whole bundles the stock on hand could make.",
    bundles_new: "New bundle",
    bundles_upload: "Upload XLSX",
    bundles_template: "Template",
    bundles_export: "Export table",
    bundles_show_archived: "Show archived",
    bundles_filter_search_hint: "Search bundle SKU, title or component SKU — Enter to apply",
    bundles_filter_all_warehouses: "All warehouses",
    bundles_col_sku: "Bundle SKU",
    bundles_col_title: "Title",
    bundles_col_components: "Components",
    bundles_col_complete: "Complete bundles",
    bundles_complete_hint: "The smallest of: available ÷ quantity, across the components (available = on hand minus reserved, for the chosen warehouse or all)",
    bundles_col_jobalots: "Jobalots sync",
    bundles_col_bargainfox: "BargainFox sync",
    bundles_col_updated: "Updated",
    bundles_col_by: "Created by",
    bundles_comp_available: "{available} available",
    bundles_edit: "Edit",
    bundles_archive: "Archive",
    bundles_archived: "Archived",
    bundles_archive_confirm: "Archive bundle {sku}? Orders will no longer expand it. Orders already received keep their component lines.",
    bundles_archived_done: "Bundle archived",
    bundles_no_rows: "No bundles yet — add one or upload a spreadsheet",
    bundles_modal_new: "New bundle",
    bundles_modal_edit: "Edit bundle",
    bundles_field_sku: "Bundle SKU",
    bundles_field_sku_required: "Bundle SKU is required",
    bundles_sku_immutable_hint: "The bundle SKU cannot be changed — archive this bundle and create a new one to rename it",
    bundles_field_title: "Title",
    bundles_sync_jobalots: "Push complete-bundle stock to Jobalots",
    bundles_sync_bargainfox: "Push complete-bundle stock to BargainFox",
    bundles_components_title: "Components",
    bundles_components_required: "Add at least one component",
    bundles_comp_sku: "Portal SKU",
    bundles_comp_qty: "Quantity",
    bundles_comp_product: "Product",
    bundles_add_component: "Add component",
    bundles_remove_component: "Remove component",
    bundles_lookup: "Look up product",
    bundles_lookup_not_found: "Not an active product",
    bundles_lookup_unavailable: "Lookup unavailable — checked on save",
    bundles_save: "Save bundle",
    bundles_saved: "Bundle saved",
    bundles_upload_missing_columns: "The sheet is missing required columns: {columns}",
    bundles_upload_empty: "The sheet has no data rows",
    bundles_upload_too_many: "The sheet has more than {max} rows — split it into smaller files",
    bundles_upload_done: "Upload complete — {created} bundle(s) created, {updated} updated",
    bundles_upload_errors: "{count} bundle(s) rejected — first: {sku} (row {row}): {message}",
    bundles_upload_failed: "Upload failed — check the file and try again",
    // ---- Admin › Warehouse › Manual Products ----
    manual_products_settings: "Manual Products",
    warehouse_tile_manual_products_desc: "No-barcode lists, SKU Finder prints, exports",
    manual_products_admin_hint: "Each list is a spreadsheet of products without barcodes (supplier, product identifier, barcode, title, image URL, cost, RRP, weight). SKU Finder › Manual Products searches a list and prints a new unique SKU for the product in hand; every print is one row below and one portal product.",
    manual_products_lists_title: "Lists",
    manual_products_new_list: "New list",
    manual_products_list_name_placeholder: "List name",
    manual_products_create_list: "Create",
    manual_products_upload: "Upload XLSX",
    manual_products_template: "Template",
    manual_products_archive: "Archive",
    manual_products_archived: "Archived",
    manual_products_rows: "{count} rows",
    manual_products_skus: "{count} SKUs",
    manual_products_upload_done: "{inserted} added, {updated} updated",
    manual_products_upload_errors: "{count} rows rejected (first: row {row} — {message})",
    manual_products_upload_missing_columns: "Missing columns: {columns}",
    manual_products_upload_empty: "The file has no rows",
    manual_products_upload_failed: "Upload failed",
    manual_products_list_created: "List created",
    manual_products_list_exists: "A list with that name already exists",
    manual_products_list_archived_done: "List archived",
    manual_products_archive_confirm: "Archive this list? It leaves SKU Finder; its rows and the SKUs already printed are kept.",
    manual_products_view_rows: "View rows",
    manual_products_rows_title: "Rows in {name}",
    manual_products_rows_search: "Search rows",
    manual_products_rows_empty: "No rows uploaded yet",
    manual_products_col_id: "ID",
    manual_products_col_date: "Date",
    manual_products_col_warehouse: "Warehouse",
    manual_products_col_sku: "SKU",
    manual_products_col_list: "List",
    manual_products_col_supplier: "Supplier",
    manual_products_col_identifier: "Product ID",
    manual_products_col_barcode: "Barcode",
    manual_products_col_title: "Title",
    manual_products_col_image: "Image",
    manual_products_col_cost: "Cost",
    manual_products_col_rrp: "RRP",
    manual_products_col_weight: "Weight (g)",
    manual_products_col_by: "By",
    manual_products_filter_search_hint: "Search SKU, identifier, barcode, title, supplier…",
    manual_products_filter_all_warehouses: "All warehouses",
    manual_products_filter_all_suppliers: "All suppliers",
    manual_products_filter_all_lists: "All lists",
    manual_products_no_rows: "No manual products yet",

    // Pick face — pre-picker shelf-replenishment hub
    pick_face: "Pick Face",
    shelf_drop: "Shelf Drop",
    forecast_drop: "Forecast Drop",
    pick_queue: "Pick Queue",

    // Picking — picker-facing UI
    picking_count_ready: "{count} ready",
    picking_card_items: "Items",
    picking_card_orders: "Orders",
    picking_card_next_wave: "Next wave",
    picking_card_ready: "Ready:",
    picking_card_suggested: "Suggested",
    // Pick Advisor (2026-10-02): the Suggested toggle + the single-tile view
    picking_suggested_toggle: "Suggested",
    picking_suggested_toggle_hint: "Show only the pick Portal recommends. Switch off to pick anything else.",
    picking_suggested_badge: "Suggested for you",
    picking_suggested_includes_put_wall: "Includes Putwall orders",
    picking_suggested_none_title: "Nothing to pick right now",
    picking_suggested_none_body: "Ask a team leader what to do next.",
    picking_suggested_show_all: "Show all picks",
    picking_suggested_fallback: "The suggested pick could not start — showing all picks",
    picking_filter_age_aria: "Order age",
    picking_filter_delivery_aria: "Delivery type",
    filter_shipping_state_aria: "Shipping state",
    filter_unshipped: "Unshipped",
    filter_due_today: "Needs to go today",
    picking_filter_channel_label: "Sales channel",
    picking_filter_channel_all: "All channels",
    picking_filter_all: "All",
    picking_filter_express_label: "Express & priority orders",
    picking_filter_standard_label: "Standard delivery orders",
    picking_filter_lt1: "<1",
    picking_filter_1to2: "1–2",
    picking_filter_2_plus: "2+",
    picking_filter_custom: "Custom",
    picking_filter_custom_from: "From",
    picking_filter_custom_to: "To",
    picking_filter_custom_from_time: "From time",
    picking_filter_custom_to_time: "To time",
    picking_filter_custom_done: "Done",
    picking_filter_custom_clear: "Clear",
    picking_filter_due_today: "Must ship today",
    picking_pick_disabled: "Coming soon",
    picking_starting: "Starting wave…",
    picking_no_orders_to_pick: "No orders ready to pick yet",
    picking_already_active_wave: "Finish your active wave first",
    picking_start_failed: "Could not start a wave",
    picking_start_conflict: "Couldn't start — a previous wave left conflicting data. Release stuck/paused waves and try again.",
    picking_label_location: "Location",
    picking_label_sku: "SKU",
    picking_label_qty: "Qty",
    picking_sub_scan_location: "SCAN LOCATION",
    picking_sub_scan_items: "SCAN ITEM",
    picking_sub_scan_items_one: "SCAN ITEM",
    picking_sub_scan_tote: "SCAN TOTE",
    picking_sub_scan_york: "SCAN YORK",
    picking_sub_scan_tote_next_order: "NEXT ORDER SCAN TOTE",
    picking_sub_scan_resume_tote: "SCAN TOTE {tote} TO RESUME",
    picking_scan_resume_tote_first: "Scan tote {tote} to resume this wave",
    picking_sub_scan_first_tote: "SCAN TOTE",
    picking_wrong_location: "Wrong location",
    picking_wrong_item: "Item not at this location",
    picking_unknown_barcode: "Barcode not recognised",
    picking_scan_rejected: "Scan rejected",
    picking_sync_wait: "Syncing — scan again in a second",
    picking_sync_pending_banner: "{count} scans not synced yet — saved on this device. Keep picking, they'll send automatically.",
    picking_sync_offline_banner: "No connection — scans will be saved on this device.",
    picking_wave_interrupted: "This wave is no longer active — it may have been paused. Back to the pick list.",
    picking_unknown_tote: "Unknown tote",
    picking_tote_unavailable: "Tote not available",
    picking_tote_in_use_elsewhere: "Tote already open on another wave",
    picking_tote_held_by_picker: "Tote held by {picker} on wave #{wave}",
    picking_tote_held_by_drop_picker: "Tote held by {picker} on a Drop session",
    picking_tote_held_by_drop: "Tote held by an in-progress Drop session",
    picking_tote_swapped: "Picking into tote {tote}",
    picking_tote_already_open: "Tote {tote} is already in use",
    picking_open_tote_label: "Currently open tote",
    // Roll-cage estimate (Large picks). "unknown" is deliberate: an
    // order with nothing measured gets no number at all rather than a
    // confident 1 the picker would plan around.
    picking_roll_cages_count: "{count} roll cages",
    picking_roll_cages_unknown: "Roll cages unknown",
    picking_roll_cages_missing_one: "1 item missing measurements",
    picking_roll_cages_missing: "{count} items missing measurements",
    picking_orders_added: "{count} new order(s) added to your wave",
    picking_sub_scan_starting_location: "SCAN LOCATION",
    picking_next_order_scan_location: "NEXT ORDER SCAN LOCATION",
    picking_anchor_done: "Done",
    picking_york_order_complete: "Order complete",
    picking_york_fill_question: "How full is your york?",
    picking_york_fill_empty: "Empty",
    picking_york_fill_quarter: "1/4 full",
    picking_york_fill_half: "1/2 full",
    picking_york_fill_three_quarters: "3/4 full",
    picking_york_fill_full: "4/4 full",
    picking_york_nothing_fits: "Nothing left fits",
    picking_york_drop_off: "Drop off york",
    picking_york_drop_zone: "Drop zone",
    picking_york_bring_empty: "Bring back an empty york",
    picking_york_dropped: "York dropped",
    picking_anchor_back: "Back",
    picking_anchor_no_orders: "No more orders to pick",
    picking_invalid_starting_location: "That barcode isn't a storage location",
    picking_scan_starting_location_first: "Scan your current location to start",
    picking_scan_location_first: "Scan location first",
    picking_scan_tote_first: "Scan a tote first",
    picking_scan_york_first: "Scan a york first",
    picking_wave_complete: "Wave complete",
    picking_tote_open: "Tote open",
    picking_tote_closed: "Tote closed",
    picking_tote_reopen: "Tote reopened",
    picking_progress: "{picked}/{total} picked",

    // Missing-item flow
    picking_missing_btn: "Missing item",
    picking_missing_title: "Stock count",
    picking_missing_cmd_scan_loc: "SCAN LOCATION",
    picking_missing_cmd_scan_items: "SCAN ITEM",
    picking_missing_done: "Done counting",
    picking_missing_done_found: "Found it — finish count",
    picking_missing_cancel: "Cancel",
    picking_missing_surplus_title: "Not expected here",
    picking_missing_surplus_body: "{sku} isn't recorded at this location. Add it to the location's stock?",
    picking_missing_extra_unit_title: "Extra unit found",
    picking_missing_extra_unit_body: "You've counted more {sku} than is recorded at this location. Add another unit to its stock?",
    picking_missing_wrong_location: "Wrong location for count",
    picking_missing_unknown_barcode: "Item not recognised",
    picking_missing_section_target: "Looking for",
    picking_missing_section_others: "Others at this location",
    picking_missing_took_over: "Took over {name}'s stock check of this location",
    picking_missing_pick_relevant: "{sku} is on your pick list — {location}",
    picking_missing_relevant_heading: "On your pick list",
    picking_missing_relevant_at: "{count} needed at {location}",
    picking_missing_count_label: "{count}",
    picking_missing_starting: "Starting count…",
    picking_missing_finishing: "Resolving…",
    picking_missing_loc_required_pre: "SCAN LOCATION",

    // Location gate (step 1) — the count is worthless if it was taken at the
    // wrong shelf, so nothing else is on screen until this barcode is scanned.
    picking_missing_gate_looking_for: "Looking for {count} x {sku}",
    picking_missing_gate_why: "Scan the location label to start the count",

    // Finish confirm (step 3) — mirrors the Stock Check module's complete
    // confirm, including the remove-or-keep choice for the rest of the shelf.
    picking_missing_confirm_title: "Finish count",
    picking_missing_confirm_found: "Found {count} x {sku}",
    picking_missing_confirm_found_next: "The item goes back on your pick list — scan it into your tote next.",
    picking_missing_confirm_not_found: "Found {count} of {required} x {sku}",
    picking_missing_confirm_not_found_next: "We'll look for stock in another location. If there's none, it's flagged missing for dispatch.",
    picking_missing_confirm_others_body: "{count} other item(s) weren't found at {location}. Take them off this location?",
    picking_missing_confirm_keep_counting: "Keep counting",
    picking_missing_confirm_keep_others: "Leave the rest alone",
    picking_missing_confirm_remove_others: "Remove {count} from location",
    picking_missing_confirm_finish: "Finish count",

    // Resolution card (step 4) — the one screen that states the next action.
    picking_missing_res_found_title: "Found it",
    picking_missing_res_found_body: "Pick {count} x {sku} from {location} now.",
    picking_missing_res_elsewhere_title: "Not in this box",
    picking_missing_res_elsewhere_next: "Go to {location} — it's your next stop.",
    picking_missing_res_elsewhere_later: "Added to your walk at {location}.",
    picking_missing_res_elsewhere_note: "Stock was found in another location, so nothing is short.",
    picking_missing_res_kept_here: "{count} x {sku} found here — pick them before you move on.",
    picking_missing_res_notfound_title: "No stock anywhere",
    picking_missing_res_notfound_body: "{sku} isn't available in this warehouse — carry on picking.",
    picking_missing_res_notfound_dispatch: "{count} unit(s) across {orders} order(s) flagged missing for dispatch.",
    picking_missing_res_notfound_dispatch_none: "Flagged missing for dispatch.",
    picking_missing_res_notfound_review: "{count} order(s) had nothing left to send — flagged for a team leader.",
    picking_missing_res_continue: "Continue picking",
    picking_missing_res_finish_wave: "Finish wave",

    // Drop missing-item flow (shelf/forecast drop flag button). The gate,
    // count list, and finish confirm reuse the picking_missing_* strings —
    // only the outcome card differs (drop has no order lines to resolve).
    drop_missing_res_found_title: "Found it",
    drop_missing_res_found_body: "{count} x {sku} counted here — the stock records match. The location stays on the route.",
    drop_missing_res_short_title: "Not here",
    drop_missing_res_short_body: "Found {count} of {required} x {sku}. The stock records have been corrected.",
    drop_missing_res_written_off: "{count} unit(s) removed from this location's records.",
    drop_missing_res_continue: "Continue",

    // Unified PickingScreen (054 redesign) — labels rendered by the
    // shared <PickingScreen> across all 5 pick workflows.
    priority_high: "HIGH",
    priority_medium: "MED",
    priority_low: "LOW",
    picking_items_unit: "items",
    picking_scan_location_label: "Scan location",
    picking_scan_item_label: "Scan item",
    picking_pick_speed_label: "Pick speed",
    picking_qty_remaining: "Quantity remaining",
    picking_show_product_image: "Show product image on picker hero",
    picking_show_product_image_hint: "Renders the product photo (thumbnail) next to the SKU and quantity. Turn off for a denser hero without imagery.",
    picking_other_skus_count: "\"Units at this location\" rows",
    picking_other_skus_count_hint: "How many sibling SKUs to display when more than one open pick line shares a location. 0 hides the panel; up to 10. Anything beyond folds into \"+N more\".",
    picking_unit_skus: "SKUs",
    picking_location_change_ms: "Location-change takeover",
    picking_location_change_ms_hint: "How long the full-screen \"new location\" takeover stays up (milliseconds) when the picker finishes a location and the next pick is somewhere else. Default 2000 ms; 0 turns the takeover off (the orange highlight on the picking screen still shows).",
    picking_new_location_highlight_ms: "New-location highlight",
    picking_new_location_highlight_ms_hint: "How long the orange \"new location\" highlight (ribbon + recoloured location code) stays on the picking screen after the takeover dismisses. Default 6000 ms; 0 turns the highlight off (the takeover still shows).",
    picking_new_location_title: "New location",
    picking_new_location_ribbon: "New location — you've moved",
    picking_new_location_was: "was {location}",
    picking_units_at_location: "Units at this location",
    picking_also_more: "+{n} more",
    picking_aisle_units_title: "Units left by aisle",
    picking_aisle_units_total: "{n} left",
    picking_aisle_units_chip: "Aisle {aisle}: {n} units left",
    picking_aisle_units_here: "here",
    picking_aisle_units_btn: "Units left by aisle",
    picking_aisle_units_hint: "Still to pick",
    picking_aisle_location_units: "{location}: {n} units left",
    picking_aisle_tap_hint: "Tap a location to pick from there next",
    picking_aisle_jump_label: "Pick from {location} next",
    picking_last_picked_label: "Last picked",
    drop_last_dropped_label: "Last dropped",
    put_away_last_put_away: "Last put away",

    // Manual pick — "barcode not scanning" fallback on the directed
    // pick screens (picking waves + shelf/forecast drop). The hand
    // button in the dark action bar opens a confirm modal for the HERO
    // item only.
    picking_manual_btn: "Barcode not scanning?",
    picking_manual_title: "Manual pick",
    picking_manual_hint: "Confirm the quantity you're picking. Use this only when the item's barcode won't scan.",
    picking_manual_qty_label: "Quantity to pick",
    picking_manual_max: "Max {max}",
    picking_manual_confirm: "Confirm pick",
    picking_manual_stale: "That item is no longer the current pick — check the screen and try again.",
    picking_manual_qty_invalid: "Quantity is more than what's left to pick.",

    // Alternate barcodes — when the hero product scans as more than the
    // barcode on the dark action bar, the bar gains a yellow "+" badge;
    // tapping the barcode area opens the full list.
    picking_alt_barcodes_btn: "Show other barcodes",
    picking_alt_barcodes_title: "Other barcodes",
    picking_alt_barcodes_hint: "This product can also be scanned with any of these barcodes.",

    // Pause / resume
    picking_pause_btn: "Pause",
    picking_paused_section: "Paused waves",
    picking_paused_meta: "{picked}/{total} picked",
    picking_paused_by: "paused by {name}",
    picking_paused_unknown_by: "paused {ago}",
    picking_paused_resume: "Resume",
    // Paired waves (Alex, 2026-10-16): two pickers on one Sorting / Putwall
    // wave. The open half shows as a Join card; a half with progress is an
    // ordinary paused card with its segment badge.
    picking_segment_badge: "Segment {no} of {of}",
    picking_segment_sibling_on: "{name} on {no}",
    picking_segment_sibling_waiting: "other half waiting for a picker",
    picking_join_title: "Join {type}",
    picking_join_meta: "{lines} lines · {items} items",
    picking_join_started_by: "started by {name} {ago}",
    picking_join_started_by_short: "with {name}",
    picking_join_started: "started {ago}",
    picking_join_cta: "Join",
    picking_join_lines: "lines",
    picking_pair_toggle: "Pick as a pair",
    picking_pair_toggle_hint: "Split the next Sorting or Putwall wave between two pickers: you take the first half, the second half goes on the Join card for anyone to pick up.",
    picking_pair_single_aisle: "This wave is one aisle, so it started as a normal wave",
    picking_pair_too_small: "This wave is {units} units or fewer, so it started as a normal wave",
    picking_suggested_as_pair: "As a pair — the other half goes on the Join card",
    picking_pause_failed: "Could not pause",
    picking_resume_failed: "Could not resume",
    picking_resume_already_active: "Finish your active wave first",
    picking_resume_already_claimed: "Already claimed by another picker",
    picking_auto_paused_toast: "Wave auto-paused after {minutes} min idle",

    // Close wave (Singles only) — Pause tap opens the choice
    picking_pause_or_close_title: "Pause or close this wave?",
    picking_pause_or_close_hint: "Pause keeps every order on this wave for you to resume later. Close wave finishes here: orders you have picked go to dispatch and the rest go back to the pick queue for anyone.",
    picking_pause_choice_sub: "Keep all orders on this wave",
    picking_close_wave_btn: "Close wave",
    picking_close_choice_sub: "Send unpicked orders back to the queue",
    picking_close_loading: "Checking orders…",
    picking_close_title: "Close this wave?",
    picking_close_done_line: "{count} picked orders go to dispatch",
    picking_close_untouched_line: "{count} orders not started go back to the pick queue",
    picking_close_confirm: "Close wave",
    picking_close_keep: "Keep picking",
    picking_close_blocked_title: "Finish these orders first",
    picking_close_blocked_body: "These orders are part-picked — their items are already in your tote. Pick the rest of each one, then close the wave.",
    picking_close_blocked_row: "{picked}/{total} picked",
    picking_close_done_toast: "Wave closed — {count} orders returned to the pick queue",
    picking_close_released_toast: "Wave closed — nothing was picked, all {count} orders returned to the pick queue",
    picking_close_failed: "Could not close wave",
    picking_ago_minutes: "{m}m ago",
    picking_ago_hours: "{h}h ago",
    picking_ago_just_now: "just now",

    // Lanes admin
    lanes_settings: "Lanes",
    lanes_warehouse_filter: "Warehouse",
    lanes_refresh: "Refresh",
    lanes_empty: "No lanes for this warehouse",
    lanes_col_zone: "Zone",
    lanes_col_lane: "Lane",
    lanes_col_status: "Status",
    lanes_col_num_totes: "Number of Totes",
    lanes_col_num_auctions: "Number of Auctions",
    lanes_col_auction_end_date: "Auction End Date",
    lanes_col_totes: "Totes",
    lanes_col_auctions: "Auctions",
    lanes_col_end: "Auction End Date",
    lanes_view_table: "Table",
    lanes_view_floor: "Floor",
    lanes_view_floor_coming_soon: "Floor view — coming soon",
    lanes_stale: "Stale",
    lanes_demo_data: "Demo data",
    lanes_filter_chip_prefix: "Filtered",
    lanes_clear_filter: "Clear filter",
    lanes_kpi_total: "Total lanes",
    lanes_kpi_on_auction: "On auction",
    lanes_kpi_closing_today: "Closing today",
    lanes_kpi_outbound: "Outbound",
    lanes_kpi_idle: "Empty",
    lanes_kpi_unprocessed: "Unprocessed",
    lanes_status_lane_empty: "Lane Empty",
    lanes_status_greens: "Greens",
    lanes_status_oranges: "Oranges",
    lanes_status_pinks: "Pinks",
    lanes_status_greys: "Greys",
    lanes_status_greens_outbound: "Greens Outbound",
    lanes_status_oranges_outbound: "Oranges Outbound",
    lanes_status_apc: "APC",
    lanes_status_auction_pallets_outbound: "Auction Pallets Outbound",
    lanes_status_ready_for_auction: "Ready for Auction",
    lanes_status_auctions_filling: "Auctions – Filling",
    lanes_status_on_auction: "On Auction",
    lanes_status_auctions_ended: "Auctions Ended",
    lanes_status_unprocessed_stock: "Unprocessed Stock",
    lanes_zone_label: "Zone",
    lanes_zone_lanes_suffix: "lanes",
    lanes_zone_busy: "busy",
    lanes_zone_idle: "empty",
    lanes_zone_unprocessed: "unprocessed",
    lanes_drawer_close: "Close",
    lanes_drawer_closes_prefix: "Closes",
    lanes_status_locked: "Status locked",
    lanes_status_locked_hint: "A lane with totes or auctions can't be changed manually. The status unlocks once the lane is empty.",
    lanes_drawer_stat_totes: "Totes",
    lanes_drawer_stat_auctions: "Auctions",
    lanes_drawer_stat_walk: "Walk #",
    lanes_drawer_active_auctions: "Active auctions",
    lanes_drawer_totes_on_lane: "Totes on lane",
    lanes_drawer_no_auctions: "No active auctions on this lane.",
    lanes_drawer_no_totes: "No totes parked here.",
    lanes_drawer_lots_suffix: "lots",
    lanes_drawer_print: "Print lane label",
    lanes_drawer_open_in_locations: "Open in Locations",

    // Lanes settings (status palette editor inside /admin/settings)
    lanes_colours_section: "Lanes",
    lanes_colours_hint: "Pick a primary colour for each lane status. The pill background, border, and text are derived automatically. Changes apply to every device the next time it loads.",
    lanes_colours_reset_all: "Reset all to defaults",
    lanes_colours_reset: "Reset",
    lanes_colours_col_status: "Status",
    lanes_colours_col_colour: "Colour",
    lanes_cfg_hint: "Configure each lane status: its label, which summary tile it counts toward, the fields it carries, and its pill colour. Changes apply to every device the next time it loads.",
    lanes_cfg_label_en: "Label (English)",
    lanes_cfg_label_pl: "Label (Polish)",
    lanes_cfg_category: "Category",
    lanes_cfg_applies: "Applies to",
    lanes_cfg_flag_totes: "Totes",
    lanes_cfg_flag_auctions: "Auctions",
    lanes_cfg_flag_end_date: "Auction end date",
    lanes_cfg_cat_auction: "On Auction",
    lanes_cfg_cat_outbound: "Outbound",
    lanes_cfg_cat_stock: "Stock",
    lanes_cfg_cat_idle: "Empty",
    lanes_cfg_cat_unprocessed: "Unprocessed",
    lanes_cfg_cat_none: "None",

    // Locations admin
    locations_settings: "Locations",
    locations_settings_panel: "Locations",
    locations_settings_hint: "Upload an XLSX spreadsheet with columns: action, warehouse, zone, aisle, bay, level, walk_order, size, high_low, temperature, barcode, name, sellable. Barcode is the scan-matching value. Temperature is 1–10 (1=cold, 10=hot). Sellable controls whether stock at this location is synced to sales channels.",
    locations_total_label: "Total locations",
    locations_upload_xlsx: "Upload XLSX",
    locations_upload_empty: "Spreadsheet is empty",
    locations_upload_bad_header: "Spreadsheet must have action and barcode columns",
    locations_upload_parse_error: "Could not read spreadsheet — make sure it's a valid .xlsx file",
    locations_col_zone: "Zone",
    locations_col_barcode: "Barcode",
    locations_col_aisle: "Aisle",
    locations_col_bay: "Bay",
    locations_col_level: "Level",
    locations_col_name: "Name",
    locations_col_walk_order: "Walk #",
    locations_col_size: "Size",
    locations_col_high_low: "High/Low",
    locations_col_temperature: "Temp",
    locations_col_sellable: "Sellable",
    locations_col_shelf_drop: "Shelf Drop",
    locations_value_sellable: "Sellable",
    locations_value_unsellable: "Unsellable",
    locations_value_high: "High",
    locations_value_low: "Low",
    locations_search_placeholder: "Search locations…",
    locations_search_hint: "Search locations (Enter; append * for exact match)",
    locations_filter_all_warehouses: "All warehouses",
    locations_filter_all_types: "All types",
    locations_filter_all_sizes: "All sizes",
    locations_filter_all_high_low: "All high/low",
    locations_download_filtered: "Download filtered ({n})",
    locations_print_labels: "Print labels ({n})",
    locations_print_labels_aria: "Print racking labels for the filtered locations",
    locations_print_pick_warehouse: "Filter to one warehouse to print racking labels",
    locations_print_labels_title: "Print racking labels — {warehouse}",
    locations_print_labels_hint: "Lists the {count} high/low racking locations in the current filter — tick the ones to print. Labels print on the stock set for {warehouse}. The racking design prints the aisle, the bay on black, the level and the barcode, as on the labels already on the racking. The sorting designs print the bay slot instead.",

    // Location types admin (Settings > Locations)
    locations_types_settings: "Location Types",
    locations_types_settings_hint: "Manage the type values available in the Locations admin Type dropdown and accepted by bulk uploads. Removing a type is only possible when no active locations and no inventory currently use it.",
    locations_type_in_use: "{locations} locations · {inventory} inventory rows",
    locations_no_types_yet: "No types defined yet — add one below.",
    locations_type_name_placeholder: "e.g. storage, lane, area, pallet",
    locations_type_add: "Add type",
    locations_type_exists: "A type with this name already exists",
    locations_type_invalid: "Type names must use only lowercase letters, digits, '-' or '_'",
    locations_type_remove_title: "Remove type?",
    locations_type_remove_body: "Remove “{name}” from the type catalogue.",
    locations_type_remove_blocked: "{locations} locations and {inventory} inventory rows still use this type — clear them before removing.",
    locations_type_remove_blocked_title: "Type is in use — clear locations and inventory before removing.",
    locations_type_remove_in_use_block: "Type is still in use — refresh and try again.",
    locations_type_remove_hint: "You can re-add the type at any time.",

    // Location sizes admin (Settings > Locations)
    locations_sizes_settings: "Location Sizes",
    locations_sizes_settings_hint: "Manage the size labels available in the Locations admin Size dropdown. Removing a size leaves any locations still using it untouched, but the value will no longer be selectable.",
    locations_size_in_use: "In use by {count} locations",
    locations_no_sizes_yet: "No sizes defined yet — add one below.",
    locations_size_name_placeholder: "e.g. Small, Medium, Large",
    locations_size_add: "Add size",
    locations_size_exists: "A size with this name already exists",
    locations_size_remove_title: "Remove size?",
    locations_size_remove_body: "Remove “{name}” from the size catalogue.",
    locations_size_remove_in_use: "{count} locations currently use this size and will keep the value, but it won't be selectable for future edits.",
    locations_size_remove_blocked_title: "Size is in use — clear locations using it before removing.",
    locations_size_remove_hint: "You can re-add the size at any time.",
    locations_no_matches: "No locations match your filters",
    locations_showing_n_of_total: "Showing {n} of {total}",
    locations_showing_range: "Showing {from}–{to} of {total}",
    locations_show_more: "Show more",
    pagination_previous: "Previous",
    pagination_next: "Next",
    pagination_page_x_of_y: "Page {page} of {total}",
    per_page: "Per page",
    filter_country_all: "All {country}",
    select_all_visible: "Select all on this page",
    select_row: "Select row",
    selected_count: "{n} selected",
    change_status_to: "Change status to…",
    apply: "Apply",
    bulk_status_summary: "{n} orders updated to {status}",
    bulk_release_consolidated: "{n} released into consolidated shipment {masters}",

    // Manual fulfil confirmation (Orders → Change status to → Fulfilled)
    manual_fulfil_title_one: "Mark this order as fulfilled?",
    manual_fulfil_title: "Mark {n} orders as fulfilled?",
    manual_fulfil_body: "This consumes the stock reservation and tells the sales channel the order has shipped. It can be undone by setting the status back, but only before the channel notification is released.",
    manual_fulfil_add_tracking: "Add tracking details",
    manual_fulfil_filled_count: "{n} filled in",
    manual_fulfil_tracking_hint: "Optional. Anything you enter is saved on the order and sent to the sales channel with the fulfilment.",
    manual_fulfil_tracking_link: "Tracking link",
    manual_fulfil_carrier_placeholder: "e.g. Royal Mail",
    manual_fulfil_code_placeholder: "e.g. AB123456789GB",
    manual_fulfil_bad_link: "A tracking link must start with http:// or https://.",
    manual_fulfil_confirm: "Mark as fulfilled",

    // Locations soft-delete
    delete: "Delete",
    deleting: "Deleting…",
    locations_delete_title: "Delete location?",
    locations_delete_body: "Hide “{barcode}” from the locations list and operational scans.",
    locations_delete_hint: "The row stays in the database — restoration is a manual step if needed.",
    locations_deleted_toast: "Deleted {barcode}",

    // Locations edit popup (click a row)
    locations_edit_title: "Edit location",
    locations_row_click_hint: "Click to edit",
    locations_col_bay_position: "Bay position",
    locations_bay_position_none: "No diagram",
    locations_edit_hint: "Leave a box empty to clear that field.",
    locations_edit_barcode_superadmin: "Only a super admin can change the barcode.",
    locations_edit_barcode_rename_warning: "Changing the barcode moves all stock, totes, picks and history at this location to the new barcode. Print a new label afterwards.",
    locations_renamed_toast: "Renamed {from} to {to}",
    locations_add_button: "Add location",
    locations_add_title: "New location",
    locations_add_barcode_placeholder: "Leave blank to generate",
    locations_add_hint: "Leave the barcode blank to have one generated automatically. Only warehouse and type are required.",
    locations_add_submit: "Add",
    locations_added_toast: "Added {barcode}",
    locations_edit_required: "{field} is required",
    locations_updated_toast: "Saved {barcode}",

    // Conveyor
    collect: "Collect",
    add: "Add",
    holding_pallets: "Holding",
    manual_sorter_scan: "Manual Sort",
    add_pallet: "Add Pallet",
    scan_pallet_id: "Scan Pallet ID",
    scan_chute: "Scan Chute",
    pallet_label: "Pallet: {id}",
    chutes_needing_pallets: "Chutes needing pallets",
    no_chutes_needing_pallets: "All chutes have pallets",
    pallet_added: "Pallet added",
    add_failed: "Add failed — try again",
    collect_chute: "Collect Chute",
    scan_chute_number: "Scan Chute",
    scan_pallet_tag: "Scan Pallet",
    take_to_location: "Take to: {location}",
    scan_location_confirm: "Scan location to confirm",
    add_pallet_back: "Add pallet back?",
    wrong_chute: "Wrong chute",
    wrong_pallet: "Wrong pallet",
    wrong_location: "Wrong location",
    invalid_pallet: "Invalid Pallet ID",
    invalid_chute: "Invalid Chute",
    chute_collected: "Chute collected",
    collect_failed: "Collect failed — try again",
    no_chutes: "No chutes complete",
    complete_chutes: "Complete Chutes",
    chute_label: "Chute: {chute}",
    type_label: "Type: {type}",
    system_label: "System: {system}",
    fetch_chutes_failed: "Fetch failed — try again",
    scan_item: "Scan Item",
    scan_location_with_name: "Scan Location: {location}",
    item_label: "Item: {sku}",
    item_scanned: "Item scanned",
    scan_failed: "Scan failed — try again",
    mark_failed: "Mark failed — try again",
    pallet_collected: "Pallet collected",
    pallet_details_failed: "Details failed — try again",
    pallet_collect_failed: "Collect failed — try again",
    pallet_no_zones_left: "No free zones left — contact team leader",
    pallet_validator: "Pallet Validator",
    scan_conveyor: "Scan Conveyor",
    scan_conveyor_confirm: "Scan the conveyor barcode to confirm",
    pallet_not_in_batch: "Pallet is not part of the current date and batch",
    pallet_already_collected: "Pallet already collected",
    wrong_barcode: "Wrong barcode",

    // Zone Storage
    scan_location_barcode: "Scan Location",
    invalid_barcode: "Invalid barcode",
    invalid_warehouse: "Invalid warehouse",
    invalid_sorter: "Invalid sorter",
    invalid_bay: "Invalid bay",
    rescan_product: "Rescan Product",
    tap_to_close: "tap to close",
    wrong_location_scanned: "Wrong location: {location}",
    invalid_barcode_size: "Invalid barcode",
    warehouse_label: "Warehouse: {warehouse}",
    bay_label: "Bay: {bay}",
    scanned_label: "Scanned: {item}",
    location_label: "Location: {location}",
    sorter_1_unloader: "Sorter 1 Unloader",
    scan_location: "Scan Location",
    invalid_scan: "Invalid scan",
    location_to_lane: "Location {location} to Lane 02",
    single_item_orders: "Single Item Orders",
    scan_tag: "Scan Tag:",
    tag_label: "Tag: {tag}",
    scanned_items: "Scanned Items",
    scan_lane_close: "Scan Lane to close",
    invalid_tag: "Invalid Tag",

    // Zone Storage Settings
    zone_storage_settings: "Zone Storage Settings",
    current_settings: "Current Settings",
    change_settings: "Change Settings",
    active_batch: "Active Batch",
    active_date: "Active Date",
    sorter_1: "Sorter 1",
    sorter_2: "Sorter 2",
    change_batch: "Change Batch:",
    change_date: "Change Date:",
    set_new_values: "Set New Values",
    newport: "Newport",
    poland: "Poland",
    test: "Test",
    pembroke_dock: "Pembroke",

    // Zone Storage Settings — Batch Info
    sorter_batch_info: "Sorter {sorter} Batch Info",
    complete_pct: "Complete: {pct}%",
    scanned_of_total: "{scanned}/{total} scanned",
    pallets_scanned_of_total: "Pallets: {scanned}/{total}",
    batch_pallets_title: "Batch {batch} Pallets",
    pallet_zone_label: "Zone: {zone}",
    pallet_status_collected: "Collected",
    pallet_status_pending: "Pending",
    no_data: "No Data",

    // Zone Storage Settings — Bays
    sorter_2_bay_info: "Sorter 2 Bay Info",
    bay_title: "Bay {number} - {type}",
    lane_label: "Lane: {lane}",
    date_label: "Date: {date}",
    batch_label: "Batch: {batch}",
    zone_label: "Sorter 2 Zone: {zone}",
    unassigned: "Unassigned",

    // Zone Storage Settings — Lanes
    sorter_lanes: "Sorter Lanes:",
    lane_complete: "COMPLETE",
    lane_ready: "READY",
    lane_not_ready: "NO READY",

    // Zone Storage Settings — Search
    item_search: "Item Search:",
    search_label: "Search:",
    item_not_found: "Item not found",
    order_details: "Order details:",
    order_not_ready: "Order Not Ready Yet.",
    number_items: "Number of Items in Order: {count}",
    collected_label: "Collected: {value}",
    sent_to_ppd: "SentToPPd: {value}",
    sorter_1_scanned: "Sorter 1 Scanned: {value}",
    sorter_1_lane: "Sorter 1 Lane: {lane}",
    sorter_2_scanned: "Sorter 2 Scanned: {value}",
    sorter_2_locations_needed: "Sorter 2 Locations Needed: {count}",
    sorter_2_locations: "Sorter 2 Location/s: {locations}",

    // Zone Storage Settings — Change Confirmation
    change_s1_settings: "Change S1 Settings",
    warehouse_name: "Warehouse {warehouse}",
    new_date_label: "New Date: {date}",
    new_batch_label: "New Batch: {batch}",
    reauction_tag: "Reauction tag: {tag}",
    confirm_change: "Are you sure you want to change the settings?",
    sorter_finished_question: "Has sorter one finished or just need to quickly switch?",
    finished: "Finished",
    quick_switch: "Quick Switch",
    enter_new_date: "Please enter the new Date you would like to change to",
    set_date: "Set Date",
    enter_new_batch: "Please enter the new batch you would like to change to",
    set_batch: "Set Batch",
    confirm_proceed: "Confirm details are correct and ready to proceed?",
    change_success: "Change made successfully. Closing box in 3 seconds...",

    // Zone Storage Settings — Edit Lane
    total_items: "Total Items: {count}",
    scanned_items_count: "Scanned Items: {count}",
    unscanned_items: "Unscanned Items",
    mark_ready: "Mark as Ready",
    mark_complete: "Mark as Complete",
    confirm_ready: "Are you sure you want to ready the lane?",
    confirm_force_close: "Are you sure you want to force close the lane?",
    order: "Order",
    item: "Item",
    status: "Status",
    lane_marked_ready: "Lane {lane} ready!",
    lane_marked_complete: "Lane {lane} complete",

    // Sorter 2
    select_lane: "Select Lane",
    no_lanes: "No Lanes Available",
    lane_in_use: "Lane in use - refreshing",
    select_bay: "Select Bay",
    no_orders_ready: "No Orders Ready",
    orders_count: "{count} orders",
    orders: "Orders",
    no_orders: "No orders available",
    no_order_in_location: "No order in location {location}",
    order_number: "Order #",
    locations: "Locations",
    items: "Items",
    order_title: "Order {number}",
    priority: "PRIORITY",
    scan_tag_suffix: "Scan Tag {suffix}",
    scan_all_locations: "Scan All Locations",
    to_scan: "To Scan",
    scanned: "Scanned",
    tags_dont_match: "Tags don't match",
    // Sorter 2 → Portal dispatch refusals (BE zoneDispatch reasons)
    zone_tag_not_a_tote: "Not a tote — scan a Portal tote",
    zone_tag_unavailable: "Tote in use ({status}) — use an available tote",
    zone_tag_bound: "Tote already holds another dispatch order",
    zone_order_not_in_portal: "Order {order} not found in Portal",
    zone_order_ambiguous: "Order {order} matches more than one Portal order — ask a supervisor",
    zone_order_not_ready: "Order {order} is {status} in Portal — not ready for dispatch",
    zone_items_mismatch: "Sorted items don't match the Portal order — ask a supervisor",
    zone_allocation_failed: "Portal could not allocate stock for order {order}",
    zone_order_no_items: "Portal order {order} has no items",
    zone_order_flagged_missing: "Order {order}: no items were found at sort — flagged in Portal for a leader, nothing sent to dispatch",
    zone_singles_refused: "{count} item(s) can't go to Portal dispatch — remove the marked items and close the tag again",
    zone_singles_no_items: "No items on this tag",
    // Unsold Reauction → Portal stock move (Sorter 1 reauction tote, BE reauctionMove reasons)
    zone_tag_in_use: "Tote is in use elsewhere — close it there first",
    zone_tote_locked: "Tote is open on another screen — close it there first",
    scan_reauction_tote: "Scan Reauction Tote",
    scan_tote_id: "Scan Tote {tote}",
    reauction_tote_label: "Reauction tote: {tote}",
    zone_reauction_wrong_tote: "Wrong tote — scan tote {tote}",
    zone_reauction_tote_not_mapped: "Tote was closed by another bay — scan a new reauction tote",
    zone_reauction_not_portal_item: "Item not found in Portal stock — give it to a supervisor",
    zone_reauction_bay_mapped: "This bay is already on tote {tote}",
    zone_reauction_disabled: "Portal reauction move is off for this warehouse",
    zone_reauction_close_title: "Close reauction tote?",
    zone_reauction_close_body: "Items already moved stay in the tote. The next reauction item will ask for a new tote.",
    zone_reauction_tote_closed: "Tote {tote} closed — {count} unit(s) moved",
    zone_reauction_tote_closed_empty: "Tote {tote} closed — it was empty",
    // Unsold Grey → Portal write-off on the slot confirm (BE migration 247).
    zone_grey_not_written_off: "{item}: no Portal stock found — nothing written off, tell a supervisor",
    zone_grey_write_off_failed: "{item}: Portal write-off failed — tell a supervisor",
    location_not_in_order: "Location not in order",
    mega_order: "Mega Order",
    scan_tag_prompt: "Please Scan Tag:",
    details_correct: "Are the details correct?",
    product_not_in_lane: "Product not in your lane, give to supervisor",
    product_in_wrong_batch: "Product is in the wrong batch, give to supervisor",
    product_on_wrong_date: "Product is on the wrong date, give to supervisor",
    item_marked_as_missing: "Item marked as missing",
    locations_not_free: "Locations not free",
    item_has_no_location: "Item does not have a location, give to supervisor.",

    // Admin
    admin_panel: "Admin Panel",
    users: "Users",
    devices: "Devices",
    displays: "Displays",
    hardware: "Hardware",
    manage: "Manage",
    enter_fullscreen: "Enter Fullscreen",
    exit_fullscreen: "Exit Fullscreen",
    chute: "Chute",
    no_complete_chutes: "No Complete Chutes",
    more_chutes: "more complete chutes",

    // Side navigation + role mode toggle
    app: "App",
    nav_primary: "Primary navigation",
    sidenav_expand: "Expand navigation",
    sidenav_collapse: "Collapse navigation",
    sidenav_open: "Open navigation",
    sidenav_close: "Close navigation",
    header_env_staging: "Staging",

    // Admin homepage — KPI cards + tile descriptions
    kpi_unfulfilled: "Unfulfilled Items",
    kpi_in_picking: "Items in Picking",
    kpi_in_sorting: "Items in Sorting",
    kpi_awaiting_dispatch: "Items Awaiting Dispatch",
    kpi_fulfilled_today: "Items Fulfilled Today",
    kpi_orders_sub: "{count} orders",
    kpi_stock_blocked_sub: "{units} units stock blocked",
    kpi_sorters_breakdown: "Sorter 1: {s1} · Sorter 2: {s2}",
    kpi_active_today: "Active today",
    kpi_totes_to_put_away: "Totes to put away",
    tile_orders_desc: "Manage and search orders",
    tile_warehouse_desc: "Inventory, totes, locations, products",
    tile_sorting_desc: "Configure zone-storage sorters",
    tile_users_desc: "Staff, roles, permissions",
    tile_displays_desc: "Chute monitors and screens",
    tile_complete_chutes_desc: "Live conveyor chute status board",
    tile_hardware_desc: "Devices and printers",
    tile_settings_desc: "Operational and dispatch settings",

    // Warehouse sub-page tile descriptions
    warehouse_tile_totes_desc: "Book-in and put-away containers",
    warehouse_tile_locations_desc: "Slots, lanes, inbound areas",
    warehouse_tile_lanes_desc: "Live lanes — totes, auctions, end dates",
    warehouse_tile_products_desc: "SKU catalogue, weights, dims, barcodes",
    warehouse_tile_suppliers_desc: "Supplier list for products and manifests",
    warehouse_tile_boxes_desc: "Packaging sizes and rules",
    warehouse_tile_inventory_desc: "Stock per SKU and warehouse",
    warehouse_tile_manifest_desc: "Expected stock — POs and preorders",
    warehouse_tile_pos_desc: "POs by supplier — expected vs booked in",
    warehouse_tile_picking_desc: "Waves — active, paused, history",

    // Users
    users_panel: "Users Panel",
    add_user: "Add User",
    users_filter_search: "Search name, username, RFID, permissions",
    users_no_matches: "No users match your filters",
    users_col_name: "Name",
    users_col_warehouse: "Warehouse",
    users_col_permissions: "Permissions",
    users_col_created: "Created",
    users_col_last_active: "Last login",
    users_col_password_changed: "Password set",
    user_added: "Added {name}",
    user_deleted: "{name} deleted",
    user_force_change_done: "{name} will be asked to set a new password on their next login",
    user_suspended: "{name} suspended",
    user_unsuspended: "{name} reinstated",

    // Users page row actions
    users_status_suspended: "Suspended",
    users_rotation_pending: "Rotation pending",
    users_rotation_pending_hint: "User will be asked to set a new password on their next login",
    users_password_expired: "Password expired",
    users_password_expired_hint: "Password is more than {days} days old — they will be asked to set a new one at their next login",
    users_force_change: "Force password change",
    users_suspend: "Suspend",
    users_unsuspend: "Reinstate",
    users_quick_actions: "Quick actions",
    users_allow_concurrent: "Allow multiple devices",
    users_allow_concurrent_hint: "Off by default: signing in on a new device signs this account out everywhere else. Only turn on for shared stations or automated clients.",
    users_force_change_title: "Force password change?",
    users_force_change_body: "{name} will be asked to set a new password the next time they log in. This can't be undone except by them completing the rotation.",
    users_force_change_confirm: "Force change",
    users_suspend_title: "Suspend user?",
    users_suspend_body: "{name} will be blocked from logging in until reinstated by an admin.",
    users_suspend_confirm: "Suspend",
    users_unsuspend_title: "Reinstate user?",
    users_unsuspend_body: "{name} will be able to log in again.",
    users_unsuspend_confirm: "Reinstate",
    edit_user: "Edit User",
    delete_user: "Delete User",
    delete_confirm: "Are you sure you want to delete this user?",
    name: "Name",
    rfid_optional: "RFID Tag (optional)",
    basic: "Basic",
    adding_user: "Adding User...",

    // Devices
    device_management: "Device Management",
    device_subtitle: "Monitor and manage devices",
    device_overview: "Device Overview",
    all_warehouses: "All Warehouses",
    clear: "Clear",
    total_devices: "Total Devices",
    checked_in: "Checked In",
    checked_out: "Checked Out",
    maintenance: "Maintenance",
    scanners: "Scanners",
    handhelds: "Handhelds",
    search_devices: "Search devices...",
    all_types: "All Device Types",
    all_statuses: "All Statuses",
    phones: "Phones",
    zebras: "Zebras",
    clear_filters: "Clear Filters",
    device: "Device",
    warehouse: "Warehouse",
    switch_warehouse: "Switch warehouse",
    type: "Type",
    last_updated: "Last Updated",
    updated_by: "Updated By",
    no_devices: "No devices found",
    adjust_filters: "Try adjusting your filters",
    showing_devices: "Showing {count} of {total}",
    current_status: "Current Status",
    notes: "Notes:",
    no_notes: "No notes available",
    save_notes: "Save Notes",
    usage_history: "Usage History",
    no_history: "No history available",
    sort_updated_desc: "Last updated (newest)",
    sort_updated_asc: "Last updated (oldest)",
    sort_name_asc: "Name (A–Z)",
    sort_name_desc: "Name (Z–A)",
    sort_status: "Status",
    sort_warehouse: "Warehouse",

    // Language
    language: "Language",
    english: "English",
    polish: "Polski",

    // Camera
    camera_denied: "Camera denied",
    camera_unavailable: "Camera unavailable",

    // PWA
    pwa_install_title: "Install Portal",
    pwa_install_description: "Add to home screen for quick access",
    pwa_install_button: "Install",
    pwa_ios_install_title: "Add to Home Screen",
    pwa_ios_install_step1: "Tap the Share button below",
    pwa_ios_install_step2: "Then tap 'Add to Home Screen'",
    network_offline: "You are offline",
    streak: "STREAK",
    score_label: "POINTS",
    best_time: "BEST",
    achievement_label: "ACHIEVEMENT",
    achievement_items: "{count} ITEMS",
    chute_info: "Chute: {chute}",
    zone_info: "Zone: {zone}",
    no_zone: "No zone",
    product_not_found: "Product not found",
    scan_zone: "Scan Zone",
    item_details: "Item Details",
    order_type: "Order Type",
    chute_location: "Chute",
    sorter_1_location: "Sorter 1 Location",
    sorter_2_location: "Sorter 2 Location",
    weight_label: "Weight",
    bay: "Bay",
    day: "Day",
    sent_to_ppd_label: "Sent to PPd",

    // Dispatch
    dispatch: "Dispatch",
    scan_desk: "Scan Desk",
    scan_desk_prompt: "Scan your packing desk barcode",
    scan_item_dispatch: "Scan Item",
    no_order_found: "No order found for this item",
    order_already_shipped: "Order already processed",
    already_scanned: "Already scanned",
    unscan: "Undo scan",
    item_not_in_order: "Item not in this order",
    item_not_in_order_number: "\"{value}\" is not in order #{order}. If this order shouldn't be open, use the back arrow to leave it.",
    leave_order: "Leave order",
    leave_order_warning: "Leave order #{order}? Your scans and boxes stay saved with the order — whoever opens it next carries on from here. Use Reset order to clear them.",
    item_missing: "Missing",
    dispatch_item_missing_chip: "{count} missing",
    dispatch_item_refund_chip: "{count} to refund",
    dispatch_added_to_consignment: "Added to existing consignment {waybill} — only the new box label(s) below were printed.",
    item_damaged: "Damaged",
    item_wrong: "Wrong Item",
    item_barcode_damaged: "Manual",
    confirm_missing: "Tap again to confirm missing",
    confirm_damaged: "Tap again to confirm damaged",
    all_items_scanned: "Complete",
    confirm_shipment: "Confirm Shipment",
    how_many_boxes: "How many boxes?",
    total_weight: "Total weight",
    items_to_ship: "items to ship",
    book_and_print: "Book & Print Labels",
    print_label: "Print Label",
    print_labels: "Print Labels",
    scan_to_print: "Scan to print",
    printing: "Printing...",
    print_failed: "Print failed — please try again",
    label_printed: "Label printed",
    checking_printer: "Checking printer...",
    print_agent_required: "Print Agent Required",
    print_agent_not_installed: "Print Agent not installed",
    print_agent_update_available: "Print Agent update available",
    print_agent_update_desc: "A newer version of the Print Agent is available. Download and install to get the latest features.",
    download_latest: "Download latest",
    print_agent_desc: "Download and install the Print Agent to enable silent label printing on this device.",
    download_print_agent: "Download Print Agent",
    install_on_any_pc: "Install on any PC",
    agent_version: "Agent",
    agent_update_required: "Update required",
    agent_network: "Network & device",
    agent_network_title: "Device — {id}",
    agent_printer: "Printer",
    agent_restart: "Restart agent",
    agent_reboot: "Reboot device",
    agent_test_print: "Print test label",
    agent_rediscover: "Find printer",
    agent_confirm_restart: "Restart the print agent on \"{id}\"? Printing pauses for a few seconds.",
    agent_confirm_reboot: "Reboot \"{id}\"? It will be offline for about a minute.",
    agent_command_done: "Done: {detail}",
    agent_command_failed: "Failed: {detail}",
    agents_needing_update: "Agents needing update",
    agent_devices: "Agent devices",
    last_seen: "Last seen",
    print_agent_installed: "Print Agent installed",
    retry_connection: "Retry Connection",
    connect_printer: "Connect Printer",
    select_printer: "Select Printer",
    network_printers: "Network Printers",
    no_printers_available: "No printers available",
    printer_offline: "Offline",
    print_job_queued: "Print job sent",
    print_job_failed: "Print job failed",
    change_printer: "Change Printer",
    selected_printer: "Selected Printer",
    printers: "Printers",
    friendly_name: "Name",
    system_name: "System Name",
    hostname: "Hostname",
    status_online: "Online",
    mobile_enabled: "Mobile Printing",
    rename_printer: "Rename",
    printer_updated: "Printer updated",
    no_printers_registered: "No printers registered",
    search_printers: "Search by printer, shortcut, or computer...",
    search_this_computer: "Search this computer",
    set_my_computer: "Set my computer",
    enter_computer_name: "Enter this device's computer name.\n\nTip: open Start and type 'About' — your PC name appears at the top. Or press Win+R, type 'cmd', then 'hostname'.",
    edit: "Edit",
    show_hidden: "Show Hidden",
    hide_hidden: "Hide Hidden",
    hide_printer: "Hide",
    unhide_printer: "Unhide",
    all: "All",
    select: "Select",
    select_warehouse_first: "Select a warehouse first",
    enter_warehouse: "Enter warehouse",
    chutes: "CHUTES",
    tap_to_enable_sound: "Tap to enable sound",
    waiting_for_chutes: "Waiting for chutes...",
    local: "This Device",
    local_printer: "Local Printer",
    this_device: "Connected directly",
    print_agent_not_found: "Print Agent not detected — make sure it is running",
    auto_print: "Auto Print",
    print: "Print",
    fetching_label: "Requesting label...",
    label_fetch_failed: "Could not get label from courier",
    // Dispatch own-label flow: the order ships on an uploaded shipping-label
    // attachment, so no courier is booked and this label is printed instead.
    own_label_shipment: "Ships on uploaded label — no courier booked",
    print_attached_label: "Print Attached Label",
    attached_label_fetch_failed: "Could not load the attached label",
    reopen_order: "Reopen",
    reopen_warning: "Shipping labels will be cancelled and new labels must be printed. Items will stay in their boxes.",
    reopen_confirm: "Reopen & Cancel Labels",
    reopen_failed: "Could not reopen the order — please try again",
    reopen_busy: "This order is already being reopened — wait a few seconds and scan it again",
    reopen_partner_notified: "The sales channel was already notified of this shipment. Updated parcel details will be sent when you re-ship.",
    print_all: "Print All Labels",
    download: "Download",
    download_all: "Download All Labels",
    download_failed: "Download failed",
    continue_label: "Continue",
    order_shipped: "Order Shipped!",
    ship_order: "Ship Order",
    ship_failed: "Shipment failed — please try again",
    ship_failed_title: "Shipment failed",
    refund_queued: "Refund queued for",
    items_flagged: "Items flagged",
    cancel_order_all_unavailable: "All items unavailable — cancel order?",
    add_box: "Add Box",
    retry: "Retry",
    label_error_title: "Label Error",
    label_generation_failed: "Labels could not be generated. Check the order details below and try again.",
    delivery_address: "Delivery Address",
    billing_address: "Billing Address",
    address_line_1: "Address line 1",
    address_line_2: "Address line 2",
    company: "Company",
    company_optional: "Company (optional)",
    city: "City",
    county: "County",
    postcode: "Postcode",
    country: "Country",
    phone: "Phone",
    phone_country_code: "Country dial code",
    phone_invalid_for_country: "Mobile number doesn't match the expected length for that country.",
    billing_phone_invalid_for_country: "Billing mobile number doesn't match the expected length for that country.",
    email: "Email",
    placed_at: "Placed at",

    // Settings > Dispatch > Shipments release scheduling
    // Settings › Dispatch › Channel cut-offs & dashboard metrics (2026-10-13)
    channel_rules_settings: "Channel cut-offs & dashboard metrics",
    channel_rules_hint: "Per sales channel: whether its orders count in the dashboard sales metrics, and the weekday grid of order cut-off and ship-by day (standard and express) that decides when an order is due — on the dashboard, the Pick Queue clock filter and Admin Orders alike. A change applies from today; earlier days keep the rule that was in force.",
    channel_rules_default_title: "Warehouse default",
    channel_rules_default_hint: "The grid every channel without its own uses, and the ship cut-off: due orders must have shipped by this time on their due day (the race finish line and the on-time score).",
    channel_rules_ship_cutoff: "Ship cut-off",
    channel_rules_day_col: "Day",
    channel_rules_standard: "Standard",
    channel_rules_express: "Express / priority",
    channel_rules_cutoff_col: "Order cut-off",
    channel_rules_ships_col: "Ships",
    channel_rules_no_cutoff: "no cut-off",
    channel_rules_same_day: "same day",
    channel_rules_channels_title: "Channels",
    channel_rules_channel_col: "Channel",
    channel_rules_orders_col: "Orders (90 days)",
    channel_rules_metrics_col: "On dashboard metrics",
    channel_rules_grid_col: "Cut-offs",
    channel_rules_uses_default: "Warehouse default",
    channel_rules_custom: "Custom grid",
    channel_rules_edit_grid: "Edit grid",
    channel_rules_use_default: "Use warehouse default",
    channel_rules_since: "since {date}",
    channel_rules_by: "by {name}",
    channel_rules_builtin: "built-in defaults (nothing saved yet)",
    channel_rules_not_saved: "default",
    channel_rules_saved: "Saved — applies from today",
    channel_rules_applies_from: "Saving applies from today ({date}); earlier days keep the previous rule.",
    channel_rules_history: "History",
    channel_rules_no_channels: "No orders in the last 90 days",
    channel_rules_bad_time: "{day}: cut-off must be HH:MM or empty",
    channel_rules_midnight_cutoff: "{day}: a 00:00 cut-off — leave it empty for no cut-off",
    channel_rules_bad_ship_days: "{day}: ships must be within 6 days",
    channel_rules_not_monotone: "{next} orders would ship before {day}'s",
    dispatch_shipments_release: "Shipments notification release",
    dispatch_shipments_release_hint: "Controls when the /shipments push is sent to the sales channel after pack-complete. 'Immediate' fires within ~30s. 'Cutoff' holds every shipment notification until the daily cutoff time — handy if you want operators to fix labels before the buyer is notified.",
    dispatch_shipments_release_mode_col: "Mode",
    pallet_orders_settings: "Pallet orders",
    pallet_orders_settings_hint: "How a pallet order from a sales channel arrives at each warehouse. A pallet order is one whose every line is a pallet SKU: a whole all-pallet order, or the _PAL half that a mixed order is divided into when it arrives. Parcel orders, and the parcel half of a mixed order, are never affected.",
    pallet_order_status_col: "Arrives as",
    pallet_order_status_unfulfilled: "Unfulfilled",
    pallet_order_status_on_hold: "On hold",
    pallet_order_status_unfulfilled_note: "Routed straight to Pallet Picks.",
    pallet_order_status_on_hold_note: "Held on arrival. Release it from the Orders page (status → Unfulfilled) to send it to Pallet Picks.",
    dispatch_shipments_release_time_col: "Cutoff time",
    dispatch_shipments_release_timezone_col: "Timezone",
    dispatch_shipments_release_schedule_col: "Schedule",
    dispatch_shipments_immediate_delay: "Delay before sending",
    dispatch_shipments_immediate_delay_hint: "Immediate mode holds the notification for a short delay (default 15 min) so an order can still be reopened and corrected before the sales channel is told it shipped. 0 sends straight away.",
    dispatch_shipments_release_immediate: "Immediate",
    dispatch_shipments_release_cutoff: "Daily cutoff",
    shipped_items: "Shipped",
    parcels_count: "parcels",
    parcel: "Parcel",
    box_label: "Box",
    boxes_label: "Boxes",
    item_singular: "item",
    item_plural: "items",
    from_label: "FROM",
    deliver_to_label: "DELIVER TO",
    remove_box: "Remove Box",
    remove_box_confirm: "Box {box} has items scanned into it. Removing it will unscan those items. Are you sure?",
    remove_box_confirm_question: "Are you sure you want to delete this box and remove all of the items in the box?",
    will_be_unscanned: "will be unscanned",
    empty_boxes_warning: "Box {boxes} has no items. Scan items into it or remove it.",
    empty_boxes_warning_rebook: "Box {boxes} has no items. Move items into it and the label will be re-booked for {packed} parcel(s), or remove it to keep the current label.",
    scan_box_before_complete: "Scan a box barcode before completing the order.",
    scan_box_prompt: "Scan box",
    box_override_title: "Different box scanned",
    box_override_dismiss_hint: "Scanned by mistake? Close this window and the box will be removed from the order.",
    box_override_question: "You scanned {scanned} instead of the recommended {recommended}. Why was that?",
    box_override_reason_items_dont_fit: "Items don't fit",
    box_override_reason_items_too_heavy: "Items too heavy",
    box_override_reason_box_unavailable: "Recommended box unavailable",
    box_override_reason_smaller_box_fits: "A smaller box fits",
    box_override_reason_extra_protection: "Extra protection needed",
    recommended_boxes: "Recommended",
    next_box: "Next box",
    box_recommendation_no_fit: "No available box fits this order — pick manually",
    box_recommendation_skipped: "{count} item(s) missing dimensions — skipped",
    box_recommendation_diagonal: "Place diagonally: {skus}",
    box_recommendation_fragile: "Fragile order",
    box_recommendation_fragile_on: "Fragile — no mailbags",
    box_recommendation_fragile_clear: "Tap to drop the fragile restriction",
    box_recommendation_settings: "Box Recommendation",
    box_recommendation_settings_hint: "Per-warehouse tolerances used by the dispatch pack screen to suggest the smallest box(es) that fit each order.",
    dispatch_void_fill_pct: "Void fill tolerance (%)",
    dispatch_void_fill_pct_hint: "Extra space inside the box reserved for void fill, as a percentage of box volume. Default: 15.",
    dispatch_packing_tolerance_mm: "Packing tolerance (mm)",
    dispatch_packing_tolerance_mm_hint: "Slack subtracted from each box dimension when checking item fit — accounts for imperfect packing. Default: 10.",
    dispatch_stock_aware_recommendation: "Consider box stock",
    dispatch_stock_aware_recommendation_hint: "When ON, only boxes with stock recorded (current stock above zero) are recommended. Leave OFF if this warehouse doesn't track box inventory — every configured box stays eligible.",
    dispatch_diagonal_recommendation: "Diagonal placement",
    dispatch_diagonal_recommendation_hint: "When ON, a long item that doesn't fit any box straight can be recommended a smaller box, cardboard mailer or plastic mailbag it fits placed diagonally (flat, rotated towards the corners). The pack screen tells the operator which items to angle. Default: ON.",
    dispatch_diagonal_tolerance_mm: "Diagonal tolerance — boxes (mm)",
    dispatch_diagonal_tolerance_mm_hint: "Packing tolerance used instead of the standard one when checking a DIAGONAL fit in rigid boxes — tilted items meet the walls corner-first, so allow more slack. Default: 10 (double the standard tolerance).",
    dispatch_diagonal_bag_tolerance_mm: "Diagonal tolerance — mailbags (mm)",
    dispatch_diagonal_bag_tolerance_mm_hint: "Packing tolerance used when checking a DIAGONAL fit in plastic and cardboard mailbags — both are flat-packed wraps, so a diagonal item sits equally tight in either. Kept separate from rigid boxes so the wrap containers can be given extra slack on their own. Default: 10 (double the standard tolerance).",
    dispatch_extra_protection_excluded_boxes: "Boxes not allowed for extra protection",
    dispatch_extra_protection_excluded_boxes_hint: "Select the box types a product marked \"Extra protection needed\" must NOT be packed in — the recommender skips them and suggests the next container that fits. Leave all unselected to allow every box. Selection applies to the whole shipment: one fragile item rules the box out for everything travelling with it.",
    dispatch_extra_protection_excluded_boxes_none: "No boxes configured",

    // Dispatch admin (settings page) + Dispatch FE box-scan flow
    dispatch_settings: "Dispatch",
    dispatch_settings_hint: "Per-warehouse packing desks and boxes used at the dispatch station.",
    desks_settings: "Packing Desks",
    desks_settings_hint: "Add and remove packing desks per warehouse. The barcode is generated automatically from the warehouse code.",
    dispatch_warehouse_toggles: "Warehouse Toggles",
    dispatch_warehouse_toggles_hint: "Per-warehouse feature flags that apply to the dispatch pack screen.",
    dispatch_show_images: "Show Images",
    dispatch_show_images_hint: "When on, the pack screen renders product images for each item. When off, every item shows a grey placeholder thumbnail (useful when image URLs aren't reachable from the warehouse network).",
    dispatch_box_recommendation_enabled: "Box Recommendation",
    dispatch_box_recommendation_enabled_hint: "When on, the pack screen shows a banner suggesting the smallest box(es) that fit the order. Tolerances are configured below.",
    add_desk: "Add Desk",
    desk_name: "Desk name",
    remove_desk: "Remove desk",
    no_desks_yet: "No desks yet",
    confirm_remove_desk: "Remove desk {name}? Operators will no longer be able to scan it. This can't be undone.",
    desk_unknown: "Unknown desk",
    edit_desk: "Edit desk",

    // Courier pallets (Settings > Dispatch) — conveyor unload
    carrier_bays_settings: "Courier Pallets",
    carrier_bays_settings_hint: "One barcode per pallet or cage at the conveyor unload point, each bound to a courier. The Conveyor Unload page names the courier for every parcel and the operator confirms by scanning the pallet.",
    add_bay: "Add pallet",
    edit_bay: "Edit pallet",
    bay_name: "Pallet name",
    bay_carrier: "Courier",
    bay_sort_codes: "Sort codes",
    bay_sort_codes_hint: "Which of this courier's parcels go on this pallet, comma separated. APC: the number in the black block on the label (e.g. 1, 2). InPost: 24, 48 or LOCKER. Leave empty for the courier's catch-all pallet.",
    remove_bay: "Remove pallet",
    no_bays_yet: "No courier pallets yet",
    confirm_remove_bay: "Remove pallet {name}? Operators will no longer be able to scan it. This can't be undone.",

    // Scansheet locations (Settings > Goods In > Scan Sheet)
    scansheet_locations_settings: "Location Barcodes",
    scansheet_locations_settings_hint: "Operators scan one of these barcodes to set the warehouse and position recorded against every scan in the session. Removed barcodes are hidden from operators but preserved for the historical scan log.",
    add_location: "Add Location",
    edit_location: "Edit location",
    remove_location: "Remove location",
    location_barcode: "Barcode",
    location_position: "Position",
    location_warehouse: "Warehouse",
    no_locations_yet: "No locations yet",
    confirm_remove_location: "Hide location {barcode}? Operators will no longer be able to scan it. It will remain in the database for historical scan logs.",
    location_barcode_taken: "This barcode is already in use",
    position_goods_in: "Goods-In",
    position_envelopes: "Envelopes",
    position_pallets: "Pallets",
    desk_display_name_en: "Display name (English)",
    desk_display_name_pl: "Display name (Polish)",
    ship_in_packaging: "Ship in packaging",
    ship_in_packaging_hint: "When TRUE, the product has previously shipped in its own retail packaging — at dispatch the item's 'Ship in own packaging' button is highlighted as a hint. Nothing is pre-selected; the packer still chooses.",
    ship_in_packaging_box_name: "Own packaging",
    ship_in_own_packaging_action: "Ship in own packaging",
    ship_in_own_packaging_hinted: "Ship in own packaging (this product has shipped in its own packaging before)",
    ship_in_packaging_no_dims: "Add product dimensions to enable",
    ship_in_packaging_enabled: "{sku} marked ship-in-packaging",
    ship_in_packaging_weight_kg: "Weight (kg)",
    ship_in_packaging_prefilled_sku: "Filled in from the last time this SKU was packed ({name}, {date}). Change anything that is different and it is saved for next time.",
    ship_in_packaging_prefilled_asin: "Filled in from {sku}, the same product (ASIN {asin}), packed by {name} on {date}. Change anything that is different and it is saved for next time.",
    ship_in_packaging_prefilled_catalogue: "Filled in from the product's catalogue size. Change anything that is different and it is saved for next time.",
    boxes_settings: "Boxes",
    boxes_settings_hint: "Add boxes per warehouse with dimensions, weight, and stock. Operators scan a box's barcode at dispatch to assign it.",
    archive_box: "Archive box",
    edit_box: "Edit box",
    dimensions_label: "Dimensions",
    barcode_label: "Barcode",
    forecast: "Forecast",
    forecast_avg_daily: "Avg / day (last 7 days)",
    forecast_to_buy: "Suggested order",
    forecast_units: "units",
    forecast_from: "from",
    forecast_no_config: "Set supplier, target days, lead time, and buffer to get a reorder suggestion.",
    forecast_current_stock: "Current stock",
    box_reorder_section: "Supplier & reorder",
    box_supplier_name: "Supplier",
    box_supplier_none: "— No supplier —",
    box_supplier_inactive: "archived",
    box_unit_cost: "Unit cost (£)",
    box_target_days: "Days of stock",
    box_lead_time: "Lead time (days)",
    box_buffer_units: "Buffer (units)",
    box_min_purchase: "Min purchase",
    box_purchase_increment: "Purchase increment",
    drag_to_reorder: "Drag to reorder",
    forecast_range_days: "{days} days",
    forecast_avg_daily_range: "Avg / day (last {days} days)",
    box_name: "Box name",
    box_dimensions_external_hint: "Enter external dimensions (the size you'd measure with a tape). Internal usable space is reduced by the cardboard wall thickness chosen below.",
    box_wall_type: "Wall type",
    box_wall_type_single: "Single wall (−8mm per axis)",
    box_wall_type_double: "Double wall (−14mm per axis)",
    box_wall_type_mailbag: "Plastic mailbag (measured flat)",
    box_wall_type_cardboard_mailbag: "Cardboard mailbag (−5mm per axis, max height)",
    box_height_na_mailbag: "Flat — no height",
    box_max_height_mm: "Max height (mm)",
    box_label_size_title: "Box label size",
    box_label_size_btn: "Label size",
    box_label_size_hint: "Leave blank to print box labels at this warehouse's Wipe label size (currently {w} × {h} mm). Set values here only if the box label printer is loaded with different stock.",
    box_label_width_mm: "Label width (mm)",
    box_label_height_mm: "Label height (mm)",
    box_wall_type_hint: "Cardboard takes up real space inside the box. Single-wall boxes lose ~8mm off each axis; double-wall ~14mm. Mailbags are measured flat (length × width): plastic loses nothing, cardboard mailbags lose ~5mm per axis and take a max filled height. Items marked Extra protection are never recommended a plastic mailbag.",
    box_primary_large: "Primary large box",
    box_primary_large_badge: "Primary Large",
    box_primary_large_hint: "Use this box as the default biggest box for recommendations. Larger boxes are only suggested when an item's dimensions genuinely need them. One per warehouse — ticking this un-ticks any other box.",
    box_length_mm: "Length (mm)",
    box_width_mm: "Width (mm)",
    box_height_mm: "Height (mm)",
    box_weight_g: "Weight (g)",
    box_max_weight_g: "Max contents weight (g)",
    box_max_weight_placeholder: "Optional",
    box_max_weight_meta: "max {kg}kg",
    box_max_weight_invalid: "Max weight must be blank or a number above 0",
    box_max_fill_mm: "Max filled thickness (mm)",
    box_max_fill_placeholder: "Optional — uncapped",
    box_max_fill_hint: "The recommender will not suggest this bag for contents thicker than this. Never sent to carriers.",
    box_max_fill_meta: "≤ {cm} cm filled",
    box_max_fill_invalid: "Max thickness must be blank or a number above 0",
    pack_over_box_max: "Over box limit {limit}kg ({weight}kg)",
    pack_over_carrier_max: "Over carrier limit {limit}kg ({weight}kg)",
    box_stock: "Stock",
    add_inventory: "Add inventory",
    add_units: "Units to add",
    no_boxes_yet: "No boxes yet",
    confirm_archive_box: "Archive box {name}? Operators will no longer be able to scan it. This can't be undone.",
    box_unknown: "Unknown box",
    box_wrong_warehouse: "That box belongs to another warehouse",
    scan_is_transparency_label: "That's an Amazon Transparency label — it identifies the single unit, not the product. Scan the item's own barcode instead.",
    scan_is_url_qr: "That's a website QR code on the packaging, not a product barcode. Scan the item's own barcode instead.",
    scan_is_logistics_label: "That's a courier / logistics label, not a product barcode. Scan the item's own barcode instead.",
    scan_belongs_to_order: "{item} — belongs to order #{order}, not this one. It looks mis-sorted.",
    scan_belongs_to_order_tote: "{item} — belongs to order #{order} (tote {tote}), not this one. It looks mis-sorted.",
    scan_belongs_to_no_order: "{item} — not on this order, and not on any recent order here.",
    box_form_invalid: "Name + dimensions + weight required",
    box_units_invalid: "Enter at least 1 unit",
    printer_select: "Choose printer",
    scan_box_to_add: "Scan a box barcode to add",
    scan_box_to_reassign: "Scan a box barcode to reassign",
    assign_box_1_first: "Assign Box 1 first",
    weight_breakdown: "Items {items} kg + Box {box} kg",
    size_prefix: "Size:",
    add_box_hint: "Scan a box barcode, or enter custom dimensions below.",
    custom_box_name: "Custom",
    length_cm: "Length (cm)",
    width_cm: "Width (cm)",
    height_cm: "Height (cm)",
    weight_g: "Weight (g)",
    units_in_container: "Units in this container",
    idle_alert: "Are you still there?",
    idle_alert_sub: "No scanning activity detected",
    im_here: "I'm here",
    session_stats: "Session Stats",
    dispatch_scanned: "scanned",
    dispatch_shipped: "shipped",
    order_title_label: "Order",
    orders_part_of_parent: "Part of order {parent}",
    orders_related_orders: "Related orders",
    orders_view_related: "Open this related order",
    orders_related_open_failed: "Couldn't open the related order",
    orders_consolidated_children: "Consolidated orders in this shipment",
    orders_consolidated_into: "Consolidated into shipment {master}",
    orders_remove_from_shipment: "Remove from shipment",
    orders_remove_from_shipment_title: "Remove order from shipment?",
    orders_remove_from_shipment_body: "Order {order} will leave consolidated shipment {master} and ship on its own. It will not be merged back into a shipment automatically.",
    orders_remove_from_shipment_last_note: "It is the last order in the shipment, so {master} will be cancelled.",
    orders_remove_from_shipment_confirm: "Remove {order}",
    orders_removed_from_shipment: "{order} removed from shipment {master} — it now ships on its own",
    orders_removed_from_shipment_last: "{order} removed — shipment {master} had no orders left and was cancelled",
    orders_consolidated_lines_hint: "These lines are copies of the consolidated orders' lines and can't be edited here. To change what ships, remove an order from the shipment.",
    orders_shipped_via_master: "Shipped as part of consolidated order {master}",
    order_tab_details: "Details",
    attachments_tab: "Attachments",
    attachments_upload: "Upload file",
    attachments_hint: "PDF, PNG, JPG, XLSX or CSV — max 10 MB",
    attachments_empty: "No attachments on this order yet",
    attachments_uploaded: "Attachment uploaded",
    attachments_too_large: "File is too large — 10 MB maximum",
    attachments_file_missing: "This file is no longer available — please re-upload it",
    attachments_mark_shipping_label: "Mark as shipping label",
    attachments_shipping_label_badge: "Shipping label",
    attachments_delete_confirm: "Delete {filename}? This cannot be undone.",
    attachments_download: "Download",
    attachments_delete: "Delete",
    attachments_col_file: "File",
    attachments_col_size: "Size",
    attachments_col_uploaded_by: "Uploaded by",
    attachments_col_date: "Date",
    attachments_col_actions: "Actions",

    // Bulk shipping-label upload (Orders ⋯ menu)
    orders_bulk_labels: "Upload shipping labels",
    bulk_labels_title: "Upload shipping labels",
    bulk_labels_intro: "Each file is matched to an order by its filename — any part between underscores can be the order number, so 1_407-1591342-5410759.pdf attaches to order 407-1591342-5410759. Ticked files are attached as that order's shipping label.",
    bulk_labels_resolving: "Matching {n} files to orders…",
    bulk_labels_resolve_failed: "Could not match the files to orders — try again",
    bulk_labels_summary: "{ready} ready · {has_label} already have a label · {unmatched} cannot be attached",
    bulk_labels_done_summary: "{done} attached · {failed} failed",
    bulk_labels_col_include: "Attach",
    bulk_labels_col_file: "File",
    bulk_labels_col_order: "Order",
    bulk_labels_col_status: "Status",
    bulk_labels_choose_order: "Choose the order…",
    bulk_labels_status_ready: "Ready",
    bulk_labels_status_has_label: "Already has a shipping label — tick to replace",
    bulk_labels_status_not_found: "No order with this number",
    bulk_labels_status_ambiguous: "Several orders match — choose one",
    bulk_labels_status_invalid_type: "Not a PDF, PNG or JPG",
    bulk_labels_status_too_large: "Over 10 MB",
    bulk_labels_status_uploading: "Uploading…",
    bulk_labels_status_done: "Attached",
    bulk_labels_status_failed: "Failed",
    bulk_labels_upload_n: "Attach {n} labels",
    bulk_labels_toast_done: "{n} shipping labels attached",
    bulk_labels_toast_partial: "{done} shipping labels attached, {failed} failed — see the table",

    // Claims tab (order detail modal) — order-claims.tsx
    claims_tab: "Claims",
    claims_intro: "Select the parcel(s) that were lost or damaged, then the item(s) inside them. Claims are batched and emailed to the carrier on the schedule set under Settings > Integrations > Carriers.",
    claims_no_parcels: "No parcels have been shipped on this order yet, so there is nothing to claim against.",
    claims_parcels_heading: "Parcels",
    claims_select_all_parcels: "Select all parcels",
    claims_unselect_all_parcels: "Unselect all parcels",
    claims_select_all_items: "Select all",
    claims_unselect_all_items: "Unselect all",
    claims_items_selected: "{n} of {of} items",
    claims_packed_in_parcel: "{n} packed in this parcel",
    claims_carrier_not_supported: "{carrier} claims are not set up in Portal yet — please raise this claim manually with the carrier for now.",
    claims_carrier_disabled: "Claims for {carrier} are switched off. Enable them under Settings > Integrations > Carriers to submit from here.",
    claims_carrier_mixed: "The selected parcels were sent with different carriers — raise one claim per carrier.",
    claims_type_label: "Claim type",
    claims_type_loss: "Loss",
    claims_type_part_loss: "Part loss",
    claims_type_damage: "Damage",
    claims_cost_label: "Claim value £",
    claims_notes_label: "Notes for the carrier",
    claims_notes_placeholder: "Optional — e.g. box arrived crushed, two units broken",
    claims_total: "Claim total",
    claims_submit: "Raise claim ({n} lines)",
    claims_submitted: "Claim raised — it will go to the carrier in the next submission",
    claims_failed: "Failed to raise claim",
    claims_existing_heading: "Claims on this order",
    claims_existing_empty: "No claims raised on this order yet",
    claims_status_pending: "Awaiting submission",
    claims_status_submitted: "Submitted {date}",
    claims_col_parcel: "Parcel",
    claims_col_sku: "SKU",
    claims_col_type: "Type",
    claims_col_cost: "Value",
    claims_col_status: "Status",
    claims_col_by: "Raised by",
    claims_col_actions: "Actions",
    claims_cancel: "Cancel",
    claims_cancel_aria: "Cancel claim for {sku}",
    claims_cancel_confirm: "Cancel the claim for {sku}? It will not be sent to the carrier.",
    claims_cancelled: "Claim cancelled",
    claims_cost_source_invoice: "invoice",
    claims_cost_source_portal: "Portal",
    claims_cost_source_invoice_title: "Priced from Amazon Liquidation Program invoice {invoice} — the figure the carrier receives",
    claims_cost_source_portal_title: "No supplier invoice found for this SKU — the entered value is used",
    claims_invoices_download: "Supplier invoices (PDF)",
    claims_invoices_downloading: "Preparing PDF…",
    claims_invoices_row_aria: "Download the supplier invoice for {sku}",
    claims_invoices_failed: "Could not build the supplier invoices PDF",

    // Carrier claims settings (Settings > Integrations > Carriers)
    carriers_claims_toggle: "Automatic claims submissions",
    carriers_claims_hint: "Emails pending lost/damaged claims from the Orders page to the carrier on a schedule.",
    carriers_claims_settings: "Claims settings",
    claims_settings_title: "Claims submission settings",
    claims_settings_from: "From address",
    claims_settings_from_name: "From name",
    claims_settings_to: "To address",
    claims_settings_cc: "CC address",
    claims_settings_reply_to: "Reply-to address",
    claims_settings_subject: "Subject",
    claims_settings_body: "Body text",
    claims_settings_placeholders: "{date} is replaced with the submission date (dd/mm/yy) and {count} with the number of claims. Several addresses can be separated with commas. The From address must be a verified sender in Amazon SES.",
    claims_settings_frequency: "Claim frequency",
    claims_freq_daily: "Daily",
    claims_freq_weekly: "Weekly",
    claims_freq_monthly: "Monthly",
    claims_settings_weekly_day: "Day of week",
    claims_settings_monthly_day: "Day of month",
    claims_settings_time: "Send time (UK)",
    claims_settings_time_hint: "Each send includes every claim added since the previous submission. If there are none, no email is sent.",
    claims_settings_status_pending: "Pending claims",
    claims_settings_status_next: "Next scheduled send",
    claims_settings_status_last_run: "Last run",
    claims_settings_last_submission: "Last submission",
    claims_settings_send_now: "Send pending claims now",
    claims_settings_send_now_confirm: "Email {n} pending claim(s) to {to} now?",
    claims_settings_saved: "Claims settings saved",
    claims_settings_mail_not_configured: "Email is not configured on this server (MAIL_* variables), so nothing can be sent.",
    claims_settings_no_recipient: "Enter the carrier's claims email address (To) and save before anything can be sent. Claims raised meanwhile wait as pending.",
    claims_settings_disabled_note: "Scheduled sending is off. Claims can still be raised on orders and sent manually from here.",
    claims_settings_download: "Download sheet",
    claims_settings_download_invoices: "Download invoices PDF",
    claims_settings_send_failed: "Last send failed: {error}",
    claims_settings_never: "Never",
    claims_settings_none: "None yet",
    claims_settings_off: "Off",
    claims_day_0: "Sunday",
    claims_day_1: "Monday",
    claims_day_2: "Tuesday",
    claims_day_3: "Wednesday",
    claims_day_4: "Thursday",
    claims_day_5: "Friday",
    claims_day_6: "Saturday",

    // Dispatch — flagged / search / admin menu
    dispatch_start: "Dispatch",
    dispatch_flagged: "Flagged",

    // Dispatch — conveyor unload (parcel to courier pallet)
    dispatch_unload: "Conveyor Unload",
    unload_scan_parcel: "Scan parcel",
    unload_put_on: "Put on",
    unload_piece_of: "Parcel {position} of {total}",
    unload_scan_pallet: "Scan the {carrier} pallet to confirm",
    unload_no_bays: "No courier pallets are set up for {warehouse}. Add them in Settings › Dispatch › Courier Pallets.",
    unload_no_bay_for_carrier: "No pallet set up for {carrier}",
    unload_set_aside: "Set aside",
    unload_ok: "OK",
    unload_wrong_pallet: "Wrong pallet",
    unload_wrong_pallet_detail: "That is the {scanned} pallet. This parcel goes on {expected}.",
    unload_finish_parcel_first: "Finish this parcel first — scan the {carrier} pallet",
    unload_not_a_pallet: "Not a pallet barcode",
    unload_voided_title: "Do not load",
    unload_voided_reopened: "Order {order} was reopened. This label is void — take the parcel back to the pack desk.",
    unload_voided_cancelled: "Order {order} was cancelled. This label is void — set the parcel aside.",
    unload_voided_booking: "The {carrier} booking for order {order} was cancelled. This label is void — set the parcel aside.",
    unload_voided_not_shipped: "Order {order} has not been shipped yet. Take the parcel back to the pack desk.",
    unload_duplicate_title: "Already loaded",
    unload_duplicate_detail: "This label was loaded onto {bay} at {time} by {name}. Check for a duplicate label.",
    unload_duplicate_detail_short: "This label has already been loaded. Check for a duplicate label.",
    unload_unknown_title: "Unknown label",
    unload_unknown_detail: "This barcode is not a label the Portal booked. Set the parcel aside.",
    unload_unknown_looks_like: "It looks like an {carrier} label.",
    unload_wrong_warehouse_title: "Wrong warehouse",
    unload_wrong_warehouse_detail: "Order {order} belongs to {warehouse}. Set the parcel aside.",
    unload_session_wrong: "wrong pallet",
    unload_session_aside: "set aside",
    // Outbound pallets (2026-10-19): close the pallet on a position under
    // the next pre-printed label, then the forklift scans it onto the lorry.
    unload_not_a_parcel_pallet_label: "That is a pallet label. Press Close pallet first, then scan it.",
    unload_not_a_parcel_floor: "That is a floor barcode. Scan the parcel first.",
    unload_wrong_barcode_routing: "That is the routing number. Scan the long barcode on the label.",
    unload_wrong_barcode_postcode: "That is the postcode barcode. Scan the tracking barcode.",
    unload_wrong_barcode: "That is not a shipping label barcode. Scan the tracking barcode.",
    unload_wrong_barcode_qr: "That is the QR code. Scan the tracking barcode.",
    unload_collection_title: "Collection",
    unload_collection_detail: "Order {order} is collected from the warehouse. Do not load it on a courier pallet — take it to the collection point.",
    unload_scan_floor_not_label: "Scan the floor barcode, not the pallet label",
    unload_on_pallet: "{count} on this pallet",
    unload_close_pallet: "Close pallet",
    unload_close_title: "Close pallet",
    unload_close_pick_bay: "Scan the floor barcode of the pallet to close",
    unload_close_target: "Closing {carrier} · {count} parcels",
    unload_close_other_bay: "or scan another floor barcode",
    unload_close_cancel: "Cancel",
    unload_close_no_pallets: "{carrier} has no pallet to close. Its parcels are only checked onto the right position.",
    unload_close_scan_again: "Scan the same floor barcode again to close it",
    unload_close_done_hint: "Your team leader will print the pallet label.",
    unload_close_printed_hint: "Label printed. Stick it on this pallet.",
    unload_close_printing: "Printing label…",
    unload_close_print_failed: "The label did not print. Check the printer, then press Print again.",
    unload_close_print_again: "Print again",
    print_on_close_title: "Print upon close",
    print_on_close_hint: "Print the pallet label on the unload handheld's printer as soon as a pallet is closed. When off, a team leader prints it from Outbound.",
    print_on_close_unavailable: "Needs database migration 226 before it can be switched on.",
    outbound_view: "View",
    outbound_view_parcels: "Parcels",
    outbound_view_pallets: "Pallets",
    outbound_print_label: "Print label",
    outbound_print_failed: "The pallet label did not print. Check the printer.",
    outbound_printed: "Printed {sku}",
    unload_close_done: "Pallet closed",
    unload_close_done_detail: "{sku} · {count} parcels",
    unload_close_empty: "Nothing has been scanned onto this pallet yet",
    unload_added_closed: "Added to closed pallet",
    unload_pallet_loaded: "{sku} is already on the lorry — scan the floor barcode",
    unload_scan_pallet_or_label: "Or scan a closed pallet's label to add it to that pallet",
    unload_move_start: "Move to another pallet",
    unload_move_to: "Move to",
    unload_move_from: "Now on {from}",
    unload_move_cancel: "Cancel move",
    unload_move_same: "It is already on this pallet — scan the pallet it is going to",
    unload_move_loaded: "{sku} is already on the lorry — this parcel can't be moved",
    unload_move_unavailable: "Moving parcels isn't switched on yet",
    unload_moved: "Parcel moved",
    unload_moved_detail: "From {from} to {to}",
    dispatch_found_items: "Found items",
    found_scan_item: "Scan found item",
    found_scan_shelf: "Scan shelf",
    found_for_order: "Wanted by order",
    found_last_booked: "Last: order {order} → shelf {shelf}",
    found_not_a_shelf: "That is not a found-items shelf — scan the shelf next to dispatch",
    found_wrong_warehouse: "That shelf belongs to another warehouse",
    found_book_back_title: "Book item back in",
    found_book_back_dispatched: "Order {order} was dispatched on {time}, more than 48 hours ago, so the customer may already have been refunded. Book this item back in so it can go back up for auction.",
    found_ship_separately_title: "Ship this item on its own",
    found_ship_separately_detail: "Order {order} for {customer} was dispatched on {shipped} without this item. Send it to the customer as a separate parcel.",
    found_ship_separately_deadline: "Ship by {time} — after that, book it back in instead.",
    found_ship_separately_detail_unpacked: "Order {order} for {customer} was closed out without this item. Send it to the customer as a separate parcel.",
    found_ship_how: "Create an extra box: Orders › {order} › Send extra box.",
    found_ship_how_refund_pending: "Its refund has not been issued yet — choose \"Cancel the pending refund and send\" so the customer is not refunded as well.",
    found_book_back_cancelled: "Order {order} was cancelled. Book this item back in so it can go back up for auction.",
    found_book_back_refunded: "Order {order} was refunded for this item. Book this item back in so it can go back up for auction.",
    found_book_back_no_order: "No open order needs {sku}. Book this item back in so it can go back up for auction.",
    found_book_back_not_worth: "Order {order} shipped without this item, but sending it on its own costs more than the customer paid for it. Refund the customer instead and book the item back in so it can go back up for auction.",
    found_book_back_not_worth_done: "The item is on Pending Refund for order {order}. Book it back in through Goods In so it can go back up for auction.",
    found_cost_line_tariff: "Shipping on its own ≈ {shipping} · customer paid {value}",
    found_cost_line_estimate: "Shipping on its own ≈ {shipping} (estimate) · customer paid {value}",
    found_refund_instead: "Move to Pending Refund",
    found_refund_instead_refused: "This item can no longer be refunded from here. Scan it again.",
    found_single_item_title: "Single item order",
    found_single_item_detail: "This is the only item on order {order}, so nothing else will bring it to a pack desk. Don't put it on the shelf.",
    found_single_item_how: "Send to packing — Generate Temp Tote: Orders › {order} › Send to packing. Take the item to a pack desk and scan or type the temp tote code there.",
    found_already_shelved_title: "Already on the shelf",
    found_already_shelved_detail: "This item is already booked for order {order} on shelf {shelf}.",
    found_flagged_title: "Order is flagged",
    found_flagged_detail: "The item is on shelf {shelf}. Order {order} is flagged — send it through Dispatch › Flagged › {order} › Resolve › Dispatch and pack it in a new box.",
    found_at_desk_title: "Take it to desk {desk}",
    found_at_desk_detail: "{packer} is packing order {order} at desk {desk} right now. Hand them this item — they scan it straight into the order. Don't put it on the shelf: they won't see it there.",
    found_at_desk_detail_no_packer: "Order {order} is being packed at desk {desk} right now. Hand this item to the packer — they scan it straight into the order. Don't put it on the shelf: they won't see it there.",
    found_at_desk_shelve: "Nobody there — put on shelf",
    found_on_shelf_title: "On the shelf — waiting for a packer",
    found_on_shelf_none: "Nothing on the found-items shelves",
    found_put_back_title: "Order gone — book back in",
    found_put_back_meta: "Shelf {shelf} · order {order}",
    found_booked_back: "Booked back in",
    found_pill_found: "Found",
    found_pill_book_in: "Book in",
    found_book_in_title: "Take off the shelf and book back in",
    found_book_in_hint: "Scan each item as you take it off the shelf (tap it if it is not there), then press the button",
    found_book_in_none: "Nothing to book back in",
    found_book_in_reason_cancelled: "order {order} cancelled",
    found_book_in_reason_not_at_desk: "order {order} shipped without it",
    found_book_in_scanned: "{scanned} of {total} scanned",
    found_taken_off_shelf: "Taken off shelf ({count})",
    found_taken_off_done: "{count} taken off the shelf — book them back in through Goods In",
    found_book_in_not_listed: "That item is not on the book-in list",
    found_book_in_already: "Already scanned",
    dispatch_load: "Load lorry",
    load_pick_courier: "Which courier is being loaded?",
    load_scan_pallet: "Scan pallet label",
    load_loading: "Loading {carrier}",
    load_loaded_detail: "{label} · {count} parcels",
    load_loaded_today: "{count} loaded today",
    load_session_loaded: "loaded",
    load_wrong_courier_title: "Wrong lorry",
    load_wrong_courier_detail: "{label} is an {pallet_carrier} pallet. You are loading {loading_carrier}.",
    load_already_loaded_title: "Already loaded",
    load_already_loaded_detail: "{label} was loaded at {time} by {name}.",
    load_label_unused_title: "Pallet not closed",
    load_label_unused_detail: "{label} has not been put on a pallet. Close the pallet at the unload point first.",
    load_wrong_warehouse_title: "Wrong warehouse",
    load_wrong_warehouse_detail: "{label} belongs to {warehouse}.",
    load_not_a_pallet: "Not a pallet label",
    load_not_a_pallet_parcel: "That is a parcel label. Scan the pallet label.",
    load_not_a_pallet_floor: "That is a floor barcode. Scan the pallet label.",
    outbound_courier_pallets_title: "Courier pallets",
    outbound_courier_pallets_empty: "No pallets closed or loaded on this day",
    outbound_col_pallet: "Pallet",
    outbound_col_position: "Position",
    outbound_col_parcels: "Parcels",
    outbound_col_closed: "Closed",
    outbound_col_loaded: "Loaded",
    outbound_pallet_open: "Open",
    outbound_pallet_closed: "Closed",
    outbound_pallet_loaded: "Loaded",
    outbound_detail_loaded_pallet: "Loaded onto {bay} ({pallet}) at {time}",
    outbound_detail_on_lorry: "on lorry {time}",
    outbound_title: "Outbound",
    outbound_hint: "Loading at the conveyor unload point and the pallets that left {warehouse} on the chosen day: parcels shipped versus loaded per courier, parcels never loaded, wrong-pallet scans, and Palletways pallets released.",
    warehouse_tile_outbound_desc: "Courier loading — shipped vs loaded",
    outbound_pallets_title: "Pallets released",
    outbound_pallets_empty: "No pallets released on this day",
    outbound_pallets_count: "Pallets",
    outbound_pallets_state: "State",
    outbound_pallets_consignment: "Consignment",
    outbound_pallets_released: "Released",
    outbound_pallet_state_booked: "Booked",
    outbound_pallet_state_released: "Released",
    outbound_pallet_state_shipped: "Shipped",
    outbound_filter_courier: "Courier",
    outbound_filter_status: "Status",
    outbound_search_placeholder: "Order or tracking number",
    outbound_parcels_title: "Parcels",
    outbound_rows_empty: "No parcels match these filters",
    outbound_col_time: "Time",
    outbound_col_order: "Order",
    outbound_col_courier: "Courier",
    outbound_col_code: "Code",
    outbound_col_status: "Status",
    outbound_col_detail: "Detail",
    outbound_col_by: "By",
    outbound_tag_loaded: "Loaded",
    outbound_tag_not_loaded: "Not loaded",
    outbound_tag_set_aside: "Set aside",
    outbound_tag_wrong_pallet: "Wrong pallet",
    outbound_tag_voided: "Void label",
    outbound_tag_duplicate: "Duplicate label",
    outbound_tag_unknown_label: "Unknown label",
    outbound_tag_wrong_warehouse: "Wrong warehouse",
    outbound_detail_loaded: "Loaded onto {bay} at {time}",
    outbound_detail_not_loaded: "Shipped {time} · parcel {position}{desk}",
    outbound_detail_set_aside: "Set aside at {time}",
    outbound_detail_mismatch: "Scanned onto {bay} — should be {expected}",
    unload_summary_title: "Loading by courier",
    unload_summary_date: "Date",
    unload_summary_courier: "Courier",
    unload_summary_shipped: "Shipped",
    unload_summary_loaded: "Loaded",
    unload_summary_not_loaded: "Not loaded",
    unload_summary_mismatches: "Wrong pallet",
    unload_summary_unknown: "Unknown labels scanned: {count}",
    unload_summary_not_loaded_list: "Shipped but not loaded",
    unload_summary_events_list: "Problems",
    unload_summary_empty: "Nothing shipped on this day",
    unload_summary_all_loaded: "Every parcel is loaded",
    unload_event_mismatch: "scanned onto {bay} ({scanned}) — should be {expected}",
    unload_event_set_aside: "set aside",
    unload_event_voided: "void label",
    unload_event_duplicate: "duplicate label",
    unload_event_unknown: "unknown label",
    unload_event_wrong_warehouse: "wrong warehouse",
    flag_order: "Flag Order",
    flag_order_confirm: "Flag this order for leader review?",
    order_flagged: "Order Flagged",
    no_flagged_orders: "No flagged orders",
    flagged_orders_title: "Flagged Orders",
    flagged_reason_user: "Flagged by dispatch staff",
    flagged_reason_packing: "Packing Issue",
    flagged_reason_label: "Label Issue",
    resolve: "Resolve",
    resolved: "Resolved",
    resolve_confirm: "Mark this order as resolved?",
    flagged_at: "Flagged",
    flagged_by_name: "Flagged by {name}",
    search_placeholder: "Order number, SKU, customer name, or postcode",
    search_placeholder_flagged: "Order number, SKU, barcode, customer, or flagged by",

    // Order statuses (Search Orders filter pills + cards)
    status_all: "All",
    status_unfulfilled: "Unfulfilled",
    status_picking: "Picking",
    status_picked: "Picked",
    status_sorting: "Sorting",
    status_dispatch: "Dispatch",
    status_fulfilled: "Fulfilled",
    status_partially_fulfilled: "Partially Fulfilled",
    status_flagged: "Flagged",
    status_partially_refunded: "Partially Refunded",
    status_refunded: "Refunded",
    status_pending_refund: "Pending Refund",
    status_cancelled: "Cancelled",
    status_on_hold: "On Hold",
    status_exchange: "Exchange",
    status_stock_blocked: "Stock blocked",
    status_consolidated: "Consolidated",
    order_locked_fulfilled: "This order is fulfilled — it has shipped and can no longer be edited.",
    flagged_kpi_open: "Open",
    flagged_kpi_avg_resolution: "Avg time to resolve",
    flagged_kpi_resolved: "Resolved",
    flagged_sort: "Sort by",
    flagged_sort_oldest: "Oldest first",
    flagged_sort_newest: "Newest first",
    flagged_kpi_overdue: "{count} overdue",
    flagged_scan_hint: "Scan a flag barcode to open its order, or an item to filter",
    flagged_lines_count: "{count} lines",

    // Flagged Picks (2026-10-08) — Pick Face walk, Flagged tile, pack desk
    flagged_picks: "Flagged Picks",
    fp_landing_open: "{count} unit(s) to fetch",
    fp_landing_none: "Nothing to fetch — every missing item is accounted for",
    fp_landing_hint: "Items pickers couldn't find at the pick face that are in stock up high. Scan a tote to walk them to the packing-room shelf.",
    fp_walk_in_progress: "{name} is already walking with tote {tote}",
    fp_sub_tote: "Scan an empty tote to pick into",
    fp_sub_go_to: "Go to this location and scan it",
    fp_sub_items: "Scan each unit into the tote",
    fp_sub_stage: "Scan a unit from the tote, or tap it below, then the staging shelf it goes on",
    fp_stage_scan_for: "Scan a staging shelf for {sku}",
    fp_stage_item_done: "{units} × {sku} shelved at {location}",
    fp_stage_scan_unknown: "Scan a unit from the tote first, then its shelf",
    fp_stage_not_in_tote: "That item isn't in the tote",
    fp_stage_continue: "Continue walk",
    fp_stage_tote_empty: "Nothing in the tote yet — use Leave walk to stop",
    fp_stage_nothing_left: "Nothing in the tote and no stops left — leave the walk to free the tote",
    fp_walk_closed_empty: "Walk finished — nothing to shelve, the tote is free",
    fp_stage_tote_title: "In the tote",
    fp_stage_shelved_title: "On the shelves",
    fp_stage_shelved_at: "On shelf {location}",
    fp_next_location: "Next location",
    fp_skip_location: "Skip for now",
    fp_not_here_btn: "Not here",
    fp_not_here_confirm: "Confirm this unit is not at {location}? The stock recorded here is written off and the system looks for it elsewhere; if there is none, the order ships without it.",
    fp_not_here_done: "Written off — the order will ship without it",
    fp_not_here_found: "Written off here — {units} found at {locations}, added to this walk",
    fp_not_here_awaiting: "Written off here — {units} in a drop tote, joins the walk once put away",
    fp_stage_done: "Tote emptied — {units} unit(s) on the staging shelves",
    fp_stage_returned: "{count} stop(s) left for the next walk",
    fp_not_staging: "That isn't a staging shelf — scan a shelf in the packing room",
    fp_not_a_stop: "That location isn't on this walk",
    fp_wrong_location: "Wrong location — go to {location}",
    fp_no_tasks: "Nothing to fetch right now",
    fp_locked: "That tote is in use by {by}",
    fp_user_has_open_tote: "You already have tote {tote} open elsewhere — finish it first",
    fp_tote_rejected: "That tote can't be used ({reason})",
    fp_scan_not_wanted: "That item isn't needed at this location",
    fp_scan_done: "Every unit of that item is already in the tote",
    fp_scan_unknown: "Unknown barcode",
    fp_for_order: "Order #{order}",
    fp_abandon: "Leave walk",
    fp_abandon_confirm: "Leave this walk? The stops go back to the list for the next leader.",
    fp_abandon_must_stage: "Units are in the tote — scan the staging shelf to finish",
    fp_put_back_title: "Put back",
    fp_put_back_hint: "Cancelled after picking - Scan a unit from the shelf, or tap an item below",
    fp_put_back_none: "Nothing to put back",
    fp_put_back_done: "{units} put back at {location}",
    fp_put_back_scan: "Scan the racking location for {qty} × {sku}",
    fp_put_back_not_storage: "That isn't a storage location",
    fp_put_back_all_counted: "All {count} on the shelf are already counted",
    fp_put_back_not_on_shelf: "That item isn't on the put-back shelf",
    fp_put_back_scan_unknown: "Unknown barcode - scan a unit or tap an item below",
    fp_put_back_gone: "That item was already put back",
    fp_put_back_qty_label: "Putting back",
    fp_put_back_clear: "Clear",
    fp_pill_walk: "Walk",
    fp_pill_put_back: "Put back",
    fp_not_available: "Flagged Picks is only switched on at Pembroke",
    fp_tote: "Tote {tote}",
    fp_remaining_units: "{count} to go",
    fp_session_ended: "This walk was closed elsewhere",
    flagged_picks_tile: "Flagged picks",
    flagged_picks_tile_sub: "{count} on the way",
    fp_kpi_open: "Open",
    fp_kpi_shelf_time: "Avg flag to shelf",
    fp_kpi_put_back: "To put back",
    fp_status_awaiting_stock: "Waiting for put-away — in {module} tote {tote} ({name})",
    fp_status_awaiting_stock_unknown: "Waiting for stock to be put away",
    fp_hold_module_shelf: "shelf drop",
    fp_hold_module_forecast: "forecast drop",
    fp_no_shelf_yet: "no shelf yet",
    fp_eta_after_put_away: "Walks after the put-away",
    fp_notice_awaiting_stock: "In a drop tote — a leader fetches it once it is put away",
    fp_landing_awaiting: "{count} more unit(s) are in shelf / forecast drop totes — they join the walk once put away",
    fp_status_pending: "Waiting for a leader",
    fp_status_picking: "Being picked by {name}",
    fp_status_staged: "On shelf {location}",
    fp_status_put_back: "To put back from {location}",
    fp_eta_due_in: "Due at the desk in {time}",
    fp_eta_overdue: "Packer waiting {time}",
    fp_eta_now: "At the desk now",
    fp_eta_unknown: "No estimate yet",
    fp_cancel: "Cancel pick",
    fp_cancel_confirm: "Cancel this pick? The order will ship without the unit.",
    fp_release_order: "Return to dispatch",
    fp_release_done: "Order #{order} is back in the pack queue",
    fp_release_not_staged: "The unit isn't on the shelf yet",
    fp_awaiting_flag: "Flagged at the desk by {name}",
    fp_from_location: "from {location}",
    fp_back_to_orders: "Flagged orders",
    fp_empty: "No flagged picks",
    fp_origin_picking_missing: "Missing at pick",
    fp_origin_pas_flag_missing: "Missing at sort",
    fp_origin_pas_flag_remaining: "Missing at sort",
    fp_origin_found_item: "Found item",
    fp_shelf_wait: "Waiting for packing",
    fp_shelf_resolve: "Resolve in Flagged",
    fp_shelf_ship: "Ship on its own",
    fp_shelf_ship_by: "Ship on its own by {time}",
    fp_shelf_book_back_in: "Book back in",
    flagged_found_tile: "Found items on shelf",
    flagged_found_tile_sub: "waiting for a packer",
    fp_kpi_on_shelf: "On shelf",
    fp_found_empty: "No found items on the shelves",
    fp_found_by: "Found by {name} at {time}",
    fp_notice_found_hint: "Found item not on the shelf? Continue and mark it missing — the order ships without it.",
    fp_notice_title: "Items coming from Flagged Picks",
    fp_notice_body: "These units were missing at the pick face but are in stock. Fetch the shelved ones before packing; flag the order if one is still on its way.",
    fp_notice_staged: "On shelf {location}",
    fp_notice_pending: "Being fetched from high racking",
    fp_notice_picking: "Being fetched by {name}",
    fp_notice_eta: "Expected at the desk {time}",
    fp_notice_continue: "Continue",
    fp_notice_flag: "Flag order — not ready yet",
    fp_notice_title_pending: "Not on the shelf yet",
    fp_notice_body_pending: "A unit for this order is still being fetched from high racking. Flag the order and keep the tote with it — a leader will send it back to the pack queue once the unit is on the shelf.",
    fp_notice_body_scan: "Fetch each unit from the packing-room shelf and scan it here — it counts as packed, so you won't scan it again.",
    fp_notice_collected: "{got} / {qty} scanned",
    fp_notice_leave: "Leave order",
    dsd_notice_title: "This is a data storage order",
    dsd_notice_instruction: "Leave in original packaging",
    dsd_notice_scan: "Scan the first item to continue",
    order_notes_notice_title: "Note on order {order}",
    fp_eta_due_at: "Due at the desk ~{time}",
    fp_item_chip_awaiting: "Awaiting pick",
    fp_item_chip_shelf: "Shelf {location}",
    fp_complete_blocked: "A unit is still being fetched from high racking — wait for it or flag the order",
    flagged_reason_awaiting_pick: "Awaiting flagged pick",
    sales_channel: "Sales Channel",
    inventory_title: "Inventory",
    inventory_hint: "Stock levels rolled up per (SKU, warehouse). The aggregate is recomputed automatically as items are booked in, put away, and allocated to orders.",
    pos_settings: "POs",
    pos_settings_hint: "Purchase orders grouped from the manifest table by supplier and PO number. Pick a supplier, then a PO, to see what was expected against what has been booked in. Lines go green once fully received. PO actions apply to every line on that PO and show straight away on the Manifest page.",
    pos_crumb_suppliers: "Suppliers",
    pos_no_supplier: "No supplier",
    pos_no_po: "No PO number",
    pos_col_active_pos: "Active POs",
    pos_col_total_pos: "All POs",
    pos_col_open_lines: "Open Lines",
    pos_col_lines: "Lines Done",
    pos_col_progress: "Progress",
    pos_col_updated: "Last Activity",
    pos_active_only: "Active",
    pos_show_all: "Show all",
    pos_no_suppliers: "No manifests yet — upload one on the Manifest page to see suppliers here.",
    pos_no_pos: "No active POs for this supplier.",
    pos_no_lines: "No lines match.",
    pos_lines_filter_all: "All lines",
    pos_lines_filter_outstanding: "Outstanding",
    pos_lines_filter_complete: "Complete",
    pos_lines_search_hint: "Filter by SKU…",
    pos_lines_showing: "Showing {shown} of {total} lines",
    pos_summary_lines: "{done} of {total} lines complete",
    pos_summary_units: "{received} of {expected} units received",
    pos_action_cancel: "Cancel PO",
    pos_action_reopen: "Reopen PO",
    pos_action_close_short: "Close short",
    pos_action_done: "{count} lines updated",
    pos_confirm_cancel_title: "Cancel this PO?",
    pos_confirm_cancel_body: "{count} open lines on PO {po} will be cancelled. Lines already received are left as they are. Book-in will no longer match against this PO.",
    pos_confirm_reopen_title: "Reopen this PO?",
    pos_confirm_reopen_body: "{count} lines on PO {po} that still have units outstanding will go back to open, so book-in can match against them again.",
    pos_confirm_close_short_title: "Close this PO short?",
    pos_confirm_close_short_body: "{count} open lines on PO {po} will be marked fulfilled even though fewer units were received than expected. Use this when the balance is not coming. You can reopen later if it does.",
    manifest_settings: "Manifest",
    manifest_settings_hint: "Expected stock — POs and preorders waiting to be received. Book-in matches each scanned item against an open manifest entry to pull cost. One row per SKU; reuse the same po_number across rows for multi-SKU POs.",
    inventory_tab_stock: "Inventory Summary",
    inventory_tab_receipts: "Receipts",
    inventory_tab_manifests: "Manifest",
    inventory_tab_detail: "Inventory Detail",
    inventory_tab_locations: "Inventory Locations",
    inventory_export_csv: "Export CSV",
    inventory_export_xlsx: "Export XLSX",
    inventory_exporting: "Exporting…",
    inventory_filter_sku: "Filter by SKU…",
    inventory_filter_detail: "Search SKU, location, PO or tote…",
    inventory_filter_locations: "Search SKU, location or tote…",
    inventory_filter_sku_hint: "Filter by SKU or barcode (press Enter)",
    inventory_filter_detail_hint: "Search SKU, barcode, location, PO or tote (press Enter)",
    inventory_filter_locations_hint: "Search SKU, barcode, location or tote (press Enter)",
    inventory_filter_sellable_all: "All sellable",
    inventory_filter_supplier: "Filter by supplier…",
    inventory_filter_supplier_hint: "Filter by supplier (press Enter)",
    manifest_filter_search: "Search Manifest #, SKU, PO or supplier…",
    manifest_filter_search_hint: "Search Manifest #, SKU, PO or supplier (press Enter)",
    inventory_col_sku: "SKU",
    inventory_col_barcode: "Barcode",
    inventory_col_warehouse: "Warehouse",
    inventory_col_location: "Location",
    inventory_col_tote: "Tote",
    inventory_col_qty: "Qty",
    inventory_col_sellable: "Sellable",
    inventory_col_unsellable: "Unsellable",
    inventory_col_allocated: "Allocated",
    inventory_col_reserved: "Reserved",
    inventory_reserved_hint: "Sold on a channel, awaiting a pick wave — no location committed yet. Channel availability = On Hand − Reserved.",
    inventory_col_reserved_projected: "Reserved (proj.)",
    inventory_reserved_projected_hint: "Projected share of the SKU's reserved (sold, awaiting wave) units at this row — oldest stock first. Actual locations are chosen when the pick wave builds.",
    inventory_col_on_hand: "On Hand",
    inventory_col_total: "Total",
    inventory_col_remaining: "Remaining",
    inventory_col_total_cost: "Total Cost",
    inventory_col_unit_cost: "Unit Cost",
    inventory_col_currency: "Currency",
    inventory_col_po: "PO #",
    inventory_col_supplier: "Supplier",
    inventory_col_received: "Received",
    inventory_col_status: "Status",
    inventory_status_available: "Available",
    inventory_status_reserved: "Reserved",
    inventory_status_damaged: "Damaged",
    inventory_status_quarantined: "Quarantined",
    inventory_status_archived: "Archived",
    inventory_detail_download_template: "Download template",
    inventory_detail_upload_csv: "Upload CSV",
    inventory_detail_upload_xlsx: "Upload XLSX",
    inventory_detail_upload_empty: "Spreadsheet is empty",
    inventory_detail_upload_bad_header: "Spreadsheet must have action and sku columns (or detail_id for update/remove)",
    inventory_detail_upload_parse_error: "Could not read spreadsheet — make sure it's a valid .xlsx file",
    inventory_receive_stock: "Receive Stock",
    inventory_receive_btn: "Receive",
    inventory_receive_invalid: "SKU, warehouse, location, qty (>0) and unit cost (≥0) are required.",
    inventory_no_stock: "No stock at the selected filters.",
    inventory_no_receipts: "No receipts at the selected filters.",
    inventory_no_locations: "No locations at the selected filters.",

    // Manifest — expected stock (POs / preorders) before arrival.
    manifest_add_title: "Add Manifest Entry",
    manifest_add_btn: "Add",
    manifest_invalid: "SKU, warehouse, expected qty (>0) and unit cost (≥0) are required.",
    manifest_no_rows: "No manifest entries at the selected filters.",
    manifest_col_id: "Manifest #",
    manifest_col_expected_qty: "Expected Qty",
    manifest_col_remaining_qty: "Remaining",
    manifest_col_received: "Received",
    manifest_col_manifest_date: "Manifest Date",
    manifest_col_expected_at: "Expected",
    manifest_col_status: "Status",
    manifest_status_open: "Open",
    manifest_status_fulfilled: "Fulfilled",
    manifest_status_cancelled: "Cancelled",
    manifest_status_archived: "Archived",
    manifest_tab_hint: "Each manifest row covers one SKU. When a PO contains multiple products, add one row per SKU and reuse the same po_number on each — that's how the system links them. Quantities can be received above or below the expected qty; book-in consumes the oldest matching PO first.",
    manifest_download_template: "Download template",
    manifest_download_current: "Download current",
    manifest_upload_csv: "Upload CSV",
    manifest_upload_xlsx: "Upload XLSX",
    manifest_upload_empty: "Spreadsheet is empty",
    manifest_upload_bad_header: "Spreadsheet must have action and sku columns (or manifest_id for cancel/archive)",
    manifest_upload_parse_error: "Could not read spreadsheet — make sure it's a valid .xlsx file",
    manifest_upload_forbidden: "You don't have permission to upload manifests. Ask an admin to check your access.",
    manifest_upload_forbidden_warehouse: "Upload refused: the spreadsheet has rows for warehouse \"{warehouse}\", which you can't upload manifests for. Check the warehouse column matches your warehouse name exactly.",
    delivery_type: "Delivery type",
    delivery_type_standard: "Standard",
    delivery_type_priority: "Priority",
    delivery_type_express: "Express",
    // Collection order: staff purchase picked up at the warehouse counter —
    // picked like any order, never booked a carrier, closed at the pack desk
    // with a COLLECTION label instead of a courier label.
    delivery_type_collection: "Collection",
    collection_order_banner: "COLLECTION — do not ship. Hand over at the counter; a collection label prints instead of a courier label.",
    print_collection_label: "Print Collection Label",
    collection_label_heading: "COLLECTION",
    collection_label_customer: "Customer",
    collection_label_packed: "Packed",
    filter_by_status: "Filter by status",
    filter_warehouse: "Warehouse",
    filter_all_warehouses: "All Warehouses",
    filter_channel: "Channel",
    filter_all_channels: "All Channels",
    // Orders the returns portal raises (replacements, exchanges): channel 'bargainfox-returns'.
    channel_bargainfox_returns: "BargainFox Returns",
    filter_date: "Date",
    filter_all_dates: "All Dates",
    filter_from: "From",
    filter_to: "To",
    filter_all: "All",
    filter_today: "Today",
    filter_yesterday: "Yesterday",
    filter_last_7: "Last 7 days",
    filter_last_30: "Last 30 days",
    filter_last_60: "Last 60 days",
    filter_custom: "Custom",
    search_results_count: "{count} results",
    search_results_count_filtered: "{count} of {total} results",

    // Orders table column headers
    col_order_number: "Order #",
    col_ready_low: "Ready",
    ready_low_title: "Ready to pick down low — every line is covered by low-level stock after older orders' claims, so no shelf drop is needed",
    col_status: "Status",
    col_customer: "Customer",
    col_channel: "Channel",
    col_items: "Items",
    col_value: "Value",
    col_order_date: "Order date",
    col_fulfilled_date: "Fulfilled date",
    col_dispatched_by: "Dispatched by",
    send_replacement: "Send replacement",
    send_replacement_parcel_hint: "Replace just this parcel — lost or damaged in transit",
    // Send to packing (Admin > Orders, 2026-10-22)
    send_to_pack_hint: "Packing this by hand? Send it straight to the dispatch desk with a temporary tote.",
    send_to_pack_confirm: "This takes the order out of picking and allocates its stock. Send it to packing?",
    send_to_pack_confirm_flagged: "This closes the flag and sends the order to the pack desk. Items marked missing go back to be packed — the desk marks anything still not there. Send it to packing?",
    send_to_pack_button: "Send to packing",
    send_to_pack_sending: "Sending…",
    send_to_pack_failed: "Could not send the order to packing",
    send_to_pack_ready_title: "Ready to pack",
    send_to_pack_ready_hint: "Scan or type this tote on the Dispatch screen.",
    send_to_pack_copy: "Copy",
    send_to_pack_print: "Print",
    send_to_pack_copied: "Copied",
    send_to_pack_copy_failed: "Could not copy — type the code instead",
    // Send extra box (Admin > Orders, 2026-10-22)
    extra_box_title: "Send extra box",
    extra_box_button: "Send extra box",
    extra_box_intro: "Book one more parcel for order #{order} — it goes out as box {n} on its own courier label and is tracked like the other boxes. No stock is taken and the sales channel is not told. The customer is emailed only where the channel's customer emails are switched on, as for any parcel.",
    extra_box_draft_failed: "Could not load the order for an extra box",
    extra_box_no_lines: "Every line on this order was refunded — there is nothing to send.",
    extra_box_line_ordered: "Ordered {ordered}",
    extra_box_line_refunded: "Ordered {ordered} · {refunded} refunded",
    extra_box_no_weight: "no weight on file",
    extra_box_box: "Box",
    extra_box_custom_box: "Other size…",
    extra_box_length_mm: "Length (mm)",
    extra_box_width_mm: "Width (mm)",
    extra_box_height_mm: "Height (mm)",
    extra_box_weight: "Contents weight (g)",
    extra_box_weight_required: "Enter the weight",
    extra_box_weight_missing: "An item has no weight on file — weigh the contents and enter it.",
    extra_box_weight_hint: "{kg} kg from the product weights — type a figure to override it",
    extra_box_courier: "Courier",
    extra_box_original: "original",
    extra_box_no_services: "No courier can book an extra box here",
    extra_box_scan_hint: "Scan an item to add it — each scan adds one more.",
    extra_box_scan_added: "Added {item} — {n} in the box.",
    extra_box_scan_full: "{item}: all {n} that can go are already in the box.",
    extra_box_scan_not_on_order: "{code} is not on this order.",
    extra_box_rules_note: "The item can appear in two boxes if the first parcel shipped without it — that is fine.",
    extra_box_book: "Book & print box {n} ({units})",
    extra_box_book_cancel_refund: "Cancel the pending refund and send box {n} ({units})",
    extra_box_line_refund_pending: "{n} refund pending",
    extra_box_line_missing: "{n} missing",
    extra_box_cancel_refund_note: "{n} item(s) in this box are waiting to be refunded. Sending them cancels that refund, so the customer is not refunded for an item they receive.",
    extra_box_booking: "Booking with {carrier}…",
    extra_box_waiting_label: "Waiting for the courier's label…",
    extra_box_label_slow: "The courier has not returned the label yet. Press Finish to try again.",
    extra_box_pending_note: "An extra box for this order is booked but not finished. Finish it to record the parcel and print its label.",
    extra_box_finish: "Finish",
    extra_box_failed: "The extra box could not be booked",
    extra_box_done: "Extra box {n} is booked — tracking {tracking}. Put the label on the box and send it with today's parcels.",
    extra_box_print_again: "Print again",
    extra_box_close: "Done",
    extra_box_tag: "Extra",
    extra_box_tag_hint: "Extra box sent after the order shipped",
    extra_box_void: "Void",
    extra_box_void_hint: "Void this extra box (only before the courier scans it)",
    extra_box_void_confirm: "Void extra box {tracking}? The label is cancelled with the courier and the parcel is removed from the order. The original shipment is not touched.",
    extra_box_voided: "Extra box voided",
    extra_box_void_failed: "The extra box could not be voided",
    extra_box_setting_title: "Send extra box",
    extra_box_setting_hint: "Lets Admin > Orders book one more courier parcel onto an order that has already shipped, for an item found after dispatch.",
    extra_box_setting_unavailable: "Needs database migration 232 before it can be switched on.",
    replacement_intro: "Create a free-of-charge replacement for order #{order}. Pick the items to resend — nothing is created until you save.",
    replacement_intro_parcel: "Resend the contents of {parcel} from order #{order}, free of charge. Everything that parcel contained is already ticked — nothing is created until you save.",
    replacement_no_charge: "£0.00 — no charge",
    replacement_add_all_items: "Add all items",
    replacement_remove_all_items: "Remove all items",
    replacement_free_stock: "{n} free in stock · {ordered} ordered",
    replacement_free_stock_refunded: "{n} free in stock · {ordered} sent, {refunded} refunded",
    replacement_free_stock_parcel: "{n} free in stock · {ordered} in this parcel",
    replacement_no_stock: "No free stock at this warehouse",
    replacement_no_lines: "This order has no stocked items to replace.",
    replacement_no_parcel_lines: "This parcel has no stocked items to replace.",
    replacement_save_and_send: "Send replacement ({n})",
    replacement_draft_failed: "Couldn't load this order's items.",
    replacement_failed: "Couldn't create the replacement order",
    replacement_insufficient_stock: "Stock has moved — quantities have been reduced to what's free now",
    replacement_created: "Replacement #{order} created and sent to the warehouse",
    orders_replacements_raised: "Replacements raised",
    orders_replacement_of: "Replacement for",
    channel_email_branding: "Customer email branding",
    channel_email_branding_hint: "Sender identity for every email Portal sends this channel's customers: replacement dispatches, and — where the switches below say so — ordinary ones too. Replacements always email the customer and never notify this channel's API, because the channel already believes the original order shipped.",
    channel_section_api: "API integration",
    channel_section_api_configured: "connected",
    channel_section_api_no_url: "no base URL",
    channel_section_emails: "Customer emails",
    channel_section_emails_no_sender: "no sender configured",
    channel_section_emails_non_api_on: "manual orders on",
    channel_section_emails_api_on: "API orders on",
    channel_order_status: "Parcel tracking to BargainFox",
    channel_order_status_hint: "Tells BargainFox when a parcel it already has from a shipment push is in transit, out for delivery or delivered, at the carrier's own time, so its orders page shows real delivery dates. Safe to leave on before BargainFox switches its side on (the portal-order-status flag): nothing changes there until it does.",
    channel_section_api_order_status_on: "parcel tracking on",
    channel_documents: "Invoices and credit notes from BargainFox",
    channel_documents_hint: "Lets the Orders page download BargainFox's own sales invoices and credit notes for an order; BargainFox generates each on request and Portal never stores them. Safe to leave on before BargainFox switches its side on: the panel stays hidden until it does.",
    channel_section_api_documents_on: "documents on",
    channel_exchange_orders: "Exchange orders to BargainFox",
    channel_exchange_orders_hint: "Shows customers their BargainFox Returns exchange orders on BargainFox's orders page (status, parcels, invoice and credit notes), sent whenever one changes and once a day. Safe to leave on before BargainFox switches its side on.",
    channel_section_api_exchange_orders_on: "exchange orders on",
    channel_replacement_orders: "Replacement orders to BargainFox",
    channel_replacement_orders_hint: "Shows customers the replacement orders we send them (REP…) on BargainFox's orders page, with their status and parcels, so they can track them and report a problem from there. Sent whenever one changes and once a day. Turn on when BargainFox switches its side on.",
    channel_section_api_replacement_orders_on: "replacement orders on",
    channel_section_consolidation: "Order consolidation",
    channel_section_protection: "Extra protection",
    channel_section_protection_ai: "AI assessment on",
    channel_section_protection_enforced: "enforced at the desk",
    channel_section_protection_off: "off",
    channel_notify_on: "On",
    channel_notify_off: "Off",
    channel_notify_non_api: "Email customers for manual / non-API orders",
    channel_notify_non_api_hint: "Orders loaded by bulk upload or by hand, which never came through this channel's API. The channel does not know they exist, so it cannot email the buyer — Portal is the only thing that can. On by default.",
    channel_notify_api: "Email customers for API orders",
    channel_notify_api_hint: "Orders received through this channel's API. These already get a shipment push, and the channel emails its own buyer off it — so this is off by default. Turn it on only once the channel has stopped sending its own dispatch email.",
    channel_notify_api_warning: "The channel also emails these buyers unless you have asked them to stop — check, or customers get two dispatch emails.",
    channel_notify_needs_sender: "Set a sender address above — without one, neither switch sends anything.",
    channel_aliases: "Sales channel aliases",
    channel_aliases_hint: "Orders with no API link are matched to this channel by their Sales channel text. The channel code always matches; add any other wording your uploads use, such as \u201cJobalots UK\u201d.",
    channel_aliases_placeholder: "e.g. Jobalots UK",
    channel_aliases_add: "Add",
    channel_aliases_remove: "Remove alias {alias}",
    channel_aliases_empty: "None \u2014 only orders whose Sales channel reads \u201c{code}\u201d are matched.",
    channel_sender_address: "Sender address",
    channel_sender_name: "Sender name",
    channel_sender_blank_hint: "Leave blank to send no customer email for this channel.",
    channel_logo: "Brand logo URL",
    channel_logo_hint: "Paste a public image URL (PNG or JPG). Email clients don't render SVG, and it must be reachable without a login. A wide banner (3:1 or wider) runs full width across the top of the email; anything squarer shows as a 140px logo.",
    channel_logo_svg_warning: "This logo is an SVG, so it is left out of the email and the brand name is shown instead. Replace it with a PNG or JPG at least 280px wide.",
    channel_reply_to_address: "Reply-to address (optional)",
    channel_reply_to_hint: "Where a customer's reply lands — usually the brand's customer-service mailbox. Leave blank and replies go to the sender address.",
    channel_test_email: "Send test email",
    channel_test_email_hint: "Sends the chosen sample to an address of your choosing, from this channel's sender, using real product images from the catalogue.",
    channel_test_email_scenario: "Sample email",
    channel_test_email_scenario_shipment: "Single shipment — one parcel, everything sent",
    channel_test_email_scenario_shipment_multi: "Multi-parcel shipment — two parcels, everything sent",
    channel_test_email_scenario_shipment_partial: "Partial shipment — items still to come",
    channel_test_email_scenario_pallet: "Pallet shipment — two pallets on one consignment",
    channel_test_email_language: "Email language",
    channel_test_email_scenario_consolidated: "Consolidated shipment — two orders in one delivery",
    channel_test_email_scenario_consolidated_partial: "Consolidated shipment — items still to come",
    channel_test_email_scenario_consolidated_many: "Consolidated shipment — five orders in one delivery",
    channel_test_email_scenario_replacement: "Replacement — nothing to pay",
    channel_test_email_prompt: "Send the sample email to which address?",
    channel_test_email_sent: "Test email ({scenario}) sent from {from}",
    channel_test_email_failed: "Test email failed: {detail}",
    col_tts: "TTS",
    col_delivery_type: "Delivery",
    col_courier: "Courier",
    col_parcel: "Parcel",
    col_service: "Service",
    col_weight: "Weight",
    col_tracking_number: "Tracking No",
    col_link: "Link",
    col_label: "Label",
    download_label_pdf: "Download PDF",
    label_reprinted: "Label reprinted",
    label_unavailable: "No label stored for this parcel",
    label_pdf_fallback_failed: "PDF fallback unavailable",
    // Parcel tracking states. Mirror the BE `label_status` enum — the
    // carrier's own wording for the exact scan is the chip's tooltip.
    parcel_status_created: "Label created",
    parcel_status_in_transit: "In transit",
    parcel_status_out_for_delivery: "Out for delivery",
    parcel_status_delivered: "Delivered",
    parcel_status_exception: "Needs attention",
    parcel_status_returned: "Returned",
    parcel_status_voided: "Cancelled",
    carrier_checked_just_now: "just now",
    carrier_checked_minutes: "{n} min ago",
    carrier_checked_hours: "{n} h ago",
    carrier_checked_days: "{n} d ago",
    carrier_status_checked: "Checked {ago}",
    carrier_status_never_checked: "Never checked against the carrier",
    carrier_status_last_checked: "Carrier status last checked {ago}",
    carrier_status_poller_idle: "These parcels have never been checked against the carrier — the tracking poller may not be running.",
    shipment_details: "Shipment",
    carrier_estimated_cost: "Estimated carrier cost",
    carrier_estimated_cost_consignments: "{n} consignments",
    carrier_estimated_cost_note: "Modelled from the declared weight and dimensions at booking — compare against the {carrier} invoice.",
    cancel_carrier_label: "Cancel label",
    cancel_carrier_label_note: "Cancellable until {cutoff} today, before the consignment manifests.",
    cancel_carrier_label_note_until_scan: "Cancellable until {carrier} first scans a parcel of this order.",
    cancel_carrier_label_done: "Label cancelled — {n} consignment(s) queued for cancellation; order returned to dispatch.",
    cancel_carrier_label_done_reship: "Label cancelled at {carrier} ({n} label(s) voided). The order is back in dispatch: scan its shipping label at the desk (or its original tote / location) to repack it.",
    cancel_carrier_label_done_cancelled: "Label cancelled at {carrier} ({n} label(s) voided). The order has been cancelled.",
    carrier_void_failed_live: "{carrier} did NOT cancel {n} label(s) — they are STILL LIVE and will be billed. Do not ship the parcel; contact {carrier} for a credit. ({detail})",
    carrier_void_retrying: "Couldn't reach {carrier} to cancel {n} label(s). It will keep retrying in the background — check the label is voided before today's cutoff.",
    carrier_labels_reissued: "{n} other order(s) share this consignment — {carrier} re-issued their labels when these boxes came off. Their old labels are void: reprint them. ({detail})",
    cancel_label_why_title: "Why cancel this label?",
    cancel_label_opt_reship: "Re-ship this order",
    cancel_label_opt_cancel_order: "Cancel the whole order",
    cancel_label_why_hint: "Re-ship voids the label and puts the order back in dispatch — the items stay with their original tote, so scanning that tote at a desk reopens it. Cancel the whole order voids the label and cancels the order.",
    cancel_carrier_label_failed: "Could not cancel the label",
    track: "Track",
    show_parcel_items: "Show parcel contents",
    hide_parcel_items: "Hide parcel contents",
    no_parcel_items_recorded: "No item details recorded for this parcel.",
    not_shipped: "Not Shipped",
    order_item_awaiting_fulfilment: "Awaiting fulfilment — {n} of {total} not shipped",
    order_item_refunded_badge: "Refunded — {n} of {total}",
    order_item_refund_pending_badge: "Refund pending — {n} of {total}",
    refund_pending_items: "Refund pending",
    refund_pending_title: "Refund pending: {n} item(s), {amount}",
    refund_pending_detail: "Issue the refund on {channel}, then mark it issued here.",
    refund_pending_lines: "Items to refund",
    refund_pending_why: "Why it's being refunded",
    refund_pending_why_none: "No reason was recorded. Check the order notes before you refund it.",
    refund_pending_parts_title: "Refund each order on its own",
    refund_pending_parts_hint: "This shipment holds several customer orders. Refund each one in {channel}, then mark it issued on that order (each is listed on Pending Refund).",
    refund_pending_part_row: "{n} item(s) · {amount}",
    refund_pending_issued_from_master: "Issue Refund pays this from the consolidated order {order}.",
    refund_issue_email_queued: "The customer will be emailed about the refund in about 10 minutes.",
    refund_issue_button: "Refund issued",
    refund_issue_saving: "Saving…",
    refund_issue_done: "Refund marked as issued ({n} item(s))",
    refund_issue_nothing_pending: "Nothing left to refund on this order — it was already issued or cancelled",
    refund_issue_failed: "Could not mark the refund as issued — try again",
    refund_pending_channel_detail: "Issue Refund refunds the customer's card on {channel}, which emails them a credit note.",
    refund_issue_channel_button: "Issue Refund",
    refund_issue_channel_saving: "Issuing refund…",
    refund_issue_channel_done: "Refund of {amount} issued on {channel}",
    refund_issue_channel_failed: "{channel} didn't issue the refund: {reason}",
    refund_issue_mark_only_button: "Already refunded on {channel} — mark issued",
    order_item_replacement_badge: "Replacement {order} · {n}×",
    refund_manual_channel_note: "Refunds must be issued manually on the sales channel",
    refunded_items: "Refunded",
    of_quantity: "of {n}",
    col_notes: "Notes",
    sort_by: "Sort by",
    sort_ascending: "Sort ascending",
    sort_descending: "Sort descending",

    // Leader flagged-order resolution
    resolve_order: "Resolve Order",
    refund: "Refund",
    refund_summary: "Refund Summary",
    items_to_refund: "Items to refund",
    items_to_ship_count: "Items to ship",
    shipping_refund: "Shipping refund",
    shipping_refund_hint: "Enter any shipping charge to refund",
    customer_paid_shipping: "Customer paid shipping",
    no_shipping_charged: "No shipping charged",
    items_refund_total: "Items refund",
    total_refund: "Total refund",
    process_refund: "Refund",
    process_refund_and_continue: "Refund & Continue",
    full_refund: "Full refund",
    partial_refund: "Partial refund",
    no_refund: "No refund required",
    resolve_complete: "Order Resolved",
    refund_issued_for: "Refund of {amount} sent to Pending Refund for the refund manager",
    resolve_not_permitted: "You don't have permission to resolve this order that way. Nothing was saved — ask a leader, or an admin to grant it in Access Control.",
    resolve_no_grant: "Resolving flagged orders is not enabled for you. An admin can grant it in Access Control.",
    resolve_refund_no_grant: "Refunding is not enabled for you. An admin can grant it in Access Control.",
    resolve_failed: "Couldn't save the resolution. Nothing was saved — please try again.",
    remaining_to_resolve: "Remaining to resolve",
    unit_price: "Unit price",

    // Flagged list — quick resolve (Resolve dropdown button)
    resolve_menu_dispatch: "Dispatch",
    resolve_menu_refund: "Refund",
    resolve_menu_manual_ship: "Manually fulfil",
    resolve_menu_replace: "Send replacement",
    // Send replacement from the flagged list — the short units start
    // ticked and the save also closes the flag.
    replacement_intro_flagged: "Resend the units that shipped short on order #{order}, free of charge. What the flag says is missing is already ticked — adjust it if the customer needs something different.",
    replacement_line_short: "{n} short",
    replacement_flag_resolve_note: "Sending also resolves the flag — the original order will be marked Fulfilled with nothing refunded.",
    replacement_created_flag_resolved: "Replacement #{order} sent to the warehouse — flag resolved",
    // Pick trace on the flagged card — where the short units were picked from
    flag_story_title: "What went wrong",
    flag_story_missing_picking: "{n} missing at picking",
    flag_story_missing_sorting: "{n} missing at sorting",
    flag_story_missing_dispatch: "{n} missing at dispatch",
    flag_story_checked_none: "{by} checked {shelf} at {when} and found none",
    flag_story_checked_found: "{by} checked {shelf} at {when} and found only {found}",
    flag_story_never_picked: "nothing was picked from {shelf}",
    flag_story_short_pick: "only {picked} of {required} picked from {shelf} by {by} at {when}",
    flag_story_never_waved_stock: "{n} never sent to a picker (no stock when the order was waved). Stock is now at",
    flag_story_never_waved_no_stock: "{n} never sent to a picker (no stock when the order was waved). Still no stock in this warehouse",
    flag_story_more_shelves: "+{n} more shelves",
    flag_story_premarked: "marked missing before sorting",
    flag_story_not_sorted: "picked, but never sorted into this order at the wall",
    flag_story_scanned_lost: "all {n} were scanned at the shelf by {by}, but not at the packing desk",
    flag_story_sorted_lost: "picked and sorted into this order, but not at the packing desk",
    flag_story_picked_lost: "picked, but not at the packing desk",
    flag_story_tote: "tote {tote}",
    flag_story_high_shelf: "High shelf",
    flag_stock_title: "Stock available to send as a replacement",
    flag_stock_title_high: "Replacement stock is on high shelves only — it will need fetching",
    flag_stock_title_none: "No stock left to send as a replacement",
    flag_stock_available: "{n} in stock",
    flag_stock_some_high: "{n} in stock ({high} on high shelves)",
    flag_stock_high_only: "{n} in stock, high shelves only",
    flag_stock_none: "none in stock",
    quick_refund_title: "Refund order #{order}",
    refund_line_outstanding: "Refund up to {n}",
    resolve_zero_refund_warning: "No refund — the order will be marked Fulfilled",
    resolve_status_result: "Order will be marked: {status}",
    manual_ship_title: "Manually fulfil #{order}",
    manual_ship_items_note: "These units will be recorded as shipped:",
    manual_ship_pick_parcel: "Which parcel are they being added to?",
    manual_ship_confirm: "Mark as shipped",
    manual_ship_done: "Recorded as shipped — order resolved",
    manual_ship_done_partial: "Recorded as shipped — {amount} sent to Pending Refund",
    manual_ship_line_outstanding: "{n} outstanding",
    manual_ship_line_to_refund: "{n} to Pending Refund",
    manual_ship_rest_to_refund: "{n} not found go to Pending Refund ({amount}).",
    manual_ship_none_selected: "Nothing selected to ship — use Refund instead",
    manual_ship_refund_not_permitted: "Units not found need a refund, which your account can't do — ship all of them, or ask a manager",
    resolve_conflict: "This order was already resolved elsewhere — the list has been refreshed",
    filter_issue: "Issue",
    flag_issue_all: "All issues",
    flag_issue_packing: "Packing issue",
    flag_issue_missing: "Missing items",
    flagged_parcels_sent: "{count} parcels sent",
    already_shipped_x: "Already shipped x{count}",
    already_scanned_x: "Already scanned x{count}",
    flag_and_print: "Flag & Print Labels",
    flag_label_hint: "{count} label(s) will be printed. Apply one to each box.",

    // Search Orders — order detail modal
    order_items: "Order Items",
    order_shipping: "Shipping",
    order_tax: "Tax",
    order_total: "Order Total",
    qty: "Qty",
    add_note: "Add Note",
    note_placeholder: "Add a note about this order...",
    note: "Note",
    // Threaded notes on the order detail modal (order-notes.tsx)
    order_notes_hint: "Saved straight away with your name and the time. You can edit or remove your own note for one hour.",
    order_notes_empty: "No notes on this order yet",
    order_notes_unknown_author: "Earlier note",
    order_notes_edited: "edited",
    order_notes_added: "Note added",
    order_notes_deleted: "Note removed",
    order_notes_delete_confirm: "Remove this note?",
    order_notes_delete_action: "Remove",
    mobile: "Mobile",
    saved: "Saved",

    // SKU mapping (dispatch detail modal)
    sku_map_title: "Map line item to a product",
    sku_map_unmapped_label: "Inbound SKU",
    sku_map_original: "Original",
    sku_map_needs_mapping: "Needs mapping",
    sku_map_non_stock: "Non-stock",
    sku_map_action_map: "Map",
    sku_map_action_remap: "Remap",
    hold_reason_unmapped: "On hold: one or more items need mapping to a product. The order releases automatically once every line is mapped or marked non-stock.",
    hold_reason_stock: "On hold: not enough stock at {warehouse} to fulfil this order. Book stock in (it releases automatically), or release it short without the missing units.",
    hold_reason_stock_multi: "On hold: not enough stock at {warehouses} to fulfil this order. Book stock in at any of them (it releases or moves there automatically), or release it short without the missing units.",
    hold_reason_or: "or",
    // Release short — free a stock-blocked order to pick without its
    // missing units (marks the shortfall on missing_count; dispatch
    // shows those units as missing for the refund).
    stock_blocked_banner: "Missing stock — this order can't be picked until stock arrives, or it is released short.",
    stock_blocked_line_missing: "Missing stock — {missing} of {need} unavailable",
    orders_release_short_btn: "Release short",
    orders_release_short_title: "Release order short",
    orders_release_short_body: "These units have no available stock anywhere in the warehouse. Releasing marks them as missing: the order goes to picking without them, and they will show as missing at dispatch for refund.",
    orders_release_short_confirm: "Mark {count} unit(s) missing & release",
    orders_release_short_done: "Order released — {count} unit(s) marked missing.",
    orders_release_short_failed: "Release short failed — try again.",
    orders_release_short_not_blocked: "This order is no longer stock-blocked — no release needed.",
    // Release short on a stock-HELD order: same action, plus it takes
    // the order off hold. Zero-shortfall variant covers a hold whose
    // shortage is other orders' reserved demand (stock is on the shelf).
    orders_release_short_hold_note: "The order will also be taken off hold and queued for picking.",
    orders_release_hold_none_body: "Every unit has stock on the shelf, but it is reserved for other orders. Releasing takes this order off hold to queue for picking as normal — no units are marked missing.",
    orders_release_hold_confirm: "Release order",
    orders_release_hold_done: "Order released off hold.",
    hold_reason_manual: "On hold: set manually. Set it back to Unfulfilled to release it.",
    exchange_order_banner: "Exchange order: the new items for a customer's return. It holds its stock and moves to Unfulfilled by itself once the return is sent, delivered or received (by its value). Release or cancel it from the return on the Returns page.",
    hold_reason_pallet_order: "On hold: pallet order held on arrival (Settings › Dispatch › Pallet orders). Set it back to Unfulfilled to send it to Pallet Picks.",
    sku_map_search_by: "Search by",
    sku_map_field_sku: "SKU",
    sku_map_field_ean: "EAN",
    sku_map_field_title: "Title",
    sku_map_placeholder_sku: "Exact SKU (case-sensitive)",
    sku_map_placeholder_ean: "Barcode / EAN",
    sku_map_placeholder_title: "Exact product title",
    sku_map_no_results: "No matching products.",
    sku_map_search_failed: "Search failed. Try again.",
    sku_map_failed: "Could not update line item.",
    sku_map_success: "Line item mapped.",
    sku_map_non_stock_marked: "Marked as non-stock.",
    sku_map_mark_non_stock: "Mark as non-stock",
    sku_map_non_stock_hint: "Use for third-party drop items we won't pick or ship.",

    // Products admin
    products_settings: "Products",
    products_settings_hint: "Manage the product catalogue. Download an XLSX template, edit it in Excel, then upload to add, update, archive, or remove products in bulk. SKU and Barcode columns are pre-formatted as Text so long digit strings round-trip without being mangled to scientific notation.",
    products_total: "Total products",
    products_active: "Active",
    products_archived: "Archived",
    products_upload_xlsx: "Upload XLSX",
    products_download_limit: "Download current is limited to {max} rows and this filter matches {total}. Narrow the filter (supplier, status or search) to download.",
    products_upload_empty: "Spreadsheet is empty",
    products_upload_bad_header: "Spreadsheet must include 'action' and 'sku' columns",
    products_upload_parse_error: "Could not read spreadsheet — make sure it's a valid .xlsx file",
    orders_upload_bad_header: "CSV must include 'action' and 'order_id' columns",
    orders_upload_rejected: "Import rejected — {n} error(s). Nothing was imported; fix the file and upload it again.",
    orders_upload_partial: "Import finished with {n} error(s) — the listed rows were NOT applied. Review the errors below.",
    orders_more_errors: "…and {n} more",
    products_upload_scientific_notation: "{field} '{value}' looks like scientific notation — precision was lost. Format the {field} column as Text in Excel and re-enter the value.",
    no_products: "No products yet",
    products_col_sku: "SKU",
    products_col_master_sku: "Master SKU",
    products_col_title: "Title",
    products_col_supplier: "Supplier",
    products_col_origin: "Origin",
    products_col_weight: "Weight",
    products_col_barcode: "Barcode",
    products_col_rrp: "RRP",
    products_col_cost_price: "Cost",
    products_col_status: "Status",
    products_filter_search: "Search SKU, title, barcode, supplier",
    products_search_hint: "Search SKU, title, barcode, supplier (press Enter)",
    products_filter_all_suppliers: "All suppliers",
    products_no_matches: "No products match your filters",
    products_modal_title: "Edit Product",
    products_modal_tab_details: "Details",
    products_modal_tab_logs: "Logs",
    products_modal_image: "Image URL",
    products_modal_commodity: "Commodity code",
    products_modal_length: "Length (cm)",
    products_modal_width: "Width (cm)",
    products_modal_height: "Height (cm)",
    products_modal_ship_in_packaging: "Ships in original packaging",
    products_modal_extra_protection: "Extra protection needed (no plastic mailbags)",
    products_modal_ships_as_pallet: "Ships as a pallet (pallet pick queue, pallet carrier)",
    products_modal_soft_item: "Soft item — folds to fit a plastic mailbag (clothing, costumes)",
    products_modal_channels_heading: "Sales channels",
    products_modal_section_identity: "Identity",
    products_modal_section_listing: "Listing",
    products_modal_section_physical: "Dimensions & weight",
    products_modal_section_commercial: "Pricing & customs",
    products_modal_sync_to: "Sync to {channel}",
    products_modal_push_stock: "Push stock now",
    products_modal_push_stock_value: "Will sync: {n}",
    products_modal_sync_status_heading: "Last sync result per channel",
    products_modal_sync_pending: "Pending",
    products_modal_sync_failed: "Failed",
    products_modal_sync_success: "Success",
    products_modal_sync_col_vendor: "Vendor",
    products_modal_sync_col_warehouse: "Warehouse",
    products_modal_sync_col_qty: "Qty",
    products_modal_sync_col_status: "Status",
    products_modal_sync_col_detail: "API",
    products_modal_sync_view_response: "View API request + response",
    products_modal_sync_no_trace: "No API trace recorded",
    products_modal_sync_request: "Request sent",
    products_modal_sync_response: "Response received",
    products_modal_push_stock_hint: "Re-sync on-hand to every enabled channel — useful after a manual adjustment.",
    products_modal_push_stock_ok: "Queued {n} channel push(es)",
    products_modal_push_stock_err: "Failed to queue stock push",
    products_modal_add_barcode: "Add barcode",
    products_modal_remove_barcode: "Remove barcode",

    // Suppliers admin
    suppliers_settings: "Suppliers",
    suppliers_settings_hint: "Manage the canonical supplier list. Add, archive, or rename suppliers; products and manifests use this list for their supplier filters and uploads. Renaming a supplier here also updates every product currently linked to it.",
    suppliers_total: "Total suppliers",
    suppliers_active: "Active",
    suppliers_archived: "Archived",
    suppliers_search_hint: "Search supplier name (press Enter)",
    suppliers_no_matches: "No suppliers match your filters",
    suppliers_col_name: "Supplier",
    suppliers_col_status: "Status",
    suppliers_col_book_in: "Book In",
    suppliers_book_in_label: "Show in supplier book-in (when it has open POs)",
    suppliers_book_in_yes: "Shown",
    suppliers_book_in_no: "Hidden",
    suppliers_col_allow_duplicates: "Allow duplicates",
    suppliers_allow_duplicates_label: "Allow duplicates (skip the 'already in stock' check when this supplier's products are booked in)",
    suppliers_allow_duplicates_yes: "Allowed",
    suppliers_allow_duplicates_no: "Blocked",
    suppliers_add: "Add supplier",
    suppliers_modal_add_title: "Add supplier",
    suppliers_modal_edit_title: "Edit supplier",
    suppliers_modal_name_label: "Supplier",
    suppliers_upload_xlsx: "Upload XLSX",
    suppliers_upload_empty: "Spreadsheet is empty",
    suppliers_upload_bad_header: "Spreadsheet must include 'action' and 'name' columns",
    suppliers_upload_parse_error: "Could not read spreadsheet — make sure it's a valid .xlsx file",
    suppliers_preflight_title: "Unknown suppliers",
    suppliers_preflight_body_missing: "These suppliers in the file don't exist yet. Add them automatically?",
    suppliers_preflight_body_archived: "These suppliers exist but are archived — they'll be restored:",
    suppliers_preflight_confirm: "Create and continue upload",
    suppliers_preflight_cancel_hint: "Cancel — no rows will be uploaded",
    products_upload_cancelled_missing_suppliers: "Upload cancelled — no rows were saved.",
    manifest_upload_cancelled_missing_suppliers: "Upload cancelled — no rows were saved.",

    // Totes admin table
    totes_filter_id: "Search tote ID",
    totes_filter_user: "Filter by user…",
    totes_filter_all_types: "All types",
    totes_no_matches: "No totes match your filters",
    totes_col_id: "Tote ID",
    totes_col_created: "Created",
    tote_status_available_filter: "Available",
    tote_status_open_filter: "Open",
    tote_status_closed_filter: "Closed",
    tote_status_stored_filter: "Stored",
    totes_search_hint: "Search tote ID (Enter; append * for exact match)",
    totes_user_search_hint: "Filter by user (press Enter)",
    totes_reset_action: "Reset to available",
    totes_reset_title: "Reset tote to available?",
    totes_reset_body: "Tote {toteId} will be flipped back to 'available'. Any items currently booked into this tote will be removed from it.",
    totes_reset_hint: "This action cannot be undone.",
    totes_reset_confirm: "Reset tote",
    totes_reset_done: "Tote {toteId} reset to available",
    totes_reset_failed: "Couldn't reset tote — try again",


    // Logs (admin)
    logs: "Logs",
    logs_hint: "Every authenticated action across Portal — book-in, put-away, sorter, conveyor, scans, settings changes, admin functions. Filter by warehouse, user, permission, department, action, and date.",
    logs_filter_search: "Search user, tote, location, order, PO, SKU, item, barcode",
    logs_filter_department: "Department",
    logs_filter_department_all: "All departments",
    logs_filter_user: "User",
    logs_filter_user_all: "All users",
    logs_page_size: "Rows per page",
    logs_page_size_option: "{count} rows",
    logs_filter_action: "Action",
    logs_filter_action_all: "All actions",
    logs_filter_permission: "Permission",
    logs_filter_permission_all: "All permissions",
    logs_filter_status: "Status",
    logs_filter_status_all: "All statuses",
    logs_filter_warehouse_all: "All warehouses",
    logs_filter_search_hint: "Search… (press Enter)",
    logs_search_by: "Search in",
    logs_search_by_all: "All fields",
    logs_search_by_user: "User",
    logs_search_by_tote: "Tote",
    logs_search_by_location: "Location",
    logs_search_by_order: "Order",
    logs_search_by_po: "PO",
    logs_search_by_sku: "SKU",
    logs_search_by_item: "Item",
    logs_search_by_barcode: "Barcode",
    logs_filter_from: "From",
    logs_filter_to: "To",
    logs_filter_range: "Date range",
    date_preset_today: "Today",
    date_preset_yesterday: "Yesterday",
    date_preset_last_7: "Last 7 days",
    date_preset_last_30: "Last 30 days",
    date_preset_last_90: "Last 90 days",
    date_preset_custom: "Custom range",
    logs_status_success: "Success",
    logs_status_error: "Error",
    logs_no_matches: "No logs match your filters",
    logs_load_failed: "Couldn't load logs — try again",
    logs_col_ts: "Timestamp",
    logs_col_user: "User",
    logs_col_department: "Department",
    logs_col_action: "Action",
    logs_col_status: "Status",
    logs_col_warehouse: "Warehouse",
    logs_col_context: "Context",
    logs_drawer_method: "Method",
    logs_drawer_path: "Path",
    logs_drawer_duration: "Duration",
    logs_drawer_metadata: "Metadata",
    // Customer emails in the order Logs tab (components/dispatch/customer-email-log.tsx)
    email_log_chip_to: "To",
    email_log_chip_lang: "Lang",
    email_log_chip_sends: "Sends",
    email_log_chip_error: "Error",
    email_log_copied: "Copied",
    email_log_copy_failed: "Could not copy — select the text and copy it instead",
    email_log_status: "Status",
    email_log_status_sent: "Sent",
    email_log_status_queued: "Queued",
    email_log_status_failed_retry: "Failed — will retry",
    email_log_status_failed_permanent: "Failed — not retried",
    email_log_type: "Email",
    email_log_kind_shipment: "Dispatch confirmation",
    email_log_kind_replacement: "Replacement on its way",
    email_log_kind_extra_box: "Extra parcel on its way",
    email_log_queued_at: "Queued",
    email_log_sends_at: "Sends at",
    email_log_attempts: "Attempts so far",
    email_log_last_error: "Last error",
    email_log_sent_at: "Sent",
    email_log_attempted_at: "Attempted",
    email_log_error: "Error",
    email_log_to: "To",
    email_log_erased: "Erased (data retention)",
    email_log_from: "From",
    email_log_reply_to: "Reply-To",
    email_log_subject: "Subject",
    email_log_language: "Language",
    email_log_titles_translated: "{n} product title(s) translated",
    email_log_language_note: "Sent in English: {reason}",
    email_log_message_id: "SES message ID",
    email_log_copy: "Copy",
    email_log_delivery: "Delivery",
    email_log_attempt_n: "attempt {n}",
    email_log_outbox_row: "outbox row {id}",
    email_log_contents: "What the email listed",
    email_log_parcel: "Parcel",
    email_log_pallet: "Pallet",
    email_log_carrier: "Carrier",
    email_log_tracking: "Tracking",
    email_log_units: "Units",
    email_log_still_to_come: "Still to come",
    email_log_units_n: "{n} unit(s)",
    email_log_orders_in_shipment: "Orders in this shipment",
    email_log_the_email: "The email",
    email_log_bodies_erased: "The email's content was erased with the order's personal data.",
    email_log_bodies_dropped: "The email's content is no longer stored (kept for 180 days). The details above remain.",
    email_log_bodies_none: "This attempt failed before an email was written.",
    email_log_view_preview: "Preview",
    email_log_view_html: "HTML source",
    email_log_view_text: "Plain text",
    email_log_open_tab: "Open in new tab",
    email_log_copy_html: "Copy HTML",
    email_log_copy_text: "Copy text",

    // Change password (forced rotation for admin / superAdmin)
    change_password_title: "Set a new password",
    change_password_subtitle: "For security, please choose a new password before continuing. This is a one-time step.",
    change_password_new_label: "New password",
    change_password_confirm_label: "Confirm new password",
    change_password_show: "Show password",
    change_password_hide: "Hide password",
    change_password_mismatch: "Passwords don't match",
    change_password_rules_label: "Password requirements",
    change_password_rule_length: "At least {min} characters",
    change_password_rule_upper: "Uppercase letter",
    change_password_rule_lower: "Lowercase letter",
    change_password_rule_digit: "Number",
    change_password_rule_symbol: "Symbol",
    change_password_rule_no_spaces: "No spaces",
    change_password_submit: "Save new password",
    change_password_done: "Password updated",
    change_password_failed: "Couldn't update password. Try again.",

    // Login attempt feedback
    login_attempts_remaining: "Invalid login. {count} attempts remaining before a 15-minute lockout.",
    login_one_attempt_remaining: "Invalid login. 1 attempt remaining before a 15-minute lockout.",
    login_colour_locked: "Too many failed attempts. This colour is locked. Try again in {minutes} minutes.",

    // Involuntary logout — shown on the login screen after the BE
    // stopped recognising the session. Portal allows one session per
    // user, so signing in anywhere signs you out everywhere else.
    login_signed_out_elsewhere: "You were signed out because this account was used to log in on another device. Only one device can be signed in at a time.",
    login_session_expired: "Your session ended. Please sign in again.",
    no_module_access: "You don't have access to that module.",
    no_area_access: "You don't have access to any area of Portal yet. Ask your manager to set up your access.",
    // Access-control read-only handheld mode (ACCESS_CONTROL_PLAN.md §8.4) —
    // shown when the signed-in position has "read" (not "write") on this
    // page's key: queues/counts still load, but every mutating control is
    // disabled and scans are rejected with an error tone.
    read_only_mode: "Read-only: you can view this page but not make changes",

    // Forgot password (no self serve, find a grown up)
    forgot_password: "Forgot password?",
    forgot_password_title: "Locked out, are we?",
    forgot_password_body: "There's no reset button on this page. Only sympathy. You'll need to track down a leader with admin access to bail you out. Approach calmly, ask nicely, prepare a convincing story about how this happened, and resist the urge to overshare. Confidence helps. Pleading also works.",
    forgot_password_dismiss: "Got it",

    // Magic-link login ("email me a login link")
    login_link: "Email me a login link",
    login_link_title: "Get a login link",
    login_link_body: "Enter your account email and we'll send you a one-time link. Open it on any device and confirm, and this device signs in automatically.",
    login_link_email_placeholder: "Email address",
    login_link_invalid_email: "Enter a valid email address",
    login_link_send: "Send link",
    login_link_sending: "Sending…",
    login_link_waiting_title: "Check your email",
    login_link_waiting_body: "We've sent a link to {email}. Open it anywhere, phone included, and confirm. This screen will sign in by itself.",
    login_link_waiting_hint: "Waiting for you to confirm the link…",
    login_link_expired_title: "Link expired",
    login_link_expired_body: "The link wasn't confirmed within 10 minutes, so it's no longer valid. Request a new one.",
    login_link_try_again: "Start over",
    // Emailed-link confirm page (/login/link)
    login_link_approve_title: "Confirm login",
    login_link_approve_body: "This signs in the device where the link was requested, not the one you're reading this on. If you didn't ask for a login link, close this page.",
    login_link_approve_confirm: "Confirm login",
    login_link_approve_working: "Confirming…",
    login_link_approved_title: "You're all set",
    login_link_approved_body: "The device that requested the link is now signed in. You can close this page.",
    login_link_invalid_title: "Link not valid",
    login_link_invalid_body: "This login link is invalid, expired, or already used. Request a fresh one from the login page.",

    // User email (Users Panel add/edit modals)
    email_optional: "Email (optional)",
    email_placeholder: "name@example.com",
    users_permissions_locked: "This position is locked: nobody changes their own, and an Admin's is fixed",
    // Username / email login + one-time account setup (2026-10-19)
    login_identifier_label: "Username or email",
    login_identifier_placeholder: "Username or email",
    login_identifier_required: "Enter your username or email and your password",
    login_or_choose_colour: "or choose your colour",
    login_identifier_locked: "Too many failed attempts. This account is locked. Try again in {minutes} minutes.",
    login_rate_limited_account: "Too many failed attempts for this account. Try again in 15 minutes.",
    login_rate_limited_network: "Too many failed login attempts from this network. Try again in 15 minutes.",
    login_colour_retired: "Colour login has been switched off. Sign in with your username, or ask a leader with admin access if you don't have one yet.",
    account_setup_title: "Set up your account",
    account_setup_subtitle: "Portal now signs you in with a username and password instead of a colour and PIN. Choose yours below. This is a one-time step.",
    account_setup_username_section: "Username",
    account_setup_username_label: "Choose a username",
    account_setup_username_hint: "3–15 characters, letters and numbers only, no spaces or symbols. You'll type this every time you log in, so keep it short.",
    account_setup_username_fixed_hint: "Your username is already set.",
    username_checking: "Checking…",
    username_available: "Available",
    username_err_too_short: "At least 3 characters",
    username_err_too_long: "No more than 15 characters",
    username_err_invalid_chars: "Letters and numbers only",
    username_err_reserved: "That username is reserved. Choose another.",
    username_err_profanity: "That username isn't allowed. Choose another.",
    username_err_taken: "That username is already taken",
    username_err_invalid: "That username can't be used",
    account_setup_email_section: "Email",
    account_setup_email_label: "Work email",
    account_setup_email_hint: "Managers and admins need an email on file. It's used to sign in by email and for login links on a new device.",
    account_setup_password_section: "Password",
    account_setup_password_hint: "Pick something you can remember and type on a handheld: two words and a number, like bluetote42 (but not that one). Capitals and symbols are allowed but not required.",
    account_setup_submit: "Finish setup",
    account_setup_done: "Account set up. Welcome to Portal.",
    account_setup_failed: "Couldn't finish setup. Try again.",
    // Shorter copy on phones (hooks/useIsPhone) — same meaning, fewer lines
    account_setup_subtitle_short: "Portal now uses a username and password. Choose yours once, below.",
    account_setup_username_hint_short: "3–15 letters or numbers, no spaces or symbols.",
    account_setup_email_hint_short: "Needed to sign in by email and for login links.",
    account_setup_password_hint_short: "Two words and a number, like bluetote42. Capitals and symbols optional.",
    change_password_subtitle_short: "Choose a new password to continue.",
    password_suggest: "Suggest a password",
    password_suggested_hint: "Suggested password filled in and shown. Note it down before saving.",
    password_generate: "Generate a password",
    password_generated_hint: "Generated for you. Use it, or press again for a different one.",
    password_suggest_short: "Suggest",
    password_generate_short: "Generate",
    change_password_subtitle_expired: "Your password is more than {days} days old. For security, choose a new one before continuing.",
    change_password_subtitle_expired_short: "Your password has expired. Choose a new one to continue.",
    change_password_rule_letter: "A letter",
    change_password_rule_not_guessable: "Not easily guessable",
    password_weak_common: "Too common. Choose something less obvious.",
    password_weak_sequence: "No runs like abcd, 1234 or qwer",
    password_weak_repeated: "No repeating the same characters",
    password_weak_username: "Must not contain your username",
    password_weak_contains_username: "Must not contain your username",
    password_weak_contains_name: "Must not contain your name",
    users_col_username: "Username",
    users_needs_setup: "Needs setup",
    users_needs_setup_hint: "No username yet. This user will be asked to choose one and set a password on their next login",
    users_username_hint: "Lowercase letters and numbers, 3–15 characters. Leave empty to let the user choose at next login.",
    users_username_updated: "Username for {name} updated",
    users_reset_password: "Reset password",
    users_reset_password_hint: "Set a temporary password for {name} and pass it on in person. It is never emailed.",
    users_reset_require_change: "Require a new password at next login",
    users_reset_password_save: "Save password",
    users_reset_password_done: "Password for {name} reset",
    users_email_required_manager: "Managers and admins must have an email address",
    users_add_password_hint: "A temporary password you hand over in person. The user is asked to choose their own at first login.",
    email_required: "Email (required)",
    // Two-factor authentication (2026-10-20): the login card's second step and the Users page
    tfa_verify_title: "Enter your authentication code",
    tfa_signed_in_as: "Signing in as {name}",
    tfa_verify_subtitle: "Enter the 6-digit code from your authenticator app.",
    tfa_backup_code_help: "Enter one of your saved backup codes. Each works once.",
    tfa_code_label: "Authentication code",
    tfa_code_placeholder: "000000",
    tfa_use_backup_code: "Use a backup code instead",
    tfa_use_authenticator_code: "Use an authenticator code instead",
    tfa_backup_code_label: "Backup code",
    tfa_backup_code_placeholder: "XXXX-XXXX",
    tfa_verify_button: "Verify",
    tfa_verifying: "Verifying…",
    tfa_error_invalid_code: "Incorrect code. Please try again.",
    tfa_error_required: "Please enter a code.",
    tfa_error_generic: "Something went wrong. Please try again.",
    tfa_locked: "Too many failed codes. This account is locked. Try again in {minutes} minutes.",
    tfa_rate_limited: "Too many attempts. Please wait a few minutes and try again.",
    tfa_challenge_expired: "Your sign-in timed out. Please enter your password again.",
    tfa_time_left: "{time} left",
    tfa_trust_device: "Remember this device for 7 days",
    tfa_back_to_login: "Back to login",
    tfa_backup_code_used_warning: "You signed in with a backup code. {count} left. If you run out, ask an Admin to reset your two-factor authentication.",
    tfa_enrol_title: "Set up two-factor authentication",
    tfa_enrol_subtitle: "Your role needs a code from an authenticator app at sign-in. Set it up once.",
    tfa_enrol_step1_title: "1. Scan the QR code",
    tfa_enrol_step1_body: "In Google or Microsoft Authenticator, add an account and scan this code.",
    tfa_enrol_qr_alt: "QR code for your authenticator app",
    tfa_enrol_loading: "Preparing your setup code…",
    tfa_enrol_manual_entry_label: "Can't scan? Enter this key:",
    tfa_enrol_copy_secret: "Copy",
    tfa_enrol_secret_copied: "Copied!",
    tfa_enrol_step2_title: "2. Enter the 6-digit code",
    tfa_enrol_step2_body: "Type the code the app shows now.",
    tfa_enrol_confirm_button: "Confirm & continue",
    tfa_enrol_confirming: "Confirming…",
    tfa_enrol_error_invalid_code: "That code did not match. Check the app and try again.",
    tfa_backup_codes_title: "Save your backup codes",
    tfa_backup_codes_subtitle: "Shown once. Each code signs you in once if you lose your phone.",
    tfa_backup_codes_warning: "You won't see these codes again after this page.",
    tfa_backup_codes_copy: "Copy codes",
    tfa_backup_codes_copied: "Copied!",
    tfa_backup_codes_download: "Download .txt",
    tfa_backup_codes_file_header: "JLI Portal two-factor backup codes. Each code works once. Keep this file somewhere safe.",
    tfa_backup_codes_confirm_checkbox: "I've saved these codes somewhere safe",
    tfa_backup_codes_continue: "Continue to Portal",
    users_two_factor: "Two-factor authentication",
    users_two_factor_pill: "2FA",
    users_two_factor_pending_pill: "2FA pending",
    users_two_factor_enrolled_hint: "Two-factor authentication is set up. This user enters an authenticator code at sign-in",
    users_two_factor_pending_hint: "This position requires two-factor authentication. The user will be asked to set it up at their next sign-in",
    users_two_factor_status_enrolled: "Two-factor authentication set up on {date}",
    users_two_factor_status_pending: "Two-factor authentication not set up yet. Asked for at the next sign-in",
    users_reset_two_factor: "Reset two-factor",
    users_reset_two_factor_title: "Reset two-factor authentication?",
    users_reset_two_factor_body: "The authenticator app and backup codes for {name} will stop working, and they will be asked to set two-factor up again at their next sign-in. Use this when they have lost their phone and their backup codes.",
    users_reset_two_factor_confirm: "Reset two-factor",
    users_reset_two_factor_done: "Two-factor authentication for {name} reset. They will set it up again at their next sign-in",
    users_reset_two_factor_error: "Could not reset two-factor authentication for this user",
    users_reset_two_factor_self_refused: "You cannot reset your own two-factor authentication. Ask another Admin.",
    users_reset_two_factor_stepup_title: "Confirm it's you",
    users_reset_two_factor_stepup_body: "Enter the current code from your own authenticator app to confirm this reset.",
    users_reset_two_factor_stepup_label: "Your authenticator code",
    users_reset_two_factor_stepup_hint: "The 6-digit code your app shows for JLI Portal.",
    users_reset_two_factor_stepup_confirm: "Confirm reset",
    users_reset_two_factor_stepup_wrong: "That code was not correct. Please try again.",
    users_reset_two_factor_stepup_locked: "Too many wrong codes. Your account is locked for {minutes} minutes.",

    logs_export: "Export",
    logs_export_progress: "Exporting…",
    logs_export_done: "Exported {count} rows",
    logs_export_empty: "Nothing to export — no rows match the current filters",
    logs_export_failed: "Export failed — try again",
    logs_export_truncated: "Exported the first {exported} of {total} rows. Tighten the filters to capture the rest.",

    // Login screen — may devices save login details? (2026-10-29)
    login_screen_settings: "Login screen",
    login_screen_settings_hint: "How the login screen behaves on every device, at every site.",
    saved_logins_toggle: "Let devices save login details",
    saved_logins_toggle_hint: "Off (recommended, because devices are shared): the browser never offers to save a username and password, and details a device saved earlier are no longer filled in, so everyone types theirs each time. Details saved earlier stay in that browser's own password list until someone deletes them there. On: phones and computers may offer to save them and fill them in next time.",
    saved_logins_now_on: "Devices may now save login details",
    saved_logins_now_off: "Devices will no longer save or fill in login details",
    saved_logins_save_failed: "Could not save the setting",
    // IP allow-list (Network access)
    ip_allowlist_title: "Network access",
    ip_allowlist_hint: "Only the IP ranges below can reach the portal. If the list is empty the gate is open and a warning is logged on every request — add at least one entry to enable enforcement.",
    ip_allowlist_add_title: "Add network",
    ip_allowlist_add_hint: "Use a single IP (e.g. 203.0.113.5) or a CIDR range (e.g. 203.0.113.0/29) for a whole site. Click \"Use my IP\" to fill in the address you're connecting from.",
    ip_allowlist_cidr_label: "CIDR / IP",
    ip_allowlist_cidr_placeholder: "203.0.113.0/24",
    ip_allowlist_label_label: "Label",
    ip_allowlist_label_placeholder: "e.g. Pembroke warehouse, or Full name",
    ip_allowlist_use_my_ip: "Use my IP",
    ip_allowlist_add_button: "Add to allow-list",
    ip_allowlist_my_network_label: "My network",
    ip_allowlist_form_required: "CIDR and label are both required",
    ip_allowlist_added: "Added to allow-list",
    ip_allowlist_added_from_blocked: "Quick-added from blocked attempt: {ip}",
    ip_allowlist_deleted: "Removed from allow-list",
    ip_allowlist_confirm_delete: "Remove {cidr} from the allow-list?",
    ip_allowlist_active_title: "Active allow-list",
    ip_allowlist_empty_warning: "The allow-list is empty. Until at least one entry is added, the IP gate fails open and lets every request through.",
    ip_allowlist_col_cidr: "CIDR",
    ip_allowlist_col_label: "Label",
    ip_allowlist_col_enabled: "Enabled",
    ip_allowlist_col_created: "Added",
    ip_allowlist_blocked_title: "Recent blocked attempts",
    ip_allowlist_blocked_hint: "IPs the portal has rejected. Click the tick to add an IP to the allow-list, or the cross to dismiss it. Older entries expire automatically after 30 quiet days.",
    ip_allowlist_blocked_empty: "No blocked attempts recorded.",
    ip_allowlist_search_placeholder: "Search IP…",
    ip_allowlist_col_ip: "IP",
    ip_allowlist_col_attempts: "Attempts",
    ip_allowlist_col_first_seen: "First seen",
    ip_allowlist_col_last_seen: "Last seen",
    ip_allowlist_col_last_request: "Last request",
    ip_allowlist_quick_add: "Add to allow-list",
    ip_allowlist_dismiss: "Dismiss",
    ip_allowlist_already_allowed: "Already in the allow-list",
    ip_allowlist_edit_label_hint: "Click to edit",
    tile_ip_allowlist_desc: "Manage which networks can reach the portal",

    // Network blocked screen — the IP allow-list refused this device
    network_blocked_title: "This network isn't authorised",
    network_blocked_body: "Portal only accepts connections from approved warehouse and office networks. The connection you are using now isn't on that list.",
    network_blocked_ip_label: "Your IP address",
    network_blocked_ip_unknown: "unknown",
    network_blocked_copy: "Copy address",
    network_blocked_copied: "Copied",
    network_blocked_hint: "Ask an admin to add this address under Settings > Network access, or connect from an approved network, then try again.",
    network_blocked_retry: "Try again",

    // Login activity (per-IP login attempt log)
    ip_allowlist_logins_title: "Login activity",
    ip_allowlist_logins_hint: "Every IP that has tried to log in to the portal, with success/failure counts. Use this to spot legitimate networks and add them to the allow-list before flipping enforcement on.",
    ip_allowlist_logins_empty: "No login activity recorded yet.",
    ip_allowlist_added_from_login: "Quick-added from login activity: {ip}",
    ip_allowlist_added_from_login_named: "{name}'s network",
    ip_allowlist_col_user: "Last user",
    ip_allowlist_col_status: "Last status",
    ip_allowlist_col_success: "Success",
    ip_allowlist_col_failure: "Fail",
    ip_allowlist_status_success: "Success",
    ip_allowlist_status_failure: "Failed",

    // Colour lockouts (per-colour brute-force guard)
    colour_lockout_title: "Locked colours",
    colour_lockout_hint: "These colours have been temporarily locked after too many failed login attempts. Lockouts clear automatically after 15 minutes; superAdmins can unlock manually.",
    colour_lockout_col_colour: "Colour / account",
    colour_lockout_col_failures: "Failures",
    colour_lockout_col_distinct_ips: "Distinct IPs",
    colour_lockout_col_locked_until: "Locked until",
    colour_lockout_col_last_ip: "Last failure IP",
    colour_lockout_unlock: "Unlock",
    colour_lockout_unlocked: "Unlocked {colour}",

    // Integrations — Sales Channels
    integrations_settings: "Integrations",
    integrations_settings_hint: "Connect Portal to outside sales channels. Each channel has its own API credentials and can be toggled independently.",
    integrations_sales_channels_heading: "Sales channels",
    integrations_jobalots: "Jobalots",
    integrations_jobalots_hint: "Connection to the Jobalots marketplace. JLI sells under several vendor sub-accounts on Jobalots — they all share the credentials below but can be toggled on or off independently.",
    integrations_bargainfox: "BargainFox",
    integrations_bargainfox_hint: "Connection to the BargainFox marketplace — a separate sales channel with its own credentials, independent of Jobalots. One vendor sub-account; set its fulfilment warehouse before enabling, or incoming orders will be rejected.",
    // --- Multi-SKU map (Shopify + Amazon) -----------------------------
    sku_map_heading: "SKU mapping",
    sku_map_hint: "Which Portal SKUs sit behind each SKU this channel lists. Several Portal SKUs can share one listing — that is how one product split across manifests is sold as a single item. Stock pushed is their combined total, and an incoming order line is split across them automatically.",
    sku_map_empty: "Nothing mapped yet — run Sync catalogue, then link anything it could not match.",
    sku_map_search_placeholder: "Search a channel SKU or Portal SKU",
    sku_map_unbacked: "{n} listing(s) have no Portal product behind them. Those will never receive stock — link a Portal SKU below or create the product.",
    sku_map_unknown_sku: "No product with this SKU exists in Portal yet",
    sku_map_untracked: "not tracked",
    sku_map_summed: "{n} Portal SKUs — stock is their combined total",
    sku_map_link: "Link",
    sku_map_link_hint: "Link a Portal SKU to a listing by hand. Hand-made links survive a catalogue re-sync; automatic ones are rebuilt each time.",
    sku_map_linked: "Linked {sku} to {external}.",
    sku_map_unlink: "Unlink",
    sku_map_external_placeholder: "Channel SKU",
    sku_map_portal_placeholder: "Portal SKU",
    // --- Amazon Seller Central ---------------------------------------
    amazon_add_channel: "Connect marketplace",
    amazon_add_channel_hint: "Connect an Amazon marketplace. One channel per seller account and marketplace — selling on amazon.co.uk and amazon.de means two, each routed to its own warehouse. Seller-fulfilled listings only: FBA stock is held and shipped by Amazon and is never touched.",
    amazon_channel_created: "Connected {name}. Add the app credentials, then sync the catalogue.",
    amazon_channel_deleted: "Removed {name}.",
    amazon_channel_hint: "A connected Amazon marketplace. Orders are pulled on a timer (Amazon does not push), stock is written as it changes, and dispatch confirms the shipment with tracking. Work down the card: credentials, catalogue, orders.",
    amazon_delete_channel: "Remove marketplace",
    amazon_field_seller_id: "Seller ID",
    amazon_field_marketplace: "Marketplace",
    amazon_field_region: "Region",
    amazon_field_warehouse: "Fulfilment warehouse",
    amazon_field_display_name: "Channel name",
    amazon_choose_marketplace: "Choose a marketplace…",
    amazon_choose_warehouse: "Choose a warehouse…",
    amazon_field_client_id: "LWA client ID",
    amazon_field_client_id_hint: "From your private app in Seller Central (starts amzn1.application-oa2-client). Shared by every marketplace authorised under the same developer profile.",
    amazon_field_client_secret: "LWA client secret",
    amazon_field_client_secret_hint: "The private app's client secret. Stored encrypted and never sent back to the browser.",
    amazon_field_refresh_token: "LWA refresh token",
    amazon_field_refresh_token_hint: "From self-authorising the app against this selling account. Long-lived; Portal exchanges it for a one-hour access token as needed.",
    amazon_needs_credentials: "Add the client ID, client secret and refresh token before enabling this marketplace.",
    amazon_push_mode_hint: "Dry run validates and logs everything Portal would send Amazon without writing anything. Leave a new marketplace in dry run until the Logs page shows correct payloads for real traffic.",
    amazon_sandbox: "Sandbox mode",
    amazon_sandbox_hint: "Point this channel at Amazon's sandbox instead of the real marketplace. The sandbox answers canned data with the same credentials, so it proves the connection and request shapes work — but never real orders or real stock. Use it to rehearse, then switch off.",
    amazon_sandbox_on: "Talking to the sandbox — no real orders or stock",
    amazon_sandbox_off: "Talking to the live marketplace",
    amazon_sandbox_pill: "Sandbox",
    amazon_test_success_sandbox: "Sandbox reachable — {latencyMs} ms. This proves credentials and transport only, not your real listings.",
    amazon_test_success: "Connected to {marketplace} — {latencyMs} ms",
    amazon_catalogue: "Catalogue",
    amazon_catalogue_hint: "Pulls your seller-fulfilled listings and maps each Amazon SKU to the Portal SKUs behind it, matching on SKU then Master SKU. This mapping is also the per-product sync switch: only mapped listings receive stock.",
    amazon_catalogue_synced: "Found {listings} seller-fulfilled listing(s); {matched} have Portal stock behind them.",
    amazon_catalogue_fba_skipped: "Skipped {n} FBA listing(s) — Amazon holds and ships that stock.",
    amazon_orders: "Orders",
    amazon_orders_hint: "Amazon has no webhook, so Portal polls every few minutes. Buyer addresses need the Direct-to-Consumer Shipping role approved on your app, or every sweep fails.",
    amazon_poll_now: "Poll now",
    amazon_poll_now_hint: "Run one order sweep immediately instead of waiting for the next scheduled one.",
    amazon_polling: "Polling…",
    amazon_poll_result: "Swept {seen} order(s): {ingested} ingested, {skipped} skipped.",
    amazon_poll_failed: "{n} order(s) failed to ingest — the cursor is held so the next sweep retries them.",
    amazon_poll_error: "Last order sweep failed: {detail}",
    amazon_last_polled: "Last swept {when}",
    amazon_never_polled: "Never swept — no orders will arrive until this succeeds",
    amazon_routing_heading: "Fulfilment warehouse",
    amazon_routing_hint: "Which warehouse fulfils this marketplace's orders. An unrouted channel rejects every order it receives, and a rejected Amazon order counts against your seller metrics.",
    amazon_unrouted: "No warehouse set",
    amazon_address_only_hint: "Amazon gives every order a unique anonymised buyer email, so the normal customer match can never find a repeat buyer. Matching on the delivery name and address instead makes consolidation work — at the cost of possibly merging two different buyers with the same name at one address.",
    amazon_address_only_on: "Matching on delivery name and address",
    amazon_address_only_off: "Matching on email (never matches on Amazon)",
    // --- Add sales channel wizard --------------------------------------
    add_channel_title: "Add sales channel",
    add_channel_choose: "Which platform are you connecting?",
    add_channel_shopify: "Shopify",
    add_channel_amazon: "Amazon Seller Central",
    add_channel_shopify_hint: "Enter the store's permanent admin domain and its custom app credentials. Nothing is saved until the store answers.",
    add_channel_amazon_hint: "Enter the seller account and your private app's credentials. Nothing is saved until Amazon answers.",
    add_channel_webhook_secret_hint: "The custom app's API secret key. Optional here — you can add it on the card — but orders will not arrive until it is set.",
    add_channel_test_ok: "Connected to {name}",
    add_channel_test_first: "Test the connection first",
    add_channel_create: "Add channel",
    add_channel_created: "Added {name}.",
    add_channel_next_steps: "Everything else — catalogue, SKU mapping, warehouse locations, webhooks — is set up on the channel's own card once it exists.",
    integrations_coming_soon: "Coming soon",
    // --- Shopify stores (multi-store sales channel) -------------------
    shopify_add_store: "Connect store",
    shopify_add_store_hint: "Connect a Shopify store. Enter its permanent admin domain — you can add as many stores as you sell from, each with its own credentials and warehouse routing.",
    shopify_store_created: "Connected {name}. Add its credentials, then sync the catalogue.",
    shopify_store_deleted: "Removed {name}.",
    shopify_store_hint: "A connected Shopify store. Orders arrive by webhook, stock is pushed as it changes, and tracking is written back as a fulfilment when the order is packed. Work down the card in order: credentials, catalogue, warehouse locations, webhooks.",
    shopify_field_display_name: "Store name",
    shopify_field_domain: "Shop domain",
    shopify_field_domain_hint: "The permanent .myshopify.com admin domain, not the customer-facing custom domain. Fixed once the store is connected.",
    shopify_field_api_version: "Admin API version",
    shopify_field_api_version_hint: "Pinned per store (e.g. 2026-07) so a Shopify release can never change a field shape underneath a running warehouse. Upgrade one store, verify, then the rest.",
    shopify_field_access_token: "Admin API access token",
    shopify_field_access_token_hint: "From the store's custom app (starts shpat_). Needs read/write on products, inventory, orders, fulfilments and locations. Stored encrypted and never sent back to the browser.",
    shopify_field_webhook_secret: "Webhook signing secret",
    shopify_field_webhook_secret_hint: "The custom app's API secret key. Portal verifies every incoming webhook against it — without this, orders from this store are rejected.",
    shopify_push_mode_hint: "Dry run validates and logs everything Portal would send Shopify without writing anything to the store. Leave a new store in dry run until the Logs page shows correct payloads for real traffic.",
    shopify_test_success: "Connected to {shop} — {latencyMs} ms",
    shopify_require_paid: "Only fulfil paid orders",
    shopify_require_paid_hint: "On: an order reaches the warehouse only once Shopify reports it paid, partially paid or authorised. Turn off only for stores taking payment on invoice or offline.",
    shopify_require_paid_on: "Waiting for payment before fulfilling",
    shopify_require_paid_off: "Fulfilling regardless of payment status",
    shopify_notify_customer: "Email the buyer on dispatch",
    shopify_notify_customer_hint: "Whether Shopify sends its own shipping-confirmation email when Portal marks the order fulfilled. Turn off if the store already sends one.",
    shopify_notify_customer_on: "Shopify emails the buyer",
    shopify_notify_customer_off: "No email from Shopify",
    shopify_catalogue: "Catalogue",
    shopify_catalogue_hint: "Pulls every variant in the store and maps its SKU to Portal's. This mapping is also the per-product sync switch: only SKUs listed on the store receive stock updates. Re-run it after adding or removing products in Shopify.",
    shopify_catalogue_sync: "Sync catalogue",
    shopify_catalogue_syncing: "Syncing…",
    shopify_catalogue_synced: "Mapped {mapped} variant(s); {matched} match a Portal product.",
    shopify_catalogue_duplicates: "Several variants share a SKU ({skus}) — only one of each can receive stock. Fix the duplicates in Shopify.",
    shopify_catalogue_state: "{n} variant(s) mapped · {when}",
    shopify_catalogue_never: "Never synced — stock will not move until you do",
    shopify_locations: "Warehouse locations",
    shopify_locations_hint: "Shopify holds inventory per location, so each fulfilment warehouse needs one. A warehouse left unmapped is simply not stocked on this store and its movements are never pushed.",
    shopify_locations_load: "Load locations",
    shopify_locations_no_routing: "Set this store's fulfilment warehouses below first — locations are mapped per routed warehouse.",
    shopify_locations_unmapped: "No Shopify location for: {warehouses}. Stock in those warehouses will not be pushed.",
    shopify_location_none: "— not stocked here —",
    shopify_webhooks: "Webhooks",
    shopify_webhooks_hint: "Shopify pushes new, paid and cancelled orders to Portal. Registering points this store at THIS Portal environment — re-register after a staging-to-production cutover, or the store keeps delivering live orders to the old address.",
    shopify_webhooks_check: "Check",
    shopify_webhooks_register: "Register webhooks",
    shopify_webhooks_registering: "Registering…",
    shopify_webhooks_registered: "Registered {n} webhook(s).",
    shopify_webhooks_target: "This Portal instance answers at {url}",
    shopify_webhooks_wrong_env: "This store is delivering orders to a different Portal environment. Orders will not arrive here until you re-register.",
    shopify_webhook_ok: "delivering here",
    shopify_webhook_missing: "not registered",
    shopify_webhook_wrong_env_detail: "going to {url}",
    shopify_routing_heading: "Fulfilment routing",
    shopify_routing_hint: "Which warehouses fulfil this store's orders, in priority order. An order for an unrouted store is rejected rather than sent to a guessed warehouse.",
    shopify_delete_store: "Remove store",
    shopify_delete_store_hint: "Only possible while no order references this store. Disable it instead to stop traffic without losing history.",
    shopify_delete_store_confirm: "Remove {name} and all its settings?",
    integrations_master_enabled: "Channel enabled",
    integrations_master_enabled_hint: "Master switch. Disabling pauses all vendor sub-accounts under this channel.",
    integrations_vendors_heading: "Vendor sub-accounts",
    integrations_vendors_hint: "The vendor identities JLI sells under on this channel. Each carries its own X-Vendor-Id and can be paused independently of the others.",
    integrations_vendors_empty: "No vendor sub-accounts configured yet.",
    integrations_vendor_enabled_hint: "Toggle this sub-account on or off without affecting the others.",
    integrations_status_pill_enabled: "Enabled",
    integrations_status_pill_disabled: "Disabled",
    integrations_warehouse_routing_heading: "Warehouse routing",
    integrations_warehouse_routing_hint: "Map each Portal warehouse to a vendor sub-account on this channel. Inbound orders carrying that vendor_key will be fulfilled from the matching warehouse.",
    integrations_warehouse_routing_empty: "No warehouses configured yet.",
    integrations_warehouse_vendor_select: "Select vendor sub-account",
    integrations_warehouse_vendor_unset: "Not routed",
    integrations_vendor_warehouse: "Fulfilment warehouse",
    integrations_vendor_warehouse_select: "Select fulfilment warehouse",
    integrations_vendor_warehouses: "Fulfilment warehouses",
    integrations_vendor_warehouses_select: "Select fulfilment warehouses",
    integrations_vendor_warehouses_hint: "Pick one or more warehouses, in priority order — the first is primary. Orders consolidate into the highest-priority warehouse that has stock, and only split across warehouses when the stock is split.",
    integrations_vendor_warehouses_summary: "{count} warehouses · primary {primary}",
    integrations_warehouse_primary: "Primary",
    integrations_push_mode: "Push mode",
    integrations_push_mode_hint: "Dry run validates and logs both directions without persisting or fulfilling anything — use it for the shadow run. Switch to Live only at the coordinated cutover.",
    integrations_push_mode_dry_run: "Dry run",
    integrations_push_mode_live: "Live",
    integrations_consolidate_orders: "Consolidate parcel orders",
    integrations_consolidate_orders_hint: "Merge new unfulfilled parcel orders that share a customer email, delivery name and delivery address into one shipment for dispatch, within the cutoff window below. Pallet orders are never included. The channel still receives shipment updates against each original order number.",
    integrations_consolidate_orders_on: "On — matching parcel orders merge into one shipment",
    integrations_consolidate_orders_off: "Off — every order ships separately",
    integrations_consolidate_pallet_orders: "Consolidate pallet orders",
    integrations_consolidate_pallet_orders_hint: "Merge unfulfilled pallet orders (every line a pallet product, including the _PAL half of a mixed order) that share a customer email, delivery name and delivery address into one consignment for the pallet desk. No cutoff and no size limit — any open pallet order for the buyer that a picker hasn't started on joins. Pallet orders only ever merge with pallet orders.",
    integrations_consolidate_pallet_orders_on: "On — a buyer's pallet orders ship as one consignment",
    integrations_consolidate_pallet_orders_off: "Off — every pallet order ships separately",
    integrations_consolidate_pallet_warehouses: "Consolidate at",
    integrations_consolidate_pallet_warehouses_hint: "Highlighted warehouses merge a buyer's pallet orders. Un-highlight a warehouse to ship every pallet order there separately (e.g. MCL, where pallet orders are fulfilled one at a time). A warehouse added later consolidates until you switch it off here.",
    channel_section_consolidation_parcel_on: "Parcel orders on",
    channel_section_consolidation_pallet_on: "Pallet orders on",
    channel_section_consolidation_pallet_on_except: "Pallet orders on (not {warehouses})",
    integrations_ai_extra_protection: "AI extra-protection assessment",
    integrations_ai_extra_protection_hint: "When a product is ordered through this channel for the first time, AI checks the title for fragility (glass, ceramics, etc.) and fills \"Extra protection needed\". Each product is assessed exactly once; manual settings on the Products page are never overridden. This only fills the flag in — whether the pack desk acts on it is the setting below.",
    integrations_ai_extra_protection_on: "On — new products are assessed automatically",
    integrations_ai_extra_protection_off: "Off — products from this channel are not assessed",
    integrations_enforce_extra_protection: "Use extra-protection boxes",
    integrations_enforce_extra_protection_hint: "Whether this channel's orders honour \"Extra protection needed\" at the pack desk: with it on, the recommender skips the box types excluded in Settings > Dispatch > Box Recommendation. Independent of the AI assessment above — leave this on with assessment off to keep respecting the flags you already have, including ones set by hand on the Products page.",
    integrations_enforce_extra_protection_on: "On — flagged items skip the excluded box types",
    integrations_enforce_extra_protection_off: "Off — this channel's orders ignore the flag entirely",
    integrations_consolidation_cutoff: "Cutoff time",
    integrations_consolidation_timezone: "Timezone",
    integrations_consolidation_days: "Cutoff days",
    integrations_consolidation_days_hint: "The cutoff fires at the set time on each selected day. Orders group together between one cutoff and the next — e.g. Mon + Wed + Fri gives three windows a week (Fri-Mon, Mon-Wed, Wed-Fri).",
    integrations_consolidation_cutoff_hint: "Orders only merge with orders placed after the most recent cutoff — each cutoff starts a fresh consolidation window. Clear the time to remove the limit.",
    integrations_consolidation_cutoff_none: "No cutoff — new orders merge with any open order that hasn't started picking.",
    integrations_consolidation_stats: "Last {days} days: {orders} orders became {shipments} shipments — {saved} parcels saved ({pct}%).",
    day_short_mon: "Mon",
    day_short_tue: "Tue",
    day_short_wed: "Wed",
    day_short_thu: "Thu",
    day_short_fri: "Fri",
    day_short_sat: "Sat",
    day_short_sun: "Sun",
    integrations_add_vendor_button: "Add sub-account",
    integrations_add_vendor_display_name: "Display name",
    integrations_add_vendor_display_name_placeholder: "e.g. Jobalots AU",
    integrations_add_vendor_vendor_id: "Vendor key",
    integrations_add_vendor_vendor_id_hint: "Lowercase, must start with a letter — only letters, digits, and underscores. Sent on the wire as X-Vendor-Id.",
    integrations_add_vendor_vendor_id_placeholder: "jobalots_au",
    integrations_add_vendor_save: "Create",
    integrations_add_vendor_invalid: "Display name and a valid vendor key are required.",
    integrations_field_enabled: "Enabled",
    integrations_field_base_url: "Base URL",
    integrations_field_base_url_hint: "The partner's API host that Portal posts shipments and stock-sync calls to. Include the /api/v1 prefix if applicable.",
    integrations_field_base_url_placeholder: "https://api.jobalots.com/v1",
    integrations_field_vendor_id: "Vendor ID",
    integrations_field_vendor_id_hint: "Identifier sent as X-Vendor-Id so the partner can route the request. Agreed between both teams.",
    integrations_field_vendor_id_placeholder: "JOBALOTS_UK",
    integrations_field_outbound_secret: "Outbound HMAC secret",
    integrations_field_outbound_secret_hint: "Portal signs calls TO the partner with this. The partner verifies. Generated by the partner.",
    integrations_field_inbound_secret: "Inbound HMAC secret",
    integrations_field_inbound_secret_hint: "Portal verifies calls FROM the partner with this. The partner signs. Generated by you and shared via 1Password.",
    integrations_secret_unset: "Not set",
    integrations_secret_summary: "Set · fp {fingerprint}",
    integrations_secret_rotated_relative: "rotated {when}",
    integrations_secret_placeholder: "Paste the secret value…",
    integrations_secret_rotate: "Rotate",
    integrations_secret_set: "Set secret",
    integrations_secret_clear: "Clear",
    integrations_secret_clear_confirm: "Clear this secret? Any traffic relying on it will start failing until a new value is set on both sides.",
    integrations_secret_clear_cancel: "Cancel",
    integrations_secret_show: "Show",
    integrations_secret_hide: "Hide",
    integrations_secret_min_length: "Secret must be at least 16 characters",
    integrations_secret_generate: "Generate",
    integrations_secret_generate_title: "Create a strong random secret on the server and show it once",
    integrations_secret_or: "or",
    integrations_secret_generated_title: "New secret — shown once",
    integrations_secret_generated_hint: "Copy it now and send it to the other side over a secure channel. It cannot be shown again; if it is lost, generate another and re-register.",
    integrations_secret_copy: "Copy",
    integrations_secret_copied: "Copied",
    integrations_secret_generated_done: "Done, I have copied it",
    integrations_status_last_push_ok: "Last successful push",
    integrations_status_last_push_failed: "Last failed push",
    integrations_status_last_health: "Last health check",
    integrations_status_never: "Never",
    integrations_status_ok: "OK",
    integrations_status_down: "Down",
    integrations_test_connection: "Test connection",
    integrations_test_running: "Testing…",
    integrations_test_success: "Connected — {latencyMs} ms",
    integrations_test_failure: "Failed: {reason}",
    integrations_test_outbound: "Test outbound (HMAC)",
    integrations_test_outbound_hint: "Sends a signed dry-run POST /stock/sync with an empty updates array. Validates the outbound HMAC secret + signing formula + reachability end-to-end. Always sent as dry_run regardless of channel mode.",
    integrations_test_outbound_success: "Outbound signed call OK — HTTP {status}",
    integrations_test_outbound_failure: "Outbound failed: {reason}",
    integrations_push_all_stock: "Push all stock",
    integrations_push_all_stock_running: "Starting…",
    integrations_push_all_stock_hint: "Enqueues a /stock/sync push for every active product synced to this channel. Runs as a background job so it scales to 100k+ products without timing out.",
    integrations_push_all_stock_hint_counted: "Push on-hand stock for {count} synced product(s) to this channel. Estimated {eta}.",
    integrations_push_all_stock_confirm: "Push current on-hand stock for every synced product to {channel}?",
    integrations_push_all_stock_failure: "Push-all failed: {reason}",
    integrations_push_all_stock_no_products: "No active synced products with stock to push.",
    integrations_push_all_stock_progress_label: "Push all stock → {channel}",
    // Confirmation modal
    integrations_push_confirm_counting: "Calculating how many products will sync…",
    integrations_push_confirm_detail: "{count} active synced product(s) will be pushed. Estimated time: {eta}.",
    integrations_push_confirm_go: "Push stock",
    integrations_push_eta_quick: "under a minute",
    integrations_push_eta_minutes: "about {n} minute(s)",
    // Phase pill (derived BE-side: enqueueing → delivering → completed)
    integrations_push_phase_enqueueing: "Queueing",
    integrations_push_phase_delivering: "Delivering",
    integrations_push_phase_completed: "Completed",
    integrations_push_phase_completed_with_errors: "Completed with errors",
    integrations_push_phase_cancelling: "Cancelling…",
    integrations_push_phase_cancelled: "Cancelled",
    integrations_push_phase_failed: "Failed",
    // Terminal completion banners
    integrations_push_done_ok: "Done — {n} product(s) synced to the channel.",
    integrations_push_done_errors: "Done — {delivered} synced, {failed} failed (see below).",
    integrations_push_job_cancel: "Cancel",
    integrations_push_job_errors_summary: "{n} error(s) — click to expand",
    integrations_push_job_unknown: "(unknown)",
    integrations_push_progress_queued: "Queued",
    integrations_push_progress_delivered: "Delivered",
    integrations_push_progress_pending: "{n} pending",
    integrations_push_progress_failed: "{n} failed",
    integrations_save: "Save",
    integrations_saved: "Saved",
    integrations_save_failed: "Save failed",
    integrations_load_failed: "Could not load integrations",

    // Pick & Sort — settings + sorting runtime
    pick_and_sort: "Pick & Sort",
    pas_settings_hint: "Configure the sorting bays a Pick & Sort wave is split into. Each slot gets a unique barcode and a coloured label; priority 1 = the fastest location.",
    // Putwall — station name in the light-agent scope select; the bay-row
    // tag and sort-screen header badge; the Add Bay toggle under Pick & Sort.
    put_wall: "Putwall",
    pas_put_wall_badge: "Putwall",
    // Paired waves: a half of the wave is still being picked.
    pas_segment_picking: "Segment {no} still being picked by {name} · {done} of {total} lines",
    pas_segment_waiting: "Segment {no} is waiting for a picker — its items are counted but not here yet",
    pas_segment_picking_generic: "Part of this wave is still being picked",
    pas_segment_still_picking: "Part of this wave is still being picked — nothing can be marked missing until it lands",
    pas_add_bay_put_wall: "Putwall (4 shelves × 18)",
    pas_add_bay_put_wall_hint: "Creates this bay as the Putwall: 18 positions wide with PW barcodes. Putwall waves sort here; it never joins the Large bay pair.",
    pas_add_bay: "Add Bay",
    pas_no_bays: "No bays configured yet",
    pas_slot_count: "{count} slots",
    pas_edit_grid: "Edit Grid",
    pas_shelf_colours: "Shelf colours",
    pas_position_colours: "Position colours",
    pas_enable_slot: "Enable slot",
    pas_priority: "Priority",
    pas_priority_mode_small: "Small wave",
    pas_priority_mode_large: "Large wave",
    pas_priority_cross_bay_hint: "Large priorities are compared across BOTH bays — number them globally (1, 2, 3… over the pair, inner edges first). The biggest order lands on priority 1. Blank = use the Small priority.",
    pas_large_wave_badge: "Large wave · 2 bays",
    pas_large_bays_not_empty: "Next wave is Large — both Pick & Sort bays must be empty. Unload the occupied bay first.",
    pas_large_wrong_bay: "This bay isn't part of the Large-wave pair",
    pas_large_bays_unavailable: "A Large wave is waiting but two Pick & Sort bays are no longer configured",
    pas_grid_hint: "Tick a slot to include it. Priority 1 = the fastest / most convenient location.",
    pas_bay_name: "Bay name",
    pas_rename_bay: "Rename Bay",
    pas_duplicate: "Duplicate",
    pas_duplicate_bay: "Duplicate Bay",
    pas_label_colours: "Label colours",
    pas_colours_hint: "Set the colour for each letter and number. Applies to every warehouse and bay.",
    pas_letters: "Letters",
    pas_numbers: "Numbers",
    pas_light_colours: "Light colours",
    pas_light_active: "Active",
    pas_light_complete: "Complete",
    pas_light_timeout: "Time Target",
    pas_light_timeout_hint: "Past half the location time target the beam flashes quickly in the active colour; past the full target it turns solid in this colour.",
    pas_light: "Light",
    pas_light_settings: "Light settings",
    pas_time_targets: "Location Time Targets",
    pas_time_target_label: "Target time per item",
    pas_time_target_hint: "Full cycle: scan item → place → scan location → next item. Leave blank for the default (6s).",
    pas_brightness: "Brightness",
    pas_light_off_delay: "Auto-off delay",
    pas_move_base: "Move time (base)",
    pas_move_step: "Move time (+ per slot of travel)",
    pas_move_threshold: "Lit-move threshold",
    pas_move_timing_hint: "The beam stays dark while the head moves and lights when this window expires — lower is faster, but too low and the beam is visibly still moving when it lights. Every move gets the base time, plus the per-slot time for each slot's worth of pan/tilt travel it actually covers (measured from this bay's own slot spacing, so diagonals, part-slot hops and long throws all scale proportionally). Moves smaller than the lit-move threshold (pan/tilt DMX delta) skip the dark window entirely and sweep lit — raise it so nearby slots cue instantly; 65535 = never go dark.",
    pas_light_enable: "Enable moving-head light for this bay",
    pas_artnet_host: "Art-Net host (DMX-AN2 IP)",
    pas_artnet_universe: "Universe",
    pas_dmx_start: "DMX start ch.",
    pas_light_hint: "The on-site light agent points the head at the scanned slot. Set each location's pan/tilt/zoom in the grid below.",
    pas_pan: "Pan",
    pas_tilt: "Tilt",
    pas_zoom: "Zoom",
    pas_aim: "Aim",
    pas_aiming: "Aiming",
    pas_aim_hint: "Point the head at this slot live — nudge with the arrow keys (↑/↓ pan, ←/→ tilt, Ctrl+↑/↓ zoom) or the steppers until the spot lands on the shelf, then Save. Click again to turn the light off.",
    pas_aim_grid_hint: "Tick a slot to include it. Click Aim to move the head to it live, then tune pan/tilt/zoom (%) so the spot lands on the shelf. Priority 1 = the fastest location.",
    pas_lights_off: "Lights off",
    sorting_print_labels_title: "Print Labels",
    sorting_label_orientation: "Orientation",
    sorting_label_orientation_normal: "As designed ({across}mm across)",
    sorting_label_orientation_cw: "Rotate 90° clockwise ({across}mm across)",
    sorting_label_orientation_ccw: "Rotate 90° anticlockwise ({across}mm across)",
    sorting_label_orientation_flip: "Upside down ({across}mm across)",
    sorting_label_style: "Label design",
    sorting_label_style_standard: "Standard — 185 x 35mm, colour",
    label_style_standard_at: "Standard — {w} x {h}mm, colour",
    label_style_racking_at: "Racking — {w} x {h}mm, aisle · bay · level · barcode",
    label_style_tote_at: "Tote — {w} x {h}mm, barcode · tote ID",
    sorting_label_style_compact: "Compact — 93 x 47mm, black & white",
    sorting_label_style_compact_hint: "Fixed at {w} x {h}mm, no colour and no arrow — for a thermal printer. Slots are identified by the letter, number and barcode.",
    sorting_label_style_large: "Large value — 70 x 30mm, black & white",
    sorting_label_style_large_hint: "Fixed at {w} x {h}mm — the shelf position in large type and the barcode, nothing else. The printed value is the slot's label, which is not always the same as the code the scanner reads.",
    sorting_label_style_large152: "Large value — 152 x 70mm, black & white",
    sorting_label_style_large152_hint: "Fixed at {w} x {h}mm — the same design as the 70 x 30mm label, scaled up for the bigger stock. The printed value is the slot's label, which is not always the same as the code the scanner reads.",
    sorting_label_style_band6x4: "Large value on 6 x 4in — 152 x 102mm, black & white",
    sorting_label_style_band6x4_hint: "The same design on the 6 x 4in stock used at dispatch. Content sits in a {band}mm band across the middle, leaving {gap}mm blank at the top and bottom. Defaults to a quarter-turn because that stock is loaded portrait — change the orientation if yours feeds the other way.",
    sorting_print_range: "Labels to print",
    sorting_print_range_placeholder: "All labels",
    sorting_print_range_hint: "{count} selected. Blank prints the whole bay; or type a slot (A1), a block (A1-D6), or several separated by commas.",
    sorting_print_range_invalid: "Not a slot or range: {token}",
    sorting_print_range_none: "No slots on this bay match that.",
    sorting_print_n: "Print {count}",
    sorting_print_labels_hint: "Prints all {count} slot labels for this bay on the label stock set for {warehouse}.",
    label_print_pick: "Labels to print",
    label_print_pick_all: "Select all",
    label_print_pick_none: "Clear",
    label_print_pick_filter: "Find a label…",
    label_print_pick_empty: "No labels match.",
    label_print_pick_count: "{count} of {total} selected",
    label_print_skip_levels: "Leave out levels {levels} ({count} labels)",
    sorting_label_width_mm: "Label width (mm)",
    sorting_label_height_mm: "Label height (mm)",
    sorting_label_size_hint: "Saved per warehouse and used for both printing and download. Leave blank for the standard {w} x {h}mm stock.",
    printer_default_device: "This device's default printer",
    pas_barcodes: "Barcodes",
    pas_barcodes_hint: "Show each slot's scannable barcode. Edit one to reuse a code that's already printed in the warehouse.",
    pas_barcode: "Barcode",
    pas_barcode_auto: "auto",
    pas_barcode_duplicate: "Duplicate barcode",
    pas_barcode_sorter_hint: "Sorter barcodes are the real location codes the operator scans — they can't be edited here.",
    pas_light_agents: "Light agents",
    pas_light_agents_hint: "Assign which warehouse each on-site light agent drives, and optionally limit it to one sorter station. An agent only controls the bays it's scoped to.",
    pas_light_agent_station_hint: "Limit this agent to one sorter's lights. Leave on \"All stations\" unless the site runs a separate device per sorter.",
    pas_unassigned: "— Unassigned —",
    pas_station_all: "All stations",
    pas_bay_all: "All bays",
    pas_light_agent_bay_hint: "Pin this agent to a single bay, e.g. the Sorter 2 Putwall, which is a separate structure with its own device. A pinned bay is no longer driven by the station-wide agents. Leave on \"All bays\" otherwise.",
    pas_online: "Online",
    pas_cue_latency_hint: "Scan-to-device latency this agent measured itself: backend cue write → arrival at the agent (median of its recent cues, includes clock skew). The physical head move time comes on top.",
    pas_offline: "Offline",
    pas_no_agents: "No light agents yet. Add one below, or start an agent on-site and it'll appear here once it polls.",
    pas_agent_id_placeholder: "Agent ID (e.g. portal-pd)",
    pas_add_agent: "Add agent",
    pas_agent_exists: "An agent with that ID already exists",
    pas_remove_agent: "Remove agent",
    pas_confirm_remove_agent: "Remove agent \"{id}\"? It will reappear if it polls in again.",
    pas_wifi: "Network / WiFi",
    pas_wifi_title: "Network — {id}",
    pas_wifi_current: "Current connection",
    pas_wifi_not_reported: "No network state reported yet — the device sends it every ~15 s while online.",
    pas_wifi_scan: "Scan for networks",
    pas_wifi_waiting: "Waiting for the device — it checks for commands every ~15 s…",
    pas_wifi_offline_warn: "Device is offline. The command is queued and will run when it reconnects.",
    pas_wifi_networks: "Networks in range",
    pas_wifi_in_use: "connected",
    pas_wifi_open: "open",
    pas_wifi_manual: "Or enter a network by name (e.g. a hidden network)",
    pas_wifi_ssid: "Network name (SSID)",
    pas_wifi_password: "Password",
    pas_wifi_password_open_hint: "Leave empty for an open network. WiFi passwords are 8–63 characters.",
    pas_wifi_save: "Save network",
    pas_wifi_save_switch: "Save & switch now",
    pas_wifi_save_hint: "Save adds the network with autoconnect, so the device joins it whenever it's in range — safe to do ahead of a move. Save & switch joins it immediately; if the join fails the device falls back to its previous network on its own.",
    pas_wifi_saved_ok: "Done: {detail}",
    pas_wifi_failed: "Failed: {detail}",
    pas_wifi_scan_failed: "Scan failed: {detail}",
    pas_wifi_no_networks: "No networks found.",
    pas_agent_warehouse: "Warehouse",
    pas_agent_station: "Station",
    pas_agent_bay: "Bay",
    pas_agent_backend: "Backend",
    pas_agent_heads: "Heads",
    pas_heads_choose: "Push to heads…",
    pas_heads_speed_2: "Speed 2 (fast)",
    pas_heads_speed_1: "Speed 1 (default)",
    pas_heads_wifly_off: "WiFly off",
    pas_heads_pan_tilt_reset: "Pan/tilt reset",
    pas_heads_hint: "Send a unit personality to every head this device drives, over DMX. Speed 2 is the fast pan/tilt setting — new heads ship on Speed 1. Only heads on light-enabled bays receive it.",
    pas_heads_confirm: "Push \"{personality}\" to every head driven by \"{id}\"? The device holds the setting on the fixtures for ~6 s.",
    pas_backend_staging: "Staging",
    pas_backend_production: "Production",
    pas_backend_unknown: "Backend: —",
    pas_backend_hint: "Which backend this device talks to. It must match the backend the site's scan stations use (light cues only exist on the instance that receives the scan). The device applies the switch within ~15 s, restarts, and reverts by itself if the chosen backend rejects it.",
    pas_backend_confirm: "Point \"{id}\" at the {backend} backend? The device restarts onto it within ~15 s. If that backend rejects the device's key it will revert to its default on its own after ~2 minutes.",
    pas_location_name: "Name",
    pas_remove_bay: "Remove Bay",
    pas_confirm_remove_bay: "Remove bay \"{name}\" and all its labels?",
    pas_no_demand: "Item not needed by any unsorted order",
    pas_sort_complete: "Sort complete — sent to dispatch",
    pas_not_all_sorted: "Not all items sorted yet",
    pas_all_sorted: "Sort Complete",
    pas_more_waiting: "More to sort. Scan the next tote to begin.",
    pas_unload_first: "Unload this wave before starting the next",
    pas_no_more_waves: "No more waves waiting to be sorted",
    pas_finish_unload: "Finish & Unload",
    pas_scan_item: "Scan item",
    pas_progress: "{sorted} / {total} sorted",
    pas_no_wave_awaiting_sort: "No wave is waiting to be sorted",
    pas_insufficient_locations: "Not enough bay slots for this wave",
    pas_nothing_to_sort: "That wave had no picked items — closed. Scan again for the next wave.",
    // Sorting — Loading / Unloading toggle
    pas_view_loading: "Loading — sort items in",
    pas_view_unloading: "Unloading — out to dispatch",
    pas_scan_slot: "Scan slot",
    pas_scan_tote: "Scan tote",
    pas_scan_tote_next_cubby: "Now scan a tote for {label}",
    pas_cubby_of: "Cubby {n} of 2",
    pas_or_cubby: "or {label} when full",
    pas_slot_not_in_order: "That cubby does not belong to this order",
    pas_scan_source_tote: "Scan tote",
    pas_wrong_tote: "That tote isn't part of this wave",
    pas_available_waves: "Waves waiting to be sorted",
    pas_available_waves_pas: "Pick & Sort waves waiting to be sorted",
    pas_available_waves_put_wall: "Putwall waves waiting to be sorted",
    pas_station_mismatch_put_wall: "That tote's wave is for the Putwall — sort it there",
    pas_station_mismatch_pas: "That tote's wave is for a Pick & Sort bay — sort it there",
    pas_wave_orders: "{count} orders",
    pas_wave_items: "{count} items",
    pas_wave_totes: "Totes: {totes}",
    pas_tote_no_wave: "That tote isn't part of any wave awaiting sorting",
    pas_tote_wave_in_progress: "That tote's wave is already being sorted at another bay",
    pas_wave_in_progress: "Being sorted",
    pas_bay_wave_in_progress: "This bay's wave has already been started — finish or unload it first",
    pas_now_sorting: "Now sorting",
    pas_order_unloaded: "Dispatched",
    pas_slot_not_ready: "That slot isn't ready to unload",
    pas_slot_not_finished: "Slot not finished — {sorted} of {required} items sorted",
    pas_slot_already_unloaded: "That slot has already been unloaded",
    pas_tote_unavailable: "Tote unavailable — use an empty, available tote",
    pas_nothing_to_unload: "Nothing ready to unload yet",
    pas_unload_remaining: "{remaining} to unload",
    pas_unload_items: "{count} items",
    pas_unload_load_more: "Load more ({count})",
    pas_unload_see_less: "See less",
    // Concurrent unloading — a SECOND operator scanning into a bay that is
    // already mid-sort is asked which job they're here to do, then (if they
    // take unloading) empties finished slots while the sort carries on.
    pas_role_sorting_by: "{name} is sorting this bay",
    pas_role_sorting_here: "This bay is already being sorted",
    pas_role_sort: "Sort",
    pas_role_sort_sub: "{count} items left",
    pas_role_unload: "Unload",
    pas_role_unload_sub: "{count} orders ready",
    pas_unload_waiting: "Waiting for orders to finish sorting",
    pas_unload_still_sorting: "{count} items still being sorted",
    // Closer's per-bay "ready to close" table in the unloading view.
    pas_bay_ready_title: "Ready to close",
    pas_bay_ready_here: "here",
    pas_bay_ready_row_aria: "{bay}: {count} ready to close",
    // Per-bay status on the stacked unload grids of a Large (double-bay) wave.
    pas_bay_to_empty: "{count} to empty",
    // Caption over each stacked band of a bay wider than 6 positions (the
    // 18-position Putwall): the positions in that band, in the mirrored
    // reading order the unloader sees them.
    pas_bay_band: "Positions {from}–{to}",
    // Short form of pas_large_wave_badge for the entry-gate wave row, which
    // uppercases its badges and already carries orders / time / picker.
    pas_wave_large_badge: "Large · 2 bays",
    pas_bay_clear: "Clear",
    pas_complete_items: "Items sorted",
    pas_complete_time: "Time taken",
    pas_complete_rate: "Items / hour",
    pas_complete_points: "Points earned",
    pas_complete_flagged: "{count} flagged missing",
    pas_flag_missing_btn: "Report missing items",
    pas_flag_missing_title: "Flag missing items",
    pas_flag_missing_summary: "You've sorted {sorted} of {total} items.",
    pas_flag_missing_question: "Flag the remaining {count} as missing? The affected orders continue to dispatch with the missing items pre-marked — they can still be packed if found later.",
    pas_flag_missing_qty: "{count} missing",
    pas_flag_missing_zero_note: "Orders with nothing sorted will be flagged for review — they cannot go to dispatch.",
    pas_flag_missing_confirm: "Flag all {count} remaining missing",
    pas_flag_success: "{count} items flagged missing",
    pas_manual_btn: "Barcode not scanning?",
    pas_manual_title: "Sort item manually",
    pas_manual_hint: "Tap the item whose barcode won't scan. It will be sorted as if scanned — then scan its slot as normal.",
    pas_manual_remaining: "{count} to sort",
    pas_manual_empty: "Nothing left to sort",
    pas_missing_item_btn: "An item is missing",
    pas_missing_item_title: "Which item is missing?",
    pas_missing_item_hint: "Tap the item that isn't in the tote. Nothing is written off until you confirm on the next screen.",
    pas_missing_item_confirm_title: "Confirm missing item",
    pas_missing_item_confirm_q: "Flag {count} × {item} as missing?",
    pas_missing_item_confirm_note: "The affected orders continue to dispatch with this item pre-marked missing — it can still be packed if it turns up. An order left with nothing sorted is flagged for review. Carry on sorting the rest of the tote afterwards.",
    pas_missing_item_confirm_btn: "Yes — flag {count} missing",
    pas_missing_item_success: "{item} flagged missing ({count})",
    pas_missing_item_gone: "Already sorted or flagged by someone else",

    // Dispatch — tote scan
    dispatch_tote_needs_sorting: "This tote must be sorted before dispatch",
    dispatch_tote_no_orders: "No orders ready in this tote",
    dispatch_tote_unknown: "Tote not recognised",
    dispatch_tote_partly_on_wall: "Half of this order is still on the Putwall in {label} — unload it first",
    dispatch_tote_partly_on_wall_unknown: "Half of this order is still on the Putwall — unload it first",
    dispatch_order_in_totes: "This order is in {count} totes: {totes}",
    dispatch_scan_label_hint: "or scan a shipping label to reopen",
    // Dispatch bench redesign (2026-10-23) — order bar, session bar, rows
    dispatch_reset_short: "Reset",
    dispatch_flag_short: "Flag",
    dispatch_stat_items: "Items",
    dispatch_more_below: "More below: {count}",
    dispatch_orders_in_tote: "Orders in this tote: {count}",
    dispatch_chip_desk: "Desk",
    dispatch_chip_tote: "Tote",
    dispatch_change_desk: "Change desk",
    dispatch_change_tote: "Change tote",
    dispatch_labels_count: "Labels",
    dispatch_box_units: "Items: {count}",
    dispatch_item_damaged_chip: "{count} damaged",
    dispatch_item_wrong_chip: "{count} wrong item",
    dispatch_address_done: "Done",
    dispatch_add_box_tab: "Add another box",
    flag_labels_to_print: "Labels to print",
    flag_label_apply_hint: "Put one on each box.",
    dispatch_flag_missing_short: "Flag missing",
    flag_remaining_title: "Flag the rest as missing",
    flagged_reason_missing_dispatch: "Item missing at dispatch",
    flag_remaining_hint: "Check the tote first. Every order below goes to Flagged with its items marked missing. No labels are printed.",
    flag_remaining_confirm: "Flag {count} as missing",
    flag_remaining_failed: "{count} could not be flagged. Try again.",
    orders_flagged: "{count} Orders Flagged",
    dispatch_label_reopen_warning: "This order has already shipped. Reopening it cancels {n} shipping label(s) at the courier, withdraws the tracking sent to the sales channel, and the order must be packed and labelled again.",
    dispatch_label_reopen_warning_no_labels: "This order has already shipped. Reopening it withdraws the tracking sent to the sales channel, and the order must be packed and labelled again.",
    dispatch_label_reopen_past_cutoff: "Past the {cutoff} manifest cutoff — the courier will refuse the cancellation, so this label stays live and billable. Raise a credit.",
    dispatch_label_reopen_already_scanned: "InPost has already scanned a parcel on this order — it is on its way and will be billed. Reopening cancels the label here only; the parcel cannot be recalled.",
    dispatch_label_order_not_dispatchable: "Order #{order} is {status} — it can't be packed here",
    dispatch_item_not_in_tote: "That item isn't in this tote",
    // Dispatch pack screen — barcode search (2026-10-26)
    dispatch_search_open: "Search by barcode",
    dispatch_search_label: "Barcode or SKU",
    dispatch_search_placeholder: "Type or scan a barcode",
    dispatch_search_hint: "Scans only search until you close",
    dispatch_search_none_hint: "Check the code and the tote",
    dispatch_search_count: "Matches: {count}",
    dispatch_search_none: "Not on this order",
    // Dispatch pack screen — the + menu and own packaging (2026-10-26)
    dispatch_new_container: "New container",
    dispatch_new_box: "New box",
    dispatch_new_box_hint: "Scan a box barcode",
    dispatch_own_pkg_menu: "Own packaging",
    dispatch_own_pkg_menu_hint: "Next scan ships without a box",
    dispatch_other_size: "Other size",
    dispatch_other_size_hint: "Enter measurements",
    dispatch_own_pkg_scan_item: "Scan item",
    dispatch_own_pkg_cancel: "Cancel own packaging",
    dispatch_own_pkg_already: "{sku} is already in its own packaging",
    dispatch_own_pkg_take_out: "Take {count} out of Box {box}",
    dispatch_own_pkg_box_emptied: "Already packed in Box {id}. Box {id} will be empty afterwards, so it will be removed.",
    dispatch_own_pkg_box_left: "Already packed in Box {id}. Left in it afterwards: {count}.",
    dispatch_own_pkg_unscanned: "Not scanned yet: {count}. They go in this packaging too, so there's no need to scan them.",
    ship_in_packaging_moved: "{sku} moved from Box {from} to Box {to}",

    // Settings > Integrations > Carriers
    carriers_heading: "Carriers",
    carriers_load_failed: "Could not load carriers",
    carriers_apc_hint: "APC Overnight via Hypaship. One depot account per warehouse.",
    carriers_section_merging: "Consignment merging",
    carriers_section_claims: "Carrier claims",
    carriers_section_credentials: "Credentials",
    carriers_section_sender: "Sender & return address",
    carriers_section_collection: "Collection window",
    carriers_section_customs: "Customs (Northern Ireland)",
    carriers_accounts_heading: "Accounts",
    carriers_accounts_digest: "{enabled} of {total} enabled",
    carriers_account_digest: "{services} services on",
    carriers_badge_on: "On",
    carriers_badge_off: "Off",
    carriers_badge_none: "None",
    carriers_badge_secret_set: "Secret set",
    carriers_badge_needs_secret: "Needs secret",
    carriers_merging_digest_same: "Same channel only",
    carriers_merging_digest_cross: "Same channel + cross-channel",
    carriers_claims_digest: "Scheduled email to {to}",
    carriers_surcharge_fuel_short: "Fuel",
    carriers_surcharge_decarb_short: "Decarb",
    carriers_surcharge_ni_short: "NI",
    carriers_surcharge_remote_short: "Remote",
    carriers_eori_hint_inpost: "Sent on Northern Ireland customs declarations. EORI optional for GB→NI.",
    carriers_duty_hint_inpost: "Contents line for Northern Ireland parcels; units and value come from the order.",
    carriers_enabled_toggle: "Enable this carrier",
    carriers_add_box_toggle: "Add box to existing consignment",
    carriers_add_box_hint: "Add boxes to the customer's same-day un-manifested consignment when cheaper. Only the new labels print.",
    carriers_cross_channel_add_box_toggle: "Cross channel — add box to existing consignment",
    carriers_cross_channel_add_box_hint: "Also match consignments from other sales channels.",
    savings_open_button: "View savings & activity",
    savings_title: "Savings & activity",
    savings_headline_all_time: "saved all time",
    savings_feature_col: "Feature",
    savings_period_1d: "1 day",
    savings_period_7d: "7 days",
    savings_period_30d: "30 days",
    savings_period_60d: "60 days",
    savings_period_all: "All time",
    savings_feature_add_box_same_channel: "Add box to existing consignment",
    savings_feature_add_box_cross_channel: "Cross channel — add box",
    savings_feature_consolidate_orders: "Consolidate orders",
    savings_feature_off: "off",
    savings_total_row: "Total",
    savings_unit_boxes: "{n} boxes",
    savings_unit_orders: "{n} orders",
    savings_estimate_note: "Order consolidation combines three things. Carriage: {rate} per eliminated shipment (the invoice-validated APC average). Packaging: {packaging} per box no longer packed. Handling: {handling} per unit merged, for the picking, sorting and packing done once instead of twice. Add-box is valued at its exact per-merge carriage saving alone — its boxes are still picked, packed and shipped, they just ride an existing consignment, so no packaging or handling is avoided. Consolidation counts every merged order, including those already dispatched.",
    carriers_environment: "Environment",
    carriers_environment_hint: "Training = APC sandbox. Live = real, billed consignments.",
    carriers_environment_hint_inpost: "Training = InPost stage host (no credentials issued, will not authenticate). Live = production. Unprinted labels are never charged.",
    carriers_env_training: "Training",
    carriers_env_live: "Live",
    carriers_account_heading: "{warehouse} account",
    carriers_account_enabled_toggle: "Enable this depot account",
    carriers_login_email: "Login email",
    carriers_login_email_hint: "APC portal / API username.",
    carriers_password: "Password",
    carriers_password_hint: "Stored encrypted; only a fingerprint is shown.",
    carriers_ready_at: "Ready from",
    carriers_closed_at: "Closed at",
    carriers_times_hint: "Sent on each booking. Blank Ready from = label time. After Closed at, bookings date to the next working day.",
    carriers_eori: "EORI number",
    carriers_ioss: "IOSS registered",
    carriers_eori_hint: "Sent on Northern Ireland (Road Service) consignments.",
    carriers_duty_description: "Duty goods description",
    carriers_duty_hts: "HTS code",
    carriers_duty_origin: "Origin",
    carriers_duty_hint: "One duty line per Northern Ireland consignment; units and value come from the order.",
    carriers_test_connection: "Test connection",
    carriers_test_ok: "Connected ({ms} ms)",
    carriers_test_failed: "Connection failed",
    carriers_last_test_ok: "Last test: OK",
    carriers_services_heading: "Services",
    carriers_services_hint: "Bookable service codes. Limits are tariff caps checked at booking (chargeable weight = max of actual and L×W×H ÷ 6000).",
    carriers_services_empty: "No services yet — add the codes the carrier issued for this account.",
    carriers_service_add: "Add service",
    carriers_service_code: "Code",
    carriers_service_name: "Service name",
    carriers_service_enabled: "Service enabled",
    carriers_service_max_pieces: "Max boxes",
    carriers_service_max_kg: "Max kg",
    carriers_service_max_l: "Max L cm",
    carriers_service_max_w: "Max W cm",
    carriers_service_max_h: "Max H cm",
    carriers_service_delete: "Delete",
    carriers_apc: "APC Overnight",
    carriers_inpost: "InPost UK",
    carriers_inpost_hint: "InPost UK 2Door (home) and OOH (locker/shop). Four OAuth accounts: warehouse × service. One shipment per box, priced per parcel by size band + surcharges; no multi-box discount. No cancel API: a voided label must never be handed over. Recipient phone must be a UK mobile (placeholder used otherwise).",
    // DPD Poland + Cargus (Poland warehouse)
    carriers_dpd_hint: "DPD Poland (DPDServices) for the Poland warehouse — domestic PL. One shipment per order with a waybill per box; ZPL labels. Requesting the label is what advises DPD, so nothing is charged until a label prints and the courier scans it. No cancel API: a voided label must never be handed over. Tracking (InfoServices) needs separate enablement by the DPD account manager.",
    carriers_cargus_hint: "Cargus (Romania) for the Poland warehouse — RO destinations. One AWB per order with a code per box; PDF labels only (print from a PC desk). Deletable until the first scan. Every AWB collects from the registered pickup point; the county/locality nomenclature should be synced so addresses route.",
    carriers_environment_hint_dpd: "Training = DPD's demo host with DPD's public demo credentials, used automatically (cannot ship). Live = production with the account's own credentials (from the DPD account manager, separate from DPD Online).",
    carriers_dpd_demo_credentials_note: "Training uses DPD's public demo credentials automatically (test / FID 1495) — nothing can ship. The fields below are your LIVE credentials, used only when the carrier is switched to Live.",
    carriers_dpd_live_credentials_note: "Live: bookings use the credentials below and create real DPD packages. Switch the carrier to Training to test on DPD's demo host without re-entering anything.",
    carriers_environment_hint_cargus: "Cargus has one host for everything: Training and Live are the same URL. A test booking creates a REAL AWB — delete it in the same session, before it gets a checkpoint.",
    carriers_login_username: "Username",
    carriers_login_username_hint_dpd: "The DPDServices login (not DPD Online). Master FID = the payer number DPD issued (sent as x-dpd-fid). Payer FID = the customer sub-number (\"numkat\") the package is billed to — the Local and INTER contracts may each have their own; a service can override it.",
    carriers_login_username_hint_cargus: "The UrgentCargus web user (LoginUser) and the price table id from the contract (0 = default).",
    carriers_master_fid: "Master FID",
    carriers_payer_fid: "Payer FID",
    carriers_tracking_channel: "InfoServices channel",
    carriers_tracking_channel_hint: "The `channel` DPD assigned to your account for InfoServices (tracking). Same login and password as above. Leave empty until DPD confirm it — the tracking sweep skips the account.",
    carriers_price_table: "Price table id",
    carriers_cargus_api_key: "APIM subscription key",
    carriers_cargus_api_key_hint: "The Primary Key from urgentcargus.developer.azure-api.net (Profile) after the StandardUrgentOnlineAPI subscription is approved. Sent as Ocp-Apim-Subscription-Key on every call.",
    carriers_pickup_location: "Pickup location (Sender.LocationId)",
    carriers_pickup_location_hint: "The registered pickup point every AWB collects from. Load the list once the key and password are saved, or type the id.",
    carriers_pickup_locations_load: "Load pickup points",
    carriers_pickup_locations_none: "— choose —",
    carriers_nomenclature_sync: "Sync county / locality names",
    carriers_nomenclature_synced: "Synced {counties} counties, {localities} localities",
    carriers_nomenclature_hint: "Pulls Cargus's county and locality nomenclature so order addresses resolve to the spelling and ids Cargus route on. Re-run occasionally; unsynced names are still sent and validated by Cargus.",
    carriers_sender_company: "Sender company",
    carriers_origin_county: "Origin county / voivodeship",
    carriers_sender_origin_hint_pl: "Printed as the sender on every label and used as the return address. Street first, then the number (Relaksowa 33). Cargus routes on the sender county.",
    carriers_times_hint_day_close: "Ready-at / closed-at bound the courier collection window; closed-at is when the day is closed with the carrier (DPD handover protocol + courier call, Cargus pickup order).",
    carriers_section_test_booking: "Test booking",
    carriers_test_booking_hint: "Books a sample shipment to this address with the real credentials, through the same payload builder and client the pack bench uses, and shows every step the carrier answered — no order, no booking row.",
    carriers_test_booking_hint_dpd: "Runs the full number-and-label round trip against DPD's demo host (Training) — nothing can ship there. On Live the test refuses to number a real package; switch to Training to test.",
    carriers_test_booking_hint_cargus: "Read-only: verifies the token, asks Cargus to route the address and quotes the price for this box and service. No AWB is created.",
    carriers_test_booking_recipient: "Sample recipient",
    carriers_test_booking_name: "Name",
    carriers_test_booking_line1: "Street and number",
    carriers_test_booking_line2: "Line 2",
    carriers_test_booking_city: "Town",
    carriers_test_booking_county: "County (județ)",
    carriers_test_booking_postcode: "Postcode",
    carriers_test_booking_country: "Country (PL = Local contract, other EU = INTER)",
    carriers_test_booking_phone: "Phone",
    carriers_test_booking_email: "Email",
    carriers_test_booking_box: "Sample box",
    carriers_test_booking_weight: "Weight (g)",
    carriers_test_booking_length: "L (mm)",
    carriers_test_booking_width: "W (mm)",
    carriers_test_booking_height: "H (mm)",
    carriers_test_booking_service: "Service",
    carriers_test_booking_service_default: "As the bench would (shipping rules)",
    carriers_test_booking_service_used: "Service used",
    carriers_test_booking_service_source_shipping_rules: "picked by shipping rule “{rule}”, exactly as at the bench",
    carriers_test_booking_service_source_account_service: "this account's first service that fits the destination (the shipping rules did not land on this account — it may still be disabled)",
    carriers_test_booking_service_source_carrier_default: "carrier default — no service on this account fits the destination, so no extras (e.g. no PRIV)",
    carriers_test_booking_run: "Book test shipment",
    carriers_test_booking_running: "Booking…",
    carriers_test_booking_ok: "Test booking succeeded",
    carriers_test_booking_failed: "Test booking failed",
    carriers_test_booking_steps: "Steps",
    carriers_test_booking_tracking: "Tracking numbers",
    carriers_test_booking_download: "Download label ({format})",
    carriers_test_booking_cleanup: "Clean-up",
    carriers_delivery_mode_point: "locker / shop",
    carriers_client_id: "Client ID",
    carriers_organization_id: "Organisation (Brand) ID",
    carriers_oauth_hint: "Issued by InPost Client Solutions, one set per account.",
    carriers_client_secret: "Client secret",
    carriers_client_secret_hint: "Stored encrypted; only a fingerprint is shown.",
    carriers_palletways_hint: "Palletways pallet network. One API key per site. Connection only for now: the key can be stored and tested, but nothing books on Palletways until consignment booking is built.",
    carriers_api_key: "API key",
    carriers_api_key_hint: "Issued by Palletways for this site's account. Stored encrypted; only a fingerprint is shown.",
    carriers_connection_only_note: "Services, labels and tracking are not set up for this carrier yet.",
    carriers_environment_hint_palletways: "Palletways has a single live API and no test environment. Test connection only reads; it never creates a consignment.",
    carriers_environment_hint_manual_pallet: "No API yet. Pallets on this carrier are booked by hand on the carrier's site; the label is attached to the order and the pallet desk prints it and records the shipment. Test connection calls nothing.",
    carriers_dbschenker_hint: "DB Schenker pallet freight for the rest of the EU — pallet orders delivered to any EU country other than Poland. Manual until the API is ready: enabling this account switches pallet routing on at Poland.",
    carriers_jas_hint: "JAS-FBG pallet freight for Poland — pallet orders with a Polish delivery address, booked from the pallet desk through JAS's ShipmentGateway API: one Ship creates the shipment, prints the Zebra label and the waybill, and marks the order shipped. JAS have no cancel API — a wrong shipment is cancelled in Extranet 2. Statuses are polled every 15 minutes. Enabling this account switches pallet routing on at Poland.",
    carriers_environment_hint_jas: "Training = JAS's test instance (shipment-test.jasfbg.com.pl, its own login server sts-api-test); shipments made there are never collected. Live = production (shipment.jasfbg.com.pl, login.jasfbg.com.pl) — every Ship creates a real shipment, committed at JAS at once.",
    carriers_jas_test_credentials_note: "Training: shipments go to JAS's test instance. The credentials below are the Extranet 2 login JAS issued for the Gateway (client id + secret, username + password). JAS issued them for the test instance — confirm with JAS whether production uses the same set before switching to Live.",
    carriers_jas_live_credentials_note: "Live: every Ship creates a real JAS shipment that JAS will collect. There is no cancel API — a wrong shipment is cancelled in Extranet 2 or with the JAS branch.",
    carriers_login_username_hint_jas: "Client id and username / password are the Extranet 2 login JAS issued for the Gateway. The VAT number (NIP) is the shipper's — JAS bill the loading place B2B on it. The sender address below is the loading place on every shipment.",
    carriers_jas_client_secret: "Client secret",
    carriers_vat_number: "VAT number (NIP)",
    carriers_jas_sections_note: "JAS pallets are booked from the pallet desk: no services or shipping rules here. Fill the sender address below — it is the loading place on every shipment.",
    carriers_raben_hint: "Raben pallet freight for Poland — a Polish pallet carrier booked from the pallet desk through Raben's SOAP GS1 XML interface: one Ship sends the shipment and prints the label. The login, department and payer identifier come from Raben customer care. The eWZ document upload over SFTP is optional.",
    carriers_environment_hint_raben: "Training = Raben's test OSB, with the receiver \"Raben Poland Test\" (added automatically). Live = Raben's production — every Ship creates a real shipment.",
    carriers_raben_test_credentials_note: "Training: shipments go to Raben's test environment and are never collected.",
    carriers_raben_live_credentials_note: "Live: every Ship creates a real Raben shipment that Raben will collect.",
    carriers_login_username_hint_raben: "The SOAP username and password (WS-Security UsernameToken) issued by Raben customer care. The VAT number (NIP) is the shipper's. The sender address below is the loading place on every shipment.",
    carriers_raben_sections_note: "Raben pallets are booked from the pallet desk: no services or shipping rules here. Fill the sender address below — it is the loading place on every shipment.",
    carriers_raben_section_edi: "EDI, payer and product",
    carriers_raben_edi_sender: "EDI sender (client business name)",
    carriers_raben_edi_receiver: "EDI receiver (Raben business unit)",
    carriers_raben_department: "Department number",
    carriers_raben_payer_searchname: "Payer identifier (PAYER_IDENTIFIER)",
    carriers_raben_edi_customer_number: "EDI customer number",
    carriers_raben_ship_from_searchname: "Loading address identifier",
    carriers_raben_product_type: "Product",
    carriers_raben_product_prod01: "Cargo Classic (PROD01)",
    carriers_raben_product_prod02: "Cargo Premium (PROD02)",
    carriers_raben_edi_hint: "Department and payer identifier come from Raben customer care. The loading address identifier is at most 20 characters. \"Test\" is appended to the receiver on Training.",
    carriers_raben_services: "Additional services",
    carriers_raben_services_hint: "Service codes sent on every shipment, e.g. ROD. Type a code and press Enter.",
    carriers_raben_service_add: "Add",
    carriers_raben_service_remove: "Remove service {code}",
    carriers_raben_notes: "Notes on every shipment",
    carriers_raben_notes_hint: "One note per line, up to {max} notes of {length} characters each.",
    carriers_raben_section_ewz: "eWZ upload (optional)",
    carriers_raben_ewz_enabled: "Upload the eWZ document over SFTP",
    carriers_raben_ewz_hint: "Optional. When on, the delivery note is uploaded to Raben's SFTP after booking; a failed upload never blocks the shipment.",
    carriers_raben_ewz_host: "SFTP host",
    carriers_raben_ewz_port: "SFTP port",
    carriers_raben_ewz_username: "SFTP username",
    carriers_raben_ewz_relation_number: "Relation number (11 characters)",
    carriers_raben_ewz_remote_path: "Remote folder",
    carriers_raben_sftp_password: "SFTP password (eWZ)",
    carriers_raben_sftp_password_hint: "Optional. Stored encrypted; only a fingerprint is shown.",
    carriers_raben_err_port: "The port must be a whole number from 1 to 65535 — not saved.",
    carriers_raben_err_relation: "The relation number must be exactly {n} characters — not saved.",
    carriers_raben_err_notes_count: "At most {max} notes — not saved.",
    carriers_raben_err_notes_length: "Each note can have at most {length} characters — not saved.",
    carriers_raben_err_ship_from_length: "The loading address identifier can have at most 20 characters — not saved.",
    carriers_sender_first_name: "Sender first name",
    carriers_sender_last_name: "Sender surname",
    carriers_sender_email: "Sender email",
    carriers_sender_phone: "Sender phone (E.164)",
    carriers_origin_house_number: "Origin building / unit",
    carriers_origin_street: "Origin street",
    carriers_origin_city: "Origin town",
    carriers_origin_postcode: "Origin postcode",
    carriers_sender_origin_hint: "Printed on labels; return address for undeliverables. Orders without a UK mobile are sent with InPost's placeholder +447777777777.",
    carriers_service_priority: "Priority",
    carriers_service_price_s: "Small £",
    carriers_service_price_m: "Medium £",
    carriers_service_price_l: "Large £",
    carriers_service_price_flat: "Flat £",
    carriers_claims_unsupported: "Claims not supported for this carrier — raise them directly.",
    carriers_webhook_heading: "Tracking webhooks",
    carriers_webhook_hint: "Production endpoint for InPost to register (all four organisations, all events). Polling covers any gap.",
    carriers_webhook_this_env: "This environment receives events at {url}.",
    carriers_webhook_secret: "Webhook signing secret",
    carriers_webhook_secret_hint: "The HMAC secret exchanged with InPost at registration. Generate one here and send it to InPost, or paste the value agreed with them. Unsigned events are rejected.",
    carriers_webhook_last_received: "Last event received {at}",
    carriers_webhook_none_yet: "No events received yet.",
    carriers_surcharges_heading: "Contract surcharges",
    carriers_surcharges_hint: "Added to band rates when estimating and comparing. Edit on notice or RPI.",
    carriers_surcharge_fuel: "Fuel surcharge",
    carriers_surcharge_fuel_from: "Applies from",
    carriers_apc_surcharges_hint: "APC's monthly fuel surcharge, added to every consignment charge from the date shown when estimating and comparing. Update when APC notify a new rate.",
    carriers_apc_fuel_digest: "Fuel {pct}% from {from}",
    carriers_apc_fuel_none: "No fuel surcharge",
    carriers_surcharge_decarb: "Decarbonisation per parcel",
    carriers_surcharge_ni: "Northern Ireland per parcel",
    carriers_surcharge_remote: "Remote area per parcel",
    carriers_surcharge_oog1: "OOG1 per Medium parcel",
    carriers_surcharge_oog2: "OOG2 per Large parcel",
    carriers_surcharge_oog_on_band: "Charge OOG1/OOG2 on every Medium/Large parcel (Schedule 1 read literally; unconfirmed by InPost)",
    carriers_surcharge_remote_postcodes: "Remote-area postcodes",
    carriers_surcharge_remote_postcodes_hint: "Patterns: area HS*, district PA48 *, sector PA48 7*. Comma separated.",
    carriers_surcharge_remote_published: "InPost's published list ({n} districts).",
    carriers_surcharge_remote_custom: "Edited list ({n} patterns) overrides InPost's.",
    carriers_surcharge_remote_restore: "Restore InPost's published list ({n} districts)",
    shipping_rules_tester_transit: "(+{days} days)",
    shipping_rules_tester_transit_long: "+{days} transit days ({area}, {when})",
    shipping_rules_strategy: "Strategy",
    shipping_rules_strategy_fixed: "Fixed service",
    shipping_rules_strategy_cheapest: "Cheapest of…",
    shipping_rules_strategy_cheapest_summary: "cheapest of {n}",
    shipping_rules_candidates: "Candidate services",
    shipping_rules_candidates_hint: "Every shipment this rule matches is priced on each candidate — APC as a consignment with its zone surcharges, InPost per parcel by size band with fuel, decarbonisation, NI and remote-area fees — and books the cheapest. Pick at least two.",
    shipping_rules_tester_candidate_excluded: "excluded ({reason})",
    shipping_rules_tester_inpost_bands: "InPost bands {bands}",
    carrier_generic: "The carrier",
    carrier_booking_carrier_rejected: "{carrier} rejected the shipment details",
    carrier_booking_carrier_unreachable: "{carrier} could not be reached",
    carrier_booking_delivery_point_required: "This order has no InPost collection point — a locker/shop service needs one",
    carriers_service_col_on: "On",
    carriers_service_col_type: "Type",
    carriers_service_base_cost: "Cost £",
    carriers_service_add_parcel_cost: "Extra parcel £",
    carriers_service_included_kg: "Incl. kg",
    carriers_service_per_kg: "£/kg over",
    carriers_service_pick: "APC service",
    carriers_service_pick_custom: "Custom service…",
    carriers_service_pick_hint: "Pre-fills code, name and published limits — all editable.",

    // Settings > Dispatch > Shipping Rules
    shipping_rules_settings: "Shipping Rules",
    shipping_rules_settings_hint: "Ordered rules that pick the carrier service when the last item of an order is scanned at dispatch. First matching rule wins; an order with no match is blocked until a rule fits — nothing ships without a booked label.",
    shipping_rules_warehouse: "Warehouse",
    shipping_rules_load_failed: "Could not load shipping rules",
    shipping_rules_empty: "No shipping rules yet — orders in this warehouse will not book a carrier.",
    shipping_rules_no_services: "No enabled carrier services for this warehouse — set up the carrier account under Integrations › Carriers first.",
    shipping_rules_add: "Add rule",
    shipping_rules_name: "Rule name",
    shipping_rules_target_service: "Ship with service",
    shipping_rules_enabled_toggle: "Rule enabled",
    shipping_rules_conditions: "Conditions",
    shipping_rules_conditions_hint: "All set conditions must match. Anything left blank matches everything.",
    shipping_rules_service_pallet_suffix: "· pallets",
    shipping_rules_pallet_rule_hint: "This rule routes PALLET orders at the pallet desk. Conditions apply to the whole order (countries, delivery type, postcode, pallet weights). Parcel orders never use it.",
    shipping_rules_cheapest_parcel_only: "Cheapest is for parcel services only — pallet services are not listed.",
    shipping_rules_pallet_intro: "Pallet carriers (JAS, Raben, Palletways, DB Schenker) are routed by rules that point at their pallet service. With no pallet rule, the pallet desk falls back to the carrier's country list.",
    shipping_rules_delivery_types: "Customer shipping choice",
    shipping_rules_box_names: "Allowed box types",
    shipping_rules_box_names_hint: "Leave all unselected to allow any box. When set, this rule only matches when EVERY box in the shipment is one of the selected types — custom-dimension boxes never match a restricted rule.",
    shipping_rules_tester_box_type: "Box type",
    shipping_rules_tester_box_custom: "Custom",
    shipping_rules_advanced_summary: "Size & weight routing (optional)",
    shipping_rules_advanced_hint: "Only needed to steer shipments between services — for example, weight tiers for a cheaper carrier or sending all multi-box orders to one service. What each service can physically carry is already enforced by its limits above; don't repeat those here.",
    shipping_rules_min_weight_kg: "Total shipment weight more than (kg) — >",
    shipping_rules_max_weight_kg: "Total shipment weight up to (kg) — ≤",
    shipping_rules_min_boxes: "Boxes at least — ≥",
    shipping_rules_max_boxes: "Boxes at most — ≤",
    shipping_rules_max_longest_side_cm: "Longest side up to (cm) — ≤",
    shipping_rules_max_length_cm: "Length up to (cm) — ≤",
    shipping_rules_max_width_cm: "Width up to (cm) — ≤",
    shipping_rules_max_height_cm: "Height up to (cm) — ≤",
    shipping_rules_weight_bounds_hint: "Weight conditions apply to the WHOLE shipment (all boxes added together, actual weight) — per-box limits come from the service above. Bounds don't overlap: “more than” excludes the value, “up to” includes it — so tiers of 0–1 kg and 1–5 kg send exactly 1 kg to the first.",
    shipping_rules_service_limits: "{code} limits (from Carriers → Services, applied automatically): {limits}. Shipments the service can't carry skip this rule and try the next one — no need to repeat these limits in the conditions below.",
    shipping_rules_limit_boxes: "≤ {n} boxes",
    shipping_rules_limit_weight: "≤ {kg} kg per box",
    shipping_rules_limit_dims: "≤ {dims} cm",
    shipping_rules_dims_hint: "Dimension caps apply per box/mailbag, whichever way round it's measured — the largest side is checked against the largest cap, and so on.",
    shipping_rules_uk_regions: "UK regions",
    shipping_rules_uk_regions_hint: "Match by destination region (from the postcode). Leave all unselected to match anywhere.",
    shipping_rules_countries: "Countries",
    shipping_rules_countries_hint: "Comma-separated ISO codes, e.g. GB, IE. Leave blank for any.",
    region_england: "England",
    region_wales: "Wales",
    region_scotland: "Scotland",
    region_scottish_highlands: "Scottish Highlands",
    region_scottish_islands: "Scottish Islands",
    region_northern_ireland: "Northern Ireland",
    region_isle_of_man: "Isle of Man",
    region_isle_of_wight: "Isle of Wight",
    region_isles_of_scilly: "Isles of Scilly",
    region_channel_islands: "Channel Islands",
    shipping_rules_postcode_includes: "Postcodes include",
    shipping_rules_postcode_excludes: "Postcodes exclude",
    shipping_rules_postcode_hint: "Comma-separated prefixes, * for wildcard — e.g. BT*, IM*, GY*.",
    shipping_rules_sales_channels: "Sales channels",
    shipping_rules_sales_channels_hint: "Comma-separated channel names exactly as orders show them, e.g. Bodysocks, Bodysocks UK. Leave blank for any channel.",
    shipping_rules_date_from: "Active from",
    shipping_rules_date_to: "Active until",
    shipping_rules_date_window_hint: "Dispatch days (inclusive) this rule applies on. Leave blank for always.",
    shipping_rules_tester_channel: "Sales channel",
    shipping_rules_tester_date: "Dispatch date",
    shipping_rules_delete: "Delete rule",
    shipping_rules_delete_confirm: "Delete this rule?",
    shipping_rules_move_up: "Move rule up",
    shipping_rules_move_down: "Move rule down",
    shipping_rules_reorder_failed: "Could not reorder rules",
    shipping_rules_tester_heading: "Rule tester",
    shipping_rules_tester_hint: "Runs the exact evaluator the dispatch bench uses against the live rules.",
    shipping_rules_tester_weight: "Weight kg",
    shipping_rules_tester_boxes: "Boxes",
    shipping_rules_tester_postcode: "Postcode",
    shipping_rules_tester_length: "Length cm",
    shipping_rules_tester_width: "Width cm",
    shipping_rules_tester_height: "Height cm",
    shipping_rules_tester_country: "Country",
    shipping_rules_tester_region: "UK region",
    shipping_rules_tester_region_any: "— any (or type a postcode) —",
    shipping_rules_tester_box: "Box {n}",
    shipping_rules_tester_add_box: "Add box",
    shipping_rules_tester_remove_box: "Remove box",
    shipping_rules_tester_facts: "{boxes} box(es) · actual {actual} kg · chargeable {chargeable} kg · region: {region}",
    shipping_rules_tester_run: "Test",
    shipping_rules_tester_matched: "Matched rule “{rule}” → {service}",
    shipping_rules_tester_estimated_cost: "Estimated cost £{cost}",
    shipping_rules_tester_zone_surcharge: "includes £{cost} surcharge ({zone})",
    shipping_rules_tester_consignments: "books as {n} consignments (cheaper than one)",
    shipping_rules_tester_no_match: "No rule matched — this shipment would be blocked at dispatch. (“service:” lines mean the rule matched but its service's limits didn't fit, so it was skipped.)",

    // Dispatch bench — carrier booking overlay
    carrier_booking_in_progress: "Hailing a courier…",
    carrier_booking_in_progress_hint: "Booking the shipment and fetching your label.",
    carrier_booking_label_pending: "Warming up the printer…",
    carrier_booking_label_pending_hint: "Label on its way.",
    carrier_booking_failed: "Carrier booking failed",
    carrier_booking_no_rules: "No shipping rules configured for this warehouse",
    carrier_booking_no_match: "No shipping rule matches this shipment",
    carrier_booking_service_constraints: "Rule “{rule}” matched, but the parcels exceed its service limits",
    carrier_booking_not_gb: "APC only ships GB addresses — this order's destination isn't GB",
    carrier_booking_country_not_served: "{carrier} only ships to {allowed} — this order's destination is {country}",
    carrier_booking_carrier_misconfigured: "{carrier} account is not set up for this warehouse — Settings › Integrations › Carriers needs credentials and a sender address",
    carrier_booking_service_limits: "{carrier} cannot carry this shipment — it exceeds the service's contract limits",
    carrier_booking_address_unroutable: "{carrier} cannot route this address — the county or town is not in its list",
    carrier_booking_label_timeout: "The carrier didn't return a label in time",
    carrier_booking_cancelling: "This order's carrier label is being cancelled — it can't be re-packed until that finishes. Wait a minute and retry; if it stays blocked, a supervisor needs to resolve the booking.",
    carrier_booking_in_flight_elsewhere: "Another bench is booking this order right now",
    carrier_booking_box_mismatch: "This order is already booked for {booked} parcel(s), but {packed} are packed. A box without a label can't be sent. Void the label and re-book for the boxes on the bench, or go back and fix the boxes.",
    carrier_booking_box_contents_mismatch: "This order's existing label covers {booked} kg of boxes, but {packed} kg is packed — these are not the same boxes. Void the label and re-book for the boxes on the bench, or go back and fix the boxes.",
    carrier_booking_rebook: "Void label & re-book for {packed} parcel(s)",
    carrier_booking_rebook_confirm: "The current label will be voided and the order booked again for {packed} parcel(s). Destroy the {booked} label(s) already printed — the old waybill will be dead.",
    carrier_booking_rebook_confirm_btn: "Yes, void and re-book",
    carrier_booking_fix_boxes: "Go back and fix the boxes",
    carrier_booking_already_shipped: "This order has already shipped, so its label can't be voided from the bench. A supervisor re-opens it from the desk.",
    carrier_booking_shared_consignment: "This label is shared with other orders on the same consignment. Voiding it here would change their labels too — a supervisor needs to resolve it.",
    carrier_booking_cancel_window_closed: "{carrier} can no longer void this label: {reason}. Flag the order for a supervisor.",
    carrier_booking_cancel_reason_manifested: "it has been manifested (cut-off {cutoff})",
    carrier_booking_cancel_reason_scanned: "the carrier has already scanned a parcel",
    carrier_booking_void_failed: "{carrier} did not confirm the void, so no new label was booked and the old one is untouched. Flag the order for a supervisor.",
    carrier_booking_wrong_status: "This order's booking is no longer live at APC — a supervisor needs to resolve it before the order can be packed",
    carrier_booking_label_fetch_failed: "The carrier refused the label request",
    carrier_booking_apc_rejected: "APC rejected the shipment details",
    carrier_booking_apc_rejected_hint: "These usually come from the order's delivery details. Correct the fields above on the order and press Retry — if the retry succeeds, dispatch carries on as normal.",
    carrier_booking_blocked_hint: "This order can't ship without a booked label. Fix the issue (or update Shipping Rules in Settings) and retry.",
    carrier_booking_retry: "Retry booking",
    carrier_said: "Carrier said: ",
    carrier_live_booking_box_warning: "Label already booked for {booked} parcel(s) — {packed} on the bench. Completing will void it and re-book.",
    carrier_booking_edit_address: "Edit delivery address",
    carrier_booking_save_address_retry: "Save address & retry",
    address_updated: "Delivery address updated",
    reopen_carrier_cancel_queued: "The old {carrier} label has been queued for cancellation.",
    reopen_carrier_cancel_done: "The old {carrier} label has been cancelled ({n} label(s) voided).",
    reopen_carrier_void_local: "The old {carrier} label has been voided ({n} label(s)).",
    cancel_carrier_label_done_local_reship: "{carrier} label voided ({n} label(s)). The order is back in dispatch: scan its shipping label at the desk (or its original tote / location) to repack it.",
    cancel_carrier_label_done_local_cancelled: "{carrier} label voided ({n} label(s)). The order has been cancelled.",
    carrier_name_unknown: "the carrier",
    // BargainFox Goods-In scan sheet
    bf_mode_title: "BargainFox",
    bf_last_item_label: "Last",
    bf_last_item_fnsku: "FNSKU",
    bf_last_item_asin: "ASIN",
    bf_last_item_scanned: "Scanned",
    bf_last_item_untitled: "No description",
    bf_location_toggle: "BF",
    bf_location_toggle_hint: "Use the BargainFox tote sorting flow at this scan-sheet location. Cannot be combined with Box info.",
    // Scan-sheet desk "Box info" flag (getProductData on /scan/check)
    box_info_toggle: "Box info",
    box_info_toggle_hint: "Show the ASINs inside each scanned box at this scan-sheet location. Cannot be combined with BF.",
    box_info_none: "No box info on file",
    box_info_units: "{count} units",
    box_info_total_rrp: "Total RRP {value}",
    box_info_col_asin: "ASIN",
    box_info_col_title: "Title",
    box_info_col_rrp: "RRP",
    box_info_col_units: "Units",
    box_info_more: "+{count} more",
    bf_hot_cover_days: "BF hot cover (days)",
    bf_hot_cover_days_hint: "Days of sales the Hot locations should cover, scaled from the BF products 30-day sales figure. Blank uses the default of 14 days.",
    bf_new_sku_hot_units: "BF new-SKU hot units",
    bf_new_sku_hot_units_hint: "A SKU with no BF sales data gets this many units sent Hot so its first sales pick from low locations; units already in hot locations, in Hot put-away totes or in open Hot totes count toward it. Once it sells, the normal hot target takes over. Scan sheet only — Forecast Drop is unaffected. Blank uses the default of 2, 0 turns it off.",
    bf_unit_units: "units",
    bf_tote_max_weight_kg: "BF hot/cold tote weight limit (kg)",
    bf_tote_max_weight_kg_hint: "On the standard BF scan sheet a Hot or Cold tote is forced closed and sent to put-away once its units' Portal product weights reach this. Units with no weight on file count as 0. Big sheets, Red and Measure totes are never limited. Blank uses the default of 10 kg, 0 turns it off.",
    bf_colour_hot: "Hot",
    bf_colour_cold: "Cold",
    bf_colour_red: "Red",
    bf_colour_measure: "Measure",
    bf_colour_black: "Black",
    bf_colour_error: "Error",
    bf_scan_tote: "Scan tote",
    bf_scan_replacement_tote: "Scan replacement tote",
    bf_scan_edit_tote: "Scan tote to edit",
    bf_scan_unit_to_edit: "Scan unit to edit",
    bf_scan_tote_to_close: "Scan tote to close",
    bf_scan_item: "Scan item",
    bf_scan_placeholder: "Scan an item or tote barcode",
    bf_setup_prompt: "Scan the {colour} tote",
    bf_setup_prompt_counted: "Scan {colour} tote {number} of {required}",
    bf_reopen_prompt: "The {colour} tote is closed — scan a new tote to reopen it",
    bf_items_blocked_missing_tote: "Item scanning is blocked until every colour has all its required totes.",
    bf_setup_close_sibling_hint: "…or scan the open {colour} tote to close it too",
    bf_swap_prompt: "Scan the new tote for {colour}",
    bf_swap_close_prompt: "Scan an open {colour} tote to close it",
    bf_reopen_tote_title: "Reopen tote?",
    bf_reopen_tote_confirm: "Tote {tote} was closed with {units} units ({closedBy}). Reopen it?",
    bf_reopen_carry_on: "Carry on ({units} units)",
    bf_reopen_start_over: "Start over — tote is empty",
    bf_reopen_start_over_confirm: "This removes the {units} units recorded for tote {tote}. Continue?",
    bf_reopen_start_over_yes: "Yes — start over",
    bf_unknown_operator: "unknown operator",
    bf_edit_tote_prompt: "Scan the {colour} tote to edit",
    bf_edit_unit_prompt: "Scan the unit to remove from tote {tote}",
    bf_close_prompt: "Scan a {colour} tote to close",
    bf_item_close_confirm: "Scan tote {tote} again to close it — {units} units",
    bf_tote_full_title: "Tote full",
    bf_item_close_weight: "Tote {tote} is at {kg} kg of the {limit} kg limit ({units} units). Scan it to close it and send it to put-away.",
    bf_tote_weight: "{kg} kg",
    bf_tote_units_weight: "Tote {tote}: {units} units, {weight}",
    bf_verdict_hot: "Hot",
    bf_verdict_cold: "Cold",
    bf_verdict_red: "Red",
    bf_verdict_measure: "Measure",
    bf_verdict_black: "Unmanifested",
    bf_verdict_not_on_portal: "Not on Portal",
    bf_not_on_portal_detail: "FNSKU {fnsku} is manifested (ASIN {asin}) but the product is missing from Portal — set the unit aside.",
    bf_verdict_big: "BIG",
    bf_no_tote: "No tote",
    bf_no_tote_open: "No tote — scan to open",
    bf_closed_reopen: "Closed — scan new tote to reopen",
    bf_waiting: "Waiting",
    bf_swap_tote: "Swap tote",
    bf_swap_booked_success: "Tote {tote} sent to put-away — {units} units.",
    bf_swap_empty_success: "Empty tote {tote} released for reuse.",
    bf_close_booked_success: "Tote {tote} sent to put-away — {units} units across {skus} SKUs.",
    bf_close_empty_success: "Empty tote {tote} released for reuse; nothing was booked.",
    bf_edit_action: "Edit {colour} tote",
    bf_edit_success: "Removed a unit from the {colour} tote {tote}.",
    bf_leave_mode: "Leave BF mode",
    bf_finish_session: "Finish session",
    bf_resume_finish: "Resume finishing",
    bf_finish_pending_title: "Pending unit",
    bf_finish_pending_warning: "Scan tote {tote} to confirm this unit, or explicitly abandon it before finishing.",
    bf_finish_abandon_pending: "Abandon unit and start finishing",
    bf_finish_complete: "Session finished",
    bf_finish_summary_intro: "Units booked for put-away",
    bf_units_booked: "units booked",
    bf_tote_units: "Tote {tote}: {units} units",
    bf_status_active: "ACTIVE",
    bf_status_open_count: "{count} open",
    bf_status_free: "free",
    bf_swap_tote_tooltip: "Swap tote — current one is full",
    bf_remove_item_tooltip: "Remove an item from this tote",
    bf_verify_tote_tooltip: "Verify tote contents (coming soon)",
    bf_done: "Done",
    bf_back_to_location: "Scan another location",
    bf_active_elsewhere_confirm: "A BargainFox session is active at {location}. Abandon it and restart here?",
    bf_confirm_retry: "The tote confirmation did not reach the server. Retry it.",
    bf_confirmation_lost_rescan: "Confirmation lost — rescan the item and tote.",
    bf_session_recovery_prompt: "Restart BargainFox here, or leave BF mode.",
    bf_restart_session: "Restart session",
    bf_error_unknown_location: "Unknown scan-sheet location.",
    bf_error_not_location: "This location is not enabled for BargainFox.",
    bf_error_active_elsewhere: "A BargainFox session is active at another location.",
    bf_error_tote_required: "Scan a tote barcode for this colour.",
    bf_error_unknown_tote: "Unknown tote",
    bf_error_tote_already_open_here: "Already open in this session",
    bf_error_tote_already_open: "Tote is in use elsewhere",
    bf_error_tote_closed: "Tote is awaiting put-away — choose another",
    bf_error_tote_awaiting_put_away: "Tote still has stock to put away — choose another",
    bf_error_tote_not_reopenable: "Tote can no longer be reopened — choose another",
    bf_error_tote_stored: "That tote has already been stored.",
    bf_error_colour_already_open: "This colour already has tote {tote} open.",
    bf_error_colour_tote_limit: "This colour already has the maximum of two open totes.",
    bf_error_old_tote_required: "Scan the tote being replaced first.",
    bf_error_no_session: "There is no active BargainFox session.",
    bf_error_session_ended: "This BargainFox session has ended.",
    bf_error_colour_new_tote_required: "Choose a colour and scan a new tote.",
    bf_error_no_event: "There is no scanned item awaiting this action.",
    bf_error_missing_location_barcode: "The session location barcode is missing.",
    bf_error_no_colour_tote: "This colour has no open tote.",
    bf_error_already_booked: "That tote has already been booked for put-away.",
    bf_error_all_totes_required: "Open every required tote before scanning items.",
    bf_error_totes_still_open: "Close every open colour tote before finishing the session.",
    bf_error_wrong_tote: "The server rejected the tote. Scan the expected colour tote.",
    bf_error_tote_weight_limit: "That tote is at its weight limit. Close it and send it to put-away, or use the other tote.",
    bf_error_tote_weight_limit_close: "Tote full — scan the full tote to close it before scanning anything else.",
    bf_error_event_not_pending: "That item is no longer awaiting confirmation.",
    bf_error_event_not_found: "The scan event could not be found.",
    bf_error_server: "BargainFox could not complete that request. Try again.",
    // BF big mode (PDBIG): three totes, over-length rule, length pop-up
    bf_location_mode: "Mode",
    bf_location_mode_hint: "Standard = Hot/Cold/Red/Measure with six totes. Big = one Hot tote (hot and cold combined), Red and Measure, plus the over-length rule.",
    bf_location_mode_standard: "Standard",
    bf_location_mode_big: "Big",
    bf_big_max_length_cm: "BF big-item max length (cm)",
    bf_big_max_length_cm_hint: "Big-mode scan sheets send a unit RED when its longest side is over this. Blank uses the default of 60 cm.",
    bf_over_length_title: "Check length",
    bf_over_length_question: "Is this item longer than {max} cm?",
    bf_over_length_yes: "Yes — over (Red)",
    bf_over_length_no: "No — under (Hot)",
    bf_over_length_detail: "Longest side {longest} cm is over the {max} cm max — Red pallet.",
    bf_operator_over_length_detail: "Marked over {max} cm by an operator — Red pallet.",
    bf_operator_under_length_detail: "Marked under {max} cm by an operator — Hot tote.",
    bf_length_change_answer: "Change answer",
    bf_error_dims_present: "This product now has dimensions — the measured size decides.",
    bf_length_answers_title: "BF length answers",
    bf_length_answers_hint: "Answers given to the big-mode \u2018over the max length?\u2019 pop-up, remembered per SKU until the product has dimensions. Remove one to ask again.",
    bf_length_answers_empty: "No remembered answers.",
    bf_length_answer_over: "Over — Red",
    bf_length_answer_under: "Under — Hot",
    bf_length_answer_measured: "Has dimensions now",
    bf_length_answer_remove: "Forget answer",
    bf_length_answer_by: "{name} · {when}",
    bf_error_colour_not_in_mode: "This tote colour is not used at this desk.",
    bf_error_not_big_mode: "Length answers only apply to a big-item desk.",
    picking_special_queues_title: "Special queues",
    picking_queue_orders: "{count} orders",
    picking_queue_items: "{count} items",
    picking_queue_pick: "Pick",
    picking_queue_start: "Start queue",
    picking_queue_not_ready: "Not ready — stock is not available yet",
    picking_queue_empty: "There are no orders in this queue.",
    picking_queue_back: "Back to pick types",
    orders_pick_queue_label: "Special pick queue",
    orders_pick_queue_none: "None",
    settings_picking_queues_title: "Special queue names",
    settings_picking_queues_hint: "Rename the three fixed special queues for each warehouse. Names cannot be empty and may be up to 40 characters.",
    settings_picking_queue_1: "Queue 1",
    settings_picking_queue_2: "Queue 2",
    settings_picking_queue_3: "Queue 3",

    // Pick to Tote (special pick queue 4 — internal orders picked into
    // one tote and handed to Put Away instead of dispatch)
    pick_to_tote: "Pick to Tote",
    bulk_pick: "Bulk Pick",
    pallet_dispatch: "Pallet Dispatch",
    pallet_dispatch_order: "Order",
    pallet_dispatch_scan_prompt: "Scan a pallet from the holding area to open its order",
    pallet_dispatch_not_enabled: "Palletways is not switched on for this warehouse — pallet orders cannot be booked here yet.",
    pallet_dispatch_no_carrier: "No pallet carrier is switched on for this warehouse — pallet orders cannot be shipped here yet.",
    pallet_dispatch_no_carrier_for_country: "No pallet carrier serves {country} — this order cannot be shipped from here.",
    pallet_dispatch_no_pallet_rule: "No pallet shipping rule matches this order — add one in Settings › Dispatch › Shipping Rules",
    pallet_dispatch_routed_by_rule: "Carrier by rule: {rule}",
    pallet_dispatch_manual_heading: "Manual shipment",
    pallet_dispatch_carrier_line: "Carrier: {carrier} (delivery country {country})",
    pallet_dispatch_manual_hint: "Book this pallet on {carrier}'s own site, attach the label here and print it, type {carrier}'s number from the booking, then Ship. The sales channel needs the number to mark the order shipped.",
    pallet_dispatch_manual_fallback: "{carrier} is not set up for API booking at this warehouse yet (missing: {missing}) — shipping by hand until Settings › Carriers is completed.",
    pallet_dispatch_manual_fallback_hint: "Book this pallet in {carrier}'s own system, attach the label here and print it, type the waybill number, then Ship. The tracking link is added automatically.",
    pallet_dispatch_tracking_needed: "Type {carrier}'s number from the booking to ship — it is on the label PDF (for example 4121310799 or 261028-004877).",
    pallet_dispatch_err_tracking_required: "Type the carrier's tracking number before shipping",
    pallet_dispatch_attachments: "Attachments",
    pallet_dispatch_no_attachments: "Nothing attached yet.",
    pallet_dispatch_kind_shipping_label: "Shipping label",
    pallet_dispatch_kind_invoice: "Invoice",
    pallet_dispatch_kind_other: "Other",
    pallet_dispatch_upload_label: "Attach label",
    pallet_dispatch_uploaded: "Label attached: {name}",
    pallet_dispatch_upload_failed: "Could not attach the label",
    pallet_dispatch_print: "Print",
    pallet_dispatch_tracking: "Tracking number",
    pallet_dispatch_tracking_url: "Tracking link (optional)",
    pallet_dispatch_ship: "Ship",
    pallet_dispatch_ship_confirm_text: "Ship {order} on {carrier} now? The order is marked shipped and the sales channel is told.",
    pallet_dispatch_ship_confirm: "Yes, ship",
    pallet_dispatch_shipped_manual: "{order} shipped on {carrier}",
    pallet_dispatch_err_no_pallet_carrier: "No pallet carrier serves this order's delivery country",
    pallet_dispatch_err_use_api_booking: "This order's carrier is booked through its API — use Book",
    pallet_dispatch_err_bad_tracking_url: "The tracking link must start with http:// or https://",
    pallet_dispatch_err_fulfil_failed: "The order could not be marked shipped",
    pallet_dispatch_ready: "Ready to book",
    pallet_dispatch_ready_manual: "Ready to ship",
    pallet_dispatch_ready_empty: "No pallet orders are waiting at the desk.",
    pallet_dispatch_booked_heading: "Booked — awaiting release",
    pallet_dispatch_released_heading: "Released — awaiting tracking number",
    pallet_dispatch_released_hint: "Released to Palletways. The order is marked shipped as soon as Palletways issue its tracking number.",
    pallet_dispatch_row_meta: "{n} pallet(s) · {kg} kg",
    pallet_dispatch_awaiting_release: "{n} booked, not yet released to Palletways",
    pallet_dispatch_release: "Release today's pallets",
    pallet_dispatch_release_confirm_text: "Send {n} consignment(s) to the Palletways depot? This cannot be undone.",
    pallet_dispatch_release_confirm: "Yes, release them",
    pallet_dispatch_released: "{n} consignment(s) released to Palletways",
    pallet_dispatch_release_failed: "{order} was NOT released: {error}",
    pallet_dispatch_nothing_to_release: "Nothing to release",
    pallet_dispatch_shipped: "Order {order} shipped — tracking {tracking}",
    pallet_dispatch_ship_failed: "Order {order} is released but could not be marked shipped: {error}",
    pallet_dispatch_state_ready: "Ready to book",
    pallet_dispatch_state_ready_manual: "Ready to ship",
    pallet_dispatch_state_booking: "Booking…",
    pallet_dispatch_state_booked: "Booked",
    pallet_dispatch_state_released: "Released",
    pallet_dispatch_state_failed: "Last booking failed",
    pallet_dispatch_col_pallet: "Pallet",
    pallet_dispatch_col_type: "Palletways type",
    pallet_dispatch_col_weight: "Weight (kg)",
    pallet_dispatch_col_height: "Height (cm)",
    pallet_dispatch_col_volumetric: "Volumetric weight (kg)",
    pallet_dispatch_no_height: "no height recorded",
    pallet_dispatch_col_scanned: "Scanned",
    pallet_dispatch_scanned: "Scanned",
    pallet_dispatch_choose_type: "Choose…",
    palletways_type_oversized: "Oversized — 2 pallets, 1 lift, no tail lift",
    pallet_dispatch_weight_default: "no weight recorded — 300 kg assumed",
    pallet_dispatch_no_phone: "no phone",
    pallet_dispatch_no_email: "no email",
    pallet_dispatch_scan_all: "Scan every pallet of this order before booking — {done} of {total} scanned",
    pallet_dispatch_scan_all_manual: "Scan every pallet of this order before shipping — {done} of {total} scanned",
    pallet_dispatch_last_attempt: "Last booking attempt failed: {error}",
    pallet_dispatch_book: "Book and print labels",
    pallet_dispatch_reprint: "Reprint labels",
    pallet_dispatch_void: "Void booking",
    pallet_dispatch_void_confirm: "Yes, void it",
    pallet_dispatch_booked: "Order {order} booked with Palletways",
    pallet_dispatch_reprinted: "Order {order} is already booked — labels reprinted",
    pallet_dispatch_voided: "Booking for {order} voided",
    pallet_dispatch_booking_line: "Consignment {con} · {service} · pallet barcodes {barcodes}",
    pallet_dispatch_print_fallback: "The print dialog did not open — the label PDF has been downloaded instead",
    pallet_dispatch_err_unknown_pallet: "That pallet is not at the pallet desk",
    pallet_dispatch_err_scan_all_pallets: "Scan every pallet of the order first",
    pallet_dispatch_err_service_limits: "This order cannot be booked as it stands",
    pallet_dispatch_err_carrier_unavailable: "{carrier} is not switched on for this warehouse",
    pallet_dispatch_err_booking_in_progress: "This order is already being booked",
    pallet_dispatch_err_already_released: "This consignment has already been released to Palletways",
    pallet_dispatch_err_no_service: "Palletways offer no economy service to this postcode",
    pallet_dispatch_err_carrier_rejected: "{carrier} rejected the booking",
    pallet_dispatch_err_carrier_unreachable: "{carrier} could not be reached",
    pallet_dispatch_err_label_fetch_failed: "Booked, but the label did not come back",
    pallet_dispatch_err_order_not_at_desk: "This order is no longer at the pallet desk",
    pallet_dispatch_err_not_all_staged: "Not all of this order's pallets are at the holding area yet",
    pallet_dispatch_err_no_booking: "There is no booking to act on",
    pallet_dispatch_err_carrier_refused: "Palletways refused — the consignment may already be released",
    pallet_dispatch_err_generic: "That did not work — try again",
    // Dispatch-style screens (2026-10-21): pack screen, confirm screen.
    pallet_dispatch_view: "View",
    pallet_dispatch_all_scanned: "All pallets scanned",
    pallet_dispatch_bar_progress: "{done} of {total} pallets scanned",
    pallet_dispatch_print_labels: "Print labels",
    pallet_dispatch_print_label: "Print label",
    pallet_dispatch_print_and_ship: "Print label and ship",
    pallet_dispatch_no_label_attached: "No shipping label is attached yet — attach it below to print it from here, or Ship without one if it was printed elsewhere.",
    pallet_dispatch_done: "Done",
    pallet_dispatch_state_shipped: "Shipped",
    pallet_dispatch_shipped_line: "Shipped on {carrier} · tracking {tracking}",
    // Direct pallet carrier (JAS, booked through its API from this desk).
    pallet_dispatch_direct_heading: "Book and ship",
    pallet_dispatch_direct_hint: "Ship books this order with {carrier} through its API: the label and the waybill come back and print here, and the order is marked shipped at once. {carrier} has no cancel API — check the pallets before you ship.",
    pallet_dispatch_book_and_ship: "Book with {carrier} and ship",
    pallet_dispatch_direct_confirm_text: "Book {order} with {carrier} and ship it now? The shipment is created at the carrier and the order is marked shipped.",
    pallet_dispatch_shipped_direct: "{order} booked with {carrier} — waybill {tracking}",
    pallet_dispatch_print_waybill: "Print waybill",
    pallet_dispatch_direct_documents_hint: "The label has printed. Print the waybill for the driver as well.",
    pallet_dispatch_err_carrier_misconfigured: "The carrier account is not set up for booking",
    pallet_dispatch_err_carrier_not_allowed: "{carrier} cannot ship this order. Allowed carriers: {allowed}",
    pallet_dispatch_err_carrier_not_supported: "{carrier} has no loading list",
    pallet_dispatch_choose_carrier: "Carrier",
    pallet_dispatch_planned_delivery: "Planned delivery {from} – {to}",
    pallet_dispatch_wz_upload_failed: "The shipment was sent, but the eWZ document upload failed: {error}",
    pallet_dispatch_loading_list: "Loading list — {carrier}",
    pallet_dispatch_loading_list_date: "Date",
    pallet_dispatch_loading_list_print: "Print loading list",
    pallet_dispatch_loading_list_none: "No shipments to load on {date}",
    pallet_dispatch_loading_list_printed: "Loading list {number} · {n} shipments",
    pallet_dispatch_err_not_this_order: "That pallet is not on this order — go back to the list to open another order",
    pallet_picks: "Pallet Picks",
    pallet_picks_empty: "No pallet orders are waiting to be picked.",
    pallet_picks_start_an_order: "Start an order",
    pallet_picks_start_an_order_hint: "Tap Start on an order, or scan one of its pallets. You bring all of that order's pallets to dispatch before starting another.",
    pallet_picks_start: "Start",
    pallet_picks_take_over: "Take over",
    pallet_picks_your_order: "Your order",
    pallet_picks_locked_by: "Being picked by {name}",
    pallet_picks_another_picker: "another picker",
    pallet_picks_next: "Next: {sku}",
    pallet_picks_next_at: "Go to {location} and scan the pallet label",
    pallet_picks_nothing_pickable: "No more pallets can be picked",
    pallet_picks_nothing_pickable_hint: "The rest of this order is not in a storage location. Leave the order so it can be sorted out.",
    pallet_picks_leave_order: "Leave order",
    pallet_picks_leave_order_confirm: "Yes, leave it",
    pallet_picks_left_order: "You have left the order",
    pallet_picks_finish_first: "Finish your order first — {n} more waiting",
    pallet_picks_take_to_holding: "Take it to the pallet dispatch area and scan {barcode}",
    pallet_picks_put_back: "Put back",
    pallet_picks_put_back_confirm: "Yes, put it back",
    pallet_picks_released: "Pallet put back — it is no longer picked",
    pallet_picks_staged: "Pallet is at dispatch",
    pallet_picks_staged_order_ready: "Pallet is at dispatch — order ready to ship",
    pallet_picks_order_progress: "{done} of {total} at dispatch",
    pallet_picks_state_to_pick: "To pick",
    pallet_picks_state_no_stock: "Not in a location",
    pallet_picks_state_moving: "On its way",
    pallet_picks_state_staged: "At dispatch",
    pallet_picks_not_enabled: "Palletways is not switched on for this warehouse, so pallet orders are not sent here automatically.",
    pallet_picks_err_stage_first: "You already have pallet {sku}. Take it to the pallet dispatch area first.",
    pallet_picks_err_unknown_barcode: "That barcode is not a pallet",
    pallet_picks_err_not_on_order: "No pallet order is waiting for that pallet",
    pallet_picks_err_no_stock: "That pallet is not in a storage location — it cannot be picked",
    pallet_picks_err_not_holding_area: "That is not the pallet dispatch area barcode",
    pallet_picks_err_nothing_in_hand: "You have no pallet to drop off — scan a pallet first",
    pallet_picks_err_order_locked: "That order is being picked by {name}",
    pallet_picks_err_not_in_your_order: "That pallet is not part of your order {order}",
    pallet_picks_err_finish_order_first: "Finish order {order} first",
    pallet_picks_err_order_not_available: "That order can no longer be picked",
    pallet_picks_err_order_cancelled: "The order for pallet {sku} was cancelled — take the pallet back and tap Put back",
    pallet_picks_err_generic: "That did not work — try again",
    orders_pallet_picks_hint: "Picked as a whole pallet with no tote, then shipped from the pallet dispatch desk. Set automatically for orders made up of pallet products.",
    pick_to_tote_empty: "No orders are assigned to Pick to Tote.",
    pick_to_tote_note_title: "Order note",
    orders_pick_to_tote_hint: "Picked into one tote and put away — the order completes without dispatch. The note below is shown to the picker.",
    orders_bulk_pick_hint: "Picked like a special queue order, but each SKU is taken from as few locations as possible — a location that holds the whole quantity is used before any split.",
    picking_single_tote_order: "This order is one tote only — keep using the tote you started",
    picking_tote_not_york: "Not a york — Pick & Sort is picked into yorks only",
    // Singles: tote swap refused because the current order is part-picked
    // (PartPickedSwapCard). {tote} = the york the units are already in,
    // or (swap/hint) the york the picker scanned.
    picking_part_picked_title: "Finish this order first?",
    picking_part_picked_body: "{picked} of {required} units for this order are already in {tote}. Swapping now would split the order across two yorks.",
    picking_part_picked_left: "Left to pick: {count}",
    picking_part_picked_keep: "Keep picking into {tote}",
    picking_part_picked_swap: "Swap to {tote} anyway",
    picking_part_picked_hint: "Or scan {tote} again to swap anyway",

    // Trophies (records + milestones modal)
    trophies_title: "My Trophies",
    trophies_close: "Close",
    trophies_tab_milestones: "Milestones",
    trophies_tab_records: "Records",
    trophies_best_day: "Best day",
    trophies_lifetime: "Lifetime",
    trophies_streak: "Streak",
    trophies_section_lifetime: "Lifetime points",
    trophies_section_day: "Big days",
    trophies_section_golden_hour: "Golden hour",
    trophies_section_streak: "Scoring streak",
    trophies_streak_days: "days",
    trophies_streak_note: "Weekends and bank holidays never break a streak — UK or Polish calendar, based on your warehouse.",
    trophies_min: "MIN",
    trophies_hr: "HR",
    trophies_more: "more",
    trophies_worldwide: "World records",
    trophies_worldwide_sub: "all users · all warehouses",
    trophies_personal: "Personal bests",
    trophies_personal_sub: "your own top runs",
    trophies_you: "You",
    trophies_items: "items",
    trophies_items_processed: "items processed",
    trophies_held: "held",
    trophies_days_short: "d",
    trophies_no_record: "No record yet — set the first",
    trophies_no_pb: "No run yet",
    trophies_to_wr: "to WR",
    trophies_new_record: "NEW WORLD RECORD",
    trophies_milestone_unlocked: "MILESTONE UNLOCKED",
    trophies_previous: "Previous",
    trophies_lifetime_points: "LIFETIME POINTS",
    trophies_in_one_day: "IN ONE DAY",
    trophies_in_one_hour: "IN ONE HOUR",
    trophies_day_streak: "DAY STREAK",
    trophies_dethroned: "Your record was beaten",
    trophies_also_broken: "Also broken",
    trophies_flow_scan_sheet: "Scan Sheet",
    trophies_flow_bf_scan: "BF Scan",
    trophies_flow_book_in: "Book In",
    trophies_flow_put_away: "Put Away",
    trophies_flow_sorter_1: "Sorter 1",
    trophies_flow_sorter_2: "Sorter 2",
    trophies_flow_pick_and_sort: "Pick & Sort",
    trophies_flow_picking_light: "Picking Single",
    trophies_flow_picking_pick_and_sort: "Picking P&S",
    trophies_flow_picking_large: "Picking Large",
    trophies_flow_drop_shelf: "Drop Shelf",
    trophies_flow_drop_forecast: "Drop Forecast",
    trophies_flow_dispatch_light: "Dispatch Single",
    trophies_flow_dispatch_pick_and_sort: "Dispatch P&S",
    trophies_flow_dispatch_large: "Dispatch Large",
    trophies_flow_wipe: "Wipe",
    trophies_dept_goods_in: "Goods In",
    trophies_dept_sorting: "Sorting",
    trophies_dept_picking: "Picking",
    trophies_dept_drops: "Drops",
    trophies_dept_dispatch: "Dispatch",
    trophies_dept_put_away: "Put Away",
    trophies_dept_wipe: "Wipe",
    trophies_sub_single: "Single",
    trophies_sub_pas: "P&S",
    trophies_sub_large: "Large",
    trophies_sub_shelf: "Shelf",
    trophies_sub_forecast: "Forecast",
    points_tab_records: "Records",
    points_records_empty: "No records set yet — the first run in each department claims the crown.",
    points_col_flow: "Department",
    points_col_window: "Window",
    points_col_holder: "Holder",
    points_col_set: "Set",
    points_col_held: "Held",
    points_user_no_records: "No records held",
    points_user_no_milestones: "No milestones yet",
    points_tab_settings: "Settings",
    points_gate_title: "Trophy modal",
    points_gate_interval_label: "Minutes between trophy views",
    points_gate_interval_hint: "From the first scan of the day, and again after every open (celebrations included).",
    points_gate_seconds_label: "Seconds the modal stays open",
    points_gate_seconds_hint: "The countdown pulses over the last 10 seconds, then the modal closes itself.",
    points_gate_saved: "Trophy settings saved",
    // Manual orders (Orders page → New order) + hand-edited lines
    new_order: "New order",
    create_order_title: "Create order",
    create_order: "Create order",
    order_created: "Order #{order} created (on hold)",
    create_order_failed: "Could not create the order — try again",
    create_order_missing_warehouse: "Choose a warehouse",
    create_order_missing_address: "Fill in the delivery name, address line 1, city, postcode and country",
    create_order_missing_billing: "Fill in the billing name, address line 1, city, postcode and country, or tick 'Billing same as delivery'",
    create_order_need_lines: "Add at least one product",
    create_order_bad_shipping: "Shipping must be a number of 0 or more",
    create_order_no_lines_yet: "No products yet — use Add product.",
    create_order_hold_note: "The order is created On Hold. Change its status to Unfulfilled to release it to picking.",
    order_number_optional: "Order number (optional)",
    order_number_auto_hint: "Blank = automatic MAN number",
    order_notes_optional: "Notes (optional)",
    billing_same_as_delivery: "Billing same as delivery",
    add_product: "Add product",
    add_product_title: "Add product to order",
    stock_free_n: "Free stock: {n}",
    stock_none_free: "No free stock",
    stock_only_n_free: "Only {n} free — reduce the quantity",
    remove_line: "Remove",
    order_line_remove_title: "Remove SKU from order?",
    order_line_remove_body: "This will remove the following line from order {order}. The removal is recorded in the order's logs with your name.",
    order_line_remove_confirm: "Remove {n} × {sku}",
    order_line_reduce_title: "Reduce quantity?",
    order_line_reduce_body: "This will change the quantity of the following line on order {order} from {from} to {to}. The change is recorded in the order's logs with your name.",
    order_line_added: "Product added",
    order_line_removed: "Line removed",
    order_line_updated: "Quantity updated",

    // Stock Control › Write Off (admin-only)
    write_off: "Write Off",
    write_off_history: "History",
    write_off_search_label: "Location",
    write_off_search_placeholder: "Scan or type a location barcode or name",
    write_off_unknown_location: "Location not found in this warehouse",
    write_off_sellable: "Sellable",
    write_off_unsellable: "Unsellable",
    write_off_units: "units",
    write_off_value: "value",
    write_off_empty_location: "Nothing booked at this location",
    write_off_select_all: "Select all",
    write_off_select: "Select",
    write_off_product: "Product",
    write_off_units_here: "Here",
    write_off_allocated: "Allocated",
    write_off_free_stock: "Free stock",
    write_off_unit_cost: "Unit cost",
    write_off_line_value: "Value",
    write_off_qty: "Qty",
    write_off_reason: "Reason",
    write_off_reason_pick: "Choose a reason…",
    write_off_reason_damaged: "Damaged",
    write_off_reason_disposed: "Disposed",
    write_off_reason_sold_offline: "Sold offline",
    write_off_reason_pallet_sold: "Pallet sold",
    write_off_reason_unsold_grey: "Unsold grey",
    write_off_reason_duplicate: "Duplicate",
    write_off_reason_stock_take: "Stock take",
    write_off_reason_other: "Other",
    write_off_reference: "Reference",
    write_off_reference_placeholder: "Reference / note (optional)",
    write_off_action: "Write off",
    write_off_problem_invalid_qty: "Enter a whole number of 1 or more",
    write_off_problem_over_writable: "Only {max} unallocated here — allocated units can't be written off",
    write_off_problem_over_free_stock: "Only {free} free SKU-wide — the rest is reserved for orders",
    write_off_error_no_lines: "Tick at least one line",
    write_off_error_no_reason: "Choose a reason",
    write_off_error_invalid_qty: "Enter a valid quantity for {sku}",
    write_off_error_over_writable: "{sku}: quantity exceeds the unallocated units here",
    write_off_error_over_free_stock: "{sku}: sold offline can't exceed free stock",
    write_off_be_not_at_location: "{sku} is no longer at this location",
    write_off_be_exceeds_writable: "{sku}: only {writable} unallocated here now",
    write_off_be_exceeds_free_stock: "{sku}: only {free} free SKU-wide now",
    write_off_be_stock_moved: "{sku}: stock moved while confirming — nothing was written off, check the figures and try again",
    write_off_confirm_title: "Write off stock?",
    write_off_confirm_body: "These units will be removed from inventory at {location}. This cannot be undone.",
    write_off_confirm_reserved_warning: "Exceeds free stock — an order for this SKU will become stock-blocked",
    write_off_confirm_action: "Confirm write-off",
    write_off_done: "Written off {units} units ({value})",
    write_off_filter_from: "From",
    write_off_filter_to: "To",
    write_off_location: "Location",
    write_off_sku: "SKU",
    write_off_date: "Date",
    write_off_who: "Who",
    write_off_export: "Export XLSX",
    write_off_history_empty: "No write-offs match",
    write_off_paging: "{from}–{to} of {total}",
    write_off_prev: "Previous",
    write_off_next: "Next",
    // By SKU (2026-10-19): search a SKU/barcode, one row per location holding it.
    write_off_mode: "Search by",
    write_off_mode_location: "Location",
    write_off_mode_sku: "SKU",
    write_off_search_sku_label: "SKU or barcode",
    write_off_search_sku_placeholder: "Scan or type a SKU or product barcode",
    write_off_unknown_sku: "No product or stock matches that SKU or barcode in this warehouse",
    write_off_empty_sku: "No stock booked at any {warehouse} location for this SKU",
    write_off_elsewhere: "On hand elsewhere: {list} — pick that warehouse next to the search to write it off there",
    write_off_warehouse: "Warehouse",
    write_off_free_stock_hint: "SKU-wide units not promised to an order — the most that can be sold offline",
    write_off_across_locations: "across {count} locations",
    write_off_filter: "Show",
    write_off_filter_on_hand: "On hand",
    write_off_filter_on_hand_hint: "Rows with unallocated units that could be written off",
    write_off_filter_allocated: "Allocated",
    write_off_filter_allocated_hint: "Rows with units an open allocation points at — those units can't be written off",
    write_off_filter_reserved: "Reserved",
    write_off_filter_reserved_hint: "Rows with more unallocated units than the SKU has free — writing off beyond free stock takes units promised to orders",
    write_off_filter_unsellable: "Unsellable",
    write_off_filter_unsellable_hint: "Rows at an unsellable location",
    write_off_filter_clear: "Clear",
    write_off_filter_empty: "No rows match the filter — clear it to see everything here",
    write_off_put_here: "Put here",
    write_off_put_here_hint: "When these units were put at this location — oldest to newest live stock row. A write-off still removes the oldest units first.",
    write_off_put_here_from: "Put here from",
    write_off_put_here_to: "Put here to",
    write_off_put_here_match: "{rows} rows · {units} units in range",
    write_off_put_here_in_range: "{units} in range",
    write_off_total_over_free_stock: "Ticked total {total} exceeds free stock {free} — the rest is reserved for orders",
    write_off_error_total_over_free_stock: "Sold offline can't exceed free stock ({free}) across the ticked locations",
    write_off_confirm_body_sku: "These units of {sku} will be removed from inventory at {count} location(s). This cannot be undone.",
    write_off_be_not_at_location_sku: "{sku} is no longer at {location}",
    write_off_be_exceeds_writable_sku: "{location}: only {writable} unallocated there now",
    write_off_be_stock_moved_sku: "{location}: stock moved while confirming — nothing was written off, check the figures and try again",
    warehouse_tile_write_off_desc: "Remove stock from a location, or a SKU across every location holding it, with a reason — damaged, disposed, sold offline, stock take — and review the write-off history",
    warehouse_tile_write_off_short: "Remove stock with a reason; history",
    // ---- Admin › Warehouse › Reports ----
    reports_title: "Reports",
    warehouse_tile_reports_desc: "Pick an export and download it",
    reports_hint: "Pick a warehouse and a report, then Download. Each report is built from the live data when you download it.",
    reports_none: "No reports available to you yet.",
    reports_load_failed: "Could not load the reports — try again",
    reports_pick_one: "Select a report",
    reports_download: "Download",
    reports_downloading: "Building…",
    reports_download_failed: "The report did not download",
    reports_from: "From",
    reports_to: "To",
    reports_sort_day: "Sort day",
    reports_batch: "Batch",
    reports_batch_n: "Batch {batch}",
    reports_batches_loading: "Loading…",
    reports_batches_none: "No batches on this day",
    reports_batches_load_failed: "Could not load the batches — try again",
    reports_trailer: "Trailer",
    reports_category_inventory: "Inventory",
    report_inventory_stock_title: "Inventory - stock by SKU",
    report_inventory_stock_desc: "One line per SKU: on hand, allocated, reserved, unsellable, on pallet, unit and total cost.",
    report_inventory_detail_title: "Inventory - detail",
    report_inventory_detail_desc: "Every live stock line with its location, tote, PO, received date and cost (the month-end detail export).",
    report_inventory_locations_title: "Inventory - by location",
    report_inventory_locations_desc: "Available stock rolled up per SKU and location.",
    report_mcl_po_export_title: "MCL PO Export",
    report_mcl_po_export_desc: "MCL's purchase-order CSV for one trailer: one row per pallet SKU on hand at MCL_TRAILER_1, MCL_TRAILER_2 or MCL_TRAILER_3 (Newport), quantity 1 each. Saved as MCL_T1_YYYYMMDD, MCL_T2_YYYYMMDD or MCL_T3_YYYYMMDD.",
    report_wipe_logs_title: "Wipe Logs",
    report_wipe_logs_desc: "Every barcode scanned at the Wipe station in the last 60 days, newest first: when, who, the barcode, the result (found, box route, not found), SKU, ASIN and cost.",
    reports_category_orders: "Orders",
    report_orders_dispatched_title: "Orders dispatched",
    report_orders_dispatched_desc: "One line per parcel dispatched in the date range: order number, channel, placed and dispatched date and time, dispatched by, desk, carrier, service, tracking number, box size and weight, units, delivery address, order total and tracking status. Consolidated orders show their CON number with the original order numbers alongside.",
    report_mcl_unfulfilled_orders_title: "MCL Unfulfilled Orders",
    report_mcl_unfulfilled_orders_desc: "MCL's order-import CSV: one row per SKU line of every order in the warehouse still to ship (not fulfilled, refunded, cancelled or on hold), with order number, product title, SKU, quantity, delivery address, email and telephone. An order with several SKUs is several rows under the same reference. Run it for the MCL warehouse. Saved as MCL_Orders_YYYYMMDD.",
    reports_category_presort: "Presort",
    report_presort_stock_title: "Presort stock file",
    report_presort_stock_desc: "Every SKU on the Inventory detail page for the warehouse (any status, sellable or not, allocated included), once, with its unit weight.",
    report_presort_sales_title: "Presort sales file",
    report_presort_sales_desc: "One line per order line placed in the date range: SKU, order number, units, delivery type and unit weight. Consolidated orders show their CON number with the original order numbers alongside. Cancelled orders are left out.",
    reports_category_bargainfox: "BargainFox",
    report_bf_price_file_title: "BargainFox price file",
    report_bf_price_file_desc: "One line per SKU with stock, BargainFox sales (7 / 30 / 90 days), first seen, last goods-in, last sold and days without a sale - the Price Updater's stock + sales input. Sold-out SKUs with a sale in the last 7 days are included.",
    reports_category_sorter: "Sorter",
    report_sorter_missing_items_title: "Sorter missing items",
    report_sorter_missing_items_desc: "Every item in the sort day and batch that Sorter 1 or Sorter 2 never scanned: order, SKU, which sorter missed it, lane, chute and Sorter 2 slot.",
    reports_nightly_title: "Nightly inventory detail",
    reports_nightly_hint: "Built every night at UK midnight for each warehouse with stock: the Inventory detail export as the day closed. Kept 35 days; month-end files are kept for good.",
    reports_nightly_none: "No nightly files for {warehouse} yet.",
    reports_nightly_load_failed: "Could not load the nightly files — try again",
    reports_nightly_col_stock_at: "Stock at",
    reports_nightly_col_lines: "Lines",
    reports_nightly_col_size: "Size",
    reports_nightly_col_built: "Built",
    reports_nightly_col_status: "Status",
    reports_nightly_end_of: "End of {date}",
    reports_nightly_month_end: "Month end",
    reports_nightly_ready: "Ready",
    reports_nightly_building: "Building",
    reports_nightly_failed: "Failed",
    reports_nightly_downloading: "Downloading…",
    reports_queued_title: "Queued exports",
    reports_queued_hint: "Files asked for from the Wipe and Manual Products tables (Queue Jobalots export). The multi-language title column is filled from the translation cache and AI, so each file is built in the background and appears here when ready. Kept 7 days.",
    reports_queued_none: "No queued exports in the last 7 days.",
    reports_queued_load_failed: "Could not load the queued exports — try again",
    reports_queued_col_report: "Export",
    reports_queued_col_warehouse: "Warehouse",
    reports_queued_col_requested_by: "Requested by",
    reports_queued_col_requested: "Requested",
    reports_queued_all_warehouses: "All",
    reports_queued_status_queued: "Queued",
    reports_queued_report_jobalots_wipe: "Jobalots import — Wipe",
    reports_queued_report_jobalots_manual_products: "Jobalots import — Manual Products",
    reports_queued_untranslated: "{count} titles could not be translated — cells left blank",

    // Goods In > Pallets (desktop + printer): build a sale pallet label
    pallets: "Pallets",
    pallets_hint: "Choose the colour, type and size, pick the supplier and add any notes. The next label for this warehouse prints, and its location and product are created so the tote's SKUs can be put away onto it.",
    pallets_step_colour: "Colour",
    pallets_step_type: "Type",
    pallets_step_size: "Size",
    pallets_step_supplier: "Supplier",
    pallets_step_notes: "Notes",
    pallets_supplier: "Supplier",
    pallets_supplier_hint: "Every active supplier is listed; {supplier} is selected to start with.",
    pallets_notes: "Notes",
    pallets_notes_placeholder: "Optional — anything worth knowing about this pallet",
    pallets_notes_hint: "Optional. Shown in Admin › Warehouse › Pallets Created and in the export.",
    pallets_notes_none: "None",
    // Contents warnings step (Settings › Goods In › Pallets toggle): prints a
    // warning triangle per hazard on the label, nothing else.
    pallets_step_hazards: "Contents warning",
    pallets_hazards: "Warning",
    pallets_hazard_liquids: "Liquids",
    pallets_hazard_glass: "Glass",
    pallets_hazards_hint: "Optional. Tick what the pallet contains; each one prints as a warning triangle on the label. Not stored or exported.",
    pallets_hazards_none: "None",
    pallets_err_supplier_required: "Choose a supplier",
    pallets_colour_black_hint: "Unmanifested stock",
    pallets_colour_dsd: "Data Devices",
    pallets_colour_dsd_hint: "Storage before wipe – never listed",
    pallets_admin_dsd_hint: "Data device storage pallet: it is Listed from creation and its status cannot be changed",
    pallets_size_fixed: "Fixed size",
    pallets_size_height: "By height",
    pallets_height_placeholder: "e.g. 180",
    pallets_height_unit: "cm",
    pallets_summary: "Label to print",
    pallets_print: "Print label",
    pallets_printing: "Printing…",
    pallets_created_toast: "{sku} created and printed",
    pallets_print_failed_created: "{sku} was created but the label did not print — use Reprint",
    pallets_reprint: "Reprint",
    pallets_new: "New pallet",
    pallets_recent: "Recent labels",
    pallets_recent_none: "No pallets printed yet",
    pallets_no_printer: "No printer connected",
    pallets_printer_connected: "Printer ready",
    pallets_printer: "Printer",
    pallets_put_away_hint: "Next: on the handheld open Put Away, scan the closed tote, then scan this label to move the SKUs onto the pallet.",
    pallets_colour: "Colour",
    pallets_type: "Type",
    pallets_size: "Size",
    pallets_not_chosen: "Not chosen",
    pallets_err_colour_invalid: "Choose a colour",
    pallets_err_type_required: "Choose a pallet type",
    pallets_err_size_required: "Choose a size or enter a height",
    pallets_err_size_invalid: "That size is no longer configured — reload the page",
    pallets_err_height_invalid: "Enter a height between 1 and 300 cm",
    pallets_err_height_not_allowed: "Height entry is switched off for this warehouse",
    pallets_err_location_exists: "A location called {sku} already exists — raise the start number in Settings › Goods In › Pallets",
    pallets_err_product_exists: "A product called {sku} already exists — raise the start number in Settings › Goods In › Pallets",
    pallets_err_seq_taken: "Number clash with another desk — try again",

    // Admin > Warehouse > Pallets Created
    pallets_admin_title: "Pallets Created",
    pallets_admin_hint: "Every sale pallet label printed from Goods In › Pallets, per warehouse: who printed it, when, its size, where it stands, what has been put away onto it, and whether it is listed yet.",
    warehouse_tile_pallets_desc: "Sale pallets — labels, contents, listed",
    pallets_admin_tile_total: "Pallets",
    pallets_admin_tile_not_listed: "Ready to list",
    pallets_admin_tile_listed: "Listed",
    pallets_admin_tile_needs_resolving: "Needs resolving",
    pallets_admin_tile_needs_resolving_hint: "Error, Mixed Supplier, Different Supplier, Empty and Duplicate SKU pallets",
    pallets_admin_tile_today: "Created today",
    pallets_admin_col_sku: "Pallet SKU",
    pallets_admin_col_colour: "Colour",
    pallets_admin_col_type: "Type",
    pallets_admin_col_size: "Size",
    pallets_admin_col_supplier: "Supplier",
    pallets_admin_col_location: "Location",
    pallets_admin_col_notes: "Notes",
    pallets_admin_col_by: "Printed by",
    pallets_admin_col_date: "Date made",
    pallets_admin_col_units: "Units",
    pallets_admin_col_skus: "SKUs",
    pallets_admin_col_value: "Cost value",
    pallets_admin_col_rrp: "RRP value",
    pallets_admin_col_status: "Status",
    pallets_status_not_listed: "Ready to List",
    pallets_status_listed: "Listed",
    pallets_status_error: "Error - Needs Resolving",
    pallets_status_mixed_supplier: "Mixed Supplier",
    pallets_status_different_supplier: "Different Supplier",
    pallets_status_empty: "Empty",
    pallets_status_duplicate_sku: "Duplicate SKU",
    pallets_status_needs_resolving: "Needs resolving",
    pallets_status_voided: "Voided",
    pallets_status_listing: "Listing",
    pallets_status_listing_mine: "My listing",
    pallets_admin_tile_listing: "Listing",
    pallets_admin_tile_listing_hint: "Pallets someone is listing now — each batch is locked to the person listing it",
    pallets_admin_col_listed_by: "Listed by",
    pallets_admin_listing_by: "In {name}'s Listing batch",
    pallets_admin_listing_locked: "In {name}'s Listing batch — only they or an Admin can change it",
    pallets_admin_listing_locked_toast: "{sku} is in {name}'s Listing batch",
    pallets_admin_listing_not_ready: "{sku} must be Ready to List before it can go into Listing",
    pallets_admin_bulk_not_ready: "{n} pallets skipped — only Ready to List pallets can go into Listing",
    pallets_admin_supplier_mismatch: "Products on this pallet are from {suppliers} — not the supplier on the label. Set by the Portal; it clears when the stock is put right or the supplier is changed here",
    pallets_admin_empty_hint: "Nothing has been put away onto this pallet yet. Set by the Portal; choose Ready to List to clear it by hand",
    pallets_admin_duplicate_hint: "A SKU on this pallet is also on another pallet (ASIN SKUs and SKUs ending /1 are not checked). Set by the Portal; it clears once the SKU is on one pallet only, or choose a status by hand to dismiss it",
    pallets_admin_duplicate_sku_line: "{sku} is also on {pallets}",
    pallets_admin_duplicate_also_on: "Also on {pallets}",
    pallets_admin_change_supplier: "Change supplier",
    pallets_admin_change_supplier_hint: "Click to change the supplier on this pallet",
    pallets_admin_supplier_on_label: "On the label: {supplier}",
    pallets_admin_supplier_on_pallet: "Put away on the pallet: {suppliers}",
    pallets_admin_supplier_on_pallet_none: "Nothing put away on the pallet yet",
    pallets_admin_supplier_saved: "{sku} supplier changed to {supplier}",
    pallets_admin_edit_notes: "Edit note",
    pallets_admin_notes_placeholder: "Add a note…",
    pallets_admin_notes_edited_by: "Last edited by {name} · {when}",
    pallets_admin_notes_saved: "{sku} note saved",
    pallets_admin_stock_export: "Stock Export",
    pallets_admin_stock_export_hint: "The pallets in this list with every SKU on them: one line per pallet, then one line per product",
    pallets_admin_select: "Select",
    pallets_admin_select_all: "Select all pallets in the list",
    pallets_admin_bulk_saved: "{n} pallets marked {status}",
    pallets_admin_bulk_skipped: "{n} pallets were not changed (in someone else's Listing batch, not Ready to List, voided or removed) — list refreshed",
    pallets_admin_search_hint: "Search pallet SKU, supplier or who printed",
    pallets_admin_none: "No pallets for this warehouse",
    pallets_admin_export: "Export XLSX",
    pallets_admin_reprinted: "Label sent to the printer",
    pallets_admin_void: "Void",
    pallets_admin_void_confirm: "Void {sku}? The number is not reused; the location and product are removed.",
    pallets_admin_voided: "{sku} voided",
    pallets_admin_void_has_stock: "{sku} has {units} units on it — move them off before voiding",
    pallets_admin_status_saved: "{sku} marked {status}",
    pallets_admin_from: "From",
    pallets_admin_to: "To",
    pallets_admin_col_weight: "Weight (kg)",
    pallets_admin_weight_hint: "Worked out from the products on the pallet: units × each product's weight",
    pallets_admin_weight_partial: "{n} units on this pallet have no product weight, so the real weight is higher",
    pallets_admin_weight_over_limit: "{weight} kg is over the Palletways {type} limit of {limit} kg — this pallet may need booking as the next size up",
    pallets_admin_locked: "Units, SKUs, values and weight were locked when this pallet was listed ({date}) — they no longer follow the stock at its location",
    pallets_admin_weight_volumetric: "Volumetric weight for this warehouse: {formula} g",

    // Settings > Goods In > Pallets
    pallets_settings: "Pallets",
    pallets_settings_hint: "How Goods In › Pallets builds a sale pallet label for each warehouse. Labels are CODE-COLOUR+number (PD-RED1, NP-YELLOW3); each warehouse, colour and number combination is used once. Printing a label creates a location and a product with that SKU.",
    pallets_settings_types: "Pallet types",
    pallets_settings_types_hint: "Optional. When set, the operator must choose one, e.g. Mixed, Toys, Homeware. With none set the type step is skipped.",
    pallets_settings_types_none: "No types — the type step is skipped",
    pallets_settings_sizes: "Fixed sizes",
    pallets_settings_sizes_hint: "The size options offered, e.g. Quarter, Half, Full.",
    pallets_settings_sizes_none: "No fixed sizes",
    pallets_settings_allow_height: "Allow size by height (cm)",
    pallets_settings_hazard_flags: "Contents warnings",
    pallets_settings_hazard_flags_hint: "Adds a step to Goods In › Pallets, between Supplier and Notes, asking whether the pallet contains liquids or glass. Each one ticked prints as a warning triangle on the label. Nothing is stored on the pallet or exported.",
    pallets_settings_hazard_flags_on: "Ask about liquids / glass and print warning triangles on the label",
    pallets_settings_palletways: "Palletways type",
    pallets_settings_palletways_hint: "The Palletways pallet type each size ships as (QP quarter, HP half, LP light, FP full, MQP mini quarter; OS oversized — booked as 2 pallets on 1 lift with 1 label, priced as two LP, no tail lift). It is copied onto each pallet when its label is printed; changing it here does not alter pallets that already exist.",
    pallets_settings_palletways_none: "Not set",
    pallets_settings_next_seq: "Next label number",
    pallets_settings_next_seq_hint: "Where numbering starts for each colour — set this at go-live so new labels continue after pallets that already exist. Numbers already issued are never repeated, whatever is entered here.",
    pallets_settings_add: "Add",
    pallets_settings_remove: "Remove {name}",
    pallets_settings_name_placeholder: "Name",
    pallets_settings_saved: "Saved",
    pallets_settings_last_printed: "last {n}",
    pallets_settings_seq_too_low: "{colour}: the next number must be above {last}, the last one printed",
    pallets_settings_volumetric: "Volumetric weight",
    pallets_settings_volumetric_hint: "Sites billed on volume rather than mass (Poland). When on, a pallet's weight is its footprint × its height ÷ the divisor, in kg, instead of the weight of what is on it. Height comes from the pallet when it is sized by height, otherwise from the height set for its fixed size below.",
    pallets_settings_volumetric_on: "Use volumetric weight for pallets",
    pallets_settings_volumetric_length_cm: "Length (cm)",
    pallets_settings_volumetric_width_cm: "Width (cm)",
    pallets_settings_volumetric_divisor: "Divisor",
    pallets_settings_volumetric_formula: "Weight (g) = ({l} × {w} × height cm ÷ {d}) × 1000",
    pallets_settings_volumetric_invalid: "Length, width and divisor must all be numbers above 0",
    pallets_settings_size_height: "Height per size (cm)",
    pallets_settings_size_height_hint: "The height the volumetric sum uses for a pallet of each fixed size. A size with no height falls back to the weight of what is on the pallet.",
    pallets_settings_size_height_invalid: "{name}: height must be between 1 and 300 cm",
    inventory_col_on_pallet: "On pallet",
    inventory_on_pallet_hint: "Units at sale-pallet locations — sellable as a pallet, never picked or pushed to channels as this SKU",
    tote_status_retired: "This pallet tote has already been put away — it cannot be used again",

    // ---- Dispatch desk session (desk saved on the account) ----
    desk_order_claimed: "{name} is packing this order at {desk} since {time}. Ask a team leader to release it.",
    desk_order_claimed_no_desk: "{name} is packing this order since {time}. Ask a team leader to release it.",
    desk_claim_unknown_packer: "Another packer",
    desk_claim_lost: "A team leader released this order",
    desk_pack_state_changed_elsewhere: "This order was changed on another screen — showing the latest.",
    desk_order_released_not_dispatch: "The order you had open is now {status} and was taken off your desk.",
    desk_order_released_generic: "The order you had open was taken off your desk.",
    desk_order_already_open: "You already have another order open — it has been restored.",
    reset_order: "Reset order",
    reset_order_confirm_one: "Remove the box and all scans on this order? Unpack the box before you continue.",
    reset_order_confirm: "Remove all {count} boxes and all scans on this order? Unpack the boxes before you continue.",
    packing_now_title: "Packing now",
    packing_now_hint: "Orders a packer is holding at a desk. Releasing one frees it for anyone to open from its tote; the boxes and scans already packed are kept.",
    packing_now_empty: "Nobody is packing an order right now.",
    packing_now_col_packer: "Packer",
    packing_now_col_desk: "Desk",
    packing_now_col_order: "Order",
    packing_now_col_since: "Since",
    packing_now_col_units: "Units",
    packing_now_col_boxes: "Boxes",
    packing_now_release: "Release",
    packing_now_release_title: "Release order",
    packing_now_release_confirm: "Release order #{order} from {name}? Anyone can then open it from its tote, with the boxes and scans already packed.",
    packing_now_released: "Order released",
    packing_now_release_failed: "Could not release the order",
    order_being_packed: "Being packed by {name} at {desk} since {time}",
    order_being_packed_no_desk: "Being packed by {name} since {time}",
    // Returns (BargainFox returns portal: Admin › Returns, Orders panel, Settings › Returns)
    rt_title: "Returns",
    tile_returns_desc: "BargainFox returns: review, labels, checks and refunds",
    rt_intro: "Requests from the BargainFox returns site. Approve or decline the ones waiting for review, book labels, and check returns when they arrive.",
    rt_tab_review: "Review",
    rt_tab_label: "Label to book",
    rt_tab_awaiting: "Awaiting return",
    rt_tab_transit: "In transit",
    rt_tab_received: "To check",
    rt_tab_done: "Done",
    rt_tab_all: "All",
    rt_empty_review: "Nothing waiting for review.",
    rt_empty_label: "No labels to book.",
    rt_empty_awaiting: "No returns waiting to be sent.",
    rt_empty_transit: "No returns on their way.",
    rt_empty_received: "Nothing to check.",
    rt_empty_done: "No finished requests yet.",
    rt_empty_all: "No return requests yet.",
    rt_empty_search: "No requests match that search.",
    // Admin › Returns › Errors (what failed in the returns portal; ReturnErrors.tsx)
    rt_tab_errors: "Errors",
    rt_err_badge_title: "Errors not yet marked as seen (last 7 days)",
    rt_err_load_failed: "Could not load the errors. Try again.",
    rt_err_area: "Area",
    rt_err_area_all: "All areas",
    rt_err_period: "Period",
    rt_err_period_1: "Last 24 hours",
    rt_err_period_7: "Last 7 days",
    rt_err_period_30: "Last 30 days",
    rt_err_in_1: "{n} in the last 24 hours",
    rt_err_in_7: "{n} in the last 7 days",
    rt_err_in_30: "{n} in the last 30 days",
    rt_err_env: "Errors from {env} only.",
    rt_err_alerts_to: "Alert emails go to {email}, at most one an hour.",
    rt_err_alerts_change: "Change in Settings › Returns",
    rt_err_no_alerts: "No alert email set.",
    rt_err_alerts_add: "Add one in Settings › Returns",
    rt_err_col_time: "When",
    rt_err_col_message: "What happened",
    rt_err_action: "To do: {action}",
    rt_err_repeats_title: "Happened {n} times",
    rt_err_show_details: "Show details",
    rt_err_hide_details: "Hide details",
    rt_err_empty: "No errors in this period.",
    rt_err_new_in_1: "{n} new in the last 24 hours",
    rt_err_new_in_7: "{n} new in the last 7 days",
    rt_err_new_in_30: "{n} new in the last 30 days",
    rt_err_show_seen: "Show seen",
    rt_err_mark_seen: "Mark seen",
    rt_err_mark_seen_title: "Mark as seen: it leaves the list of new errors",
    rt_err_mark_unseen: "Mark unseen",
    rt_err_mark_all_seen: "Mark all as seen",
    rt_err_mark_all_title: "Mark every new error in this period and area as seen",
    rt_err_mark_failed: "Could not mark the errors. Try again.",
    rt_err_seen_by: "Seen by {name} · {time}",
    rt_err_seen_at: "Seen · {time}",
    rt_err_empty_new: "No new errors in this period.",
    rt_err_empty_seen_hidden: "Errors already marked as seen are hidden.",
    rt_err_area_site: "Customer website",
    rt_err_area_api: "Returns API",
    rt_err_area_labels: "Labels",
    rt_err_area_payments: "Payments",
    rt_err_area_tracking: "Tracking",
    rt_err_area_emails: "Customer emails",
    rt_err_area_exchange: "Exchanges",
    rt_err_area_contact: "Contact form",
    rt_err_area_staff: "Staff actions",
    rt_err_area_jobs: "Background jobs",
    rt_err_area_config: "Configuration",
    rt_err_detail_kind: "Kind",
    rt_err_detail_code: "Code",
    rt_err_detail_status: "HTTP status",
    rt_err_detail_api_path: "API path",
    rt_err_detail_page: "Page",
    rt_err_detail_build: "Build",
    rt_err_detail_instance: "Server",
    rt_err_detail_user_agent: "Browser",
    rt_err_detail_stack: "Stack trace",
    rt_status_review: "Review",
    rt_status_label_pending: "Label to book",
    rt_status_awaiting_return: "Awaiting return",
    rt_status_in_transit: "In transit",
    rt_status_received: "Received",
    rt_status_refund_pending: "Refund pending",
    rt_status_replacement_sent: "Replacement sent",
    rt_status_exchange_booked: "Exchange booked",
    rt_status_completed: "Completed",
    rt_status_cancelled: "Cancelled",
    rt_problem_return: "Return",
    rt_problem_damaged: "Damaged or faulty",
    rt_problem_missing: "Missing item",
    rt_problem_wrong: "Wrong item",
    rt_problem_notarrived: "Not arrived",
    rt_res_refund: "Refund",
    rt_res_replacement: "Replacement",
    rt_res_exchange: "Exchange",
    rt_search_placeholder: "Reference, order number, email or tracking number",
    rt_from: "From",
    rt_to: "To",
    rt_clear: "Clear",
    rt_refresh: "Refresh",
    rt_col_request: "Request",
    rt_col_customer: "Customer",
    rt_col_items: "Items",
    rt_col_outcome: "Problem",
    rt_col_refund: "Refund",
    rt_col_status: "Status",
    rt_units: "{n} unit(s)",
    rt_more_lines: "+{n} more",
    rt_has_photos: "Photos",
    rt_showing: "{from}-{to} of {total}",
    rt_page_of: "Page {page} of {pages}",
    rt_prev: "Previous",
    rt_next: "Next",
    rt_load_failed: "Could not load returns. Try again.",
    rt_not_found: "No such return request.",
    rt_started: "Started {when} · {channel}",
    rt_flag_claim: "Carrier says delivered",
    rt_flag_shortfall: "Credit {short} short",
    rt_exchange_shortfall: "The accepted items (credit {credit}) no longer cover the new items ({basket}): {short} short. Nothing was charged - decide by hand.",
    rt_flag_keep: "Customer keeps it",
    rt_auto_failed: "The automatic step failed, so this came to review: {why}",
    rt_approve: "Approve",
    rt_decline: "Decline",
    rt_book_label: "Book label",
    rt_manual_label: "Add label by hand",
    rt_mark_received: "Mark received",
    rt_complete: "Check and complete",
    rt_release_exchange: "Release now",
    rt_release_exchange_confirm: "Release the exchange order now, without waiting for the return? It moves from Exchange to Unfulfilled and the new items go out before the return is back.",
    rt_release_replacement: "Send replacement now",
    rt_release_replacement_confirm: "Send the replacement now? It leaves the hold and goes to the pick pool before the return has a carrier scan.",
    rt_refund_payment: "Refund card payment",
    rt_cancel: "Cancel request",
    rt_not_available: "Not available yet: this part of the returns portal hasn't been released.",
    rt_action_failed: "That didn't work. Try again.",
    rt_already_done: "Already done.",
    rt_file_failed: "Could not open the file.",
    rt_approved: "Request approved",
    rt_declined: "Request declined. The customer has been emailed.",
    rt_completed: "Return checked and completed",
    rt_cancelled: "Request cancelled",
    rt_label_booked: "Label booked",
    rt_label_added: "Label saved",
    rt_label_voided: "Label voided",
    rt_marked_received: "Marked as received",
    rt_exchange_released: "Exchange order released",
    rt_replacement_released: "Replacement order released",
    rt_payment_refunded: "Card payment refunded",
    rt_note_added: "Note added",
    rt_void_reminder: "Booked parcels are still live at the carrier. Void them: {parcels}",
    rt_items: "Items",
    rt_order_photos: "Photos for the whole order",
    rt_timeline: "Timeline",
    rt_add_note: "Add a note",
    rt_note_placeholder: "Only staff see notes",
    rt_save_note: "Save note",
    rt_customer: "Customer",
    rt_name: "Name",
    rt_email: "Email",
    rt_address: "Address",
    rt_phone: "Phone",
    rt_entry: "Came in by",
    rt_entry_link: "Link from BargainFox",
    rt_entry_direct: "Order lookup on the site",
    rt_return_rate: "Return rate",
    rt_ip: "IP address",
    rt_orders: "Orders",
    rt_delivered_on: "Delivered {date}",
    rt_not_delivered: "No delivery scan",
    rt_return_by: "return by {date}",
    rt_replacement_orders: "Replacement orders",
    rt_exchange_orders: "Exchange orders",
    rt_on_hold: "on hold",
    rt_rep_held: "Held until the return is on its way. Ships on the carrier's first scan.",
    rt_rep_released: "Released {date} ({how}).",
    rt_rep_released_plain: "Released {date}.",
    rt_rep_via_staff: "by staff",
    rt_rep_cancelled: "Cancelled {date}: the return was never sent.",
    rt_exc_title: "Exchange",
    rt_exc_held: "The exchange order waits in Exchange, holding its stock, until the return {when}. Then it moves to Unfulfilled.",
    rt_exc_when_shipped: "is on its way",
    rt_exc_when_delivered: "is delivered to us",
    rt_exc_when_received: "has been checked",
    rt_exc_when_booked: "is booked",
    rt_exc_released: "Released to Unfulfilled {date} - {how}.",
    rt_exc_released_plain: "Released to Unfulfilled {date}.",
    rt_exc_via_shipped: "when the return was on its way",
    rt_exc_via_delivered: "when the return was delivered to us",
    rt_exc_via_received: "when the return had been checked",
    rt_exc_via_booked: "when the return was booked",
    rt_exc_via_staff: "by staff (Release now)",
    rt_exc_cancelled: "Exchange cancelled {date}: {why}.",
    rt_exc_cancelled_plain: "Exchange cancelled {date}.",
    rt_exc_test_hold: "Staging test: when released, the exchange order goes on a manual hold instead of Unfulfilled, so it is never picked or shipped.",
    rt_exc_each: "{price} each",
    rt_exc_total: "Basket total",
    rt_exc_express: "Express delivery",
    rt_exc_express_fastfox: "Free with FastFox",
    rt_exc_stock_short: "Not enough stock to create the exchange order (checked {when}). No order was created.",
    rt_exc_short_line: "needs {needed}, {available} available",
    rt_exc_stock_short_help: "Once it's restocked, press \"Release now\" again. Or cancel the request and refund the customer instead.",
    rt_money: "Money",
    rt_items_value: "Items",
    rt_vat_incl: "of which VAT",
    rt_delivery_refund: "Delivery refund",
    rt_postage: "Return postage",
    rt_payable: "Customer pays",
    rt_refund_quoted: "Refund quoted",
    rt_refund_now: "Refund now",
    rt_service: "Service {service} · {labels} label(s)",
    rt_parcels: "Parcels",
    rt_no_parcels: "No label booked yet.",
    rt_nothing_back: "Nothing comes back.",
    rt_parcel_n: "Parcel {n}",
    rt_label_pdf: "Label PDF",
    rt_void: "Void",
    rt_payments: "Payments and invoices",
    rt_payment_line: "Payment {amount}",
    rt_refund_line: "Refund {amount}",
    rt_sales_invoice: "Sales invoice {number}",
    rt_credit_invoice: "Credit invoice {number}",
    rt_card: "{scheme} ending {last4}",
    rt_qty: "Qty {n}",
    rt_fault_ours: "Our fault",
    rt_fault_customer: "Customer's reason",
    rt_line_replaced: "{n} replaced",
    rt_line_pended: "{n} on Pending Refund",
    rt_line_checked: "Checked: {a} accepted, {r} rejected",
    rt_delivery_short: "delivery",
    rt_approve_title: "Approve request",
    rt_approve_intro: "The customer asked for: {asked}. Choose what we do.",
    rt_approve_replacement_hint: "A replacement order goes out. Anything out of stock goes on Pending Refund.",
    rt_approve_replacement_no: "Only when every item is our fault.",
    rt_approve_refund_now: "Goes on Pending Refund now. Nothing comes back.",
    rt_approve_refund_back: "The item comes back first: the refund goes on Pending Refund after the check.",
    rt_message_optional: "Message to the customer (optional)",
    rt_message_customer: "Message to the customer",
    rt_message_required: "Write a message to the customer.",
    rt_message_required_reject: "Tell the customer why some items weren't accepted.",
    rt_decline_title: "Decline request",
    rt_decline_intro: "The request is cancelled and the customer is emailed with your message.",
    rt_cancel_title: "Cancel request",
    rt_cancel_intro: "The customer is emailed that it was cancelled. The items can be returned again in a new request. Any booked label must be voided separately.",
    rt_cancel_reason: "Reason (staff only)",
    rt_cancel_message: "Message to the customer (optional)",
    rt_cancel_message_hint: "Goes in the cancellation email and on their status page. The reason above never does.",
    rt_keep: "Keep it",
    rt_complete_title: "Check the return",
    rt_complete_intro_refund: "Accepted units go on Pending Refund. Anything not accepted is rejected, and the customer is told why.",
    rt_complete_intro_other: "Record what came back. No money moves here.",
    rt_item: "Item",
    rt_came_back: "To check",
    rt_accept: "Accept",
    rt_accept_qty_for: "Units accepted: {item}",
    rt_rejecting: "{n} unit(s) will be rejected.",
    rt_charge_postage: "Charge return postage ({amount})",
    rt_charge_postage_hint: "Use when the item wasn't damaged, faulty or wrong after all. It comes off the refund, or the exchange's leftover credit. For a replacement it's recorded as owed.",
    rt_charge_postage_placeholder: "Why you're charging return postage, e.g. the item isn't damaged.",
    rt_charge_postage_message_required: "Tell the customer why you're charging return postage.",
    rt_manual_intro: "For a label booked outside Portal (Royal Mail, InPost or anything else).",
    rt_carrier: "Carrier",
    rt_carrier_royalmail: "Royal Mail",
    rt_carrier_inpost: "InPost",
    rt_carrier_apc: "APC",
    rt_carrier_other: "Other",
    rt_tracking_number: "Tracking number",
    rt_tracking_required: "Enter the tracking number.",
    rt_track_title: "Open {carrier}'s tracking page",
    rt_label_file: "Label PDF (optional)",
    rt_save_label: "Save label",
    rt_refund_payment_confirm: "Refund {amount} to the customer's card?",
    rt_event_request_submitted: "Request submitted",
    rt_event_refund_pending: "Pending Refund added",
    rt_event_replacement_created: "Replacement order raised",
    rt_event_staff_approved: "Approved",
    rt_event_staff_declined: "Declined",
    rt_event_staff_completed: "Checked and completed",
    rt_event_staff_cancelled: "Cancelled",
    rt_event_staff_note: "Note",
    rt_event_customer_cancelled: "Cancelled by the customer",
    rt_event_customer_cancelled_labels: "Labels to void: {n}",
    rt_event_label_void_failed: "Label NOT voided - void it by hand",
    rt_event_exchange_shortfall: "Exchange credit short - nothing charged",
    rt_event_apc_voided: "APC consignment voided",
    rt_event_apc_void_manifested: "APC consignment already manifested - ask APC for a credit",
    rt_event_apc_void_failed: "APC void failed - retried daily",
    rt_event_labels_voided: "Unused labels voided",
    rt_event_labels_voided_parcels: "{n} parcel(s) cancelled",
    rt_event_pool_label_issued: "Royal Mail label issued",
    rt_event_pool_label_specimen: "Royal Mail SPECIMEN label (not production)",
    rt_event_pool_label_downloaded: "Royal Mail label downloaded",
    rt_event_pool_label_released: "Royal Mail label back in the pool",
    rt_event_pool_label_kept: "Royal Mail label kept (already downloaded)",
    rt_event_replacement_held: "Replacement held until the return is on its way",
    rt_event_replacement_released: "Replacement released",
    rt_event_replacement_cancelled: "Held replacement cancelled",
    rt_event_postage_charged: "Return postage charged",
    rt_event_refund_issued: "Refund issued on BargainFox",
    rt_event_refund_declined: "BargainFox refund declined",
    rt_labels_voided: "Voided at APC: {waybills}",
    rt_labels_void_failed: "APC wouldn't void {waybills}: it's flagged on the parcel and retried daily. Check the APC portal.",
    rt_drop_off_code: "Drop-off code (InPost, optional)",
    rt_drop_off_code_hint: "The code the customer types at the locker, if InPost gave one.",
    rt_drop_off_code_invalid: "4-32 letters or digits",
    rs_max_dims: "Max box cm",
    rs_max_kg_for: "Max kg for {name}",
    rs_max_len_for: "Max length cm for {name}",
    rs_max_dims_for: "Largest box for {name} (cm)",
    rs_from_carrier: "From carrier settings",
    rs_no_box_limit: "No box limit",
    rs_limits_hint: "Empty limits come from the carrier's own settings (Integrations › Carriers); a value here can only tighten them. Box size is length × width × height in cm, any orientation.",
    rs_inpost_apc: "InPost and APC",
    rs_inpost_account: "InPost return account",
    rs_inpost_account_hint: "The account at the return warehouse that returns are booked on (Integrations › Carriers).",
    rs_inpost_returns_only: "{label} - returns only (off for outbound labels)",
    rs_inpost_not_at: "{label} isn't an InPost account at {warehouse}. Pick one of its accounts.",
    rs_inpost_none_at: "{warehouse} has no InPost account (Integrations › Carriers).",
    rs_pick_one: "Choose one from the list.",
    rs_not_listed: "{value} (not available)",
    rs_warehouse_unknown: "{value} isn't a Portal warehouse. Pick one from the list.",
    rs_inpost_drop_off_days: "Days to drop off at InPost",
    rs_inpost_drop_off_days_hint: "How long the customer's drop-off code lasts. Empty = InPost's default.",
    rs_inpost_default: "InPost default",
    rs_inpost_radius: "Locker search radius (km)",
    rs_inpost_radius_hint: "How far from the customer to look for lockers and shops.",
    rs_inpost_lockers_shown: "Lockers shown",
    rs_depot_grace: "APC depot drop-off grace (days)",
    rs_depot_grace_hint: "Days after the booked drop-off day before an unused depot return counts as missed.",
    rt_event_approved_as: "As a {resolution}",
    rm_title: "Royal Mail labels",
    rm_hint: "Pre-generated Royal Mail Tracked 48 return labels. Upload them here in bulk; each return gets the oldest unused one. Only production hands out real labels; staging and test machines issue specimens.",
    rm_low_stock_setting: "Warn below",
    rm_low_stock_setting_hint: "Usable labels left before the low-stock warning shows (here and on the Returns page).",
    rm_max_age: "Maximum label age (days)",
    rm_max_age_hint: "Never issue a label uploaded longer ago than this. Empty = no limit (Royal Mail haven't confirmed an expiry).",
    rm_no_limit: "No limit",
    rm_oba: "Royal Mail account (OBA)",
    rm_oba_hint: "Uploaded labels for any other account are refused.",
    rm_limits_note: "Weight, size and the customer's fee for a Royal Mail return are on the Royal Mail row under Return services. Confirm the limits with Royal Mail.",
    rm_low_stock: "Royal Mail return labels are running low: {n} left (warning below {min}). Upload more in Settings › Returns.",
    rm_specimen_note: "This server issues SPECIMEN labels only (not production); the counts are the shared pool.",
    rm_status_available: "Available",
    rm_status_issued: "Issued, not downloaded",
    rm_status_downloaded: "Downloaded",
    rm_status_received: "Received",
    rm_status_void: "Void",
    rm_drop_here: "Drop label PDFs here, or",
    rm_choose_files: "Choose files",
    rm_uploading: "Uploading and checking every page…",
    rm_pdf_only: "Only PDF files can be uploaded.",
    rm_upload_failed: "The upload didn't work.",
    rm_result: "{pages} pages: {added} added, {dup} already in the pool, {bad} refused",
    rm_page: "Page {n}",
    rm_more_rejected: "…and {n} more refused pages",
    rm_search: "Search by tracking number or return",
    rm_status_filter: "Status",
    rm_all_statuses: "All statuses",
    rm_tracking: "Tracking number",
    rm_status: "Status",
    rm_return: "Return",
    rm_issued: "Issued",
    rm_downloaded: "Downloaded",
    rm_received: "Received",
    rm_none: "No labels match.",
    rm_open_pdf: "Open label {tracking}",
    rm_void_label: "Void label {tracking}",
    rm_void_reason: "Why is it void?",
    rm_void: "Void",
    rm_voided: "Label voided",
    rm_not_ready: "The Royal Mail label pool isn't set up on this database yet.",
    rt_contacts_title: "Customer messages after the return window",
    rt_contacts_hint: "Sent from the returns site's contact form. Reply from the customer service inbox.",
    rt_contact_reason_faulty: "Faulty or damaged",
    rt_contact_reason_missing: "Missing item",
    rt_contact_reason_notarrived: "Not arrived",
    rt_contact_reason_other: "Something else",
    rt_contact_delivery_gorgias: "Ticket in Gorgias",
    rt_contact_delivery_email: "Emailed to the inbox",
    rt_contact_delivery_pending: "Waiting to send",
    rt_contact_delivery_failed: "Not delivered",
    rt_contact_view_gorgias: "View in Gorgias",
    rt_contact_order: "Order {ref}",
    rt_event_auto_failed: "Sent to review: {why}",
    rt_photo_open: "Open photo {n}",
    rt_photo_title: "Customer photo",
    rt_photo_of: "Photo {n} of {total}",
    rt_photo_prev: "Previous photo",
    rt_photo_next: "Next photo",
    rt_photo_download: "Download",
    rt_photo_failed: "Could not load this photo.",
    rt_photo_heic: "This photo is HEIC, which the browser can't show. Download it to view.",
    rt_panel_title: "Returns",
    rt_relation_original: "Return on this order",
    rt_relation_replacement: "Replacement for a return",
    rt_relation_exchange: "Exchange for a return",
    rt_refund_amount: "refund {amount}",
    rt_paid_amount: "paid {amount}",
    // Returns page: a parcel returned to sender, scanned into the search (ReturnedParcelPanel.tsx).
    rt_rts_title: "Returned parcel",
    rt_rts_returned: "Returned to sender",
    rt_rts_tracking: "Tracking: {status}",
    rt_rts_superseded: "This label is no longer on its order (the order was relabelled). These are the order's parcels now.",
    rt_rts_matches: "This code matches {n} parcels:",
    rt_rts_order: "Order",
    rt_rts_parts: "Customer orders: {orders}",
    rt_rts_customer: "Customer",
    rt_rts_parcel: "Parcel",
    rt_rts_box_of: "Box {n} of {total}",
    rt_rts_shipped: "sent {date}",
    rt_rts_not_channel: "Not a BargainFox or Jobalots order ({channel}). Refund it where it was sold.",
    rt_rts_replacement: "This is a replacement for order #{order}, so nothing was paid for it. If a refund is due, use the original order.",
    rt_rts_label_voided: "This label was cancelled, so the parcel never left on it. Check the order on the Orders page.",
    rt_rts_order_status: "The order is {status}. Settle it on the Orders page first.",
    rt_rts_nothing_left: "Nothing left to refund in this parcel.",
    rt_rts_contents_not_recorded: "What went in this box was not recorded, so every line of the order is listed. Check the box and set the quantities.",
    rt_rts_history: "Already on Pending Refund from this parcel: {amount} ({n} item(s)), {when}, {by}",
    rt_rts_in_box: "{n} in the box",
    rt_rts_each: "{price} each",
    rt_rts_refunded_pending: "Refunded {refunded} · Pending {pending}",
    rt_rts_qty_label: "Units of {sku} to refund",
    rt_rts_of: "of {n}",
    rt_rts_none_left: "None left",
    rt_rts_delivery: "Delivery paid on this order: {amount}. Not included: the order note tells the refund manager.",
    rt_rts_total: "Total",
    rt_rts_put: "Put {amount} on Pending Refund",
    rt_rts_process: "Process refund",
    rt_rts_why: "Why is it being refunded?",
    rt_rts_reason_rts: "Returned to sender",
    rt_rts_reason_label: "Reason",
    rt_rts_reason_placeholder: "Or type the reason",
    rt_rts_reason_needed: "Choose Returned to sender or type a reason first",
    rt_rts_reason_hint: "Nothing is paid now. The customer is emailed once the refund manager marks the refund as issued on Pending Refund.",
    rt_rts_contents_not_recorded_many: "What went in this box was not recorded, and the order went in {n} boxes, so nothing is filled in. Check the box and set the quantities.",
    rt_rts_failed: "Could not put the refund on Pending Refund. Try again.",
    rt_rts_done: "{amount} for {n} item(s) is on Pending Refund for order #{order}.",
    rt_rts_open_order: "Open the order",
    rt_rts_already: "Already on Pending Refund: nothing more to refund in this parcel.",
    rt_rts_no_parcels: "This label belongs to order #{order}, which has no dispatched parcels now.",
    rp_pay_title: "BargainFox Returns payment",
    rp_pay_paid_full: "Paid {amount} by {method} on {date}",
    rp_pay_paid_method: "Paid {amount} by {method}",
    rp_pay_paid_date: "Paid {amount} on {date}",
    rp_pay_paid: "Paid {amount}",
    rp_pay_refunded: "Refunded {amount}",
    rp_pay_pending: "Pending {amount}",
    rp_pay_left: "Left to refund {amount}",
    rp_pay_fully_refunded: "Fully refunded",
    rp_pay_invoice: "Sales invoice {number}",
    rp_pay_credit_note: "Credit invoice {number} · {amount}",
    rp_pay_open_credit_note: "Open credit invoice {number}",
    rp_pay_history: "Refunds",
    rp_pay_status_refunded: "Refunded",
    rp_pay_status_waiting: "Waiting for Checkout.com",
    rp_pay_status_declined: "Declined",
    rp_pay_status_failed: "Failed",
    rp_pay_emailed: "Customer emailed",
    rp_pay_source_staff: "Staff",
    rp_pay_source_returns_page: "Returns page",
    rp_pay_source_exchange_cancelled: "Exchange cancelled",
    rp_pay_source_dashboard: "Checkout.com dashboard",
    rp_pay_source_earlier: "Earlier refund",
    rp_pay_refund: "Refund",
    rp_pay_amount: "Amount (£)",
    rp_pay_full_amount: "Full amount",
    rp_pay_up_to: "Up to {amount}",
    rp_pay_amount_invalid: "Enter an amount in pounds, like 5.00",
    rp_pay_amount_min: "The smallest refund is £0.01",
    rp_pay_amount_max: "At most {amount}: that is what is left to refund",
    rp_pay_reason: "Reason (shown to the customer on the credit invoice)",
    rp_pay_reason_placeholder: "Item arrived damaged",
    rp_pay_reason_short: "At least 3 characters",
    rp_pay_notify: "Email the customer the credit invoice",
    rp_pay_confirm: "Refund {amount} to {method}",
    rp_pay_confirm_plain: "Refund {amount}",
    rp_pay_sending: "Refunding…",
    rp_pay_done: "Refund of {amount} issued",
    rp_pay_sent: "Refund of {amount} sent to Checkout.com, waiting for confirmation",
    rp_pay_failed: "The refund could not be confirmed. Check the refunds list before trying again.",
    ocd_title: "{channel} documents",
    ocd_title_generic: "Sales channel documents",
    ocd_invoice: "Sales invoice {number}",
    ocd_credit_note: "Credit note {number}",
    ocd_corrects: "Corrects invoice {number}",
    ocd_error: "{channel} didn't send the documents for #{reference} just now.",
    ocd_error_generic: "The sales channel didn't send the documents for #{reference} just now.",
    ocd_not_available: "That document isn't available just now.",
    ocd_file_failed: "Could not open the document: the sales channel may not have answered. Try again in a moment.",
    returns_settings: "Returns",
    returns_settings_hint: "The BargainFox returns portal: windows, refunds, replacements, exchanges, reasons and return services. Admin only to change.",
    rs_no_access: "You don't have access to the returns settings.",
    rs_load_failed: "Could not load the returns settings.",
    rs_read_only: "Read only: only an Admin can change these settings.",
    rs_last_saved: "Last saved by {who} on {when}",
    rs_portal: "Returns portal",
    rs_enabled: "Accept new requests",
    rs_return_warehouse: "Return to warehouse",
    rs_return_warehouse_hint: "The warehouse returns are booked back into.",
    rs_terms_url: "Terms of service link",
    rs_help_url: "Help centre link",
    rs_url_hint: "An https link, or empty for none.",
    rs_return_address: "Return address",
    rs_return_address_hint: "Every return label is addressed here.",
    rs_addr_company: "Company",
    rs_addr_name: "Name",
    rs_addr_line_1: "Address line 1",
    rs_addr_line_2: "Address line 2",
    rs_addr_city: "Town or city",
    rs_addr_postcode: "Postcode",
    rs_addr_country: "Country",
    rs_addr_vat_number: "VAT number",
    rs_window: "Return window",
    rs_window_days: "Days from delivery",
    rs_window_days_hint: "Shown to the customer.",
    rs_problem_window_days: "Window for damaged, faulty, wrong or missing items (days after delivery)",
    rs_problem_window_days_hint: "Normally the same as the return window. Leave it empty to use that ({days} days). The order stays open while either window is.",
    rs_same_as_window: "Same ({days})",
    rs_grace_days: "Grace days",
    rs_grace_days_hint: "Silent extra days. Not shown.",
    rs_no_scan_days: "No delivery scan: days from order date",
    rs_no_scan_days_hint: "Used when there is no delivered scan.",
    rs_not_arrived: "Not-arrived claims open after",
    rs_not_arrived_hint: "Working days past the service's expected delivery.",
    rs_refunds: "Refunds and returnless refunds",
    rs_returnless_damaged: "Returnless up to: damaged or faulty (with photos)",
    rs_returnless_damaged_hint: "Item value (inc. VAT) up to this: no label, the customer keeps it. A damaged or faulty reason that needs photos. £0 = always comes back.",
    rs_returnless_wrong: "Returnless up to: wrong item or not as described",
    rs_returnless_wrong_hint: "Wrong item sent, and damaged or faulty reasons with no photos (e.g. not as described). £0 = always comes back.",
    rs_returnless_mind: "Returnless up to: change of mind",
    rs_returnless_mind_hint: "Every 'I want to return something' reason. £0 = always comes back.",
    rs_returnless_rate: "Max return rate (%)",
    rs_returnless_rate_hint: "From the number of orders above: over this, items always have to come back.",
    rs_return_rate_explained: "Return rate = the customer's BargainFox orders in the window that had a return or refund ÷ all their BargainFox orders in the window, matched by email. A keep-it request a person declined doesn't count. The request being made isn't counted.",
    rs_standing: "Who may keep items",
    rs_standing_days: "Look back (days)",
    rs_standing_days_hint: "Orders and keep-it requests in this many days count. 365 = a rolling 12 months.",
    rs_standing_min_orders: "Return rate applies from (orders)",
    rs_standing_min_orders_hint: "A customer with fewer orders than this in the window is judged by the allowance instead.",
    rs_standing_allowance: "Keep-it allowance below that",
    rs_standing_allowance_hint: "How many keep-it requests such a customer gets in the window. After that, items come back.",
    rs_returnless_refunds: "Returnless applies to refunds",
    rs_returnless_refunds_hint: "Creates a Pending Refund on the Orders page straight away.",
    rs_returnless_replacements: "Returnless applies to replacements",
    rs_returnless_replacements_hint: "Damaged or wrong items within their limit are not sent back.",
    rs_refund_delivery: "Refund original delivery when it's our fault",
    rs_refund_delivery_hint: "Whole order: in full. Part of an order: pro rata by item value.",
    rs_deduct_postage: "Deduct the return postage when it's the customer's reason",
    rs_deduct_postage_hint: "The fee per service is set under Return services.",
    rs_replacements: "Replacements",
    rs_replacements_hint: "A replacement order (the REP clone) under the BargainFox Returns channel. Instant ones are released for picking at once. With auto-approve on, larger ones whose item comes back are held until the return is on its way; the rest wait on the Returns page for review.",
    rs_instant_limit: "Send instantly when worth under",
    rs_instant_limit_hint: "Value of the items being re-sent, inc. VAT.",
    rs_auto_approve_returns: "Auto-approve returns",
    rs_auto_approve_returns_hint: "A replacement at or over the instant replacement limit whose item comes back isn't reviewed. Its return label is booked straight away, and the replacement ships as soon as the carrier scans the return. If there's no scan within the exchange cancel days, the replacement is cancelled.",
    rs_catalogue_refresh: "Refresh the shop every (minutes)",
    rs_catalogue_refresh_hint: "How often prices, stock and listings are refreshed from BargainFox for the exchange shop (5 to 60). The best-seller order is worked out once a day. 0 = off: the shop is built when a customer opens it, which is slower.",
    rs_missing: "Missing and not arrived",
    rs_missing_allowance: "Allowed below the order count",
    rs_missing_allowance_hint: "Missing or not-arrived requests a customer with fewer orders than the standing's order count can make in the window before every one is reviewed. From that many orders on, the return rate rule decides.",
    rs_review_missing: "Review every missing and not-arrived request",
    rs_review_missing_hint: "Off: under the limits above they're resent or refunded straight away while the customer is in good standing, and reviewed whatever their value once they aren't. On: a person checks every one.",
    rs_refund_review_limit: "Check refunds with nothing sent back from",
    rs_refund_review_limit_hint: "Missing, not arrived or kept items: a refund at or over this waits here for a person. Inc. VAT; 0 checks every one.",
    rs_exchanges: "Exchanges",
    rs_exchanges_enabled: "Offer exchanges",
    rs_min_stock: "Only list products with at least",
    rs_min_stock_hint: "Units available to sell.",
    rs_cancel_days: "Cancel if the return isn't sent within (days)",
    rs_cancel_days_hint: "The exchange order waits in Exchange, holding its stock. No carrier scan by then: it is cancelled, the stock freed, any top-up refunded and the customer emailed.",
    rs_express_fee: "Express delivery fee",
    rs_express_fee_hint: "What the customer pays for express delivery of their new items, however many there are and whatever they weigh. Standard delivery is free. FastFox members get express free.",
    rs_tiers: "When the exchange order moves to Unfulfilled",
    rs_tiers_hint: "By the value of the new items. The order is created when the exchange is booked and waits in Exchange, holding its stock, until the return reaches that point - then the warehouse picks it.",
    rs_tier_value: "Exchange value",
    rs_tier_when: "Send it when",
    rs_tier_under: "Under",
    rs_tier_and_over: "£{amount} and over",
    rs_tier_limit: "Tier {n} limit",
    rs_tier_trigger: "Tier {n} trigger",
    rs_when_booked: "The return is booked (no longer allowed)",
    rs_tier_when_retired: "Tier {n}: that trigger is no longer allowed. The exchange order only moves to Unfulfilled once the customer has shipped the return - choose when.",
    rs_when_shipped: "The return is shipped (first carrier scan)",
    rs_when_delivered: "The return is delivered to our warehouse",
    rs_when_received: "The warehouse marks it received",
    rs_ranking: "Ranking on the exchange page",
    rs_ranking_hint: "Score = units ordered in the window × (price ÷ median price) ^ price weight.",
    rs_ranking_days: "Ranking window (days)",
    rs_price_weight: "Price weight",
    rs_price_weight_hint: "0 = sales only · 0.5 = gentle lift · 1 = strong lift.",
    rs_min_units: "Minimum units ordered in window",
    rs_top_badges: "\"Top seller\" badge on the first",
    rs_top_badges_hint: "Products. 0 hides the badge.",
    rs_invoices: "Payments and invoices",
    rs_invoices_hint: "The seller printed on exchange invoices.",
    rs_emails: "Customer emails",
    rs_emails_hint: "Sent from the address below and logged on the order's Logs tab.",
    rs_from_address: "Send from",
    rs_from_address_hint: "Customer emails from the returns portal are sent from this address. It must be on a domain our mail service can send from (bargainfox.com).",
    rs_reply_to: "Reply-to address",
    rs_reply_to_hint: "Customer replies go here.",
    rs_support_inbox: "Customer service inbox",
    rs_contact_gorgias: "Send contact-form messages to Gorgias",
    rs_contact_gorgias_hint: "Creates a Gorgias ticket on the BargainFox inbox (needs the Gorgias keys on the server). Off: they're emailed to the inbox above.",
    rs_shipping_link: "Returns button in BargainFox shipping emails",
    rs_shipping_link_hint: "Adds \"Return or report a problem\" to the shipping email Portal sends: a link for that order only, valid for the link days under Access and security.",
    rs_support_inbox_hint: "Messages from the window-closed contact form. Production makes them Gorgias tickets on this inbox; elsewhere they are emailed here.",
    rs_error_alert_email: "Error alert email",
    rs_error_alert_email_hint: "We email this address when the returns portal hits errors, at most once an hour. Leave empty for no emails.",
    rs_reasons: "Reasons",
    rs_reasons_hint: "Who's at fault drives free postage, delivery refunds and which outcomes are offered. Changes save straight away.",
    rs_on: "On",
    rs_problem: "Problem",
    rs_reason_label: "Reason the customer sees",
    rs_fault: "Fault",
    rs_needs_detail: "Needs details",
    rs_needs_photo: "Needs photo",
    rs_actions: "Actions",
    rs_reason_on: "Offer {label}",
    rs_reason_fixed: "The fixed reason of its problem: it can be renamed, not switched off.",
    rs_reason_delete: "Delete reason {code}",
    rs_reason_delete_confirm: "Delete the reason {code}? A reason used by a request can only be switched off.",
    rs_add_reason: "Add reason",
    rs_reason_code: "Code",
    rs_services: "Return services",
    rs_services_hint: "Postcode patterns work like the remote-area list: area HS*, district PA48 *, sector PA48 7*. Separate them with commas.",
    rs_service: "Service",
    rs_service_on: "Offer {name}",
    rs_fee: "Customer fee",
    rs_fee_for: "Customer fee for {name}",
    rs_max_kg: "Max kg",
    rs_max_len: "Max length cm",
    rs_pc_only: "Postcodes: only",
    rs_pc_never: "Postcodes: never",
    rs_pc_only_for: "Only these postcodes for {name}",
    rs_pc_never_for: "Never these postcodes for {name}",
    rs_pc_all: "All",
    rs_pc_none: "None",
    rs_max_labels: "Most labels per return",
    rs_max_labels_hint: "Never more than the parcels the order was sent in.",
    rs_security: "Access and security",
    rs_token_account: "Link from a BargainFox account (minutes)",
    rs_token_account_hint: "Single use.",
    rs_token_email: "Link in an email (days)",
    rs_token_email_hint: "Reusable until it expires.",
    rs_session_idle: "Session times out after (minutes idle)",
    rs_ip_failures: "Failed lookups per IP (15 minutes)",
    rs_ip_failures_hint: "Then a cooldown.",
    rs_order_failures: "Failed lookups per order number (1 hour)",
    rs_order_failures_hint: "Then a cooldown.",
    rs_captcha_after: "Show the security check after (failed lookups)",
    rs_mask: "Mask personal details in order-lookup sessions",
    rs_mask_hint: "For example \"S. M***\" and \"CF14 ***\". Items are shown in full.",
    rs_other: "Other settings",
    rs_other_hint: "Settings this screen doesn't lay out yet.",
    rs_unsaved: "{n} unsaved change(s)",
    rs_no_changes: "No unsaved changes",
    rs_discard: "Discard",
    rs_save: "Save returns settings",
    rs_saved: "Returns settings saved",
    rs_save_failed: "Could not save. Try again.",
    rs_fix_fields: "Some settings aren't valid. Check the highlighted fields.",
    rs_admin_only: "Only an Admin can change the returns settings.",
};

export default en;
